//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class ApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param id (optional) 
     * @return OK
     */
    academicYearGetById(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfAcademicYearEntity> {
        let url_ = this.baseUrl + "/api/v1/academic-year/get-by-id?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcademicYearGetById(_response);
        });
    }

    protected processAcademicYearGetById(response: AxiosResponse): Promise<ApiResponse_1OfAcademicYearEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfAcademicYearEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfAcademicYearEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfAcademicYearEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveAcademicYear(body: AcademicYearEntity | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfAcademicYearEntity> {
        let url_ = this.baseUrl + "/api/v1/academic-year/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveAcademicYear(_response);
        });
    }

    protected processSaveAcademicYear(response: AxiosResponse): Promise<ApiResponse_1OfAcademicYearEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfAcademicYearEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfAcademicYearEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfAcademicYearEntity>(null as any);
    }

    /**
     * @return OK
     */
    academicYearGetList( cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfAcademicYearEntity> {
        let url_ = this.baseUrl + "/api/v1/academic-year/get-all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcademicYearGetList(_response);
        });
    }

    protected processAcademicYearGetList(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfAcademicYearEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfAcademicYearEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfAcademicYearEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfAcademicYearEntity>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    academicYearDelete(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/academic-year/delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcademicYearDelete(_response);
        });
    }

    protected processAcademicYearDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    register(body: RegisterDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/account/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegister(_response);
        });
    }

    protected processRegister(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    loginMobile(body: LoginDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfLoginResponseDto> {
        let url_ = this.baseUrl + "/api/v1/account/login-mobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLoginMobile(_response);
        });
    }

    protected processLoginMobile(response: AxiosResponse): Promise<ApiResponse_1OfLoginResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfLoginResponseDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfLoginResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfLoginResponseDto>(null as any);
    }

    /**
     * @param userName (optional) 
     * @param password (optional) 
     * @param rememberMe (optional) 
     * @param captchaText (optional) 
     * @param captchaToken (optional) 
     * @param captchaInputText (optional) 
     * @return OK
     */
    login(userName: string | undefined, password: string | undefined, rememberMe: boolean | undefined, captchaText: string | undefined, captchaToken: string | undefined, captchaInputText: string | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfLoginResponseDto> {
        let url_ = this.baseUrl + "/api/v1/account/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (userName === null || userName === undefined)
            throw new globalThis.Error("The parameter 'userName' cannot be null.");
        else
            content_.append("UserName", userName.toString());
        if (password === null || password === undefined)
            throw new globalThis.Error("The parameter 'password' cannot be null.");
        else
            content_.append("Password", password.toString());
        if (rememberMe === null || rememberMe === undefined)
            throw new globalThis.Error("The parameter 'rememberMe' cannot be null.");
        else
            content_.append("RememberMe", rememberMe.toString());
        if (captchaText === null || captchaText === undefined)
            throw new globalThis.Error("The parameter 'captchaText' cannot be null.");
        else
            content_.append("CaptchaText", captchaText.toString());
        if (captchaToken === null || captchaToken === undefined)
            throw new globalThis.Error("The parameter 'captchaToken' cannot be null.");
        else
            content_.append("CaptchaToken", captchaToken.toString());
        if (captchaInputText === null || captchaInputText === undefined)
            throw new globalThis.Error("The parameter 'captchaInputText' cannot be null.");
        else
            content_.append("CaptchaInputText", captchaInputText.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: AxiosResponse): Promise<ApiResponse_1OfLoginResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfLoginResponseDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfLoginResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfLoginResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    loginWithGoogle(body: GoogleLoginDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfLoginResponseDto> {
        let url_ = this.baseUrl + "/api/v1/account/login-with-google";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLoginWithGoogle(_response);
        });
    }

    protected processLoginWithGoogle(response: AxiosResponse): Promise<ApiResponse_1OfLoginResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfLoginResponseDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfLoginResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfLoginResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    linkGoogle(body: GoogleLoginDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/account/link-google";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLinkGoogle(_response);
        });
    }

    protected processLinkGoogle(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    getGoogleLinkStatus( cancelToken?: CancelToken): Promise<ApiResponse_1OfGoogleLinkStatusDto> {
        let url_ = this.baseUrl + "/api/v1/account/google-link-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGoogleLinkStatus(_response);
        });
    }

    protected processGetGoogleLinkStatus(response: AxiosResponse): Promise<ApiResponse_1OfGoogleLinkStatusDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfGoogleLinkStatusDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfGoogleLinkStatusDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfGoogleLinkStatusDto>(null as any);
    }

    /**
     * @return OK
     */
    unlinkGoogle( cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/account/unlink-google";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnlinkGoogle(_response);
        });
    }

    protected processUnlinkGoogle(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    loginWithFacebook(body: FacebookLoginDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfLoginResponseDto> {
        let url_ = this.baseUrl + "/api/v1/account/login-with-facebook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLoginWithFacebook(_response);
        });
    }

    protected processLoginWithFacebook(response: AxiosResponse): Promise<ApiResponse_1OfLoginResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfLoginResponseDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfLoginResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfLoginResponseDto>(null as any);
    }

    /**
     * @return OK
     */
    generateCaptcha( cancelToken?: CancelToken): Promise<DNTCaptchaApiResponse> {
        let url_ = this.baseUrl + "/api/v1/account/captcha";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateCaptcha(_response);
        });
    }

    protected processGenerateCaptcha(response: AxiosResponse): Promise<DNTCaptchaApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DNTCaptchaApiResponse.fromJS(resultData200);
            return Promise.resolve<DNTCaptchaApiResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DNTCaptchaApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    refreshToken( cancelToken?: CancelToken): Promise<ApiResponse_1OfRefreshTokenResponseDto> {
        let url_ = this.baseUrl + "/api/v1/account/refresh-token";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshToken(_response);
        });
    }

    protected processRefreshToken(response: AxiosResponse): Promise<ApiResponse_1OfRefreshTokenResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfRefreshTokenResponseDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfRefreshTokenResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfRefreshTokenResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    loginWith2FA(body: LoginWith2FADto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfLoginResponseDto> {
        let url_ = this.baseUrl + "/api/v1/account/login-with-2fa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLoginWith2FA(_response);
        });
    }

    protected processLoginWith2FA(response: AxiosResponse): Promise<ApiResponse_1OfLoginResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfLoginResponseDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfLoginResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfLoginResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendRecover2FaOtp(body: Recover2FaSendOtpDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfOtpSendResultDto> {
        let url_ = this.baseUrl + "/api/v1/account/recover-2fa/send-otp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendRecover2FaOtp(_response);
        });
    }

    protected processSendRecover2FaOtp(response: AxiosResponse): Promise<ApiResponse_1OfOtpSendResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfOtpSendResultDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfOtpSendResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfOtpSendResultDto>(null as any);
    }

    /**
     * @return OK
     */
    userInfo( cancelToken?: CancelToken): Promise<UserInfoDto> {
        let url_ = this.baseUrl + "/api/v1/account/user-info";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserInfo(_response);
        });
    }

    protected processUserInfo(response: AxiosResponse): Promise<UserInfoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserInfoDto.fromJS(resultData200);
            return Promise.resolve<UserInfoDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserInfoDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setPassword(body: SetPasswordDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/account/set-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetPassword(_response);
        });
    }

    protected processSetPassword(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param value (optional) 
     * @return OK
     */
    checkUsernameAvailable(value: string | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfObject> {
        let url_ = this.baseUrl + "/api/v1/account/check-username-available?";
        if (value === null)
            throw new globalThis.Error("The parameter 'value' cannot be null.");
        else if (value !== undefined)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckUsernameAvailable(_response);
        });
    }

    protected processCheckUsernameAvailable(response: AxiosResponse): Promise<ApiResponse_1OfObject> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfObject.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfObject>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfObject>(null as any);
    }

    /**
     * @return OK
     */
    getValidationRules( cancelToken?: CancelToken): Promise<ApiResponse_1OfValidationRulesDto> {
        let url_ = this.baseUrl + "/api/v1/account/validation-rules";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetValidationRules(_response);
        });
    }

    protected processGetValidationRules(response: AxiosResponse): Promise<ApiResponse_1OfValidationRulesDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfValidationRulesDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfValidationRulesDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfValidationRulesDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    initiateChangePassword(body: ChangePasswordInitiateDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfChangePasswordInitiateResultDto> {
        let url_ = this.baseUrl + "/api/v1/account/change-password/initiate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInitiateChangePassword(_response);
        });
    }

    protected processInitiateChangePassword(response: AxiosResponse): Promise<ApiResponse_1OfChangePasswordInitiateResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfChangePasswordInitiateResultDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfChangePasswordInitiateResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfChangePasswordInitiateResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendChangePasswordOtp(body: ChangePasswordSendOtpDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfOtpSendResultDto> {
        let url_ = this.baseUrl + "/api/v1/account/change-password/send-otp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendChangePasswordOtp(_response);
        });
    }

    protected processSendChangePasswordOtp(response: AxiosResponse): Promise<ApiResponse_1OfOtpSendResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfOtpSendResultDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfOtpSendResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfOtpSendResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    changePassword(body: ChangePasswordDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/account/change-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    setup2FA( cancelToken?: CancelToken): Promise<Setup2FADto> {
        let url_ = this.baseUrl + "/api/v1/account/setup-2fa";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetup2FA(_response);
        });
    }

    protected processSetup2FA(response: AxiosResponse): Promise<Setup2FADto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Setup2FADto.fromJS(resultData200);
            return Promise.resolve<Setup2FADto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Setup2FADto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    enable2FA(body: Enable2FADto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfEnable2FAResultDto> {
        let url_ = this.baseUrl + "/api/v1/account/enable-2fa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnable2FA(_response);
        });
    }

    protected processEnable2FA(response: AxiosResponse): Promise<ApiResponse_1OfEnable2FAResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfEnable2FAResultDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfEnable2FAResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfEnable2FAResultDto>(null as any);
    }

    /**
     * @return OK
     */
    get2FaRecoveryCodes( cancelToken?: CancelToken): Promise<ApiResponse_1OfRecoveryCodesStatusDto> {
        let url_ = this.baseUrl + "/api/v1/account/2fa/recovery-codes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet2FaRecoveryCodes(_response);
        });
    }

    protected processGet2FaRecoveryCodes(response: AxiosResponse): Promise<ApiResponse_1OfRecoveryCodesStatusDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfRecoveryCodesStatusDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfRecoveryCodesStatusDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfRecoveryCodesStatusDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    generate2FaRecoveryCodes(body: Enable2FADto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfEnable2FAResultDto> {
        let url_ = this.baseUrl + "/api/v1/account/regenerate-2fa-recovery-codes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerate2FaRecoveryCodes(_response);
        });
    }

    protected processGenerate2FaRecoveryCodes(response: AxiosResponse): Promise<ApiResponse_1OfEnable2FAResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfEnable2FAResultDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfEnable2FAResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfEnable2FAResultDto>(null as any);
    }

    /**
     * @return OK
     */
    get2FAStatus( cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/account/get-2fa-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet2FAStatus(_response);
        });
    }

    protected processGet2FAStatus(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    disable2FA(body: Disable2FADto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/account/disable-2fa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDisable2FA(_response);
        });
    }

    protected processDisable2FA(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendDisable2FaOtp(body: Disable2FaSendOtpDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfOtpSendResultDto> {
        let url_ = this.baseUrl + "/api/v1/account/disable-2fa/send-otp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendDisable2FaOtp(_response);
        });
    }

    protected processSendDisable2FaOtp(response: AxiosResponse): Promise<ApiResponse_1OfOtpSendResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfOtpSendResultDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfOtpSendResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfOtpSendResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateAvatar(body: UpdateAvatarDto | undefined, cancelToken?: CancelToken): Promise<UpdateAvatarDto> {
        let url_ = this.baseUrl + "/api/v1/account/update-avatar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAvatar(_response);
        });
    }

    protected processUpdateAvatar(response: AxiosResponse): Promise<UpdateAvatarDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateAvatarDto.fromJS(resultData200);
            return Promise.resolve<UpdateAvatarDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateAvatarDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateInfo(body: UpdateInfoDto | undefined, cancelToken?: CancelToken): Promise<UpdateInfoDto> {
        let url_ = this.baseUrl + "/api/v1/account/update-info";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateInfo(_response);
        });
    }

    protected processUpdateInfo(response: AxiosResponse): Promise<UpdateInfoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateInfoDto.fromJS(resultData200);
            return Promise.resolve<UpdateInfoDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateInfoDto>(null as any);
    }

    /**
     * @param type (optional) 
     * @return OK
     */
    getIdentifiers(type: UserIdentifierType | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfUserIdentifierDto> {
        let url_ = this.baseUrl + "/api/v1/account/identifiers?";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIdentifiers(_response);
        });
    }

    protected processGetIdentifiers(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfUserIdentifierDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfUserIdentifierDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfUserIdentifierDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfUserIdentifierDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    renameUsername(body: RenameUsernameDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/account/identifiers/rename-username";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRenameUsername(_response);
        });
    }

    protected processRenameUsername(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addUsername(body: AddUsernameDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/account/identifiers/add-username";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddUsername(_response);
        });
    }

    protected processAddUsername(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    deleteUsername(username: string, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/account/identifiers/username/{username}";
        if (username === undefined || username === null)
            throw new globalThis.Error("The parameter 'username' must be defined.");
        url_ = url_.replace("{username}", encodeURIComponent("" + username));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteUsername(_response);
        });
    }

    protected processDeleteUsername(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param email (optional) 
     * @return OK
     */
    checkEmailAvailable(email: string | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfObject> {
        let url_ = this.baseUrl + "/api/v1/account/identifiers/email/check-available?";
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckEmailAvailable(_response);
        });
    }

    protected processCheckEmailAvailable(response: AxiosResponse): Promise<ApiResponse_1OfObject> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfObject.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfObject>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfObject>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendAddEmailOtp(body: AddEmailDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfOtpSendResultDto> {
        let url_ = this.baseUrl + "/api/v1/account/identifiers/email/send-otp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendAddEmailOtp(_response);
        });
    }

    protected processSendAddEmailOtp(response: AxiosResponse): Promise<ApiResponse_1OfOtpSendResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfOtpSendResultDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfOtpSendResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfOtpSendResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    confirmAddEmail(body: ConfirmEmailDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/account/identifiers/email/confirm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfirmAddEmail(_response);
        });
    }

    protected processConfirmAddEmail(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendDeleteEmailOtp(body: DeleteEmailRequestDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfOtpSendResultDto> {
        let url_ = this.baseUrl + "/api/v1/account/identifiers/email/delete/send-otp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendDeleteEmailOtp(_response);
        });
    }

    protected processSendDeleteEmailOtp(response: AxiosResponse): Promise<ApiResponse_1OfOtpSendResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfOtpSendResultDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfOtpSendResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfOtpSendResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    confirmDeleteEmail(body: ConfirmDeleteEmailDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/account/identifiers/email/delete/confirm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfirmDeleteEmail(_response);
        });
    }

    protected processConfirmDeleteEmail(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setDefaultIdentifier(body: SetDefaultIdentifierDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/account/identifiers/set-default";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetDefaultIdentifier(_response);
        });
    }

    protected processSetDefaultIdentifier(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    logout( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/account/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param token (optional) 
     * @return OK
     */
    validateToken(token: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/account/token/validate?";
        if (token === null)
            throw new globalThis.Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateToken(_response);
        });
    }

    protected processValidateToken(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    checkSession( cancelToken?: CancelToken): Promise<ApiResponse_1OfSessionStatusDto> {
        let url_ = this.baseUrl + "/api/v1/account/check-session";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckSession(_response);
        });
    }

    protected processCheckSession(response: AxiosResponse): Promise<ApiResponse_1OfSessionStatusDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfSessionStatusDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfSessionStatusDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfSessionStatusDto>(null as any);
    }

    /**
     * @param userName (optional) 
     * @param targetEmail (optional) 
     * @return OK
     */
    checkUserName(userName: string | undefined, targetEmail: string | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfCurrentObjectDto> {
        let url_ = this.baseUrl + "/api/v1/account/check-username?";
        if (userName === null)
            throw new globalThis.Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        if (targetEmail === null)
            throw new globalThis.Error("The parameter 'targetEmail' cannot be null.");
        else if (targetEmail !== undefined)
            url_ += "targetEmail=" + encodeURIComponent("" + targetEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckUserName(_response);
        });
    }

    protected processCheckUserName(response: AxiosResponse): Promise<ApiResponse_1OfCurrentObjectDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfCurrentObjectDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfCurrentObjectDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfCurrentObjectDto>(null as any);
    }

    /**
     * @param userName (optional) 
     * @return OK
     */
    getForgotPasswordOtpTargets(userName: string | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfOtpTargetEmailOptionsDto> {
        let url_ = this.baseUrl + "/api/v1/account/forgot-password/otp-targets?";
        if (userName === null)
            throw new globalThis.Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForgotPasswordOtpTargets(_response);
        });
    }

    protected processGetForgotPasswordOtpTargets(response: AxiosResponse): Promise<ApiResponse_1OfOtpTargetEmailOptionsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfOtpTargetEmailOptionsDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfOtpTargetEmailOptionsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfOtpTargetEmailOptionsDto>(null as any);
    }

    /**
     * @return OK
     */
    getOtpTargetEmails( cancelToken?: CancelToken): Promise<ApiResponse_1OfOtpTargetEmailOptionsDto> {
        let url_ = this.baseUrl + "/api/v1/account/otp-target-emails";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOtpTargetEmails(_response);
        });
    }

    protected processGetOtpTargetEmails(response: AxiosResponse): Promise<ApiResponse_1OfOtpTargetEmailOptionsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfOtpTargetEmailOptionsDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfOtpTargetEmailOptionsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfOtpTargetEmailOptionsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    checkFogotPasswordOTP(body: ForgotPasswordCheckOTPResource | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfForgotPasswordOtpVerifiedDto> {
        let url_ = this.baseUrl + "/api/v1/account/check-fogot-password-otp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckFogotPasswordOTP(_response);
        });
    }

    protected processCheckFogotPasswordOTP(response: AxiosResponse): Promise<ApiResponse_1OfForgotPasswordOtpVerifiedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfForgotPasswordOtpVerifiedDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfForgotPasswordOtpVerifiedDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfForgotPasswordOtpVerifiedDto>(null as any);
    }

    /**
     * @param userName (optional) 
     * @param targetEmail (optional) 
     * @return OK
     */
    resendOtp(userName: string | undefined, targetEmail: string | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfCurrentObjectDto> {
        let url_ = this.baseUrl + "/api/v1/account/resend-otp?";
        if (userName === null)
            throw new globalThis.Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        if (targetEmail === null)
            throw new globalThis.Error("The parameter 'targetEmail' cannot be null.");
        else if (targetEmail !== undefined)
            url_ += "targetEmail=" + encodeURIComponent("" + targetEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResendOtp(_response);
        });
    }

    protected processResendOtp(response: AxiosResponse): Promise<ApiResponse_1OfCurrentObjectDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfCurrentObjectDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfCurrentObjectDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfCurrentObjectDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    forgotPassword(body: ResetPasswordByUserNameResource | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/account/forgot-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processForgotPassword(_response);
        });
    }

    protected processForgotPassword(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    getDevices( cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfUserDeviceListItemDto> {
        let url_ = this.baseUrl + "/api/v1/account/devices";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDevices(_response);
        });
    }

    protected processGetDevices(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfUserDeviceListItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfUserDeviceListItemDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfUserDeviceListItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfUserDeviceListItemDto>(null as any);
    }

    /**
     * @return OK
     */
    revokeDevice(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/account/devices/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRevokeDevice(_response);
        });
    }

    protected processRevokeDevice(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    revokeOtherDevices( cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/account/devices/revoke-others";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRevokeOtherDevices(_response);
        });
    }

    protected processRevokeOtherDevices(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    trustDevice(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/account/devices/{id}/trust";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTrustDevice(_response);
        });
    }

    protected processTrustDevice(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    untrustDevice(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/account/devices/{id}/untrust";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUntrustDevice(_response);
        });
    }

    protected processUntrustDevice(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    getDeviceSessions(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfUserSessionListItemDto> {
        let url_ = this.baseUrl + "/api/v1/account/devices/{id}/sessions";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeviceSessions(_response);
        });
    }

    protected processGetDeviceSessions(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfUserSessionListItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfUserSessionListItemDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfUserSessionListItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfUserSessionListItemDto>(null as any);
    }

    /**
     * @return OK
     */
    revokeSession(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/account/sessions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRevokeSession(_response);
        });
    }

    protected processRevokeSession(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param deviceId (optional) 
     * @param take (optional) 
     * @return OK
     */
    getLoginHistory(deviceId: number | undefined, take: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfLoginHistoryListItemDto> {
        let url_ = this.baseUrl + "/api/v1/account/login-history?";
        if (deviceId === null)
            throw new globalThis.Error("The parameter 'deviceId' cannot be null.");
        else if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLoginHistory(_response);
        });
    }

    protected processGetLoginHistory(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfLoginHistoryListItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfLoginHistoryListItemDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfLoginHistoryListItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfLoginHistoryListItemDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    userGetList(body: UserGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfUserListDto> {
        let url_ = this.baseUrl + "/api/v1/account/get-list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserGetList(_response);
        });
    }

    protected processUserGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfUserListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfUserListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfUserListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfUserListDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param objectId (optional) 
     * @return OK
     */
    userGetById(id: number | undefined, objectId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfRegisterDto> {
        let url_ = this.baseUrl + "/api/v1/account/get-by-id?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (objectId === null)
            throw new globalThis.Error("The parameter 'objectId' cannot be null.");
        else if (objectId !== undefined)
            url_ += "objectId=" + encodeURIComponent("" + objectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserGetById(_response);
        });
    }

    protected processUserGetById(response: AxiosResponse): Promise<ApiResponse_1OfRegisterDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfRegisterDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfRegisterDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfRegisterDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @return OK
     */
    userGetByExact(keyword: string | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfRegisterDto> {
        let url_ = this.baseUrl + "/api/v1/account/get-by-exact?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserGetByExact(_response);
        });
    }

    protected processUserGetByExact(response: AxiosResponse): Promise<ApiResponse_1OfRegisterDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfRegisterDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfRegisterDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfRegisterDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param objectId (optional) 
     * @return OK
     */
    userGetPermission(userId: number | undefined, objectId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfRoleModuleDto> {
        let url_ = this.baseUrl + "/api/v1/account/get-permission?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (objectId === null)
            throw new globalThis.Error("The parameter 'objectId' cannot be null.");
        else if (objectId !== undefined)
            url_ += "objectId=" + encodeURIComponent("" + objectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserGetPermission(_response);
        });
    }

    protected processUserGetPermission(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfRoleModuleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfRoleModuleDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfRoleModuleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfRoleModuleDto>(null as any);
    }

    /**
     * @param objectId (optional) 
     * @return OK
     */
    currentUserPermission(objectId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfRoleModuleDto> {
        let url_ = this.baseUrl + "/api/v1/account/current-permission?";
        if (objectId === null)
            throw new globalThis.Error("The parameter 'objectId' cannot be null.");
        else if (objectId !== undefined)
            url_ += "objectId=" + encodeURIComponent("" + objectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCurrentUserPermission(_response);
        });
    }

    protected processCurrentUserPermission(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfRoleModuleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfRoleModuleDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfRoleModuleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfRoleModuleDto>(null as any);
    }

    /**
     * @param isRessPass (optional) 
     * @param objectId (optional) 
     * @param body (optional) 
     * @return OK
     */
    userUpdate(isRessPass: boolean | undefined, objectId: number | undefined, body: RegisterDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/account/update?";
        if (isRessPass === null)
            throw new globalThis.Error("The parameter 'isRessPass' cannot be null.");
        else if (isRessPass !== undefined)
            url_ += "isRessPass=" + encodeURIComponent("" + isRessPass) + "&";
        if (objectId === null)
            throw new globalThis.Error("The parameter 'objectId' cannot be null.");
        else if (objectId !== undefined)
            url_ += "objectId=" + encodeURIComponent("" + objectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserUpdate(_response);
        });
    }

    protected processUserUpdate(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param objectId (optional) 
     * @param body (optional) 
     * @return OK
     */
    userUpdatePermisson(userId: number | undefined, objectId: number | undefined, body: RoleModuleDto[] | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/account/update-permission?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (objectId === null)
            throw new globalThis.Error("The parameter 'objectId' cannot be null.");
        else if (objectId !== undefined)
            url_ += "objectId=" + encodeURIComponent("" + objectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserUpdatePermisson(_response);
        });
    }

    protected processUserUpdatePermisson(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    userUpdateEmail(body: ChangeEmailDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/account/update-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserUpdateEmail(_response);
        });
    }

    protected processUserUpdateEmail(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    accountDelete(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/account/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAccountDelete(_response);
        });
    }

    protected processAccountDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param type (optional) 
     * @return OK
     */
    userGetListByType(type: UserTypeEnum | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfUserWithSimpleInfoDto> {
        let url_ = this.baseUrl + "/api/v1/account/get-list-by-type?";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserGetListByType(_response);
        });
    }

    protected processUserGetListByType(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfUserWithSimpleInfoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfUserWithSimpleInfoDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfUserWithSimpleInfoDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfUserWithSimpleInfoDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    actionRuleGetList(body: ActionRuleFilterDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfActionRuleDto> {
        let url_ = this.baseUrl + "/api/v1/action-rule/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActionRuleGetList(_response);
        });
    }

    protected processActionRuleGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfActionRuleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfActionRuleDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfActionRuleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfActionRuleDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    actionRuleSave(body: ActionRuleDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfActionRuleDto> {
        let url_ = this.baseUrl + "/api/v1/action-rule/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActionRuleSave(_response);
        });
    }

    protected processActionRuleSave(response: AxiosResponse): Promise<ApiResponse_1OfActionRuleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfActionRuleDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfActionRuleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfActionRuleDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    actionRuleDelete(body: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/action-rule/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActionRuleDelete(_response);
        });
    }

    protected processActionRuleDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    getTrackingActionCodes( cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfTrackingActionCodeItemDto> {
        let url_ = this.baseUrl + "/api/v1/action-rule/action-codes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTrackingActionCodes(_response);
        });
    }

    protected processGetTrackingActionCodes(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfTrackingActionCodeItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfTrackingActionCodeItemDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfTrackingActionCodeItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfTrackingActionCodeItemDto>(null as any);
    }

    /**
     * @return OK
     */
    activityGetById(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfActivitySaveDto> {
        let url_ = this.baseUrl + "/api/v1/activity/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivityGetById(_response);
        });
    }

    protected processActivityGetById(response: AxiosResponse): Promise<ApiResponse_1OfActivitySaveDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfActivitySaveDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfActivitySaveDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfActivitySaveDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveActivity(body: ActivitySaveDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfActivityEntity> {
        let url_ = this.baseUrl + "/api/v1/activity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveActivity(_response);
        });
    }

    protected processSaveActivity(response: AxiosResponse): Promise<ApiResponse_1OfActivityEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfActivityEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfActivityEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfActivityEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    activityGetList(body: ActivityGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfActivityListDto> {
        let url_ = this.baseUrl + "/api/v1/activity/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivityGetList(_response);
        });
    }

    protected processActivityGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfActivityListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfActivityListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfActivityListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfActivityListDto>(null as any);
    }

    /**
     * @return OK
     */
    activityDelete(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/activity/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivityDelete(_response);
        });
    }

    protected processActivityDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addActivityLog(body: ActivityLogEntity | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfActivityLogEntity> {
        let url_ = this.baseUrl + "/api/v1/activity-log";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddActivityLog(_response);
        });
    }

    protected processAddActivityLog(response: AxiosResponse): Promise<ApiResponse_1OfActivityLogEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfActivityLogEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfActivityLogEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfActivityLogEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    activityLogGetList(body: GetListLogQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfListActivityLogDto> {
        let url_ = this.baseUrl + "/api/v1/activity-log/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivityLogGetList(_response);
        });
    }

    protected processActivityLogGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfListActivityLogDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfListActivityLogDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfListActivityLogDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfListActivityLogDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    chatWithPrompt(body: AiPromptRequest | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfAiResponse> {
        let url_ = this.baseUrl + "/api/v1/ai/chat-with-prompt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChatWithPrompt(_response);
        });
    }

    protected processChatWithPrompt(response: AxiosResponse): Promise<ApiResponse_1OfAiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfAiResponse.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfAiResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfAiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    chat(body: AiChatRequest | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfAiResponse> {
        let url_ = this.baseUrl + "/api/v1/ai/chat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChat(_response);
        });
    }

    protected processChat(response: AxiosResponse): Promise<ApiResponse_1OfAiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfAiResponse.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfAiResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfAiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    chatSimple(body: SimpleChatRequest | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfAiResponse> {
        let url_ = this.baseUrl + "/api/v1/ai/chat-simple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChatSimple(_response);
        });
    }

    protected processChatSimple(response: AxiosResponse): Promise<ApiResponse_1OfAiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfAiResponse.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfAiResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfAiResponse>(null as any);
    }

    /**
     * @return OK
     */
    aiPromptGetById(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfAiPromptEntity> {
        let url_ = this.baseUrl + "/api/v1/ai-prompt/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAiPromptGetById(_response);
        });
    }

    protected processAiPromptGetById(response: AxiosResponse): Promise<ApiResponse_1OfAiPromptEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfAiPromptEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfAiPromptEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfAiPromptEntity>(null as any);
    }

    /**
     * @param grade (optional) 
     * @param categoryId (optional) 
     * @return OK
     */
    aiPromptGetByCode(code: string, grade: number | undefined, categoryId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfAiPromptEntity> {
        let url_ = this.baseUrl + "/api/v1/ai-prompt/by-code/{code}?";
        if (code === undefined || code === null)
            throw new globalThis.Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        if (grade === null)
            throw new globalThis.Error("The parameter 'grade' cannot be null.");
        else if (grade !== undefined)
            url_ += "grade=" + encodeURIComponent("" + grade) + "&";
        if (categoryId === null)
            throw new globalThis.Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAiPromptGetByCode(_response);
        });
    }

    protected processAiPromptGetByCode(response: AxiosResponse): Promise<ApiResponse_1OfAiPromptEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfAiPromptEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfAiPromptEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfAiPromptEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveAiPrompt(body: AiPromptEntity | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfAiPromptEntity> {
        let url_ = this.baseUrl + "/api/v1/ai-prompt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveAiPrompt(_response);
        });
    }

    protected processSaveAiPrompt(response: AxiosResponse): Promise<ApiResponse_1OfAiPromptEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfAiPromptEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfAiPromptEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfAiPromptEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    aiPromptGetList(body: AiPromptGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfAiPromptListDto> {
        let url_ = this.baseUrl + "/api/v1/ai-prompt/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAiPromptGetList(_response);
        });
    }

    protected processAiPromptGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfAiPromptListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfAiPromptListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfAiPromptListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfAiPromptListDto>(null as any);
    }

    /**
     * @return OK
     */
    aiPromptDelete(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/ai-prompt/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAiPromptDelete(_response);
        });
    }

    protected processAiPromptDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    listExamOfUser(body: AssignExamListExamFilterDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfAssignExamListExamDto> {
        let url_ = this.baseUrl + "/api/v1/assign-exam/list-exam-of-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListExamOfUser(_response);
        });
    }

    protected processListExamOfUser(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfAssignExamListExamDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfAssignExamListExamDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfAssignExamListExamDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfAssignExamListExamDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    assignExamUpdate(body: AssignExamEntity | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/assign-exam/assign-exam-update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignExamUpdate(_response);
        });
    }

    protected processAssignExamUpdate(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    assignExamAddMultiple(body: AssignExamAddMultipleDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/assign-exam/assign-exam-add-multiple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignExamAddMultiple(_response);
        });
    }

    protected processAssignExamAddMultiple(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    assignExamCheckDoExam(body: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfAssignExamCheckDoExamDto> {
        let url_ = this.baseUrl + "/api/v1/assign-exam/assign-exam-check-do-exam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignExamCheckDoExam(_response);
        });
    }

    protected processAssignExamCheckDoExam(response: AxiosResponse): Promise<ApiResponse_1OfAssignExamCheckDoExamDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfAssignExamCheckDoExamDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfAssignExamCheckDoExamDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfAssignExamCheckDoExamDto>(null as any);
    }

    /**
     * @param classId (optional) 
     * @return OK
     */
    assignExamUserCount(classId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfAssignExamCountDto> {
        let url_ = this.baseUrl + "/api/v1/assign-exam/assign-exam-user-count?";
        if (classId === null)
            throw new globalThis.Error("The parameter 'classId' cannot be null.");
        else if (classId !== undefined)
            url_ += "classId=" + encodeURIComponent("" + classId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignExamUserCount(_response);
        });
    }

    protected processAssignExamUserCount(response: AxiosResponse): Promise<ApiResponse_1OfAssignExamCountDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfAssignExamCountDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfAssignExamCountDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfAssignExamCountDto>(null as any);
    }

    /**
     * @param pageSize (optional) 
     * @return OK
     */
    assignExamDone(pageSize: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfAssignExamDoneDto> {
        let url_ = this.baseUrl + "/api/v1/assign-exam/assign-exam-done?";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignExamDone(_response);
        });
    }

    protected processAssignExamDone(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfAssignExamDoneDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfAssignExamDoneDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfAssignExamDoneDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfAssignExamDoneDto>(null as any);
    }

    /**
     * @param pageSize (optional) 
     * @return OK
     */
    assignExamNeedDo(pageSize: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfAssignExamNeedDoDto> {
        let url_ = this.baseUrl + "/api/v1/assign-exam/assign-exam-need-do?";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignExamNeedDo(_response);
        });
    }

    protected processAssignExamNeedDo(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfAssignExamNeedDoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfAssignExamNeedDoDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfAssignExamNeedDoDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfAssignExamNeedDoDto>(null as any);
    }

    /**
     * @param assignExamId (optional) 
     * @return OK
     */
    assignExamDelete(assignExamId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/assign-exam/assign-exam-delete?";
        if (assignExamId === null)
            throw new globalThis.Error("The parameter 'assignExamId' cannot be null.");
        else if (assignExamId !== undefined)
            url_ += "assignExamId=" + encodeURIComponent("" + assignExamId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignExamDelete(_response);
        });
    }

    protected processAssignExamDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param assignExamId (optional) 
     * @return OK
     */
    assignExamTopDifficultQuestion(assignExamId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfAssignExamTopDifficultQuestionDto> {
        let url_ = this.baseUrl + "/api/v1/assign-exam/assign-exam-top-difficult-question?";
        if (assignExamId === null)
            throw new globalThis.Error("The parameter 'assignExamId' cannot be null.");
        else if (assignExamId !== undefined)
            url_ += "assignExamId=" + encodeURIComponent("" + assignExamId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignExamTopDifficultQuestion(_response);
        });
    }

    protected processAssignExamTopDifficultQuestion(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfAssignExamTopDifficultQuestionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfAssignExamTopDifficultQuestionDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfAssignExamTopDifficultQuestionDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfAssignExamTopDifficultQuestionDto>(null as any);
    }

    /**
     * @param assignExamId (optional) 
     * @return OK
     */
    assignExamScoreDistribution(assignExamId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfAssignExamScoreDistributionDto> {
        let url_ = this.baseUrl + "/api/v1/assign-exam/assign-exam-score-distribution?";
        if (assignExamId === null)
            throw new globalThis.Error("The parameter 'assignExamId' cannot be null.");
        else if (assignExamId !== undefined)
            url_ += "assignExamId=" + encodeURIComponent("" + assignExamId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignExamScoreDistribution(_response);
        });
    }

    protected processAssignExamScoreDistribution(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfAssignExamScoreDistributionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfAssignExamScoreDistributionDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfAssignExamScoreDistributionDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfAssignExamScoreDistributionDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    assignExamListByExamId(body: AssignExamListByExamIdFilterDto | undefined, cancelToken?: CancelToken): Promise<FilterResult_1OfAssignExamListByExamIdDto> {
        let url_ = this.baseUrl + "/api/v1/assign-exam/assign-exam-list-by-exam-id";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignExamListByExamId(_response);
        });
    }

    protected processAssignExamListByExamId(response: AxiosResponse): Promise<FilterResult_1OfAssignExamListByExamIdDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilterResult_1OfAssignExamListByExamIdDto.fromJS(resultData200);
            return Promise.resolve<FilterResult_1OfAssignExamListByExamIdDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilterResult_1OfAssignExamListByExamIdDto>(null as any);
    }

    /**
     * @param data (optional) 
     * @return OK
     */
    refreshGET(data: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/captcha/refresh?";
        if (data === null)
            throw new globalThis.Error("The parameter 'data' cannot be null.");
        else if (data !== undefined)
            url_ += "data=" + encodeURIComponent("" + data) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshGET(_response);
        });
    }

    protected processRefreshGET(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param data (optional) 
     * @return OK
     */
    refreshPOST(data: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/captcha/refresh?";
        if (data === null)
            throw new globalThis.Error("The parameter 'data' cannot be null.");
        else if (data !== undefined)
            url_ += "data=" + encodeURIComponent("" + data) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshPOST(_response);
        });
    }

    protected processRefreshPOST(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param data (optional) 
     * @return OK
     */
    showGET(data: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/captcha/show?";
        if (data === null)
            throw new globalThis.Error("The parameter 'data' cannot be null.");
        else if (data !== undefined)
            url_ += "data=" + encodeURIComponent("" + data) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processShowGET(_response);
        });
    }

    protected processShowGET(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param data (optional) 
     * @return OK
     */
    showPOST(data: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/captcha/show?";
        if (data === null)
            throw new globalThis.Error("The parameter 'data' cannot be null.");
        else if (data !== undefined)
            url_ += "data=" + encodeURIComponent("" + data) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processShowPOST(_response);
        });
    }

    protected processShowPOST(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    cartGetMyCart( cancelToken?: CancelToken): Promise<ApiResponse_1OfCartDto> {
        let url_ = this.baseUrl + "/api/v1/cart/my";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCartGetMyCart(_response);
        });
    }

    protected processCartGetMyCart(response: AxiosResponse): Promise<ApiResponse_1OfCartDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfCartDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfCartDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfCartDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    cartAddItem(body: CartAddItemDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfCartDto> {
        let url_ = this.baseUrl + "/api/v1/cart/add-item";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCartAddItem(_response);
        });
    }

    protected processCartAddItem(response: AxiosResponse): Promise<ApiResponse_1OfCartDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfCartDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfCartDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfCartDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    cartUpdateItem(body: CartUpdateItemDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/cart/update-item";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCartUpdateItem(_response);
        });
    }

    protected processCartUpdateItem(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    cartRemoveItem(cartItemId: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/cart/remove-item/{cartItemId}";
        if (cartItemId === undefined || cartItemId === null)
            throw new globalThis.Error("The parameter 'cartItemId' must be defined.");
        url_ = url_.replace("{cartItemId}", encodeURIComponent("" + cartItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCartRemoveItem(_response);
        });
    }

    protected processCartRemoveItem(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    cartClear( cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/cart/clear";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCartClear(_response);
        });
    }

    protected processCartClear(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    categoryGetById(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfCategoryEntity> {
        let url_ = this.baseUrl + "/api/v1/category/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCategoryGetById(_response);
        });
    }

    protected processCategoryGetById(response: AxiosResponse): Promise<ApiResponse_1OfCategoryEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfCategoryEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfCategoryEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfCategoryEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveCategory(body: CategoryEntity | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfCategoryEntity> {
        let url_ = this.baseUrl + "/api/v1/category";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveCategory(_response);
        });
    }

    protected processSaveCategory(response: AxiosResponse): Promise<ApiResponse_1OfCategoryEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfCategoryEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfCategoryEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfCategoryEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    categoryReorder(body: CategoryReorderItemDto[] | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/category/reorder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCategoryReorder(_response);
        });
    }

    protected processCategoryReorder(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    categoryGetList(body: CategoryGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfCategoryListDto> {
        let url_ = this.baseUrl + "/api/v1/category/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCategoryGetList(_response);
        });
    }

    protected processCategoryGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfCategoryListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfCategoryListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfCategoryListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfCategoryListDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    categoryGetListWithNewsCount(body: CategoryGetListWithNewsCountQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfCategoryWithNewsCountDto> {
        let url_ = this.baseUrl + "/api/v1/category/list-with-news-count";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCategoryGetListWithNewsCount(_response);
        });
    }

    protected processCategoryGetListWithNewsCount(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfCategoryWithNewsCountDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfCategoryWithNewsCountDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfCategoryWithNewsCountDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfCategoryWithNewsCountDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    categoryGetListWithGalleryCount(body: CategoryGetListWithGalleryCountQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfCategoryWithGalleryCountDto> {
        let url_ = this.baseUrl + "/api/v1/category/list-with-gallery-count";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCategoryGetListWithGalleryCount(_response);
        });
    }

    protected processCategoryGetListWithGalleryCount(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfCategoryWithGalleryCountDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfCategoryWithGalleryCountDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfCategoryWithGalleryCountDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfCategoryWithGalleryCountDto>(null as any);
    }

    /**
     * @return OK
     */
    categoryDelete(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/category/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCategoryDelete(_response);
        });
    }

    protected processCategoryDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    categoryConfigGetActive( cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfCategoryConfigListDto> {
        let url_ = this.baseUrl + "/api/v1/category-config";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCategoryConfigGetActive(_response);
        });
    }

    protected processCategoryConfigGetActive(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfCategoryConfigListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfCategoryConfigListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfCategoryConfigListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfCategoryConfigListDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    categoryConfigSave(body: CategoryConfigSaveDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfCategoryConfigEntity> {
        let url_ = this.baseUrl + "/api/v1/category-config";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCategoryConfigSave(_response);
        });
    }

    protected processCategoryConfigSave(response: AxiosResponse): Promise<ApiResponse_1OfCategoryConfigEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfCategoryConfigEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfCategoryConfigEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfCategoryConfigEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    categoryConfigGetList(body: CategoryConfigGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfCategoryConfigListDto> {
        let url_ = this.baseUrl + "/api/v1/category-config/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCategoryConfigGetList(_response);
        });
    }

    protected processCategoryConfigGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfCategoryConfigListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfCategoryConfigListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfCategoryConfigListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfCategoryConfigListDto>(null as any);
    }

    /**
     * @return OK
     */
    categoryConfigGetById(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfCategoryConfigListDto> {
        let url_ = this.baseUrl + "/api/v1/category-config/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCategoryConfigGetById(_response);
        });
    }

    protected processCategoryConfigGetById(response: AxiosResponse): Promise<ApiResponse_1OfCategoryConfigListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfCategoryConfigListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfCategoryConfigListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfCategoryConfigListDto>(null as any);
    }

    /**
     * @return OK
     */
    categoryConfigDelete(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/category-config/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCategoryConfigDelete(_response);
        });
    }

    protected processCategoryConfigDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    listChatGroupOfUser(keyword: string | undefined, pageIndex: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfListChatGroupDto> {
        let url_ = this.baseUrl + "/api/v1/chat/list-chat-group-of-user?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageIndex === null)
            throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListChatGroupOfUser(_response);
        });
    }

    protected processListChatGroupOfUser(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfListChatGroupDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfListChatGroupDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfListChatGroupDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfListChatGroupDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createChatGroup(body: CreateChatGroupDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfChatGroupEntity> {
        let url_ = this.baseUrl + "/api/v1/chat/create-chat-group";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateChatGroup(_response);
        });
    }

    protected processCreateChatGroup(response: AxiosResponse): Promise<ApiResponse_1OfChatGroupEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfChatGroupEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfChatGroupEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfChatGroupEntity>(null as any);
    }

    /**
     * @param chatGroupId (optional) 
     * @return OK
     */
    getDetailChatGroup(chatGroupId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfChatGroupDetailDto> {
        let url_ = this.baseUrl + "/api/v1/chat/get-detail-chat-group?";
        if (chatGroupId === null)
            throw new globalThis.Error("The parameter 'chatGroupId' cannot be null.");
        else if (chatGroupId !== undefined)
            url_ += "chatGroupId=" + encodeURIComponent("" + chatGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDetailChatGroup(_response);
        });
    }

    protected processGetDetailChatGroup(response: AxiosResponse): Promise<ApiResponse_1OfChatGroupDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfChatGroupDetailDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfChatGroupDetailDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfChatGroupDetailDto>(null as any);
    }

    /**
     * @param chatGroupId (optional) 
     * @param skipSize (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    getListMessageByChatGroupId(chatGroupId: number | undefined, skipSize: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfListChatMessageByGroupDto> {
        let url_ = this.baseUrl + "/api/v1/chat/get-list-message-by-groupid?";
        if (chatGroupId === null)
            throw new globalThis.Error("The parameter 'chatGroupId' cannot be null.");
        else if (chatGroupId !== undefined)
            url_ += "chatGroupId=" + encodeURIComponent("" + chatGroupId) + "&";
        if (skipSize === null)
            throw new globalThis.Error("The parameter 'skipSize' cannot be null.");
        else if (skipSize !== undefined)
            url_ += "skipSize=" + encodeURIComponent("" + skipSize) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListMessageByChatGroupId(_response);
        });
    }

    protected processGetListMessageByChatGroupId(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfListChatMessageByGroupDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfListChatMessageByGroupDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfListChatMessageByGroupDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfListChatMessageByGroupDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getListUserForCreateChatGroup(body: GetListUserForCreateChatGroupQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfUserListDto> {
        let url_ = this.baseUrl + "/api/v1/chat/get-list-user-for-create-chat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListUserForCreateChatGroup(_response);
        });
    }

    protected processGetListUserForCreateChatGroup(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfUserListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfUserListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfUserListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfUserListDto>(null as any);
    }

    /**
     * @param documentId (optional) 
     * @return OK
     */
    createChatGroupOfDocument(documentId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfChatGroupEntity> {
        let url_ = this.baseUrl + "/api/v1/chat/create-chat-group-of-document?";
        if (documentId === null)
            throw new globalThis.Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateChatGroupOfDocument(_response);
        });
    }

    protected processCreateChatGroupOfDocument(response: AxiosResponse): Promise<ApiResponse_1OfChatGroupEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfChatGroupEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfChatGroupEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfChatGroupEntity>(null as any);
    }

    /**
     * @param chatGroupId (optional) 
     * @param body (optional) 
     * @return OK
     */
    addUserToChatGroup(chatGroupId: number | undefined, body: number[] | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/chat/add-user-to-chat-group?";
        if (chatGroupId === null)
            throw new globalThis.Error("The parameter 'chatGroupId' cannot be null.");
        else if (chatGroupId !== undefined)
            url_ += "chatGroupId=" + encodeURIComponent("" + chatGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddUserToChatGroup(_response);
        });
    }

    protected processAddUserToChatGroup(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param chatGroupId (optional) 
     * @return OK
     */
    updateMessageUnRead(chatGroupId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/chat/update-message-un-read?";
        if (chatGroupId === null)
            throw new globalThis.Error("The parameter 'chatGroupId' cannot be null.");
        else if (chatGroupId !== undefined)
            url_ += "chatGroupId=" + encodeURIComponent("" + chatGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMessageUnRead(_response);
        });
    }

    protected processUpdateMessageUnRead(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getList(body: ClassGetListFilter | undefined, cancelToken?: CancelToken): Promise<FilterResult_1OfClassListDto> {
        let url_ = this.baseUrl + "/api/v1/class/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<FilterResult_1OfClassListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilterResult_1OfClassListDto.fromJS(resultData200);
            return Promise.resolve<FilterResult_1OfClassListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilterResult_1OfClassListDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    classGetById(id: number | undefined, cancelToken?: CancelToken): Promise<ClassDetailDto> {
        let url_ = this.baseUrl + "/api/v1/class/get-by-id?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClassGetById(_response);
        });
    }

    protected processClassGetById(response: AxiosResponse): Promise<ClassDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ClassDetailDto.fromJS(resultData200);
            return Promise.resolve<ClassDetailDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClassDetailDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    classSave(body: ClassEntity | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/v1/class/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClassSave(_response);
        });
    }

    protected processClassSave(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    classLinkProduct(body: ClassLinkProductCommand | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/class/link-product";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClassLinkProduct(_response);
        });
    }

    protected processClassLinkProduct(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    classDelete(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/class/delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClassDelete(_response);
        });
    }

    protected processClassDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    classChangeClass(body: ClassChangeClassCommand | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/class/change-class";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClassChangeClass(_response);
        });
    }

    protected processClassChangeClass(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    classAddListUser(body: ClassAddListUserCommand | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/class/add-list-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClassAddListUser(_response);
        });
    }

    protected processClassAddListUser(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    classAddTeacher(body: ClassUserEntity[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/class/add-teacher";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClassAddTeacher(_response);
        });
    }

    protected processClassAddTeacher(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    classAssignTeacher(body: ClassAssignTeacherDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/class/assign-teacher";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClassAssignTeacher(_response);
        });
    }

    protected processClassAssignTeacher(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    classUpdateManager(body: TeacherUpdateManagerCommand | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/class/update-manager";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClassUpdateManager(_response);
        });
    }

    protected processClassUpdateManager(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    classRemoveUser(body: ClassRemoveUserCommand | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/class/remove-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClassRemoveUser(_response);
        });
    }

    protected processClassRemoveUser(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    classRemoveProduct(body: ClassRemoveProductCommand | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/class/remove-product";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClassRemoveProduct(_response);
        });
    }

    protected processClassRemoveProduct(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    classCheckZoomSlot(body: ClassCheckZoomSlotCommand | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/class/check-zoom-slot";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClassCheckZoomSlot(_response);
        });
    }

    protected processClassCheckZoomSlot(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getPupilInClass(body: PupilFilterDto | undefined, cancelToken?: CancelToken): Promise<FilterResult_1OfPupilListDto> {
        let url_ = this.baseUrl + "/api/v1/class/get-pupil-in-class";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPupilInClass(_response);
        });
    }

    protected processGetPupilInClass(response: AxiosResponse): Promise<FilterResult_1OfPupilListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilterResult_1OfPupilListDto.fromJS(resultData200);
            return Promise.resolve<FilterResult_1OfPupilListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilterResult_1OfPupilListDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getPupilNotInClass(body: PupilFilterDto | undefined, cancelToken?: CancelToken): Promise<FilterResult_1OfPupilListDto> {
        let url_ = this.baseUrl + "/api/v1/class/get-pupil-not-in-class";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPupilNotInClass(_response);
        });
    }

    protected processGetPupilNotInClass(response: AxiosResponse): Promise<FilterResult_1OfPupilListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilterResult_1OfPupilListDto.fromJS(resultData200);
            return Promise.resolve<FilterResult_1OfPupilListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilterResult_1OfPupilListDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getTeacherNotInClass(body: TeacherFilterDto | undefined, cancelToken?: CancelToken): Promise<FilterResult_1OfTeacherListDto> {
        let url_ = this.baseUrl + "/api/v1/class/get-teacher-not-in-class";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTeacherNotInClass(_response);
        });
    }

    protected processGetTeacherNotInClass(response: AxiosResponse): Promise<FilterResult_1OfTeacherListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilterResult_1OfTeacherListDto.fromJS(resultData200);
            return Promise.resolve<FilterResult_1OfTeacherListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilterResult_1OfTeacherListDto>(null as any);
    }

    /**
     * @param classId (optional) 
     * @return OK
     */
    pupilExport(classId: number | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/class/pupil-export?";
        if (classId === null)
            throw new globalThis.Error("The parameter 'classId' cannot be null.");
        else if (classId !== undefined)
            url_ += "classId=" + encodeURIComponent("" + classId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPupilExport(_response);
        });
    }

    protected processPupilExport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getTeacherInClass(body: TeacherFilterDto | undefined, cancelToken?: CancelToken): Promise<FilterResult_1OfTeacherListDto> {
        let url_ = this.baseUrl + "/api/v1/class/get-teacher-in-class";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTeacherInClass(_response);
        });
    }

    protected processGetTeacherInClass(response: AxiosResponse): Promise<FilterResult_1OfTeacherListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilterResult_1OfTeacherListDto.fromJS(resultData200);
            return Promise.resolve<FilterResult_1OfTeacherListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilterResult_1OfTeacherListDto>(null as any);
    }

    /**
     * @param classId (optional) 
     * @return OK
     */
    teacherExport(classId: number | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/class/teacher-export?";
        if (classId === null)
            throw new globalThis.Error("The parameter 'classId' cannot be null.");
        else if (classId !== undefined)
            url_ += "classId=" + encodeURIComponent("" + classId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTeacherExport(_response);
        });
    }

    protected processTeacherExport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    teacherUpdateSubjects(body: TeacherUpdateSubjectsCommand | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/class/teacher-update-subjects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTeacherUpdateSubjects(_response);
        });
    }

    protected processTeacherUpdateSubjects(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    dowloadTempTeacher( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/class/template-import-teacher";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDowloadTempTeacher(_response);
        });
    }

    protected processDowloadTempTeacher(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param classId (optional) 
     * @param file (optional) 
     * @return OK
     */
    importTeacher(classId: number | undefined, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/class/import-teacher?";
        if (classId === null)
            throw new globalThis.Error("The parameter 'classId' cannot be null.");
        else if (classId !== undefined)
            url_ += "classId=" + encodeURIComponent("" + classId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportTeacher(_response);
        });
    }

    protected processImportTeacher(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return OK
     */
    dowloadTempPupil( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/class/template-import-pupil";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDowloadTempPupil(_response);
        });
    }

    protected processDowloadTempPupil(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param classId (optional) 
     * @param file (optional) 
     * @return OK
     */
    importPupil(classId: number | undefined, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/class/import-pupil?";
        if (classId === null)
            throw new globalThis.Error("The parameter 'classId' cannot be null.");
        else if (classId !== undefined)
            url_ += "classId=" + encodeURIComponent("" + classId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportPupil(_response);
        });
    }

    protected processImportPupil(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param classId (optional) 
     * @return OK
     */
    getClassStatistical(classId: number | undefined, cancelToken?: CancelToken): Promise<ClassStatisticalDto> {
        let url_ = this.baseUrl + "/api/v1/class/class-statistical?";
        if (classId === null)
            throw new globalThis.Error("The parameter 'classId' cannot be null.");
        else if (classId !== undefined)
            url_ += "classId=" + encodeURIComponent("" + classId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetClassStatistical(_response);
        });
    }

    protected processGetClassStatistical(response: AxiosResponse): Promise<ClassStatisticalDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ClassStatisticalDto.fromJS(resultData200);
            return Promise.resolve<ClassStatisticalDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClassStatisticalDto>(null as any);
    }

    /**
     * @param classId (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    getAssignExamTopAverageScores(classId: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<TopAverageScoreDto[]> {
        let url_ = this.baseUrl + "/api/v1/class/assign-exam-top-average-scores?";
        if (classId === null)
            throw new globalThis.Error("The parameter 'classId' cannot be null.");
        else if (classId !== undefined)
            url_ += "classId=" + encodeURIComponent("" + classId) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssignExamTopAverageScores(_response);
        });
    }

    protected processGetAssignExamTopAverageScores(response: AxiosResponse): Promise<TopAverageScoreDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TopAverageScoreDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TopAverageScoreDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TopAverageScoreDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAssignExamResult(body: ExamResultFilterDto | undefined, cancelToken?: CancelToken): Promise<FilterResult_1OfExamResultDto> {
        let url_ = this.baseUrl + "/api/v1/class/assign-exam-result";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssignExamResult(_response);
        });
    }

    protected processGetAssignExamResult(response: AxiosResponse): Promise<FilterResult_1OfExamResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilterResult_1OfExamResultDto.fromJS(resultData200);
            return Promise.resolve<FilterResult_1OfExamResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilterResult_1OfExamResultDto>(null as any);
    }

    /**
     * @param classId (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    getAssignExamTopNeedsToDoHomework(classId: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<TopNeedsToDoHomeworkDto[]> {
        let url_ = this.baseUrl + "/api/v1/class/assign-exam-top-needs-to-do-homework?";
        if (classId === null)
            throw new globalThis.Error("The parameter 'classId' cannot be null.");
        else if (classId !== undefined)
            url_ += "classId=" + encodeURIComponent("" + classId) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssignExamTopNeedsToDoHomework(_response);
        });
    }

    protected processGetAssignExamTopNeedsToDoHomework(response: AxiosResponse): Promise<TopNeedsToDoHomeworkDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TopNeedsToDoHomeworkDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TopNeedsToDoHomeworkDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TopNeedsToDoHomeworkDto[]>(null as any);
    }

    /**
     * @param classId (optional) 
     * @return OK
     */
    getAssignExamResultExport(classId: number | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/class/assign-exam-result-export?";
        if (classId === null)
            throw new globalThis.Error("The parameter 'classId' cannot be null.");
        else if (classId !== undefined)
            url_ += "classId=" + encodeURIComponent("" + classId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssignExamResultExport(_response);
        });
    }

    protected processGetAssignExamResultExport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAssignExamListByClass(body: AssignExamListByClassQuery | undefined, cancelToken?: CancelToken): Promise<FilterResult_1OfAssignExamListDto> {
        let url_ = this.baseUrl + "/api/v1/class/assign-exam-list-by-class";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssignExamListByClass(_response);
        });
    }

    protected processGetAssignExamListByClass(response: AxiosResponse): Promise<FilterResult_1OfAssignExamListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilterResult_1OfAssignExamListDto.fromJS(resultData200);
            return Promise.resolve<FilterResult_1OfAssignExamListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilterResult_1OfAssignExamListDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    assignExamAdd(body: AssignExamAddDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/class/assign-exam-add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignExamAdd(_response);
        });
    }

    protected processAssignExamAdd(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAssignExamListUsers(body: AssignExamListUserFilterDto | undefined, cancelToken?: CancelToken): Promise<AssignExamListUserDto[]> {
        let url_ = this.baseUrl + "/api/v1/class/assign-exam-list-users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssignExamListUsers(_response);
        });
    }

    protected processGetAssignExamListUsers(response: AxiosResponse): Promise<AssignExamListUserDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssignExamListUserDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AssignExamListUserDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssignExamListUserDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    assignExamUpdateTime(body: AssignExamUpdateTimeDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/class/assign-exam-update-time";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignExamUpdateTime(_response);
        });
    }

    protected processAssignExamUpdateTime(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    assignExamGetById(id: number | undefined, cancelToken?: CancelToken): Promise<AssignExamEditDto> {
        let url_ = this.baseUrl + "/api/v1/class/assign-exam-get-by-id?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignExamGetById(_response);
        });
    }

    protected processAssignExamGetById(response: AxiosResponse): Promise<AssignExamEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssignExamEditDto.fromJS(resultData200);
            return Promise.resolve<AssignExamEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssignExamEditDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    assignExamGetDetail(id: number | undefined, cancelToken?: CancelToken): Promise<AssignExamDetailDto> {
        let url_ = this.baseUrl + "/api/v1/class/assign-exam-get-detail?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignExamGetDetail(_response);
        });
    }

    protected processAssignExamGetDetail(response: AxiosResponse): Promise<AssignExamDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssignExamDetailDto.fromJS(resultData200);
            return Promise.resolve<AssignExamDetailDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssignExamDetailDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    assignExamUpdateNote(body: AssignExamUpdateNoteDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/class/assign-exam-update-note";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignExamUpdateNote(_response);
        });
    }

    protected processAssignExamUpdateNote(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param assignExamId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    assignExamUserGetNote(assignExamId: number | undefined, userId: number | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/class/assign-exam-user-get-note?";
        if (assignExamId === null)
            throw new globalThis.Error("The parameter 'assignExamId' cannot be null.");
        else if (assignExamId !== undefined)
            url_ += "assignExamId=" + encodeURIComponent("" + assignExamId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignExamUserGetNote(_response);
        });
    }

    protected processAssignExamUserGetNote(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param classId (optional) 
     * @return OK
     */
    getClassWithPupils(classId: number | undefined, cancelToken?: CancelToken): Promise<SchoolClassDto[]> {
        let url_ = this.baseUrl + "/api/v1/class/class-with-pupils?";
        if (classId === null)
            throw new globalThis.Error("The parameter 'classId' cannot be null.");
        else if (classId !== undefined)
            url_ += "classId=" + encodeURIComponent("" + classId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetClassWithPupils(_response);
        });
    }

    protected processGetClassWithPupils(response: AxiosResponse): Promise<SchoolClassDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SchoolClassDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<SchoolClassDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SchoolClassDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    pupilChangePassword(body: PupilChangePasswordCommand | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/class/pupil-change-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPupilChangePassword(_response);
        });
    }

    protected processPupilChangePassword(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    pupilAddMulti(body: PupilAddMultiCommand | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/class/pupil-add-multi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPupilAddMulti(_response);
        });
    }

    protected processPupilAddMulti(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param pageSize (optional) 
     * @return OK
     */
    getClassOfPupil(pageSize: number | undefined, cancelToken?: CancelToken): Promise<ClassPupilDto[]> {
        let url_ = this.baseUrl + "/api/v1/class/class-of-pupil?";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetClassOfPupil(_response);
        });
    }

    protected processGetClassOfPupil(response: AxiosResponse): Promise<ClassPupilDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClassPupilDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ClassPupilDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClassPupilDto[]>(null as any);
    }

    /**
     * @param classId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    teacherGetSubject(classId: number | undefined, userId: number | undefined, cancelToken?: CancelToken): Promise<CategoryEntity[]> {
        let url_ = this.baseUrl + "/api/v1/class/teacher-get-subject?";
        if (classId === null)
            throw new globalThis.Error("The parameter 'classId' cannot be null.");
        else if (classId !== undefined)
            url_ += "classId=" + encodeURIComponent("" + classId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTeacherGetSubject(_response);
        });
    }

    protected processTeacherGetSubject(response: AxiosResponse): Promise<CategoryEntity[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CategoryEntity.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CategoryEntity[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryEntity[]>(null as any);
    }

    /**
     * @param schoolId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    classGetByUser(schoolId: number | undefined, userId: number | undefined, cancelToken?: CancelToken): Promise<ClassByUserDto[]> {
        let url_ = this.baseUrl + "/api/v1/class/class-get-by-user?";
        if (schoolId === null)
            throw new globalThis.Error("The parameter 'schoolId' cannot be null.");
        else if (schoolId !== undefined)
            url_ += "schoolId=" + encodeURIComponent("" + schoolId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClassGetByUser(_response);
        });
    }

    protected processClassGetByUser(response: AxiosResponse): Promise<ClassByUserDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClassByUserDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ClassByUserDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClassByUserDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getClassListOfSchool(body: ClassListOfSchoolFilter | undefined, cancelToken?: CancelToken): Promise<FilterResult_1OfClassListOfSchoolDto> {
        let url_ = this.baseUrl + "/api/v1/class/class-list-of-school";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetClassListOfSchool(_response);
        });
    }

    protected processGetClassListOfSchool(response: AxiosResponse): Promise<FilterResult_1OfClassListOfSchoolDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilterResult_1OfClassListOfSchoolDto.fromJS(resultData200);
            return Promise.resolve<FilterResult_1OfClassListOfSchoolDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilterResult_1OfClassListOfSchoolDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    pupilCopyFromClass(body: PupilCopyFromClassCommand | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/class/pupil-copy-from-class";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPupilCopyFromClass(_response);
        });
    }

    protected processPupilCopyFromClass(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param classId (optional) 
     * @return OK
     */
    pupilCheckGoToClass(classId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfPupilCheckGoToClassDto> {
        let url_ = this.baseUrl + "/api/v1/class/pupil-check-go-to-class?";
        if (classId === null)
            throw new globalThis.Error("The parameter 'classId' cannot be null.");
        else if (classId !== undefined)
            url_ += "classId=" + encodeURIComponent("" + classId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPupilCheckGoToClass(_response);
        });
    }

    protected processPupilCheckGoToClass(response: AxiosResponse): Promise<ApiResponse_1OfPupilCheckGoToClassDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfPupilCheckGoToClassDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfPupilCheckGoToClassDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfPupilCheckGoToClassDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    pupilGoToClass(body: PupilGoToClassCommand | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/class/pupil-go-to-class";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPupilGoToClass(_response);
        });
    }

    protected processPupilGoToClass(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    classEnrollPupilByOrder(body: ClassEnrollPupilByOrderCommand | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/class/enroll-by-order";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClassEnrollPupilByOrder(_response);
        });
    }

    protected processClassEnrollPupilByOrder(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param classId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    classAnalysisData(classId: number | undefined, userId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfAiResponse> {
        let url_ = this.baseUrl + "/api/v1/class/class-analysis-data?";
        if (classId === null)
            throw new globalThis.Error("The parameter 'classId' cannot be null.");
        else if (classId !== undefined)
            url_ += "classId=" + encodeURIComponent("" + classId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClassAnalysisData(_response);
        });
    }

    protected processClassAnalysisData(response: AxiosResponse): Promise<ApiResponse_1OfAiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfAiResponse.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfAiResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfAiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    classSaveSession(body: ClassSaveSessionDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfInt64> {
        let url_ = this.baseUrl + "/api/v1/class/save-session";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClassSaveSession(_response);
        });
    }

    protected processClassSaveSession(response: AxiosResponse): Promise<ApiResponse_1OfInt64> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfInt64.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfInt64>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfInt64>(null as any);
    }

    /**
     * @param classId (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @return OK
     */
    classGetSessions(classId: number | undefined, from: Date | undefined, to: Date | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfClassSessionDto> {
        let url_ = this.baseUrl + "/api/v1/class/get-sessions?";
        if (classId === null)
            throw new globalThis.Error("The parameter 'classId' cannot be null.");
        else if (classId !== undefined)
            url_ += "classId=" + encodeURIComponent("" + classId) + "&";
        if (from === null)
            throw new globalThis.Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new globalThis.Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClassGetSessions(_response);
        });
    }

    protected processClassGetSessions(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfClassSessionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfClassSessionDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfClassSessionDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfClassSessionDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    consultationRegistrationSave(body: ConsultationRegistrationSaveDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfConsultationRegistrationEntity> {
        let url_ = this.baseUrl + "/api/v1/consultation-registration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConsultationRegistrationSave(_response);
        });
    }

    protected processConsultationRegistrationSave(response: AxiosResponse): Promise<ApiResponse_1OfConsultationRegistrationEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfConsultationRegistrationEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfConsultationRegistrationEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfConsultationRegistrationEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    consultationRegistrationGetList(body: ConsultationRegistrationGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfConsultationRegistrationListDto> {
        let url_ = this.baseUrl + "/api/v1/consultation-registration/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConsultationRegistrationGetList(_response);
        });
    }

    protected processConsultationRegistrationGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfConsultationRegistrationListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfConsultationRegistrationListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfConsultationRegistrationListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfConsultationRegistrationListDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    consultationRegistrationUpdateStatus(id: number, body: ConsultationRegistrationUpdateStatusRequest | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/consultation-registration/update-status/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConsultationRegistrationUpdateStatus(_response);
        });
    }

    protected processConsultationRegistrationUpdateStatus(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    contactSave(body: ContactSaveDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfContactEntity> {
        let url_ = this.baseUrl + "/api/v1/contact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processContactSave(_response);
        });
    }

    protected processContactSave(response: AxiosResponse): Promise<ApiResponse_1OfContactEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfContactEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfContactEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfContactEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    contactGetList(body: ContactGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfContactListDto> {
        let url_ = this.baseUrl + "/api/v1/contact/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processContactGetList(_response);
        });
    }

    protected processContactGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfContactListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfContactListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfContactListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfContactListDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    contactUpdateStatus(id: number, body: ContactUpdateStatusRequest | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/contact/update-status/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processContactUpdateStatus(_response);
        });
    }

    protected processContactUpdateStatus(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param objectType (optional) 
     * @param objectId (optional) 
     * @return OK
     */
    departmentGetList(objectType: ObjectOwnerTypeEnum | undefined, objectId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfDepartmentEntity> {
        let url_ = this.baseUrl + "/api/v1/department/list?";
        if (objectType === null)
            throw new globalThis.Error("The parameter 'objectType' cannot be null.");
        else if (objectType !== undefined)
            url_ += "objectType=" + encodeURIComponent("" + objectType) + "&";
        if (objectId === null)
            throw new globalThis.Error("The parameter 'objectId' cannot be null.");
        else if (objectId !== undefined)
            url_ += "objectId=" + encodeURIComponent("" + objectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDepartmentGetList(_response);
        });
    }

    protected processDepartmentGetList(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfDepartmentEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfDepartmentEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfDepartmentEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfDepartmentEntity>(null as any);
    }

    /**
     * @param objectType (optional) 
     * @param objectId (optional) 
     * @return OK
     */
    departmentMenuGet(objectType: ObjectOwnerTypeEnum | undefined, objectId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfDepartmentMenuNodeDto> {
        let url_ = this.baseUrl + "/api/v1/department/menu?";
        if (objectType === null)
            throw new globalThis.Error("The parameter 'objectType' cannot be null.");
        else if (objectType !== undefined)
            url_ += "objectType=" + encodeURIComponent("" + objectType) + "&";
        if (objectId === null)
            throw new globalThis.Error("The parameter 'objectId' cannot be null.");
        else if (objectId !== undefined)
            url_ += "objectId=" + encodeURIComponent("" + objectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDepartmentMenuGet(_response);
        });
    }

    protected processDepartmentMenuGet(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfDepartmentMenuNodeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfDepartmentMenuNodeDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfDepartmentMenuNodeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfDepartmentMenuNodeDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    departmentSave(body: DepartmentSaveRequest | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfDepartmentEntity> {
        let url_ = this.baseUrl + "/api/v1/department/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDepartmentSave(_response);
        });
    }

    protected processDepartmentSave(response: AxiosResponse): Promise<ApiResponse_1OfDepartmentEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfDepartmentEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfDepartmentEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfDepartmentEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    departmentSaveList(body: DepartmentSaveListRequest | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfDepartmentEntity> {
        let url_ = this.baseUrl + "/api/v1/department/save-list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDepartmentSaveList(_response);
        });
    }

    protected processDepartmentSaveList(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfDepartmentEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfDepartmentEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfDepartmentEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfDepartmentEntity>(null as any);
    }

    /**
     * @param objectType (optional) 
     * @return OK
     */
    departmentSeedFixed(objectType: ObjectOwnerTypeEnum | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfDepartmentEntity> {
        let url_ = this.baseUrl + "/api/v1/department/seed-fixed?";
        if (objectType === null)
            throw new globalThis.Error("The parameter 'objectType' cannot be null.");
        else if (objectType !== undefined)
            url_ += "objectType=" + encodeURIComponent("" + objectType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDepartmentSeedFixed(_response);
        });
    }

    protected processDepartmentSeedFixed(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfDepartmentEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfDepartmentEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfDepartmentEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfDepartmentEntity>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    departmentDelete(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/department/delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDepartmentDelete(_response);
        });
    }

    protected processDepartmentDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param departmentId (optional) 
     * @return OK
     */
    departmentRoles(departmentId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfDepartmentRoleDto> {
        let url_ = this.baseUrl + "/api/v1/department/roles?";
        if (departmentId === null)
            throw new globalThis.Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDepartmentRoles(_response);
        });
    }

    protected processDepartmentRoles(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfDepartmentRoleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfDepartmentRoleDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfDepartmentRoleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfDepartmentRoleDto>(null as any);
    }

    /**
     * @param roleId (optional) 
     * @param departmentId (optional) 
     * @return OK
     */
    departmentRoleGetById(roleId: number | undefined, departmentId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfDepartmentRoleDto> {
        let url_ = this.baseUrl + "/api/v1/department/role?";
        if (roleId === null)
            throw new globalThis.Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "roleId=" + encodeURIComponent("" + roleId) + "&";
        if (departmentId === null)
            throw new globalThis.Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDepartmentRoleGetById(_response);
        });
    }

    protected processDepartmentRoleGetById(response: AxiosResponse): Promise<ApiResponse_1OfDepartmentRoleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfDepartmentRoleDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfDepartmentRoleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfDepartmentRoleDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    departmentRoleSave(body: DepartmentRoleSaveRequest | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfDepartmentRoleDto> {
        let url_ = this.baseUrl + "/api/v1/department/role/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDepartmentRoleSave(_response);
        });
    }

    protected processDepartmentRoleSave(response: AxiosResponse): Promise<ApiResponse_1OfDepartmentRoleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfDepartmentRoleDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfDepartmentRoleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfDepartmentRoleDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    departmentRoleSaveList(body: DepartmentRoleSaveListRequest | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfDepartmentRoleDto> {
        let url_ = this.baseUrl + "/api/v1/department/role/save-list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDepartmentRoleSaveList(_response);
        });
    }

    protected processDepartmentRoleSaveList(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfDepartmentRoleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfDepartmentRoleDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfDepartmentRoleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfDepartmentRoleDto>(null as any);
    }

    /**
     * @param roleId (optional) 
     * @param departmentId (optional) 
     * @return OK
     */
    departmentRoleDelete(roleId: number | undefined, departmentId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/department/role/delete?";
        if (roleId === null)
            throw new globalThis.Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "roleId=" + encodeURIComponent("" + roleId) + "&";
        if (departmentId === null)
            throw new globalThis.Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDepartmentRoleDelete(_response);
        });
    }

    protected processDepartmentRoleDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param departmentId (optional) 
     * @param objectType (optional) 
     * @param objectId (optional) 
     * @return OK
     */
    departmentUsers(departmentId: number | undefined, objectType: ObjectOwnerTypeEnum | undefined, objectId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfDepartmentUserEntity> {
        let url_ = this.baseUrl + "/api/v1/department/users?";
        if (departmentId === null)
            throw new globalThis.Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (objectType === null)
            throw new globalThis.Error("The parameter 'objectType' cannot be null.");
        else if (objectType !== undefined)
            url_ += "objectType=" + encodeURIComponent("" + objectType) + "&";
        if (objectId === null)
            throw new globalThis.Error("The parameter 'objectId' cannot be null.");
        else if (objectId !== undefined)
            url_ += "objectId=" + encodeURIComponent("" + objectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDepartmentUsers(_response);
        });
    }

    protected processDepartmentUsers(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfDepartmentUserEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfDepartmentUserEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfDepartmentUserEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfDepartmentUserEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    departmentUserSave(body: DepartmentUserSaveRequest | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfDepartmentUserEntity> {
        let url_ = this.baseUrl + "/api/v1/department/user/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDepartmentUserSave(_response);
        });
    }

    protected processDepartmentUserSave(response: AxiosResponse): Promise<ApiResponse_1OfDepartmentUserEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfDepartmentUserEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfDepartmentUserEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfDepartmentUserEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    departmentUserSaveList(body: DepartmentUserSaveListRequest | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfDepartmentUserEntity> {
        let url_ = this.baseUrl + "/api/v1/department/user/save-list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDepartmentUserSaveList(_response);
        });
    }

    protected processDepartmentUserSaveList(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfDepartmentUserEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfDepartmentUserEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfDepartmentUserEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfDepartmentUserEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    departmentUserSaveByUser(body: DepartmentUserSaveByUserRequest | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfDepartmentUserEntity> {
        let url_ = this.baseUrl + "/api/v1/department/user/save-by-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDepartmentUserSaveByUser(_response);
        });
    }

    protected processDepartmentUserSaveByUser(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfDepartmentUserEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfDepartmentUserEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfDepartmentUserEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfDepartmentUserEntity>(null as any);
    }

    /**
     * @param departmentUserId (optional) 
     * @return OK
     */
    departmentUserLeave(departmentUserId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/department/user/leave?";
        if (departmentUserId === null)
            throw new globalThis.Error("The parameter 'departmentUserId' cannot be null.");
        else if (departmentUserId !== undefined)
            url_ += "departmentUserId=" + encodeURIComponent("" + departmentUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDepartmentUserLeave(_response);
        });
    }

    protected processDepartmentUserLeave(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    getStatus( cancelToken?: CancelToken): Promise<ApiResponse_1OfObject> {
        let url_ = this.baseUrl + "/api/v1/documents/status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStatus(_response);
        });
    }

    protected processGetStatus(response: AxiosResponse): Promise<ApiResponse_1OfObject> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfObject.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfObject>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfObject>(null as any);
    }

    /**
     * @return OK
     */
    exportSrsToWord( cancelToken?: CancelToken): Promise<ApiResponse_1OfObject> {
        let url_ = this.baseUrl + "/api/v1/documents/export/srs-word";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportSrsToWord(_response);
        });
    }

    protected processExportSrsToWord(response: AxiosResponse): Promise<ApiResponse_1OfObject> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfObject.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfObject>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfObject>(null as any);
    }

    /**
     * @return OK
     */
    exportBrdToWord( cancelToken?: CancelToken): Promise<ApiResponse_1OfObject> {
        let url_ = this.baseUrl + "/api/v1/documents/export/brd-word";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportBrdToWord(_response);
        });
    }

    protected processExportBrdToWord(response: AxiosResponse): Promise<ApiResponse_1OfObject> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfObject.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfObject>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfObject>(null as any);
    }

    /**
     * @return OK
     */
    getBrdDocumentInfo( cancelToken?: CancelToken): Promise<ApiResponse_1OfDocumentInfo> {
        let url_ = this.baseUrl + "/api/v1/documents/brd/info";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBrdDocumentInfo(_response);
        });
    }

    protected processGetBrdDocumentInfo(response: AxiosResponse): Promise<ApiResponse_1OfDocumentInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfDocumentInfo.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfDocumentInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfDocumentInfo>(null as any);
    }

    /**
     * @return OK
     */
    getSrsDocumentInfo( cancelToken?: CancelToken): Promise<ApiResponse_1OfDocumentInfo> {
        let url_ = this.baseUrl + "/api/v1/documents/srs/info";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSrsDocumentInfo(_response);
        });
    }

    protected processGetSrsDocumentInfo(response: AxiosResponse): Promise<ApiResponse_1OfDocumentInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfDocumentInfo.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfDocumentInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfDocumentInfo>(null as any);
    }

    /**
     * @return OK
     */
    previewBrdFile(fileName: string, cancelToken?: CancelToken): Promise<ApiResponse_1OfDocumentPreviewResponse> {
        let url_ = this.baseUrl + "/api/v1/documents/brd/preview/{fileName}";
        if (fileName === undefined || fileName === null)
            throw new globalThis.Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPreviewBrdFile(_response);
        });
    }

    protected processPreviewBrdFile(response: AxiosResponse): Promise<ApiResponse_1OfDocumentPreviewResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfDocumentPreviewResponse.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfDocumentPreviewResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfDocumentPreviewResponse>(null as any);
    }

    /**
     * @return OK
     */
    previewSrsFile(fileName: string, cancelToken?: CancelToken): Promise<ApiResponse_1OfDocumentPreviewResponse> {
        let url_ = this.baseUrl + "/api/v1/documents/srs/preview/{fileName}";
        if (fileName === undefined || fileName === null)
            throw new globalThis.Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPreviewSrsFile(_response);
        });
    }

    protected processPreviewSrsFile(response: AxiosResponse): Promise<ApiResponse_1OfDocumentPreviewResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfDocumentPreviewResponse.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfDocumentPreviewResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfDocumentPreviewResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    examGetList(body: ExamGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfExamListDto> {
        let url_ = this.baseUrl + "/api/v1/exam/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExamGetList(_response);
        });
    }

    protected processExamGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfExamListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfExamListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfExamListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfExamListDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    examGetById(id: number | undefined, cancelToken?: CancelToken): Promise<ExamDto> {
        let url_ = this.baseUrl + "/api/v1/exam/get-by-id?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExamGetById(_response);
        });
    }

    protected processExamGetById(response: AxiosResponse): Promise<ExamDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExamDto.fromJS(resultData200);
            return Promise.resolve<ExamDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExamDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    examGetDetail(id: number | undefined, cancelToken?: CancelToken): Promise<ExamDto> {
        let url_ = this.baseUrl + "/api/v1/exam/get-detail?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExamGetDetail(_response);
        });
    }

    protected processExamGetDetail(response: AxiosResponse): Promise<ExamDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExamDto.fromJS(resultData200);
            return Promise.resolve<ExamDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExamDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    examGetByLearn(id: number | undefined, cancelToken?: CancelToken): Promise<ExamLearnDto> {
        let url_ = this.baseUrl + "/api/v1/exam/get-by-learn?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExamGetByLearn(_response);
        });
    }

    protected processExamGetByLearn(response: AxiosResponse): Promise<ExamLearnDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExamLearnDto.fromJS(resultData200);
            return Promise.resolve<ExamLearnDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExamLearnDto>(null as any);
    }

    /**
     * @param byImport (optional) 
     * @param body (optional) 
     * @return OK
     */
    examSave(byImport: boolean | undefined, body: ExamSaveDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfExamSaveDto> {
        let url_ = this.baseUrl + "/api/v1/exam/save?";
        if (byImport === null)
            throw new globalThis.Error("The parameter 'byImport' cannot be null.");
        else if (byImport !== undefined)
            url_ += "byImport=" + encodeURIComponent("" + byImport) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExamSave(_response);
        });
    }

    protected processExamSave(response: AxiosResponse): Promise<ApiResponse_1OfExamSaveDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfExamSaveDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfExamSaveDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfExamSaveDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    examDelete(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/exam/delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExamDelete(_response);
        });
    }

    protected processExamDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    examCheckDataBeforeDelete(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfExamDataBeforeDeleteDto> {
        let url_ = this.baseUrl + "/api/v1/exam/ckeck-data-delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExamCheckDataBeforeDelete(_response);
        });
    }

    protected processExamCheckDataBeforeDelete(response: AxiosResponse): Promise<ApiResponse_1OfExamDataBeforeDeleteDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfExamDataBeforeDeleteDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfExamDataBeforeDeleteDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfExamDataBeforeDeleteDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    examSaveFile(body: ExamFileSaveDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfInt64> {
        let url_ = this.baseUrl + "/api/v1/exam/save-file";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExamSaveFile(_response);
        });
    }

    protected processExamSaveFile(response: AxiosResponse): Promise<ApiResponse_1OfInt64> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfInt64.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfInt64>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfInt64>(null as any);
    }

    /**
     * @param formFile (optional) 
     * @return OK
     */
    examImport(formFile: FileParameter | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfExamDto> {
        let url_ = this.baseUrl + "/api/v1/exam/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formFile === null || formFile === undefined)
            throw new globalThis.Error("The parameter 'formFile' cannot be null.");
        else
            content_.append("formFile", formFile.data, formFile.fileName ? formFile.fileName : "formFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExamImport(_response);
        });
    }

    protected processExamImport(response: AxiosResponse): Promise<ApiResponse_1OfExamDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfExamDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfExamDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfExamDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    examShare(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/exam/share?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExamShare(_response);
        });
    }

    protected processExamShare(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    examShareRevoke(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/exam/share-revoke?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExamShareRevoke(_response);
        });
    }

    protected processExamShareRevoke(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    examShareApprove(id: number | undefined, target: ShareTargetEnum, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/exam/share-approve?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ += "target=" + encodeURIComponent("" + target) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExamShare(_response);
        });
    }

    examShareReject(id: number | undefined, target: ShareTargetEnum, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/exam/share-reject?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ += "target=" + encodeURIComponent("" + target) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExamShare(_response);
        });
    }

    /**
     * @return OK
     */
    getChildren( cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfFamilyMemberDto> {
        let url_ = this.baseUrl + "/api/v1/family/children";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetChildren(_response);
        });
    }

    protected processGetChildren(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfFamilyMemberDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfFamilyMemberDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfFamilyMemberDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfFamilyMemberDto>(null as any);
    }

    /**
     * @return OK
     */
    getParents( cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfFamilyMemberDto> {
        let url_ = this.baseUrl + "/api/v1/family/parents";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetParents(_response);
        });
    }

    protected processGetParents(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfFamilyMemberDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfFamilyMemberDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfFamilyMemberDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfFamilyMemberDto>(null as any);
    }

    /**
     * @return OK
     */
    getQuota( cancelToken?: CancelToken): Promise<ApiResponse_1OfFamilyQuotaDto> {
        let url_ = this.baseUrl + "/api/v1/family/quota";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuota(_response);
        });
    }

    protected processGetQuota(response: AxiosResponse): Promise<ApiResponse_1OfFamilyQuotaDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFamilyQuotaDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFamilyQuotaDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFamilyQuotaDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    linkChild(body: FamilyLinkByIdentifierDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/family/link-child";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLinkChild(_response);
        });
    }

    protected processLinkChild(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    linkParent(body: FamilyLinkByIdentifierDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/family/link-parent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLinkParent(_response);
        });
    }

    protected processLinkParent(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    accept(familyLinkId: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/family/accept/{familyLinkId}";
        if (familyLinkId === undefined || familyLinkId === null)
            throw new globalThis.Error("The parameter 'familyLinkId' must be defined.");
        url_ = url_.replace("{familyLinkId}", encodeURIComponent("" + familyLinkId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAccept(_response);
        });
    }

    protected processAccept(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    reject(familyLinkId: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/family/reject/{familyLinkId}";
        if (familyLinkId === undefined || familyLinkId === null)
            throw new globalThis.Error("The parameter 'familyLinkId' must be defined.");
        url_ = url_.replace("{familyLinkId}", encodeURIComponent("" + familyLinkId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReject(_response);
        });
    }

    protected processReject(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    removeLink(familyLinkId: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/family/{familyLinkId}";
        if (familyLinkId === undefined || familyLinkId === null)
            throw new globalThis.Error("The parameter 'familyLinkId' must be defined.");
        url_ = url_.replace("{familyLinkId}", encodeURIComponent("" + familyLinkId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveLink(_response);
        });
    }

    protected processRemoveLink(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createChild(body: FamilyCreateChildDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/family/create-child";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateChild(_response);
        });
    }

    protected processCreateChild(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    sendResetChildPasswordOtp(childUserId: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfOtpSendResultDto> {
        let url_ = this.baseUrl + "/api/v1/family/reset-child-password/send-otp/{childUserId}";
        if (childUserId === undefined || childUserId === null)
            throw new globalThis.Error("The parameter 'childUserId' must be defined.");
        url_ = url_.replace("{childUserId}", encodeURIComponent("" + childUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendResetChildPasswordOtp(_response);
        });
    }

    protected processSendResetChildPasswordOtp(response: AxiosResponse): Promise<ApiResponse_1OfOtpSendResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfOtpSendResultDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfOtpSendResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfOtpSendResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    resetChildPassword(body: FamilyResetChildPasswordDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/family/reset-child-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetChildPassword(_response);
        });
    }

    protected processResetChildPassword(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    becomeIndependent( cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/family/become-independent";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBecomeIndependent(_response);
        });
    }

    protected processBecomeIndependent(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param idQuery (optional) 
     * @return OK
     */
    fileGetById(idQuery: number | undefined, idPath: string, cancelToken?: CancelToken): Promise<FileEntity> {
        let url_ = this.baseUrl + "/api/v1/file/{id}?";
        if (idPath === undefined || idPath === null)
            throw new globalThis.Error("The parameter 'idPath' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + idPath));
        if (idQuery === null)
            throw new globalThis.Error("The parameter 'idQuery' cannot be null.");
        else if (idQuery !== undefined)
            url_ += "Id=" + encodeURIComponent("" + idQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFileGetById(_response);
        });
    }

    protected processFileGetById(response: AxiosResponse): Promise<FileEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileEntity.fromJS(resultData200);
            return Promise.resolve<FileEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileEntity>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    fileGetMetaById(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfFileMetaDataEntity> {
        let url_ = this.baseUrl + "/api/v1/file/get-meta?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFileGetMetaById(_response);
        });
    }

    protected processFileGetMetaById(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfFileMetaDataEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfFileMetaDataEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfFileMetaDataEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfFileMetaDataEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    fileUpdate(body: FileUpdateCommand | undefined, cancelToken?: CancelToken): Promise<FileEntity> {
        let url_ = this.baseUrl + "/api/v1/file";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFileUpdate(_response);
        });
    }

    protected processFileUpdate(response: AxiosResponse): Promise<FileEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileEntity.fromJS(resultData200);
            return Promise.resolve<FileEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    fileUpdateAvatar(body: FileUpdateAvatarCommand | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/file/avatar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFileUpdateAvatar(_response);
        });
    }

    protected processFileUpdateAvatar(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    fileUpdateName(body: FileUpdateNameCommand | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/file/name";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFileUpdateName(_response);
        });
    }

    protected processFileUpdateName(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    fileUpdateStatus(body: FileUpdateStatusCommand | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/file/status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFileUpdateStatus(_response);
        });
    }

    protected processFileUpdateStatus(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    fileGetList(body: FileGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfFileEntity> {
        let url_ = this.baseUrl + "/api/v1/file/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFileGetList(_response);
        });
    }

    protected processFileGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfFileEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfFileEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfFileEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfFileEntity>(null as any);
    }

    /**
     * @param request (optional) 
     * @return OK
     */
    folderGetAll(request: FolderGetAllQuery | undefined, cancelToken?: CancelToken): Promise<FolderEntity[]> {
        let url_ = this.baseUrl + "/api/v1/file/folder-all?";
        if (request === null)
            throw new globalThis.Error("The parameter 'request' cannot be null.");
        else if (request !== undefined)
            url_ += "request=" + encodeURIComponent("" + request) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFolderGetAll(_response);
        });
    }

    protected processFolderGetAll(response: AxiosResponse): Promise<FolderEntity[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FolderEntity.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<FolderEntity[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FolderEntity[]>(null as any);
    }

    /**
     * @param idQuery (optional) 
     * @return OK
     */
    folderGetById(idQuery: number | undefined, idPath: string, cancelToken?: CancelToken): Promise<FolderEntity> {
        let url_ = this.baseUrl + "/api/v1/file/folder/{id}?";
        if (idPath === undefined || idPath === null)
            throw new globalThis.Error("The parameter 'idPath' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + idPath));
        if (idQuery === null)
            throw new globalThis.Error("The parameter 'idQuery' cannot be null.");
        else if (idQuery !== undefined)
            url_ += "Id=" + encodeURIComponent("" + idQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFolderGetById(_response);
        });
    }

    protected processFolderGetById(response: AxiosResponse): Promise<FolderEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FolderEntity.fromJS(resultData200);
            return Promise.resolve<FolderEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FolderEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    folderUpdate(body: FolderUpdateCommand | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFolderEntity> {
        let url_ = this.baseUrl + "/api/v1/file/folder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFolderUpdate(_response);
        });
    }

    protected processFolderUpdate(response: AxiosResponse): Promise<ApiResponse_1OfFolderEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFolderEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFolderEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFolderEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    folderGetList(body: FolderGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfFolderNodeDto> {
        let url_ = this.baseUrl + "/api/v1/file/folder/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFolderGetList(_response);
        });
    }

    protected processFolderGetList(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfFolderNodeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfFolderNodeDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfFolderNodeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfFolderNodeDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    folderDelete(body: FolderDeleteCommand | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/file/folder/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFolderDelete(_response);
        });
    }

    protected processFolderDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param url (optional) 
     * @return OK
     */
    uploadByUrl(url: string | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFileUploadByUrlResponseDto> {
        let url_ = this.baseUrl + "/api/v1/file/file/upload-by-url?";
        if (url === null)
            throw new globalThis.Error("The parameter 'url' cannot be null.");
        else if (url !== undefined)
            url_ += "url=" + encodeURIComponent("" + url) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadByUrl(_response);
        });
    }

    protected processUploadByUrl(response: AxiosResponse): Promise<ApiResponse_1OfFileUploadByUrlResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFileUploadByUrlResponseDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFileUploadByUrlResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFileUploadByUrlResponseDto>(null as any);
    }

    /**
     * @return OK
     */
    galleryGetById(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfGallerySaveDto> {
        let url_ = this.baseUrl + "/api/v1/gallery/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGalleryGetById(_response);
        });
    }

    protected processGalleryGetById(response: AxiosResponse): Promise<ApiResponse_1OfGallerySaveDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfGallerySaveDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfGallerySaveDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfGallerySaveDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveGallery(body: GallerySaveDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfGalleryEntity> {
        let url_ = this.baseUrl + "/api/v1/gallery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveGallery(_response);
        });
    }

    protected processSaveGallery(response: AxiosResponse): Promise<ApiResponse_1OfGalleryEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfGalleryEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfGalleryEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfGalleryEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    galleryGetList(body: GalleryGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfGalleryListDto> {
        let url_ = this.baseUrl + "/api/v1/gallery/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGalleryGetList(_response);
        });
    }

    protected processGalleryGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfGalleryListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfGalleryListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfGalleryListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfGalleryListDto>(null as any);
    }

    /**
     * @return OK
     */
    galleryDelete(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/gallery/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGalleryDelete(_response);
        });
    }

    protected processGalleryDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    languageGetActive( cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfLanguageListDto> {
        let url_ = this.baseUrl + "/api/v1/languages";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLanguageGetActive(_response);
        });
    }

    protected processLanguageGetActive(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfLanguageListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfLanguageListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfLanguageListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfLanguageListDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    languageSave(body: LanguageSaveDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfLanguageEntity> {
        let url_ = this.baseUrl + "/api/v1/languages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLanguageSave(_response);
        });
    }

    protected processLanguageSave(response: AxiosResponse): Promise<ApiResponse_1OfLanguageEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfLanguageEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfLanguageEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfLanguageEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    languageGetList(body: LanguageGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfLanguageListDto> {
        let url_ = this.baseUrl + "/api/v1/languages/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLanguageGetList(_response);
        });
    }

    protected processLanguageGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfLanguageListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfLanguageListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfLanguageListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfLanguageListDto>(null as any);
    }

    /**
     * @return OK
     */
    languageGetById(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfLanguageListDto> {
        let url_ = this.baseUrl + "/api/v1/languages/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLanguageGetById(_response);
        });
    }

    protected processLanguageGetById(response: AxiosResponse): Promise<ApiResponse_1OfLanguageListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfLanguageListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfLanguageListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfLanguageListDto>(null as any);
    }

    /**
     * @return OK
     */
    languageDelete(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/languages/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLanguageDelete(_response);
        });
    }

    protected processLanguageDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    lessonHistorySave(body: LessonHistorySaveCommand | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/lesson-history/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLessonHistorySave(_response);
        });
    }

    protected processLessonHistorySave(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    lessonHistoryGetByProduct(productId: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfLessonCompletionDto> {
        let url_ = this.baseUrl + "/api/v1/lesson-history/by-product/{productId}";
        if (productId === undefined || productId === null)
            throw new globalThis.Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLessonHistoryGetByProduct(_response);
        });
    }

    protected processLessonHistoryGetByProduct(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfLessonCompletionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfLessonCompletionDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfLessonCompletionDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfLessonCompletionDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    lessonHistoryGetOrCreateZoomLink(body: LessonHistoryGetOrCreateZoomLinkQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfLessonHistoryZoomLinkResultDto> {
        let url_ = this.baseUrl + "/api/v1/lesson-history/zoom-join-link";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLessonHistoryGetOrCreateZoomLink(_response);
        });
    }

    protected processLessonHistoryGetOrCreateZoomLink(response: AxiosResponse): Promise<ApiResponse_1OfLessonHistoryZoomLinkResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfLessonHistoryZoomLinkResultDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfLessonHistoryZoomLinkResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfLessonHistoryZoomLinkResultDto>(null as any);
    }

    /**
     * @return OK
     */
    lessonHistoryGetZoomJoinCredentialsBySession(sessionId: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfLessonHistoryZoomCredentialsResultDto> {
        let url_ = this.baseUrl + "/api/v1/lesson-history/zoom-join-credentials/{sessionId}";
        if (sessionId === undefined || sessionId === null)
            throw new globalThis.Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLessonHistoryGetZoomJoinCredentialsBySession(_response);
        });
    }

    protected processLessonHistoryGetZoomJoinCredentialsBySession(response: AxiosResponse): Promise<ApiResponse_1OfLessonHistoryZoomCredentialsResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfLessonHistoryZoomCredentialsResultDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfLessonHistoryZoomCredentialsResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfLessonHistoryZoomCredentialsResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    lessonHistoryGetZoomJoinCredentials(body: LessonHistoryGetZoomJoinCredentialsQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfLessonHistoryZoomCredentialsResultDto> {
        let url_ = this.baseUrl + "/api/v1/lesson-history/zoom-join-credentials";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLessonHistoryGetZoomJoinCredentials(_response);
        });
    }

    protected processLessonHistoryGetZoomJoinCredentials(response: AxiosResponse): Promise<ApiResponse_1OfLessonHistoryZoomCredentialsResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfLessonHistoryZoomCredentialsResultDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfLessonHistoryZoomCredentialsResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfLessonHistoryZoomCredentialsResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    localityGetById(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfLocalityEntity> {
        let url_ = this.baseUrl + "/api/v1/locality/get-by-id?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLocalityGetById(_response);
        });
    }

    protected processLocalityGetById(response: AxiosResponse): Promise<ApiResponse_1OfLocalityEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfLocalityEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfLocalityEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfLocalityEntity>(null as any);
    }

    /**
     * @return OK
     */
    localityGetByIds( cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfLocalityEntity> {
        let url_ = this.baseUrl + "/api/v1/locality/ids";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLocalityGetByIds(_response);
        });
    }

    protected processLocalityGetByIds(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfLocalityEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfLocalityEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfLocalityEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfLocalityEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    localityGetList(body: LocalityGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfLocalityEntity> {
        let url_ = this.baseUrl + "/api/v1/locality/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLocalityGetList(_response);
        });
    }

    protected processLocalityGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfLocalityEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfLocalityEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfLocalityEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfLocalityEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    localitySave(body: LocalityEntity | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfLocalityEntity> {
        let url_ = this.baseUrl + "/api/v1/locality/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLocalitySave(_response);
        });
    }

    protected processLocalitySave(response: AxiosResponse): Promise<ApiResponse_1OfLocalityEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfLocalityEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfLocalityEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfLocalityEntity>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    localityDelete(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/locality/delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLocalityDelete(_response);
        });
    }

    protected processLocalityDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param app (optional) 
     * @return OK
     */
    moduleGetList(app: ApplicationEnum | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfModuleDefinitionDto> {
        let url_ = this.baseUrl + "/api/v1/module/list?";
        if (app === null)
            throw new globalThis.Error("The parameter 'app' cannot be null.");
        else if (app !== undefined)
            url_ += "app=" + encodeURIComponent("" + app) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processModuleGetList(_response);
        });
    }

    protected processModuleGetList(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfModuleDefinitionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfModuleDefinitionDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfModuleDefinitionDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfModuleDefinitionDto>(null as any);
    }

    /**
     * @param app (optional) 
     * @return OK
     */
    moduleGetAdminList(app: ApplicationEnum | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfModuleDefinitionDto> {
        let url_ = this.baseUrl + "/api/v1/module/admin-list?";
        if (app === null)
            throw new globalThis.Error("The parameter 'app' cannot be null.");
        else if (app !== undefined)
            url_ += "app=" + encodeURIComponent("" + app) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processModuleGetAdminList(_response);
        });
    }

    protected processModuleGetAdminList(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfModuleDefinitionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfModuleDefinitionDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfModuleDefinitionDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfModuleDefinitionDto>(null as any);
    }

    /**
     * @return OK
     */
    moduleGetById(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfModuleDefinitionDto> {
        let url_ = this.baseUrl + "/api/v1/module/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processModuleGetById(_response);
        });
    }

    protected processModuleGetById(response: AxiosResponse): Promise<ApiResponse_1OfModuleDefinitionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfModuleDefinitionDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfModuleDefinitionDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfModuleDefinitionDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    moduleSave(body: ModuleDefinitionSaveDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/module/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processModuleSave(_response);
        });
    }

    protected processModuleSave(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param app (optional) 
     * @return OK
     */
    moduleGetListLegacy(app: ApplicationEnum | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfEnumListEntity> {
        let url_ = this.baseUrl + "/api/v1/module/list-legacy?";
        if (app === null)
            throw new globalThis.Error("The parameter 'app' cannot be null.");
        else if (app !== undefined)
            url_ += "app=" + encodeURIComponent("" + app) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processModuleGetListLegacy(_response);
        });
    }

    protected processModuleGetListLegacy(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfEnumListEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfEnumListEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfEnumListEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfEnumListEntity>(null as any);
    }

    /**
     * @return OK
     */
    newsGetById(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfNewsDetailDto> {
        let url_ = this.baseUrl + "/api/v1/news/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNewsGetById(_response);
        });
    }

    protected processNewsGetById(response: AxiosResponse): Promise<ApiResponse_1OfNewsDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfNewsDetailDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfNewsDetailDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfNewsDetailDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveNews(body: NewsSaveDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfNewsEntity> {
        let url_ = this.baseUrl + "/api/v1/news";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveNews(_response);
        });
    }

    protected processSaveNews(response: AxiosResponse): Promise<ApiResponse_1OfNewsEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfNewsEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfNewsEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfNewsEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    newsGetList(body: NewsGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfNewsListDto> {
        let url_ = this.baseUrl + "/api/v1/news/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNewsGetList(_response);
        });
    }

    protected processNewsGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfNewsListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfNewsListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfNewsListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfNewsListDto>(null as any);
    }

    /**
     * @return OK
     */
    newsDelete(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/news/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNewsDelete(_response);
        });
    }

    protected processNewsDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    getNotifications(page: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<FilterResult_1OfNotificationDto> {
        let url_ = this.baseUrl + "/api/v1/notification/list?";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNotifications(_response);
        });
    }

    protected processGetNotifications(response: AxiosResponse): Promise<FilterResult_1OfNotificationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilterResult_1OfNotificationDto.fromJS(resultData200);
            return Promise.resolve<FilterResult_1OfNotificationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilterResult_1OfNotificationDto>(null as any);
    }

    /**
     * @return OK
     */
    notificationMarkAsRead(notificationId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/notification/{notificationId}/mark-as-read";
        if (notificationId === undefined || notificationId === null)
            throw new globalThis.Error("The parameter 'notificationId' must be defined.");
        url_ = url_.replace("{notificationId}", encodeURIComponent("" + notificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNotificationMarkAsRead(_response);
        });
    }

    protected processNotificationMarkAsRead(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    notificationMarkAllAsRead( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/notification/mark-all-as-read";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNotificationMarkAllAsRead(_response);
        });
    }

    protected processNotificationMarkAllAsRead(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    notificationCountUnRead( cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/v1/notification/count-un-read";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNotificationCountUnRead(_response);
        });
    }

    protected processNotificationCountUnRead(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    objectLikeSave(body: ObjectLikeSaveCommand | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/objectlike/object-like-save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processObjectLikeSave(_response);
        });
    }

    protected processObjectLikeSave(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    officeGetList(body: OfficeGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfOfficeDto> {
        let url_ = this.baseUrl + "/api/v1/office/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOfficeGetList(_response);
        });
    }

    protected processOfficeGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfOfficeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfOfficeDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfOfficeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfOfficeDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    orderCreate(body: OrderCreateDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfOrderPaymentDto> {
        let url_ = this.baseUrl + "/api/v1/order/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrderCreate(_response);
        });
    }

    protected processOrderCreate(response: AxiosResponse): Promise<ApiResponse_1OfOrderPaymentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfOrderPaymentDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfOrderPaymentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfOrderPaymentDto>(null as any);
    }

    /**
     * @return OK
     */
    orderGetPurchaseTargets( cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfPurchaseTargetDto> {
        let url_ = this.baseUrl + "/api/v1/order/purchase-targets";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrderGetPurchaseTargets(_response);
        });
    }

    protected processOrderGetPurchaseTargets(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfPurchaseTargetDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfPurchaseTargetDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfPurchaseTargetDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfPurchaseTargetDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    orderGetList(body: OrderGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfOrderDto> {
        let url_ = this.baseUrl + "/api/v1/order/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrderGetList(_response);
        });
    }

    protected processOrderGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfOrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfOrderDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfOrderDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfOrderDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    orderGetListMy(body: OrderGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfOrderDto> {
        let url_ = this.baseUrl + "/api/v1/order/list-my";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrderGetListMy(_response);
        });
    }

    protected processOrderGetListMy(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfOrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfOrderDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfOrderDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfOrderDto>(null as any);
    }

    /**
     * @return OK
     */
    orderGetById(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfOrderDto> {
        let url_ = this.baseUrl + "/api/v1/order/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrderGetById(_response);
        });
    }

    protected processOrderGetById(response: AxiosResponse): Promise<ApiResponse_1OfOrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfOrderDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfOrderDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfOrderDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    orderUpdate(id: number, body: OrderUpdateDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/order/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrderUpdate(_response);
        });
    }

    protected processOrderUpdate(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    orderUpdateStatus(id: number, body: OrderStatusEnum | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/order/{id}/status";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrderUpdateStatus(_response);
        });
    }

    protected processOrderUpdateStatus(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    orderUpdateNotes(id: number, body: string | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/order/{id}/notes";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrderUpdateNotes(_response);
        });
    }

    protected processOrderUpdateNotes(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    orderCreateWithClass(body: OrderCreateWithClassDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfOrderEntity> {
        let url_ = this.baseUrl + "/api/v1/order/create-with-class";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrderCreateWithClass(_response);
        });
    }

    protected processOrderCreateWithClass(response: AxiosResponse): Promise<ApiResponse_1OfOrderEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfOrderEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfOrderEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfOrderEntity>(null as any);
    }

    /**
     * @return OK
     */
    orderCheckPaid(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/order/check-paid/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrderCheckPaid(_response);
        });
    }

    protected processOrderCheckPaid(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    orderGetPayment(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfOrderPaymentDto> {
        let url_ = this.baseUrl + "/api/v1/order/payment/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrderGetPayment(_response);
        });
    }

    protected processOrderGetPayment(response: AxiosResponse): Promise<ApiResponse_1OfOrderPaymentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfOrderPaymentDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfOrderPaymentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfOrderPaymentDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sePayWebHook(body: SePayNotifyResource | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/order/sepay-webhook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSePayWebHook(_response);
        });
    }

    protected processSePayWebHook(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    organizationGetList(body: OrganizationGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfOrganizationListDto> {
        let url_ = this.baseUrl + "/api/v1/organization/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrganizationGetList(_response);
        });
    }

    protected processOrganizationGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfOrganizationListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfOrganizationListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfOrganizationListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfOrganizationListDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    organizationGetById(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfOrganizationDto> {
        let url_ = this.baseUrl + "/api/v1/organization/get-by-id?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrganizationGetById(_response);
        });
    }

    protected processOrganizationGetById(response: AxiosResponse): Promise<ApiResponse_1OfOrganizationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfOrganizationDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfOrganizationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfOrganizationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    organizationSave(body: OrganizationEntity | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfOrganizationEntity> {
        let url_ = this.baseUrl + "/api/v1/organization/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrganizationSave(_response);
        });
    }

    protected processOrganizationSave(response: AxiosResponse): Promise<ApiResponse_1OfOrganizationEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfOrganizationEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfOrganizationEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfOrganizationEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    organizationCreateByPersonal(body: OrganizationCreateRequest | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfOrganizationEntity> {
        let url_ = this.baseUrl + "/api/v1/organization/create-by-personal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrganizationCreateByPersonal(_response);
        });
    }

    protected processOrganizationCreateByPersonal(response: AxiosResponse): Promise<ApiResponse_1OfOrganizationEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfOrganizationEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfOrganizationEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfOrganizationEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    organizationCreateByAdmin(body: OrganizationCreateRequest | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfOrganizationEntity> {
        let url_ = this.baseUrl + "/api/v1/organization/create-by-admin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrganizationCreateByAdmin(_response);
        });
    }

    protected processOrganizationCreateByAdmin(response: AxiosResponse): Promise<ApiResponse_1OfOrganizationEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfOrganizationEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfOrganizationEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfOrganizationEntity>(null as any);
    }

    /**
     * @param objectId (optional) 
     * @return OK
     */
    organizationApprove(objectId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfOrganizationEntity> {
        let url_ = this.baseUrl + "/api/v1/organization/approve?";
        if (objectId === null)
            throw new globalThis.Error("The parameter 'objectId' cannot be null.");
        else if (objectId !== undefined)
            url_ += "objectId=" + encodeURIComponent("" + objectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrganizationApprove(_response);
        });
    }

    protected processOrganizationApprove(response: AxiosResponse): Promise<ApiResponse_1OfOrganizationEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfOrganizationEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfOrganizationEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfOrganizationEntity>(null as any);
    }

    /**
     * @param objectId (optional) 
     * @param reason (optional) 
     * @return OK
     */
    organizationReject(objectId: number | undefined, reason: string | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfOrganizationEntity> {
        let url_ = this.baseUrl + "/api/v1/organization/reject?";
        if (objectId === null)
            throw new globalThis.Error("The parameter 'objectId' cannot be null.");
        else if (objectId !== undefined)
            url_ += "objectId=" + encodeURIComponent("" + objectId) + "&";
        if (reason === null)
            throw new globalThis.Error("The parameter 'reason' cannot be null.");
        else if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrganizationReject(_response);
        });
    }

    protected processOrganizationReject(response: AxiosResponse): Promise<ApiResponse_1OfOrganizationEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfOrganizationEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfOrganizationEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfOrganizationEntity>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    organizationDelete(id: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/organization/delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrganizationDelete(_response);
        });
    }

    protected processOrganizationDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    userObjectAdd(body: UserObjectAddDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfInt64> {
        let url_ = this.baseUrl + "/api/v1/organization/user-add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserObjectAdd(_response);
        });
    }

    protected processUserObjectAdd(response: AxiosResponse): Promise<ApiResponse_1OfInt64> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfInt64.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfInt64>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfInt64>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    userObjectRemove(body: UserObjectRemoveDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/organization/user-remove";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserObjectRemove(_response);
        });
    }

    protected processUserObjectRemove(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    userObjectUpdateRoles(body: UserObjectRolesDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/organization/user-roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserObjectUpdateRoles(_response);
        });
    }

    protected processUserObjectUpdateRoles(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    userObjectUpdateSubjects(body: UserObjectSubjectsDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfInt64> {
        let url_ = this.baseUrl + "/api/v1/organization/user-subjects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserObjectUpdateSubjects(_response);
        });
    }

    protected processUserObjectUpdateSubjects(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfInt64> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfInt64.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfInt64>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfInt64>(null as any);
    }

    /**
     * @return OK
     */
    userObjectGetList(userId: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfUserObjectDto> {
        let url_ = this.baseUrl + "/api/v1/organization/by-user/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserObjectGetList(_response);
        });
    }

    protected processUserObjectGetList(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfUserObjectDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfUserObjectDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfUserObjectDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfUserObjectDto>(null as any);
    }

    /**
     * @return OK
     */
    userObjectInviteInbox( cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfUserObjectInviteDto> {
        let url_ = this.baseUrl + "/api/v1/organization/user-invites/inbox";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserObjectInviteInbox(_response);
        });
    }

    protected processUserObjectInviteInbox(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfUserObjectInviteDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfUserObjectInviteDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfUserObjectInviteDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfUserObjectInviteDto>(null as any);
    }

    /**
     * @param objectType (optional) 
     * @param objectId (optional) 
     * @return OK
     */
    userObjectInviteList(objectType: ObjectOwnerTypeEnum | undefined, objectId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfUserObjectInviteDto> {
        let url_ = this.baseUrl + "/api/v1/organization/user-invites?";
        if (objectType === null)
            throw new globalThis.Error("The parameter 'objectType' cannot be null.");
        else if (objectType !== undefined)
            url_ += "objectType=" + encodeURIComponent("" + objectType) + "&";
        if (objectId === null)
            throw new globalThis.Error("The parameter 'objectId' cannot be null.");
        else if (objectId !== undefined)
            url_ += "objectId=" + encodeURIComponent("" + objectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserObjectInviteList(_response);
        });
    }

    protected processUserObjectInviteList(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfUserObjectInviteDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfUserObjectInviteDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfUserObjectInviteDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfUserObjectInviteDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    userObjectInviteAccept(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/organization/user-invite/accept?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserObjectInviteAccept(_response);
        });
    }

    protected processUserObjectInviteAccept(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    userObjectInviteReject(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/organization/user-invite/reject?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserObjectInviteReject(_response);
        });
    }

    protected processUserObjectInviteReject(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    userObjectInviteCancel(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/organization/user-invite/cancel?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserObjectInviteCancel(_response);
        });
    }

    protected processUserObjectInviteCancel(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    ownershipTransferRequest(body: OwnershipTransferRequestDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfOwnershipTransferEntity> {
        let url_ = this.baseUrl + "/api/v1/ownership/transfer/request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOwnershipTransferRequest(_response);
        });
    }

    protected processOwnershipTransferRequest(response: AxiosResponse): Promise<ApiResponse_1OfOwnershipTransferEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfOwnershipTransferEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfOwnershipTransferEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfOwnershipTransferEntity>(null as any);
    }

    /**
     * @param transferId (optional) 
     * @return OK
     */
    ownershipTransferAccept(transferId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/ownership/transfer/accept?";
        if (transferId === null)
            throw new globalThis.Error("The parameter 'transferId' cannot be null.");
        else if (transferId !== undefined)
            url_ += "transferId=" + encodeURIComponent("" + transferId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOwnershipTransferAccept(_response);
        });
    }

    protected processOwnershipTransferAccept(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param transferId (optional) 
     * @return OK
     */
    ownershipTransferReject(transferId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/ownership/transfer/reject?";
        if (transferId === null)
            throw new globalThis.Error("The parameter 'transferId' cannot be null.");
        else if (transferId !== undefined)
            url_ += "transferId=" + encodeURIComponent("" + transferId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOwnershipTransferReject(_response);
        });
    }

    protected processOwnershipTransferReject(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param transferId (optional) 
     * @return OK
     */
    ownershipTransferCancel(transferId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/ownership/transfer/cancel?";
        if (transferId === null)
            throw new globalThis.Error("The parameter 'transferId' cannot be null.");
        else if (transferId !== undefined)
            url_ += "transferId=" + encodeURIComponent("" + transferId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOwnershipTransferCancel(_response);
        });
    }

    protected processOwnershipTransferCancel(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    ownershipTransferInbox( cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfOwnershipTransferDto> {
        let url_ = this.baseUrl + "/api/v1/ownership/transfer/inbox";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOwnershipTransferInbox(_response);
        });
    }

    protected processOwnershipTransferInbox(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfOwnershipTransferDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfOwnershipTransferDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfOwnershipTransferDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfOwnershipTransferDto>(null as any);
    }

    /**
     * @param objectType (optional) 
     * @param objectId (optional) 
     * @return OK
     */
    ownershipTransferList(objectType: ObjectOwnerTypeEnum | undefined, objectId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfOwnershipTransferDto> {
        let url_ = this.baseUrl + "/api/v1/ownership/transfer/list?";
        if (objectType === null)
            throw new globalThis.Error("The parameter 'objectType' cannot be null.");
        else if (objectType !== undefined)
            url_ += "objectType=" + encodeURIComponent("" + objectType) + "&";
        if (objectId === null)
            throw new globalThis.Error("The parameter 'objectId' cannot be null.");
        else if (objectId !== undefined)
            url_ += "objectId=" + encodeURIComponent("" + objectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOwnershipTransferList(_response);
        });
    }

    protected processOwnershipTransferList(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfOwnershipTransferDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfOwnershipTransferDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfOwnershipTransferDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfOwnershipTransferDto>(null as any);
    }

    /**
     * @param classId (optional) 
     * @return OK
     */
    productGetMyCourse(classId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfUserProductDto> {
        let url_ = this.baseUrl + "/api/v1/product/my-course?";
        if (classId === null)
            throw new globalThis.Error("The parameter 'classId' cannot be null.");
        else if (classId !== undefined)
            url_ += "classId=" + encodeURIComponent("" + classId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProductGetMyCourse(_response);
        });
    }

    protected processProductGetMyCourse(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfUserProductDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfUserProductDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfUserProductDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfUserProductDto>(null as any);
    }

    /**
     * @return OK
     */
    productGetById(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfProductSaveDto> {
        let url_ = this.baseUrl + "/api/v1/product/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProductGetById(_response);
        });
    }

    protected processProductGetById(response: AxiosResponse): Promise<ApiResponse_1OfProductSaveDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfProductSaveDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfProductSaveDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfProductSaveDto>(null as any);
    }

    /**
     * @param classId (optional) 
     * @return OK
     */
    productGetDetail(id: number, classId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfProductDetailDto> {
        let url_ = this.baseUrl + "/api/v1/product/detail/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (classId === null)
            throw new globalThis.Error("The parameter 'classId' cannot be null.");
        else if (classId !== undefined)
            url_ += "classId=" + encodeURIComponent("" + classId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProductGetDetail(_response);
        });
    }

    protected processProductGetDetail(response: AxiosResponse): Promise<ApiResponse_1OfProductDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfProductDetailDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfProductDetailDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfProductDetailDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveProduct(body: ProductSaveDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfProductEntity> {
        let url_ = this.baseUrl + "/api/v1/product";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveProduct(_response);
        });
    }

    protected processSaveProduct(response: AxiosResponse): Promise<ApiResponse_1OfProductEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfProductEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfProductEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfProductEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveProductLesson(body: ProductLessonSaveDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfProductLessonSaveDto> {
        let url_ = this.baseUrl + "/api/v1/product/lesson/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveProductLesson(_response);
        });
    }

    protected processSaveProductLesson(response: AxiosResponse): Promise<ApiResponse_1OfProductLessonSaveDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfProductLessonSaveDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfProductLessonSaveDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfProductLessonSaveDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveProductChapter(body: ProductChapterSaveDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfProductChapterSaveDto> {
        let url_ = this.baseUrl + "/api/v1/product/chapter/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveProductChapter(_response);
        });
    }

    protected processSaveProductChapter(response: AxiosResponse): Promise<ApiResponse_1OfProductChapterSaveDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfProductChapterSaveDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfProductChapterSaveDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfProductChapterSaveDto>(null as any);
    }

    /**
     * @return OK
     */
    deleteProductChapter(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/product/chapter/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteProductChapter(_response);
        });
    }

    protected processDeleteProductChapter(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    deleteProductLesson(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/product/lesson/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteProductLesson(_response);
        });
    }

    protected processDeleteProductLesson(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    productGetList(body: ProductGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfProductListDto> {
        let url_ = this.baseUrl + "/api/v1/product/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProductGetList(_response);
        });
    }

    protected processProductGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfProductListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfProductListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfProductListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfProductListDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    productDashboardGetList(body: ProductDashboardListFilter | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfProductDashboardListDto> {
        let url_ = this.baseUrl + "/api/v1/product/dashboard-list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProductDashboardGetList(_response);
        });
    }

    protected processProductDashboardGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfProductDashboardListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfProductDashboardListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfProductDashboardListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfProductDashboardListDto>(null as any);
    }

    /**
     * @return OK
     */
    productDelete(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/product/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProductDelete(_response);
        });
    }

    protected processProductDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    productReviewCreate(id: number, body: ProductReviewCreateDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfProductReviewEntity> {
        let url_ = this.baseUrl + "/api/v1/product/{id}/reviews";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProductReviewCreate(_response);
        });
    }

    protected processProductReviewCreate(response: AxiosResponse): Promise<ApiResponse_1OfProductReviewEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfProductReviewEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfProductReviewEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfProductReviewEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    productReviewGetList(id: number, body: ProductReviewGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfProductReviewListDto> {
        let url_ = this.baseUrl + "/api/v1/product/{id}/reviews/list";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProductReviewGetList(_response);
        });
    }

    protected processProductReviewGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfProductReviewListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfProductReviewListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfProductReviewListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfProductReviewListDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    productReviewApprove(id: number, body: ProductReviewApproveCommand | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/product/reviews/{id}/approve";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProductReviewApprove(_response);
        });
    }

    protected processProductReviewApprove(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    productReviewAdminList(body: ProductReviewGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfProductReviewListDto> {
        let url_ = this.baseUrl + "/api/v1/product/reviews/admin-list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProductReviewAdminList(_response);
        });
    }

    protected processProductReviewAdminList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfProductReviewListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfProductReviewListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfProductReviewListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfProductReviewListDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    productReviewGenerateAi(id: number, body: ProductReviewGenerateAiRequest | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfProductReviewEntity> {
        let url_ = this.baseUrl + "/api/v1/product/{id}/reviews/generate-ai";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProductReviewGenerateAi(_response);
        });
    }

    protected processProductReviewGenerateAi(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfProductReviewEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfProductReviewEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfProductReviewEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfProductReviewEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    productGetByIds(body: ProductGetByIdsQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfProductListDto> {
        let url_ = this.baseUrl + "/api/v1/product/by-ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProductGetByIds(_response);
        });
    }

    protected processProductGetByIds(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfProductListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfProductListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfProductListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfProductListDto>(null as any);
    }

    /**
     * @return OK
     */
    getPurchaseProductIds( cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfProductListDto> {
        let url_ = this.baseUrl + "/api/v1/product/purchase-config";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPurchaseProductIds(_response);
        });
    }

    protected processGetPurchaseProductIds(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfProductListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfProductListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfProductListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfProductListDto>(null as any);
    }

    /**
     * @param onlyAvailable (optional) 
     * @return OK
     */
    productGetClasses(id: number, onlyAvailable: boolean | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfProductClassDto> {
        let url_ = this.baseUrl + "/api/v1/product/{id}/classes?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (onlyAvailable === null)
            throw new globalThis.Error("The parameter 'onlyAvailable' cannot be null.");
        else if (onlyAvailable !== undefined)
            url_ += "onlyAvailable=" + encodeURIComponent("" + onlyAvailable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProductGetClasses(_response);
        });
    }

    protected processProductGetClasses(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfProductClassDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfProductClassDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfProductClassDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfProductClassDto>(null as any);
    }

    /**
     * @return OK
     */
    productGetClassesForEnroll(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfProductClassDto> {
        let url_ = this.baseUrl + "/api/v1/product/{id}/classes-enroll";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProductGetClassesForEnroll(_response);
        });
    }

    protected processProductGetClassesForEnroll(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfProductClassDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfProductClassDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfProductClassDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfProductClassDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    pupilGetList(body: PupilFilterDto | undefined, cancelToken?: CancelToken): Promise<FilterResult_1OfPupilListDto> {
        let url_ = this.baseUrl + "/api/v1/pupil/get-list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPupilGetList(_response);
        });
    }

    protected processPupilGetList(response: AxiosResponse): Promise<FilterResult_1OfPupilListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilterResult_1OfPupilListDto.fromJS(resultData200);
            return Promise.resolve<FilterResult_1OfPupilListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilterResult_1OfPupilListDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param schoolId (optional) 
     * @return OK
     */
    pupilGetById(id: number | undefined, schoolId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfPupilDetailDto> {
        let url_ = this.baseUrl + "/api/v1/pupil/get-by-id?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (schoolId === null)
            throw new globalThis.Error("The parameter 'schoolId' cannot be null.");
        else if (schoolId !== undefined)
            url_ += "schoolId=" + encodeURIComponent("" + schoolId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPupilGetById(_response);
        });
    }

    protected processPupilGetById(response: AxiosResponse): Promise<ApiResponse_1OfPupilDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfPupilDetailDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfPupilDetailDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfPupilDetailDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    pupilSaveProfile(body: UserProfileDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfUserProfileDto> {
        let url_ = this.baseUrl + "/api/v1/pupil/save-profile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPupilSaveProfile(_response);
        });
    }

    protected processPupilSaveProfile(response: AxiosResponse): Promise<ApiResponse_1OfUserProfileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfUserProfileDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfUserProfileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfUserProfileDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param schoolId (optional) 
     * @return OK
     */
    pupilGetClasses(id: number | undefined, schoolId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfPupilClassItemDto> {
        let url_ = this.baseUrl + "/api/v1/pupil/classes?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (schoolId === null)
            throw new globalThis.Error("The parameter 'schoolId' cannot be null.");
        else if (schoolId !== undefined)
            url_ += "schoolId=" + encodeURIComponent("" + schoolId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPupilGetClasses(_response);
        });
    }

    protected processPupilGetClasses(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfPupilClassItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfPupilClassItemDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfPupilClassItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfPupilClassItemDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    pupilGetCourses(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfPupilCourseItemDto> {
        let url_ = this.baseUrl + "/api/v1/pupil/courses?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPupilGetCourses(_response);
        });
    }

    protected processPupilGetCourses(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfPupilCourseItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfPupilCourseItemDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfPupilCourseItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfPupilCourseItemDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    pupilGetParents(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfFamilyMemberDto> {
        let url_ = this.baseUrl + "/api/v1/pupil/parents?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPupilGetParents(_response);
        });
    }

    protected processPupilGetParents(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfFamilyMemberDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfFamilyMemberDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfFamilyMemberDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfFamilyMemberDto>(null as any);
    }

    /**
     * @param classId (optional) 
     * @param userId (optional) 
     * @param subjectId (optional) 
     * @return OK
     */
    pupilStatic(classId: number | undefined, userId: number | undefined, subjectId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfPupilStaticDto> {
        let url_ = this.baseUrl + "/api/v1/pupil/pupil-static?";
        if (classId === null)
            throw new globalThis.Error("The parameter 'classId' cannot be null.");
        else if (classId !== undefined)
            url_ += "classId=" + encodeURIComponent("" + classId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (subjectId === null)
            throw new globalThis.Error("The parameter 'subjectId' cannot be null.");
        else if (subjectId !== undefined)
            url_ += "subjectId=" + encodeURIComponent("" + subjectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPupilStatic(_response);
        });
    }

    protected processPupilStatic(response: AxiosResponse): Promise<ApiResponse_1OfPupilStaticDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfPupilStaticDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfPupilStaticDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfPupilStaticDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    pupilHistoryDoExam(body: PupilHistoryDoExamFilterDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfPupilHistoryDoExamDto> {
        let url_ = this.baseUrl + "/api/v1/pupil/pupil-history-do-exam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPupilHistoryDoExam(_response);
        });
    }

    protected processPupilHistoryDoExam(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfPupilHistoryDoExamDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfPupilHistoryDoExamDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfPupilHistoryDoExamDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfPupilHistoryDoExamDto>(null as any);
    }

    /**
     * @param classId (optional) 
     * @param userId (optional) 
     * @param subjectId (optional) 
     * @return OK
     */
    pupilStaticByTypeExam(classId: number | undefined, userId: number | undefined, subjectId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfPupilStaticByTypeExamDto> {
        let url_ = this.baseUrl + "/api/v1/pupil/pupil-static-by-type-exam?";
        if (classId === null)
            throw new globalThis.Error("The parameter 'classId' cannot be null.");
        else if (classId !== undefined)
            url_ += "classId=" + encodeURIComponent("" + classId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (subjectId === null)
            throw new globalThis.Error("The parameter 'subjectId' cannot be null.");
        else if (subjectId !== undefined)
            url_ += "subjectId=" + encodeURIComponent("" + subjectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPupilStaticByTypeExam(_response);
        });
    }

    protected processPupilStaticByTypeExam(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfPupilStaticByTypeExamDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfPupilStaticByTypeExamDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfPupilStaticByTypeExamDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfPupilStaticByTypeExamDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    pupilStatisticalOfClass(body: ClassPupilStatisticalFilter | undefined, cancelToken?: CancelToken): Promise<FilterResult_1OfClassPupilStatisticalDto> {
        let url_ = this.baseUrl + "/api/v1/pupil/pupil-statistical-of-class";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPupilStatisticalOfClass(_response);
        });
    }

    protected processPupilStatisticalOfClass(response: AxiosResponse): Promise<FilterResult_1OfClassPupilStatisticalDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilterResult_1OfClassPupilStatisticalDto.fromJS(resultData200);
            return Promise.resolve<FilterResult_1OfClassPupilStatisticalDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilterResult_1OfClassPupilStatisticalDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    questionGetList(body: QuestionGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfQuestionListDto> {
        let url_ = this.baseUrl + "/api/v1/question/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuestionGetList(_response);
        });
    }

    protected processQuestionGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfQuestionListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfQuestionListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfQuestionListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfQuestionListDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    questionGetById(id: number | undefined, cancelToken?: CancelToken): Promise<QuestionDto> {
        let url_ = this.baseUrl + "/api/v1/question/get-by-id?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuestionGetById(_response);
        });
    }

    protected processQuestionGetById(response: AxiosResponse): Promise<QuestionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuestionDto.fromJS(resultData200);
            return Promise.resolve<QuestionDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuestionDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    questionGetByIds(body: number[] | undefined, cancelToken?: CancelToken): Promise<QuestionDto[]> {
        let url_ = this.baseUrl + "/api/v1/question/get-by-ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuestionGetByIds(_response);
        });
    }

    protected processQuestionGetByIds(response: AxiosResponse): Promise<QuestionDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuestionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<QuestionDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuestionDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    questionSave(body: QuestionDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfQuestionDto> {
        let url_ = this.baseUrl + "/api/v1/question/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuestionSave(_response);
        });
    }

    protected processQuestionSave(response: AxiosResponse): Promise<ApiResponse_1OfQuestionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfQuestionDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfQuestionDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfQuestionDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    questionDelete(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/question/delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuestionDelete(_response);
        });
    }

    protected processQuestionDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param formFile (optional) 
     * @return OK
     */
    questionImport(formFile: FileParameter | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfQuestionDto> {
        let url_ = this.baseUrl + "/api/v1/question/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formFile === null || formFile === undefined)
            throw new globalThis.Error("The parameter 'formFile' cannot be null.");
        else
            content_.append("formFile", formFile.data, formFile.fileName ? formFile.fileName : "formFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuestionImport(_response);
        });
    }

    protected processQuestionImport(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfQuestionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfQuestionDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfQuestionDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfQuestionDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    questionShare(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/question/share?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuestionShare(_response);
        });
    }

    protected processQuestionShare(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    questionShareRevoke(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/question/share-revoke?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuestionShareRevoke(_response);
        });
    }

    protected processQuestionShareRevoke(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    questionShareApprove(id: number | undefined, target: ShareTargetEnum, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/question/share-approve?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ += "target=" + encodeURIComponent("" + target) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuestionShare(_response);
        });
    }

    questionShareReject(id: number | undefined, target: ShareTargetEnum, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/question/share-reject?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ += "target=" + encodeURIComponent("" + target) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuestionShare(_response);
        });
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    roleSave(body: RoleDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfInt64> {
        let url_ = this.baseUrl + "/api/v1/role/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRoleSave(_response);
        });
    }

    protected processRoleSave(response: AxiosResponse): Promise<ApiResponse_1OfInt64> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfInt64.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfInt64>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfInt64>(null as any);
    }

    /**
     * @return OK
     */
    roleGetById(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfRoleDto> {
        let url_ = this.baseUrl + "/api/v1/role/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRoleGetById(_response);
        });
    }

    protected processRoleGetById(response: AxiosResponse): Promise<ApiResponse_1OfRoleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfRoleDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfRoleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfRoleDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @return OK
     */
    roleGetList(keyword: string | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfRoleDto> {
        let url_ = this.baseUrl + "/api/v1/role/list?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRoleGetList(_response);
        });
    }

    protected processRoleGetList(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfRoleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfRoleDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfRoleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfRoleDto>(null as any);
    }

    /**
     * @return OK
     */
    getListModule( cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfEnumListEntity> {
        let url_ = this.baseUrl + "/api/v1/role/list-module";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListModule(_response);
        });
    }

    protected processGetListModule(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfEnumListEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfEnumListEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfEnumListEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfEnumListEntity>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    roleDelete(id: string | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/role/delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRoleDelete(_response);
        });
    }

    protected processRoleDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    schoolGetList(body: SchoolGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfSchoolListDto> {
        let url_ = this.baseUrl + "/api/v1/school/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSchoolGetList(_response);
        });
    }

    protected processSchoolGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfSchoolListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfSchoolListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfSchoolListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfSchoolListDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    schoolGetById(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfSchoolDto> {
        let url_ = this.baseUrl + "/api/v1/school/get-by-id?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSchoolGetById(_response);
        });
    }

    protected processSchoolGetById(response: AxiosResponse): Promise<ApiResponse_1OfSchoolDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfSchoolDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfSchoolDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfSchoolDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    schoolSave(body: SchoolEntity | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfSchoolEntity> {
        let url_ = this.baseUrl + "/api/v1/school/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSchoolSave(_response);
        });
    }

    protected processSchoolSave(response: AxiosResponse): Promise<ApiResponse_1OfSchoolEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfSchoolEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfSchoolEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfSchoolEntity>(null as any);
    }

    /**
     * @param code (optional) 
     * @param excludeId (optional) 
     * @return OK
     */
    schoolCheckCode(code: string | undefined, excludeId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfSchoolCodeCheckDto> {
        let url_ = this.baseUrl + "/api/v1/school/check-code?";
        if (code === null)
            throw new globalThis.Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (excludeId === null)
            throw new globalThis.Error("The parameter 'excludeId' cannot be null.");
        else if (excludeId !== undefined)
            url_ += "excludeId=" + encodeURIComponent("" + excludeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSchoolCheckCode(_response);
        });
    }

    protected processSchoolCheckCode(response: AxiosResponse): Promise<ApiResponse_1OfSchoolCodeCheckDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfSchoolCodeCheckDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfSchoolCodeCheckDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfSchoolCodeCheckDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    schoolCreateByPersonal(body: SchoolCreateRequest | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfSchoolEntity> {
        let url_ = this.baseUrl + "/api/v1/school/create-by-personal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSchoolCreateByPersonal(_response);
        });
    }

    protected processSchoolCreateByPersonal(response: AxiosResponse): Promise<ApiResponse_1OfSchoolEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfSchoolEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfSchoolEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfSchoolEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    schoolUpdateByPersonal(body: SchoolUpdateByPersonalRequest | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfSchoolEntity> {
        let url_ = this.baseUrl + "/api/v1/school/update-by-personal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSchoolUpdateByPersonal(_response);
        });
    }

    protected processSchoolUpdateByPersonal(response: AxiosResponse): Promise<ApiResponse_1OfSchoolEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfSchoolEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfSchoolEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfSchoolEntity>(null as any);
    }

    /**
     * @param schoolId (optional) 
     * @return OK
     */
    schoolDeleteByPersonal(schoolId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/school/delete-by-personal?";
        if (schoolId === null)
            throw new globalThis.Error("The parameter 'schoolId' cannot be null.");
        else if (schoolId !== undefined)
            url_ += "schoolId=" + encodeURIComponent("" + schoolId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSchoolDeleteByPersonal(_response);
        });
    }

    protected processSchoolDeleteByPersonal(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    schoolCreateByAdmin(body: SchoolCreateRequest | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfSchoolEntity> {
        let url_ = this.baseUrl + "/api/v1/school/create-by-admin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSchoolCreateByAdmin(_response);
        });
    }

    protected processSchoolCreateByAdmin(response: AxiosResponse): Promise<ApiResponse_1OfSchoolEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfSchoolEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfSchoolEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfSchoolEntity>(null as any);
    }

    /**
     * @param schoolId (optional) 
     * @return OK
     */
    schoolApprove(schoolId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfSchoolEntity> {
        let url_ = this.baseUrl + "/api/v1/school/approve?";
        if (schoolId === null)
            throw new globalThis.Error("The parameter 'schoolId' cannot be null.");
        else if (schoolId !== undefined)
            url_ += "schoolId=" + encodeURIComponent("" + schoolId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSchoolApprove(_response);
        });
    }

    protected processSchoolApprove(response: AxiosResponse): Promise<ApiResponse_1OfSchoolEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfSchoolEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfSchoolEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfSchoolEntity>(null as any);
    }

    /**
     * @param schoolId (optional) 
     * @param reason (optional) 
     * @return OK
     */
    schoolReject(schoolId: number | undefined, reason: string | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfSchoolEntity> {
        let url_ = this.baseUrl + "/api/v1/school/reject?";
        if (schoolId === null)
            throw new globalThis.Error("The parameter 'schoolId' cannot be null.");
        else if (schoolId !== undefined)
            url_ += "schoolId=" + encodeURIComponent("" + schoolId) + "&";
        if (reason === null)
            throw new globalThis.Error("The parameter 'reason' cannot be null.");
        else if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSchoolReject(_response);
        });
    }

    protected processSchoolReject(response: AxiosResponse): Promise<ApiResponse_1OfSchoolEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfSchoolEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfSchoolEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfSchoolEntity>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    schoolDelete(id: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/school/delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSchoolDelete(_response);
        });
    }

    protected processSchoolDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param schoolId (optional) 
     * @param file (optional) 
     * @return OK
     */
    quyLXSchoolImportPupil(schoolId: number | undefined, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/school/quylx-school-import-pupil?";
        if (schoolId === null)
            throw new globalThis.Error("The parameter 'schoolId' cannot be null.");
        else if (schoolId !== undefined)
            url_ += "schoolId=" + encodeURIComponent("" + schoolId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuyLXSchoolImportPupil(_response);
        });
    }

    protected processQuyLXSchoolImportPupil(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param schoolId (optional) 
     * @param file (optional) 
     * @return OK
     */
    quyLXSchoolImportTeacher(schoolId: number | undefined, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/school/quylx-school-import-teacher?";
        if (schoolId === null)
            throw new globalThis.Error("The parameter 'schoolId' cannot be null.");
        else if (schoolId !== undefined)
            url_ += "schoolId=" + encodeURIComponent("" + schoolId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuyLXSchoolImportTeacher(_response);
        });
    }

    protected processQuyLXSchoolImportTeacher(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param schoolId (optional) 
     * @param file (optional) 
     * @return OK
     */
    schoolImportPupil(schoolId: number | undefined, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/school/school-import-pupil?";
        if (schoolId === null)
            throw new globalThis.Error("The parameter 'schoolId' cannot be null.");
        else if (schoolId !== undefined)
            url_ += "schoolId=" + encodeURIComponent("" + schoolId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSchoolImportPupil(_response);
        });
    }

    protected processSchoolImportPupil(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param schoolId (optional) 
     * @param file (optional) 
     * @return OK
     */
    schoolImportPupilPreview(schoolId: number | undefined, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<UserCreateDto[]> {
        let url_ = this.baseUrl + "/api/v1/school/school-import-pupil-preview?";
        if (schoolId === null)
            throw new globalThis.Error("The parameter 'schoolId' cannot be null.");
        else if (schoolId !== undefined)
            url_ += "schoolId=" + encodeURIComponent("" + schoolId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSchoolImportPupilPreview(_response);
        });
    }

    protected processSchoolImportPupilPreview(response: AxiosResponse): Promise<UserCreateDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserCreateDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UserCreateDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserCreateDto[]>(null as any);
    }

    /**
     * @param schoolId (optional) 
     * @param file (optional) 
     * @return OK
     */
    schoolImportTeacher(schoolId: number | undefined, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/school/school-import-teacher?";
        if (schoolId === null)
            throw new globalThis.Error("The parameter 'schoolId' cannot be null.");
        else if (schoolId !== undefined)
            url_ += "schoolId=" + encodeURIComponent("" + schoolId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSchoolImportTeacher(_response);
        });
    }

    protected processSchoolImportTeacher(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param schoolId (optional) 
     * @param file (optional) 
     * @return OK
     */
    schoolImportTeacherPreview(schoolId: number | undefined, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<TeacherCreateDto[]> {
        let url_ = this.baseUrl + "/api/v1/school/school-import-teacher-preview?";
        if (schoolId === null)
            throw new globalThis.Error("The parameter 'schoolId' cannot be null.");
        else if (schoolId !== undefined)
            url_ += "schoolId=" + encodeURIComponent("" + schoolId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSchoolImportTeacherPreview(_response);
        });
    }

    protected processSchoolImportTeacherPreview(response: AxiosResponse): Promise<TeacherCreateDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TeacherCreateDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TeacherCreateDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TeacherCreateDto[]>(null as any);
    }

    /**
     * @param schoolId (optional) 
     * @param body (optional) 
     * @return OK
     */
    schoolCreateTeacher(schoolId: number | undefined, body: TeacherCreateDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/school/teacher-create?";
        if (schoolId === null)
            throw new globalThis.Error("The parameter 'schoolId' cannot be null.");
        else if (schoolId !== undefined)
            url_ += "schoolId=" + encodeURIComponent("" + schoolId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSchoolCreateTeacher(_response);
        });
    }

    protected processSchoolCreateTeacher(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    schoolAssignExistingTeacher(body: AssignExistingTeacherDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/school/teacher-assign-existing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSchoolAssignExistingTeacher(_response);
        });
    }

    protected processSchoolAssignExistingTeacher(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    schoolListByUser( cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfSchoolListDto> {
        let url_ = this.baseUrl + "/api/v1/school/list-by-user";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSchoolListByUser(_response);
        });
    }

    protected processSchoolListByUser(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfSchoolListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfSchoolListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfSchoolListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfSchoolListDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    schoolGetByPersonal(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfSchoolEntity> {
        let url_ = this.baseUrl + "/api/v1/school/get-by-personal?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSchoolGetByPersonal(_response);
        });
    }

    protected processSchoolGetByPersonal(response: AxiosResponse): Promise<ApiResponse_1OfSchoolEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfSchoolEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfSchoolEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfSchoolEntity>(null as any);
    }

    /**
     * @param schoolId (optional) 
     * @param departmentId (optional) 
     * @param includeLeft (optional) 
     * @param userType (optional) 
     * @return OK
     */
    schoolUserGetList(schoolId: number | undefined, departmentId: number | undefined, includeLeft: boolean | undefined, userType: UserTypeEnum | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfSchoolUserDto> {
        let url_ = this.baseUrl + "/api/v1/school/users?";
        if (schoolId === null)
            throw new globalThis.Error("The parameter 'schoolId' cannot be null.");
        else if (schoolId !== undefined)
            url_ += "schoolId=" + encodeURIComponent("" + schoolId) + "&";
        if (departmentId === null)
            throw new globalThis.Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (includeLeft === null)
            throw new globalThis.Error("The parameter 'includeLeft' cannot be null.");
        else if (includeLeft !== undefined)
            url_ += "includeLeft=" + encodeURIComponent("" + includeLeft) + "&";
        if (userType === null)
            throw new globalThis.Error("The parameter 'userType' cannot be null.");
        else if (userType !== undefined)
            url_ += "userType=" + encodeURIComponent("" + userType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSchoolUserGetList(_response);
        });
    }

    protected processSchoolUserGetList(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfSchoolUserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfSchoolUserDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfSchoolUserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfSchoolUserDto>(null as any);
    }

    /**
     * @return OK
     */
    schoolMemberTemplateStaff( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/school/member/template-staff";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSchoolMemberTemplateStaff(_response);
        });
    }

    protected processSchoolMemberTemplateStaff(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return OK
     */
    schoolMemberTemplateTeacher( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/school/member/template-teacher";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSchoolMemberTemplateTeacher(_response);
        });
    }

    protected processSchoolMemberTemplateTeacher(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return OK
     */
    schoolMemberTemplateStudent( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/school/member/template-student";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSchoolMemberTemplateStudent(_response);
        });
    }

    protected processSchoolMemberTemplateStudent(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param schoolId (optional) 
     * @param file (optional) 
     * @return OK
     */
    schoolMemberImportStaff(schoolId: number | undefined, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/school/member/import-staff?";
        if (schoolId === null)
            throw new globalThis.Error("The parameter 'schoolId' cannot be null.");
        else if (schoolId !== undefined)
            url_ += "schoolId=" + encodeURIComponent("" + schoolId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSchoolMemberImportStaff(_response);
        });
    }

    protected processSchoolMemberImportStaff(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param schoolId (optional) 
     * @param file (optional) 
     * @return OK
     */
    schoolMemberImportTeacher(schoolId: number | undefined, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/school/member/import-teacher?";
        if (schoolId === null)
            throw new globalThis.Error("The parameter 'schoolId' cannot be null.");
        else if (schoolId !== undefined)
            url_ += "schoolId=" + encodeURIComponent("" + schoolId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSchoolMemberImportTeacher(_response);
        });
    }

    protected processSchoolMemberImportTeacher(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param schoolId (optional) 
     * @param file (optional) 
     * @return OK
     */
    schoolMemberImportStudent(schoolId: number | undefined, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/school/member/import-student?";
        if (schoolId === null)
            throw new globalThis.Error("The parameter 'schoolId' cannot be null.");
        else if (schoolId !== undefined)
            url_ += "schoolId=" + encodeURIComponent("" + schoolId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSchoolMemberImportStudent(_response);
        });
    }

    protected processSchoolMemberImportStudent(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    teacherGetBySchool(body: TeacherGetBySchoolFilterDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfTeacherGetBySchoolDto> {
        let url_ = this.baseUrl + "/api/v1/school/teacher-get-by-school";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTeacherGetBySchool(_response);
        });
    }

    protected processTeacherGetBySchool(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfTeacherGetBySchoolDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfTeacherGetBySchoolDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfTeacherGetBySchoolDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfTeacherGetBySchoolDto>(null as any);
    }

    /**
     * @param schoolId (optional) 
     * @return OK
     */
    schoolStaticCount(schoolId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfSchoolStaticCountDto> {
        let url_ = this.baseUrl + "/api/v1/school/static-count?";
        if (schoolId === null)
            throw new globalThis.Error("The parameter 'schoolId' cannot be null.");
        else if (schoolId !== undefined)
            url_ += "schoolId=" + encodeURIComponent("" + schoolId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSchoolStaticCount(_response);
        });
    }

    protected processSchoolStaticCount(response: AxiosResponse): Promise<ApiResponse_1OfSchoolStaticCountDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfSchoolStaticCountDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfSchoolStaticCountDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfSchoolStaticCountDto>(null as any);
    }

    /**
     * @param schoolId (optional) 
     * @return OK
     */
    classProgramTypeList(schoolId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfClassProgramTypeEntity> {
        let url_ = this.baseUrl + "/api/v1/school/class-program-types?";
        if (schoolId === null)
            throw new globalThis.Error("The parameter 'schoolId' cannot be null.");
        else if (schoolId !== undefined)
            url_ += "schoolId=" + encodeURIComponent("" + schoolId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClassProgramTypeList(_response);
        });
    }

    protected processClassProgramTypeList(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfClassProgramTypeEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfClassProgramTypeEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfClassProgramTypeEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfClassProgramTypeEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    classProgramTypeSave(body: ClassProgramTypeEntity | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfClassProgramTypeEntity> {
        let url_ = this.baseUrl + "/api/v1/school/class-program-types";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClassProgramTypeSave(_response);
        });
    }

    protected processClassProgramTypeSave(response: AxiosResponse): Promise<ApiResponse_1OfClassProgramTypeEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfClassProgramTypeEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfClassProgramTypeEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfClassProgramTypeEntity>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    classProgramTypeDelete(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/school/class-program-types?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClassProgramTypeDelete(_response);
        });
    }

    protected processClassProgramTypeDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param schoolId (optional) 
     * @return OK
     */
    zoomAccountList(schoolId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfZoomAccountListDto> {
        let url_ = this.baseUrl + "/api/v1/school/zoom-accounts?";
        if (schoolId === null)
            throw new globalThis.Error("The parameter 'schoolId' cannot be null.");
        else if (schoolId !== undefined)
            url_ += "schoolId=" + encodeURIComponent("" + schoolId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processZoomAccountList(_response);
        });
    }

    protected processZoomAccountList(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfZoomAccountListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfZoomAccountListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfZoomAccountListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfZoomAccountListDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    zoomAccountSave(body: ZoomAccountSaveDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfZoomAccountListDto> {
        let url_ = this.baseUrl + "/api/v1/school/zoom-accounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processZoomAccountSave(_response);
        });
    }

    protected processZoomAccountSave(response: AxiosResponse): Promise<ApiResponse_1OfZoomAccountListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfZoomAccountListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfZoomAccountListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfZoomAccountListDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    zoomAccountDelete(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/school/zoom-accounts?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processZoomAccountDelete(_response);
        });
    }

    protected processZoomAccountDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @param schoolId (optional) 
     * @return OK
     */
    zoomAccountDetail(id: number | undefined, schoolId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfZoomAccountDetailDto> {
        let url_ = this.baseUrl + "/api/v1/school/zoom-accounts/detail?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (schoolId === null)
            throw new globalThis.Error("The parameter 'schoolId' cannot be null.");
        else if (schoolId !== undefined)
            url_ += "schoolId=" + encodeURIComponent("" + schoolId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processZoomAccountDetail(_response);
        });
    }

    protected processZoomAccountDetail(response: AxiosResponse): Promise<ApiResponse_1OfZoomAccountDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfZoomAccountDetailDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfZoomAccountDetailDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfZoomAccountDetailDto>(null as any);
    }

    /**
     * @param locale (optional) 
     * @return OK
     */
    staticPageGetByKey(pageKey: string, locale: string | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfStaticPageDetailDto> {
        let url_ = this.baseUrl + "/api/v1/static-pages/{pageKey}?";
        if (pageKey === undefined || pageKey === null)
            throw new globalThis.Error("The parameter 'pageKey' must be defined.");
        url_ = url_.replace("{pageKey}", encodeURIComponent("" + pageKey));
        if (locale === null)
            throw new globalThis.Error("The parameter 'locale' cannot be null.");
        else if (locale !== undefined)
            url_ += "locale=" + encodeURIComponent("" + locale) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStaticPageGetByKey(_response);
        });
    }

    protected processStaticPageGetByKey(response: AxiosResponse): Promise<ApiResponse_1OfStaticPageDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfStaticPageDetailDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfStaticPageDetailDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfStaticPageDetailDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    staticPageGetList(body: StaticPageGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfStaticPageListDto> {
        let url_ = this.baseUrl + "/api/v1/static-pages/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStaticPageGetList(_response);
        });
    }

    protected processStaticPageGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfStaticPageListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfStaticPageListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfStaticPageListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfStaticPageListDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    staticPageSave(body: StaticPageSaveDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfStaticPageEntity> {
        let url_ = this.baseUrl + "/api/v1/static-pages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStaticPageSave(_response);
        });
    }

    protected processStaticPageSave(response: AxiosResponse): Promise<ApiResponse_1OfStaticPageEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfStaticPageEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfStaticPageEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfStaticPageEntity>(null as any);
    }

    /**
     * @return OK
     */
    staticPageDelete(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/static-pages/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStaticPageDelete(_response);
        });
    }

    protected processStaticPageDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    staticPageLocaleGetList(pageId: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfStaticPageLocaleDto> {
        let url_ = this.baseUrl + "/api/v1/static-pages/{pageId}/locales";
        if (pageId === undefined || pageId === null)
            throw new globalThis.Error("The parameter 'pageId' must be defined.");
        url_ = url_.replace("{pageId}", encodeURIComponent("" + pageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStaticPageLocaleGetList(_response);
        });
    }

    protected processStaticPageLocaleGetList(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfStaticPageLocaleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfStaticPageLocaleDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfStaticPageLocaleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfStaticPageLocaleDto>(null as any);
    }

    /**
     * @return OK
     */
    staticPageLocaleStatusGet(pageId: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfStaticPageLocaleStatusDto> {
        let url_ = this.baseUrl + "/api/v1/static-pages/{pageId}/locale-status";
        if (pageId === undefined || pageId === null)
            throw new globalThis.Error("The parameter 'pageId' must be defined.");
        url_ = url_.replace("{pageId}", encodeURIComponent("" + pageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStaticPageLocaleStatusGet(_response);
        });
    }

    protected processStaticPageLocaleStatusGet(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfStaticPageLocaleStatusDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfStaticPageLocaleStatusDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfStaticPageLocaleStatusDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfStaticPageLocaleStatusDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    staticPageLocaleSave(body: StaticPageLocaleSaveDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfStaticPageLocaleEntity> {
        let url_ = this.baseUrl + "/api/v1/static-pages/locales";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStaticPageLocaleSave(_response);
        });
    }

    protected processStaticPageLocaleSave(response: AxiosResponse): Promise<ApiResponse_1OfStaticPageLocaleEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfStaticPageLocaleEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfStaticPageLocaleEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfStaticPageLocaleEntity>(null as any);
    }

    /**
     * @return OK
     */
    staticPageSectionGetList(pageId: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfStaticPageSectionListDto> {
        let url_ = this.baseUrl + "/api/v1/static-pages/{pageId}/sections";
        if (pageId === undefined || pageId === null)
            throw new globalThis.Error("The parameter 'pageId' must be defined.");
        url_ = url_.replace("{pageId}", encodeURIComponent("" + pageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStaticPageSectionGetList(_response);
        });
    }

    protected processStaticPageSectionGetList(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfStaticPageSectionListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfStaticPageSectionListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfStaticPageSectionListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfStaticPageSectionListDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    staticPageSectionSave(body: StaticPageSectionSaveDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfStaticPageSectionEntity> {
        let url_ = this.baseUrl + "/api/v1/static-pages/sections";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStaticPageSectionSave(_response);
        });
    }

    protected processStaticPageSectionSave(response: AxiosResponse): Promise<ApiResponse_1OfStaticPageSectionEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfStaticPageSectionEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfStaticPageSectionEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfStaticPageSectionEntity>(null as any);
    }

    /**
     * @param languageCode (optional) 
     * @return OK
     */
    staticPageSectionContentGet(sectionId: number, languageCode: string | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfStaticPageSectionContentDto> {
        let url_ = this.baseUrl + "/api/v1/static-pages/sections/{sectionId}/content?";
        if (sectionId === undefined || sectionId === null)
            throw new globalThis.Error("The parameter 'sectionId' must be defined.");
        url_ = url_.replace("{sectionId}", encodeURIComponent("" + sectionId));
        if (languageCode === null)
            throw new globalThis.Error("The parameter 'languageCode' cannot be null.");
        else if (languageCode !== undefined)
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStaticPageSectionContentGet(_response);
        });
    }

    protected processStaticPageSectionContentGet(response: AxiosResponse): Promise<ApiResponse_1OfStaticPageSectionContentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfStaticPageSectionContentDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfStaticPageSectionContentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfStaticPageSectionContentDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    staticPageSectionContentSave(body: StaticPageSectionContentSaveDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfStaticPageSectionContentEntity> {
        let url_ = this.baseUrl + "/api/v1/static-pages/sections/content";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStaticPageSectionContentSave(_response);
        });
    }

    protected processStaticPageSectionContentSave(response: AxiosResponse): Promise<ApiResponse_1OfStaticPageSectionContentEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfStaticPageSectionContentEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfStaticPageSectionContentEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfStaticPageSectionContentEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    staticPageSectionContentCopy(body: StaticPageSectionContentCopyDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/static-pages/sections/content/copy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStaticPageSectionContentCopy(_response);
        });
    }

    protected processStaticPageSectionContentCopy(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    staticPageSectionDelete(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/static-pages/sections/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStaticPageSectionDelete(_response);
        });
    }

    protected processStaticPageSectionDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    staticPageSectionReorder(body: StaticPageSectionReorderDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/static-pages/sections/reorder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStaticPageSectionReorder(_response);
        });
    }

    protected processStaticPageSectionReorder(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    statisticalNumber( cancelToken?: CancelToken): Promise<ApiResponse_1OfStatisticalDto> {
        let url_ = this.baseUrl + "/api/v1/statistical/static-number";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStatisticalNumber(_response);
        });
    }

    protected processStatisticalNumber(response: AxiosResponse): Promise<ApiResponse_1OfStatisticalDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfStatisticalDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfStatisticalDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfStatisticalDto>(null as any);
    }

    /**
     * @return OK
     */
    statisticalClass( cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfDashBoardClassStatisticalDto> {
        let url_ = this.baseUrl + "/api/v1/statistical/class";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStatisticalClass(_response);
        });
    }

    protected processStatisticalClass(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfDashBoardClassStatisticalDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfDashBoardClassStatisticalDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfDashBoardClassStatisticalDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfDashBoardClassStatisticalDto>(null as any);
    }

    /**
     * @return OK
     */
    statisticalExam( cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfDashBoardExamListDto> {
        let url_ = this.baseUrl + "/api/v1/statistical/exam";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStatisticalExam(_response);
        });
    }

    protected processStatisticalExam(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfDashBoardExamListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfDashBoardExamListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfDashBoardExamListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfDashBoardExamListDto>(null as any);
    }

    /**
     * @return OK
     */
    statisticalQuestion( cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfDashBoardQuestionListDto> {
        let url_ = this.baseUrl + "/api/v1/statistical/question";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStatisticalQuestion(_response);
        });
    }

    protected processStatisticalQuestion(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfDashBoardQuestionListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfDashBoardQuestionListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfDashBoardQuestionListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfDashBoardQuestionListDto>(null as any);
    }

    /**
     * @return OK
     */
    statisticalPupil( cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfDashBoardPupilListDto> {
        let url_ = this.baseUrl + "/api/v1/statistical/pupil";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStatisticalPupil(_response);
        });
    }

    protected processStatisticalPupil(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfDashBoardPupilListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfDashBoardPupilListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfDashBoardPupilListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfDashBoardPupilListDto>(null as any);
    }

    /**
     * @return OK
     */
    statisticalPupilNumber( cancelToken?: CancelToken): Promise<ApiResponse_1OfPupilStatisticalDto> {
        let url_ = this.baseUrl + "/api/v1/statistical/pupil-number";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStatisticalPupilNumber(_response);
        });
    }

    protected processStatisticalPupilNumber(response: AxiosResponse): Promise<ApiResponse_1OfPupilStatisticalDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfPupilStatisticalDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfPupilStatisticalDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfPupilStatisticalDto>(null as any);
    }

    /**
     * @return OK
     */
    statisticalPupilDashboard( cancelToken?: CancelToken): Promise<ApiResponse_1OfPupilDashboardStatisticalDto> {
        let url_ = this.baseUrl + "/api/v1/statistical/pupil-dashboard";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStatisticalPupilDashboard(_response);
        });
    }

    protected processStatisticalPupilDashboard(response: AxiosResponse): Promise<ApiResponse_1OfPupilDashboardStatisticalDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfPupilDashboardStatisticalDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfPupilDashboardStatisticalDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfPupilDashboardStatisticalDto>(null as any);
    }

    /**
     * @param from (optional) 
     * @param to (optional) 
     * @return OK
     */
    statisticalUserSchedule(from: Date | undefined, to: Date | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfUserScheduleDto> {
        let url_ = this.baseUrl + "/api/v1/statistical/user-schedule?";
        if (from === null)
            throw new globalThis.Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new globalThis.Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStatisticalUserSchedule(_response);
        });
    }

    protected processStatisticalUserSchedule(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfUserScheduleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfUserScheduleDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfUserScheduleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfUserScheduleDto>(null as any);
    }

    /**
     * @param from (optional) 
     * @param to (optional) 
     * @return OK
     */
    statisticalDailyStudyTime(from: Date | undefined, to: Date | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfDailyStudyTimeDto> {
        let url_ = this.baseUrl + "/api/v1/statistical/daily-study-time?";
        if (from === null)
            throw new globalThis.Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new globalThis.Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStatisticalDailyStudyTime(_response);
        });
    }

    protected processStatisticalDailyStudyTime(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfDailyStudyTimeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfDailyStudyTimeDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfDailyStudyTimeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfDailyStudyTimeDto>(null as any);
    }

    /**
     * @param top (optional) 
     * @return OK
     */
    statisticalTopCourse(top: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfTopCourseStatisticalDto> {
        let url_ = this.baseUrl + "/api/v1/statistical/top-course?";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStatisticalTopCourse(_response);
        });
    }

    protected processStatisticalTopCourse(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfTopCourseStatisticalDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfTopCourseStatisticalDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfTopCourseStatisticalDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfTopCourseStatisticalDto>(null as any);
    }

    /**
     * @param top (optional) 
     * @return OK
     */
    statisticalUpcomingSessions(top: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfUserScheduleDto> {
        let url_ = this.baseUrl + "/api/v1/statistical/upcoming-sessions?";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStatisticalUpcomingSessions(_response);
        });
    }

    protected processStatisticalUpcomingSessions(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfUserScheduleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfUserScheduleDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfUserScheduleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfUserScheduleDto>(null as any);
    }

    /**
     * @return OK
     */
    initSystem( cancelToken?: CancelToken): Promise<ApiResponse_1OfSystemInitDto> {
        let url_ = this.baseUrl + "/api/v1/system/init";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInitSystem(_response);
        });
    }

    protected processInitSystem(response: AxiosResponse): Promise<ApiResponse_1OfSystemInitDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfSystemInitDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfSystemInitDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfSystemInitDto>(null as any);
    }

    /**
     * @param rebuildUserPermissions (optional) 
     * @return OK
     */
    migratePermissions(rebuildUserPermissions: boolean | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfPermissionMigrationResult> {
        let url_ = this.baseUrl + "/api/v1/system/migrate-permissions?";
        if (rebuildUserPermissions === null)
            throw new globalThis.Error("The parameter 'rebuildUserPermissions' cannot be null.");
        else if (rebuildUserPermissions !== undefined)
            url_ += "rebuildUserPermissions=" + encodeURIComponent("" + rebuildUserPermissions) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMigratePermissions(_response);
        });
    }

    protected processMigratePermissions(response: AxiosResponse): Promise<ApiResponse_1OfPermissionMigrationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfPermissionMigrationResult.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfPermissionMigrationResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfPermissionMigrationResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    systemConfigAdminGetList(body: SystemConfigFilterDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfSystemConfigAdminDto> {
        let url_ = this.baseUrl + "/api/v1/system-config/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSystemConfigAdminGetList(_response);
        });
    }

    protected processSystemConfigAdminGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfSystemConfigAdminDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfSystemConfigAdminDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfSystemConfigAdminDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfSystemConfigAdminDto>(null as any);
    }

    /**
     * @return OK
     */
    systemConfigAdminGetById(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfSystemConfigAdminDto> {
        let url_ = this.baseUrl + "/api/v1/system-config/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSystemConfigAdminGetById(_response);
        });
    }

    protected processSystemConfigAdminGetById(response: AxiosResponse): Promise<ApiResponse_1OfSystemConfigAdminDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfSystemConfigAdminDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfSystemConfigAdminDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfSystemConfigAdminDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    systemConfigAdminSave(body: SystemConfigSaveDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfSystemConfigAdminDto> {
        let url_ = this.baseUrl + "/api/v1/system-config/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSystemConfigAdminSave(_response);
        });
    }

    protected processSystemConfigAdminSave(response: AxiosResponse): Promise<ApiResponse_1OfSystemConfigAdminDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfSystemConfigAdminDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfSystemConfigAdminDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfSystemConfigAdminDto>(null as any);
    }

    /**
     * @return OK
     */
    tagGetById(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfTagDto> {
        let url_ = this.baseUrl + "/api/v1/tag/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTagGetById(_response);
        });
    }

    protected processTagGetById(response: AxiosResponse): Promise<ApiResponse_1OfTagDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfTagDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfTagDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfTagDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveTag(body: TagDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfTagDto> {
        let url_ = this.baseUrl + "/api/v1/tag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveTag(_response);
        });
    }

    protected processSaveTag(response: AxiosResponse): Promise<ApiResponse_1OfTagDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfTagDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfTagDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfTagDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    tagGetList(body: TagGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfTagListDto> {
        let url_ = this.baseUrl + "/api/v1/tag/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTagGetList(_response);
        });
    }

    protected processTagGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfTagListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfTagListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfTagListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfTagListDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    tagGetByIds(body: number[] | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfTagDto> {
        let url_ = this.baseUrl + "/api/v1/tag/list-by-ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTagGetByIds(_response);
        });
    }

    protected processTagGetByIds(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfTagDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfTagDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfTagDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfTagDto>(null as any);
    }

    /**
     * @return OK
     */
    tagDelete(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/tag/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTagDelete(_response);
        });
    }

    protected processTagDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @param isHot (optional) 
     * @return OK
     */
    tagUpadteHot(id: number | undefined, isHot: boolean | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/tag/update-hot?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (isHot === null)
            throw new globalThis.Error("The parameter 'isHot' cannot be null.");
        else if (isHot !== undefined)
            url_ += "IsHot=" + encodeURIComponent("" + isHot) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTagUpadteHot(_response);
        });
    }

    protected processTagUpadteHot(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @param newsId (optional) 
     * @return OK
     */
    tagRemoveNews(id: number | undefined, newsId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/tag/remove-news?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (newsId === null)
            throw new globalThis.Error("The parameter 'newsId' cannot be null.");
        else if (newsId !== undefined)
            url_ += "newsId=" + encodeURIComponent("" + newsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTagRemoveNews(_response);
        });
    }

    protected processTagRemoveNews(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    tagAddNews(body: TagAddNewsDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/tag/add-news";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTagAddNews(_response);
        });
    }

    protected processTagAddNews(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    tagGetListWithNewsCount(body: TagGetListWithNewsCountQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfTagListDto> {
        let url_ = this.baseUrl + "/api/v1/tag/list-with-news-count";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTagGetListWithNewsCount(_response);
        });
    }

    protected processTagGetListWithNewsCount(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfTagListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfTagListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfTagListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfTagListDto>(null as any);
    }

    /**
     * @param classId (optional) 
     * @param userId (optional) 
     * @param subjectId (optional) 
     * @return OK
     */
    teacherStaticByTypeExam(classId: number | undefined, userId: number | undefined, subjectId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfTeacherStaticByTypeExamDto> {
        let url_ = this.baseUrl + "/api/v1/teacher/static-by-type-exam?";
        if (classId === null)
            throw new globalThis.Error("The parameter 'classId' cannot be null.");
        else if (classId !== undefined)
            url_ += "classId=" + encodeURIComponent("" + classId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (subjectId === null)
            throw new globalThis.Error("The parameter 'subjectId' cannot be null.");
        else if (subjectId !== undefined)
            url_ += "subjectId=" + encodeURIComponent("" + subjectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTeacherStaticByTypeExam(_response);
        });
    }

    protected processTeacherStaticByTypeExam(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfTeacherStaticByTypeExamDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfTeacherStaticByTypeExamDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfTeacherStaticByTypeExamDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfTeacherStaticByTypeExamDto>(null as any);
    }

    /**
     * @return OK
     */
    testKafka( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/test/test-kafka";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestKafka(_response);
        });
    }

    protected processTestKafka(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    testParseJson( cancelToken?: CancelToken): Promise<ApiResponse_1OfResponseX> {
        let url_ = this.baseUrl + "/api/v1/test/test-parsejson";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestParseJson(_response);
        });
    }

    protected processTestParseJson(response: AxiosResponse): Promise<ApiResponse_1OfResponseX> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfResponseX.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfResponseX>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfResponseX>(null as any);
    }

    /**
     * @return OK
     */
    testLog( cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/test/test-log";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestLog(_response);
        });
    }

    protected processTestLog(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    testZoomMeetingNow( cancelToken?: CancelToken): Promise<ApiResponse_1OfZoomMeetingDto> {
        let url_ = this.baseUrl + "/api/v1/test/test-zoom-meeting-now";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestZoomMeetingNow(_response);
        });
    }

    protected processTestZoomMeetingNow(response: AxiosResponse): Promise<ApiResponse_1OfZoomMeetingDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfZoomMeetingDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfZoomMeetingDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfZoomMeetingDto>(null as any);
    }

    /**
     * @param meetingId (optional) 
     * @param names (optional) 
     * @param timeToLiveSeconds (optional) 
     * @param zoomAccountId (optional) 
     * @return OK
     */
    testZoomInviteLinks(meetingId: string | undefined, names: string | undefined, timeToLiveSeconds: number | undefined, zoomAccountId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfZoomInviteLinkDto> {
        let url_ = this.baseUrl + "/api/v1/test/test-zoom-invite-links?";
        if (meetingId === null)
            throw new globalThis.Error("The parameter 'meetingId' cannot be null.");
        else if (meetingId !== undefined)
            url_ += "meetingId=" + encodeURIComponent("" + meetingId) + "&";
        if (names === null)
            throw new globalThis.Error("The parameter 'names' cannot be null.");
        else if (names !== undefined)
            url_ += "names=" + encodeURIComponent("" + names) + "&";
        if (timeToLiveSeconds === null)
            throw new globalThis.Error("The parameter 'timeToLiveSeconds' cannot be null.");
        else if (timeToLiveSeconds !== undefined)
            url_ += "timeToLiveSeconds=" + encodeURIComponent("" + timeToLiveSeconds) + "&";
        if (zoomAccountId === null)
            throw new globalThis.Error("The parameter 'zoomAccountId' cannot be null.");
        else if (zoomAccountId !== undefined)
            url_ += "zoomAccountId=" + encodeURIComponent("" + zoomAccountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestZoomInviteLinks(_response);
        });
    }

    protected processTestZoomInviteLinks(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfZoomInviteLinkDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfZoomInviteLinkDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfZoomInviteLinkDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfZoomInviteLinkDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    trackEvents(body: TrackEventsRequestDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/tracking/events";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTrackEvents(_response);
        });
    }

    protected processTrackEvents(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            let result202: any = null;
            let resultData202  = _responseText;
            result202 = ApiResponse_1OfBoolean.fromJS(resultData202);
            return Promise.resolve<ApiResponse_1OfBoolean>(result202);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    videoHeartbeat(body: VideoHeartbeatRequestDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/tracking/heartbeat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVideoHeartbeat(_response);
        });
    }

    protected processVideoHeartbeat(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            let result202: any = null;
            let resultData202  = _responseText;
            result202 = ApiResponse_1OfBoolean.fromJS(resultData202);
            return Promise.resolve<ApiResponse_1OfBoolean>(result202);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param take (optional) 
     * @return OK
     */
    getMyActivity(take: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfUserActivityLogItemDto> {
        let url_ = this.baseUrl + "/api/v1/tracking/my-activity?";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyActivity(_response);
        });
    }

    protected processGetMyActivity(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfUserActivityLogItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfUserActivityLogItemDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfUserActivityLogItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfUserActivityLogItemDto>(null as any);
    }

    /**
     * @return OK
     */
    getMyPoints( cancelToken?: CancelToken): Promise<ApiResponse_1OfUserPointSummaryDto> {
        let url_ = this.baseUrl + "/api/v1/tracking/my-points";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyPoints(_response);
        });
    }

    protected processGetMyPoints(response: AxiosResponse): Promise<ApiResponse_1OfUserPointSummaryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfUserPointSummaryDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfUserPointSummaryDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfUserPointSummaryDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getActivityLogList(body: ActivityLogFilterDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfUserActivityLogAdminItemDto> {
        let url_ = this.baseUrl + "/api/v1/tracking/activity-logs/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivityLogList(_response);
        });
    }

    protected processGetActivityLogList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfUserActivityLogAdminItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfUserActivityLogAdminItemDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfUserActivityLogAdminItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfUserActivityLogAdminItemDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getActivityStatsDailyList(body: ActivityStatsDailyFilterDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfActivityStatsDailyItemDto> {
        let url_ = this.baseUrl + "/api/v1/tracking/activity-stats/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivityStatsDailyList(_response);
        });
    }

    protected processGetActivityStatsDailyList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfActivityStatsDailyItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfActivityStatsDailyItemDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfActivityStatsDailyItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfActivityStatsDailyItemDto>(null as any);
    }

    /**
     * @param period (optional) 
     * @param take (optional) 
     * @return OK
     */
    getLeaderboard(period: string | undefined, take: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfLeaderboardItemDto> {
        let url_ = this.baseUrl + "/api/v1/tracking/leaderboard?";
        if (period === null)
            throw new globalThis.Error("The parameter 'period' cannot be null.");
        else if (period !== undefined)
            url_ += "period=" + encodeURIComponent("" + period) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLeaderboard(_response);
        });
    }

    protected processGetLeaderboard(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfLeaderboardItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfLeaderboardItemDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfLeaderboardItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfLeaderboardItemDto>(null as any);
    }

    /**
     * @param namespace (optional) 
     * @return OK
     */
    translationGetBundle(locale: string, namespace: string | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfTranslationBundleDto> {
        let url_ = this.baseUrl + "/api/v1/translations/bundle/{locale}?";
        if (locale === undefined || locale === null)
            throw new globalThis.Error("The parameter 'locale' must be defined.");
        url_ = url_.replace("{locale}", encodeURIComponent("" + locale));
        if (namespace === null)
            throw new globalThis.Error("The parameter 'namespace' cannot be null.");
        else if (namespace !== undefined)
            url_ += "namespace=" + encodeURIComponent("" + namespace) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTranslationGetBundle(_response);
        });
    }

    protected processTranslationGetBundle(response: AxiosResponse): Promise<ApiResponse_1OfTranslationBundleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfTranslationBundleDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfTranslationBundleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfTranslationBundleDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    translationGetList(body: TranslationGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfTranslationListDto> {
        let url_ = this.baseUrl + "/api/v1/translations/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTranslationGetList(_response);
        });
    }

    protected processTranslationGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfTranslationListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfTranslationListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfTranslationListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfTranslationListDto>(null as any);
    }

    /**
     * @return OK
     */
    translationGetById(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfTranslationDetailDto> {
        let url_ = this.baseUrl + "/api/v1/translations/detail/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTranslationGetById(_response);
        });
    }

    protected processTranslationGetById(response: AxiosResponse): Promise<ApiResponse_1OfTranslationDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfTranslationDetailDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfTranslationDetailDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfTranslationDetailDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    translationSave(body: TranslationSaveDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfTranslationKeyEntity> {
        let url_ = this.baseUrl + "/api/v1/translations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTranslationSave(_response);
        });
    }

    protected processTranslationSave(response: AxiosResponse): Promise<ApiResponse_1OfTranslationKeyEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfTranslationKeyEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfTranslationKeyEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfTranslationKeyEntity>(null as any);
    }

    /**
     * @return OK
     */
    translationDelete(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/translations/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTranslationDelete(_response);
        });
    }

    protected processTranslationDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param email (optional) 
     * @param classId (optional) 
     * @return OK
     */
    getByEmail(email: string | undefined, classId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfUserInfoDto> {
        let url_ = this.baseUrl + "/api/v1/user/get-by-email?";
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (classId === null)
            throw new globalThis.Error("The parameter 'classId' cannot be null.");
        else if (classId !== undefined)
            url_ += "classId=" + encodeURIComponent("" + classId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByEmail(_response);
        });
    }

    protected processGetByEmail(response: AxiosResponse): Promise<ApiResponse_1OfUserInfoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfUserInfoDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfUserInfoDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfUserInfoDto>(null as any);
    }

    /**
     * @return OK
     */
    downloadTemplateImport( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/user/template-import";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadTemplateImport(_response);
        });
    }

    protected processDownloadTemplateImport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param file (optional) 
     * @return OK
     */
    importUser(file: FileParameter | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/user/import-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportUser(_response);
        });
    }

    protected processImportUser(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    userExamResultGetById(id: number | undefined, cancelToken?: CancelToken): Promise<UserExamResultDetailWithMessageDto> {
        let url_ = this.baseUrl + "/api/v1/user-exam-result/get-by-id?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserExamResultGetById(_response);
        });
    }

    protected processUserExamResultGetById(response: AxiosResponse): Promise<UserExamResultDetailWithMessageDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserExamResultDetailWithMessageDto.fromJS(resultData200);
            return Promise.resolve<UserExamResultDetailWithMessageDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserExamResultDetailWithMessageDto>(null as any);
    }

    /**
     * @param examId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    userExamResultGetByExam(examId: number | undefined, userId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfUserExamAttemptListItemDto> {
        let url_ = this.baseUrl + "/api/v1/user-exam-result/get-by-exam?";
        if (examId === null)
            throw new globalThis.Error("The parameter 'examId' cannot be null.");
        else if (examId !== undefined)
            url_ += "examId=" + encodeURIComponent("" + examId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserExamResultGetByExam(_response);
        });
    }

    protected processUserExamResultGetByExam(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfUserExamAttemptListItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfUserExamAttemptListItemDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfUserExamAttemptListItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfUserExamAttemptListItemDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    userExamResultSave(body: UserExamResultDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfUserExamResultEntity> {
        let url_ = this.baseUrl + "/api/v1/user-exam-result/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserExamResultSave(_response);
        });
    }

    protected processUserExamResultSave(response: AxiosResponse): Promise<ApiResponse_1OfUserExamResultEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfUserExamResultEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfUserExamResultEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfUserExamResultEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    userAnswerComment(body: UserAnswerEntity | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/user-exam-result/comment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserAnswerComment(_response);
        });
    }

    protected processUserAnswerComment(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param userExamResultId (optional) 
     * @param comment (optional) 
     * @param body (optional) 
     * @return OK
     */
    userAnswerChangeMark(userExamResultId: number | undefined, comment: string | undefined, body: UserAnswerEntity[] | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/user-exam-result/change-mark?";
        if (userExamResultId === null)
            throw new globalThis.Error("The parameter 'userExamResultId' cannot be null.");
        else if (userExamResultId !== undefined)
            url_ += "userExamResultId=" + encodeURIComponent("" + userExamResultId) + "&";
        if (comment === null)
            throw new globalThis.Error("The parameter 'comment' cannot be null.");
        else if (comment !== undefined)
            url_ += "comment=" + encodeURIComponent("" + comment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserAnswerChangeMark(_response);
        });
    }

    protected processUserAnswerChangeMark(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    essaySuggestionMark(body: EssaySuggestionMarkDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfAiResponse> {
        let url_ = this.baseUrl + "/api/v1/user-exam-result/essay-suggestion-mark";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEssaySuggestionMark(_response);
        });
    }

    protected processEssaySuggestionMark(response: AxiosResponse): Promise<ApiResponse_1OfAiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfAiResponse.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfAiResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfAiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    userIdentifierAdminGetList(body: UserIdentifierAdminFilterDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfUserIdentifierAdminDto> {
        let url_ = this.baseUrl + "/api/v1/user-identifier-admin/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserIdentifierAdminGetList(_response);
        });
    }

    protected processUserIdentifierAdminGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfUserIdentifierAdminDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfUserIdentifierAdminDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfUserIdentifierAdminDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfUserIdentifierAdminDto>(null as any);
    }

    /**
     * @param userLookup (optional) 
     * @return OK
     */
    userIdentifierAdminResolveUser(userLookup: string | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfUserIdentifierAdminResolveUserDto> {
        let url_ = this.baseUrl + "/api/v1/user-identifier-admin/resolve-user?";
        if (userLookup === null)
            throw new globalThis.Error("The parameter 'userLookup' cannot be null.");
        else if (userLookup !== undefined)
            url_ += "userLookup=" + encodeURIComponent("" + userLookup) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserIdentifierAdminResolveUser(_response);
        });
    }

    protected processUserIdentifierAdminResolveUser(response: AxiosResponse): Promise<ApiResponse_1OfUserIdentifierAdminResolveUserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfUserIdentifierAdminResolveUserDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfUserIdentifierAdminResolveUserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfUserIdentifierAdminResolveUserDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    userIdentifierAdminSave(body: UserIdentifierAdminSaveDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfUserIdentifierAdminDto> {
        let url_ = this.baseUrl + "/api/v1/user-identifier-admin/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserIdentifierAdminSave(_response);
        });
    }

    protected processUserIdentifierAdminSave(response: AxiosResponse): Promise<ApiResponse_1OfUserIdentifierAdminDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfUserIdentifierAdminDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfUserIdentifierAdminDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfUserIdentifierAdminDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    userIdentifierAdminAssign(body: UserIdentifierAdminAssignDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfUserIdentifierAdminDto> {
        let url_ = this.baseUrl + "/api/v1/user-identifier-admin/assign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserIdentifierAdminAssign(_response);
        });
    }

    protected processUserIdentifierAdminAssign(response: AxiosResponse): Promise<ApiResponse_1OfUserIdentifierAdminDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfUserIdentifierAdminDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfUserIdentifierAdminDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfUserIdentifierAdminDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    userIdentifierAdminDelete(body: UserIdentifierAdminDeleteRequestDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/user-identifier-admin/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserIdentifierAdminDelete(_response);
        });
    }

    protected processUserIdentifierAdminDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    userMobileTokenSave(body: UserMobileTokenUpdateCommand | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfUserMobileTokenEntity> {
        let url_ = this.baseUrl + "/api/v1/user-mobile-token/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserMobileTokenSave(_response);
        });
    }

    protected processUserMobileTokenSave(response: AxiosResponse): Promise<ApiResponse_1OfUserMobileTokenEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfUserMobileTokenEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfUserMobileTokenEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfUserMobileTokenEntity>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return OK
     */
    roleGetByUser(userId: number | undefined, id: string, cancelToken?: CancelToken): Promise<RoleDto> {
        let url_ = this.baseUrl + "/api/v1/user-permission/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRoleGetByUser(_response);
        });
    }

    protected processRoleGetByUser(response: AxiosResponse): Promise<RoleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoleDto.fromJS(resultData200);
            return Promise.resolve<RoleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    userWebTokenSave(body: UserWebTokenUpdateCommand | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfUserWebTokenEntity> {
        let url_ = this.baseUrl + "/api/v1/user-web-token/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserWebTokenSave(_response);
        });
    }

    protected processUserWebTokenSave(response: AxiosResponse): Promise<ApiResponse_1OfUserWebTokenEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfUserWebTokenEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfUserWebTokenEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfUserWebTokenEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    userWebTokenDelete(body: UserWebTokenDeleteCommand | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/user-web-token/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserWebTokenDelete(_response);
        });
    }

    protected processUserWebTokenDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    generateVapidKeys( cancelToken?: CancelToken): Promise<ApiResponse_1OfVapidDetails> {
        let url_ = this.baseUrl + "/api/v1/user-web-token/generate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateVapidKeys(_response);
        });
    }

    protected processGenerateVapidKeys(response: AxiosResponse): Promise<ApiResponse_1OfVapidDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfVapidDetails.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfVapidDetails>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfVapidDetails>(null as any);
    }

    /**
     * @param type (optional) 
     * @param slug (optional) 
     * @return OK
     */
    vanityResolve(type: VanityTypeEnum | undefined, slug: string | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfVanityOwnerDto> {
        let url_ = this.baseUrl + "/api/v1/vanity/resolve?";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (slug === null)
            throw new globalThis.Error("The parameter 'slug' cannot be null.");
        else if (slug !== undefined)
            url_ += "slug=" + encodeURIComponent("" + slug) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVanityResolve(_response);
        });
    }

    protected processVanityResolve(response: AxiosResponse): Promise<ApiResponse_1OfVanityOwnerDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfVanityOwnerDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfVanityOwnerDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfVanityOwnerDto>(null as any);
    }

    /**
     * @return OK
     */
    get( cancelToken?: CancelToken): Promise<WeatherForecast[]> {
        let url_ = this.baseUrl + "/weatherforecast/get";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<WeatherForecast[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WeatherForecast.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<WeatherForecast[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WeatherForecast[]>(null as any);
    }

    /**
     * @return OK
     */
    handleWebhook( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/zoom-webhook";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHandleWebhook(_response);
        });
    }

    protected processHandleWebhook(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ConsultationRegistrationUpdateStatusRequest implements IConsultationRegistrationUpdateStatusRequest {
    status?: ConsultationStatusEnum;
    adminNote?: string | undefined;

    constructor(data?: IConsultationRegistrationUpdateStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.adminNote = _data["adminNote"];
        }
    }

    static fromJS(data: any): ConsultationRegistrationUpdateStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationRegistrationUpdateStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["adminNote"] = this.adminNote;
        return data;
    }
}

export interface IConsultationRegistrationUpdateStatusRequest {
    status?: ConsultationStatusEnum;
    adminNote?: string | undefined;
}

export class ContactUpdateStatusRequest implements IContactUpdateStatusRequest {
    status?: ContactStatusEnum;
    adminNote?: string | undefined;

    constructor(data?: IContactUpdateStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.adminNote = _data["adminNote"];
        }
    }

    static fromJS(data: any): ContactUpdateStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ContactUpdateStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["adminNote"] = this.adminNote;
        return data;
    }
}

export interface IContactUpdateStatusRequest {
    status?: ContactStatusEnum;
    adminNote?: string | undefined;
}

export class DocumentFileInfo implements IDocumentFileInfo {
    fileName?: string | undefined;
    displayName?: string | undefined;
    size?: number;
    lineCount?: number;
    lastModified?: Date;
    exists?: boolean;

    constructor(data?: IDocumentFileInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.displayName = _data["displayName"];
            this.size = _data["size"];
            this.lineCount = _data["lineCount"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
            this.exists = _data["exists"];
        }
    }

    static fromJS(data: any): DocumentFileInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentFileInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["displayName"] = this.displayName;
        data["size"] = this.size;
        data["lineCount"] = this.lineCount;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        data["exists"] = this.exists;
        return data;
    }
}

export interface IDocumentFileInfo {
    fileName?: string | undefined;
    displayName?: string | undefined;
    size?: number;
    lineCount?: number;
    lastModified?: Date;
    exists?: boolean;
}

export class DocumentInfo implements IDocumentInfo {
    files?: DocumentFileInfo[] | undefined;
    totalFiles?: number;
    existingFiles?: number;
    totalSize?: number;
    lastUpdated?: Date;

    constructor(data?: IDocumentInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(DocumentFileInfo.fromJS(item));
            }
            this.totalFiles = _data["totalFiles"];
            this.existingFiles = _data["existingFiles"];
            this.totalSize = _data["totalSize"];
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): DocumentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalFiles"] = this.totalFiles;
        data["existingFiles"] = this.existingFiles;
        data["totalSize"] = this.totalSize;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : undefined as any;
        return data;
    }
}

export interface IDocumentInfo {
    files?: DocumentFileInfo[] | undefined;
    totalFiles?: number;
    existingFiles?: number;
    totalSize?: number;
    lastUpdated?: Date;
}

export class DocumentPreviewResponse implements IDocumentPreviewResponse {
    fileName?: string | undefined;
    displayName?: string | undefined;
    previewContent?: string | undefined;
    totalLines?: number;
    previewLines?: number;
    hasMore?: boolean;
    fileSize?: number;

    constructor(data?: IDocumentPreviewResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.displayName = _data["displayName"];
            this.previewContent = _data["previewContent"];
            this.totalLines = _data["totalLines"];
            this.previewLines = _data["previewLines"];
            this.hasMore = _data["hasMore"];
            this.fileSize = _data["fileSize"];
        }
    }

    static fromJS(data: any): DocumentPreviewResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentPreviewResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["displayName"] = this.displayName;
        data["previewContent"] = this.previewContent;
        data["totalLines"] = this.totalLines;
        data["previewLines"] = this.previewLines;
        data["hasMore"] = this.hasMore;
        data["fileSize"] = this.fileSize;
        return data;
    }
}

export interface IDocumentPreviewResponse {
    fileName?: string | undefined;
    displayName?: string | undefined;
    previewContent?: string | undefined;
    totalLines?: number;
    previewLines?: number;
    hasMore?: boolean;
    fileSize?: number;
}

export class ProductReviewGenerateAiRequest implements IProductReviewGenerateAiRequest {
    count?: number;

    constructor(data?: IProductReviewGenerateAiRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): ProductReviewGenerateAiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProductReviewGenerateAiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        return data;
    }
}

export interface IProductReviewGenerateAiRequest {
    count?: number;
}

export class ResponseX implements IResponseX {
    sessionId?: number;
    fileId?: number;
    docType?: string | undefined;
    pages?: { [key: string]: number[][]; } | undefined;

    constructor(data?: IResponseX) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.fileId = _data["fileId"];
            this.docType = _data["docType"];
            if (_data["pages"]) {
                this.pages = {} as any;
                for (let key in _data["pages"]) {
                    if (_data["pages"].hasOwnProperty(key))
                        (this.pages as any)![key] = _data["pages"][key] !== undefined ? _data["pages"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ResponseX {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseX();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["fileId"] = this.fileId;
        data["docType"] = this.docType;
        if (this.pages) {
            data["pages"] = {};
            for (let key in this.pages) {
                if (this.pages.hasOwnProperty(key))
                    (data["pages"] as any)[key] = (this.pages as any)[key];
            }
        }
        return data;
    }
}

export interface IResponseX {
    sessionId?: number;
    fileId?: number;
    docType?: string | undefined;
    pages?: { [key: string]: number[][]; } | undefined;
}

export class SimpleChatRequest implements ISimpleChatRequest {
    message?: string | undefined;
    systemPrompt?: string | undefined;

    constructor(data?: ISimpleChatRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.systemPrompt = _data["systemPrompt"];
        }
    }

    static fromJS(data: any): SimpleChatRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleChatRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["systemPrompt"] = this.systemPrompt;
        return data;
    }
}

export interface ISimpleChatRequest {
    message?: string | undefined;
    systemPrompt?: string | undefined;
}

export class SystemEnums implements ISystemEnums {
    code?: string | undefined;
    values?: Enum;
    items?: EnumItemEntity[] | undefined;

    constructor(data?: ISystemEnums) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.values = _data["values"] ? Enum.fromJS(_data["values"]) : undefined as any;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EnumItemEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SystemEnums {
        data = typeof data === 'object' ? data : {};
        let result = new SystemEnums();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["values"] = this.values ? this.values.toJSON() : undefined as any;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISystemEnums {
    code?: string | undefined;
    values?: Enum;
    items?: EnumItemEntity[] | undefined;
}

export class SystemInitDto implements ISystemInitDto {
    systemObjectId?: number;
    isSystem?: boolean;
    isSuperAdmin?: boolean;
    users?: UserWithSimpleInfoDto[] | undefined;
    category?: CategoryEntity[] | undefined;
    enums?: SystemEnums[] | undefined;
    userPermissions?: RoleModuleDto[] | undefined;
    currentObject?: CurrentObjectDto;
    processingStatus?: { [key: string]: number[]; } | undefined;
    readonly schoolLevels?: SchoolLevel[] | undefined;
    school?: SchoolEntity;
    academicYears?: AcademicYearEntity[] | undefined;
    languages?: LanguageListDto[] | undefined;

    constructor(data?: ISystemInitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.systemObjectId = _data["systemObjectId"];
            this.isSystem = _data["isSystem"];
            this.isSuperAdmin = _data["isSuperAdmin"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserWithSimpleInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["category"])) {
                this.category = [] as any;
                for (let item of _data["category"])
                    this.category!.push(CategoryEntity.fromJS(item));
            }
            if (Array.isArray(_data["enums"])) {
                this.enums = [] as any;
                for (let item of _data["enums"])
                    this.enums!.push(SystemEnums.fromJS(item));
            }
            if (Array.isArray(_data["userPermissions"])) {
                this.userPermissions = [] as any;
                for (let item of _data["userPermissions"])
                    this.userPermissions!.push(RoleModuleDto.fromJS(item));
            }
            this.currentObject = _data["currentObject"] ? CurrentObjectDto.fromJS(_data["currentObject"]) : undefined as any;
            if (_data["processingStatus"]) {
                this.processingStatus = {} as any;
                for (let key in _data["processingStatus"]) {
                    if (_data["processingStatus"].hasOwnProperty(key))
                        (this.processingStatus as any)![key] = _data["processingStatus"][key] !== undefined ? _data["processingStatus"][key] : [];
                }
            }
            if (Array.isArray(_data["schoolLevels"])) {
                (this as any).schoolLevels = [] as any;
                for (let item of _data["schoolLevels"])
                    (this as any).schoolLevels!.push(SchoolLevel.fromJS(item));
            }
            this.school = _data["school"] ? SchoolEntity.fromJS(_data["school"]) : undefined as any;
            if (Array.isArray(_data["academicYears"])) {
                this.academicYears = [] as any;
                for (let item of _data["academicYears"])
                    this.academicYears!.push(AcademicYearEntity.fromJS(item));
            }
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(LanguageListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SystemInitDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemInitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["systemObjectId"] = this.systemObjectId;
        data["isSystem"] = this.isSystem;
        data["isSuperAdmin"] = this.isSuperAdmin;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.category)) {
            data["category"] = [];
            for (let item of this.category)
                data["category"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.enums)) {
            data["enums"] = [];
            for (let item of this.enums)
                data["enums"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.userPermissions)) {
            data["userPermissions"] = [];
            for (let item of this.userPermissions)
                data["userPermissions"].push(item ? item.toJSON() : undefined as any);
        }
        data["currentObject"] = this.currentObject ? this.currentObject.toJSON() : undefined as any;
        if (this.processingStatus) {
            data["processingStatus"] = {};
            for (let key in this.processingStatus) {
                if (this.processingStatus.hasOwnProperty(key))
                    (data["processingStatus"] as any)[key] = (this.processingStatus as any)[key];
            }
        }
        if (Array.isArray(this.schoolLevels)) {
            data["schoolLevels"] = [];
            for (let item of this.schoolLevels)
                data["schoolLevels"].push(item ? item.toJSON() : undefined as any);
        }
        data["school"] = this.school ? this.school.toJSON() : undefined as any;
        if (Array.isArray(this.academicYears)) {
            data["academicYears"] = [];
            for (let item of this.academicYears)
                data["academicYears"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISystemInitDto {
    systemObjectId?: number;
    isSystem?: boolean;
    isSuperAdmin?: boolean;
    users?: UserWithSimpleInfoDto[] | undefined;
    category?: CategoryEntity[] | undefined;
    enums?: SystemEnums[] | undefined;
    userPermissions?: RoleModuleDto[] | undefined;
    currentObject?: CurrentObjectDto;
    processingStatus?: { [key: string]: number[]; } | undefined;
    schoolLevels?: SchoolLevel[] | undefined;
    school?: SchoolEntity;
    academicYears?: AcademicYearEntity[] | undefined;
    languages?: LanguageListDto[] | undefined;
}

export class UserIdentifierAdminDeleteRequestDto implements IUserIdentifierAdminDeleteRequestDto {
    id?: number;
    scope?: UserIdentifierAdminScopeEnum;

    constructor(data?: IUserIdentifierAdminDeleteRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.scope = _data["scope"];
        }
    }

    static fromJS(data: any): UserIdentifierAdminDeleteRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserIdentifierAdminDeleteRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["scope"] = this.scope;
        return data;
    }
}

export interface IUserIdentifierAdminDeleteRequestDto {
    id?: number;
    scope?: UserIdentifierAdminScopeEnum;
}

export class WeatherForecast implements IWeatherForecast {
    date?: Date;
    temperatureC?: number;
    readonly temperatureF?: number;
    summary?: string | undefined;

    constructor(data?: IWeatherForecast) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.temperatureC = _data["temperatureC"];
            (this as any).temperatureF = _data["temperatureF"];
            this.summary = _data["summary"];
        }
    }

    static fromJS(data: any): WeatherForecast {
        data = typeof data === 'object' ? data : {};
        let result = new WeatherForecast();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : undefined as any;
        data["temperatureC"] = this.temperatureC;
        data["temperatureF"] = this.temperatureF;
        data["summary"] = this.summary;
        return data;
    }
}

export interface IWeatherForecast {
    date?: Date;
    temperatureC?: number;
    temperatureF?: number;
    summary?: string | undefined;
}

export class AddEmailDto implements IAddEmailDto {
    email?: string | undefined;

    constructor(data?: IAddEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): AddEmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IAddEmailDto {
    email?: string | undefined;
}

export class AddUsernameDto implements IAddUsernameDto {
    username?: string | undefined;
    setAsDefault?: boolean;

    constructor(data?: IAddUsernameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.setAsDefault = _data["setAsDefault"];
        }
    }

    static fromJS(data: any): AddUsernameDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddUsernameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["setAsDefault"] = this.setAsDefault;
        return data;
    }
}

export interface IAddUsernameDto {
    username?: string | undefined;
    setAsDefault?: boolean;
}

export class ChangeEmailDto implements IChangeEmailDto {
    id?: number;
    password?: string | undefined;
    email?: string | undefined;

    constructor(data?: IChangeEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.password = _data["password"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ChangeEmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["password"] = this.password;
        data["email"] = this.email;
        return data;
    }
}

export interface IChangeEmailDto {
    id?: number;
    password?: string | undefined;
    email?: string | undefined;
}

export class ChangePasswordDto implements IChangePasswordDto {
    verificationToken?: string | undefined;
    methodId?: string | undefined;
    code?: string | undefined;

    constructor(data?: IChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.verificationToken = _data["verificationToken"];
            this.methodId = _data["methodId"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["verificationToken"] = this.verificationToken;
        data["methodId"] = this.methodId;
        data["code"] = this.code;
        return data;
    }
}

export interface IChangePasswordDto {
    verificationToken?: string | undefined;
    methodId?: string | undefined;
    code?: string | undefined;
}

export class ChangePasswordInitiateDto implements IChangePasswordInitiateDto {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;
    reNewPassword?: string | undefined;

    constructor(data?: IChangePasswordInitiateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
            this.reNewPassword = _data["reNewPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordInitiateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordInitiateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        data["reNewPassword"] = this.reNewPassword;
        return data;
    }
}

export interface IChangePasswordInitiateDto {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;
    reNewPassword?: string | undefined;
}

export class ChangePasswordInitiateResultDto implements IChangePasswordInitiateResultDto {
    verificationToken?: string | undefined;
    methods?: ChangePasswordVerifyMethodDto[] | undefined;

    constructor(data?: IChangePasswordInitiateResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.verificationToken = _data["verificationToken"];
            if (Array.isArray(_data["methods"])) {
                this.methods = [] as any;
                for (let item of _data["methods"])
                    this.methods!.push(ChangePasswordVerifyMethodDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChangePasswordInitiateResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordInitiateResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["verificationToken"] = this.verificationToken;
        if (Array.isArray(this.methods)) {
            data["methods"] = [];
            for (let item of this.methods)
                data["methods"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IChangePasswordInitiateResultDto {
    verificationToken?: string | undefined;
    methods?: ChangePasswordVerifyMethodDto[] | undefined;
}

export class ChangePasswordSendOtpDto implements IChangePasswordSendOtpDto {
    verificationToken?: string | undefined;
    methodId?: string | undefined;

    constructor(data?: IChangePasswordSendOtpDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.verificationToken = _data["verificationToken"];
            this.methodId = _data["methodId"];
        }
    }

    static fromJS(data: any): ChangePasswordSendOtpDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordSendOtpDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["verificationToken"] = this.verificationToken;
        data["methodId"] = this.methodId;
        return data;
    }
}

export interface IChangePasswordSendOtpDto {
    verificationToken?: string | undefined;
    methodId?: string | undefined;
}

export class ChangePasswordVerifyMethodDto implements IChangePasswordVerifyMethodDto {
    id?: string | undefined;
    type?: string | undefined;
    label?: string | undefined;

    constructor(data?: IChangePasswordVerifyMethodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): ChangePasswordVerifyMethodDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordVerifyMethodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["label"] = this.label;
        return data;
    }
}

export interface IChangePasswordVerifyMethodDto {
    id?: string | undefined;
    type?: string | undefined;
    label?: string | undefined;
}

export class ConfirmDeleteEmailDto implements IConfirmDeleteEmailDto {
    identifierId?: number;
    otp?: string | undefined;

    constructor(data?: IConfirmDeleteEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifierId = _data["identifierId"];
            this.otp = _data["otp"];
        }
    }

    static fromJS(data: any): ConfirmDeleteEmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmDeleteEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifierId"] = this.identifierId;
        data["otp"] = this.otp;
        return data;
    }
}

export interface IConfirmDeleteEmailDto {
    identifierId?: number;
    otp?: string | undefined;
}

export class ConfirmEmailDto implements IConfirmEmailDto {
    email?: string | undefined;
    otp?: string | undefined;

    constructor(data?: IConfirmEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.otp = _data["otp"];
        }
    }

    static fromJS(data: any): ConfirmEmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["otp"] = this.otp;
        return data;
    }
}

export interface IConfirmEmailDto {
    email?: string | undefined;
    otp?: string | undefined;
}

export class CurrentObjectDto implements ICurrentObjectDto {
    userTypes?: number[] | undefined;
    id?: number;
    type?: UserTypeEnum;
    name?: string | undefined;

    constructor(data?: ICurrentObjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userTypes = _data["userTypes"];
            this.id = _data["id"];
            this.type = _data["type"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CurrentObjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentObjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userTypes"] = this.userTypes;
        data["id"] = this.id;
        data["type"] = this.type;
        data["name"] = this.name;
        return data;
    }
}

export interface ICurrentObjectDto {
    userTypes?: number[] | undefined;
    id?: number;
    type?: UserTypeEnum;
    name?: string | undefined;
}

export class DeleteEmailRequestDto implements IDeleteEmailRequestDto {
    identifierId?: number;

    constructor(data?: IDeleteEmailRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifierId = _data["identifierId"];
        }
    }

    static fromJS(data: any): DeleteEmailRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteEmailRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifierId"] = this.identifierId;
        return data;
    }
}

export interface IDeleteEmailRequestDto {
    identifierId?: number;
}

export class Disable2FADto implements IDisable2FADto {
    code?: string | undefined;

    constructor(data?: IDisable2FADto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): Disable2FADto {
        data = typeof data === 'object' ? data : {};
        let result = new Disable2FADto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        return data;
    }
}

export interface IDisable2FADto {
    code?: string | undefined;
}

export class Disable2FaSendOtpDto implements IDisable2FaSendOtpDto {
    targetEmail?: string | undefined;

    constructor(data?: IDisable2FaSendOtpDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetEmail = _data["targetEmail"];
        }
    }

    static fromJS(data: any): Disable2FaSendOtpDto {
        data = typeof data === 'object' ? data : {};
        let result = new Disable2FaSendOtpDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetEmail"] = this.targetEmail;
        return data;
    }
}

export interface IDisable2FaSendOtpDto {
    targetEmail?: string | undefined;
}

export class Enable2FADto implements IEnable2FADto {
    code?: string | undefined;

    constructor(data?: IEnable2FADto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): Enable2FADto {
        data = typeof data === 'object' ? data : {};
        let result = new Enable2FADto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        return data;
    }
}

export interface IEnable2FADto {
    code?: string | undefined;
}

export class Enable2FAResultDto implements IEnable2FAResultDto {
    recoveryCodes?: string[] | undefined;

    constructor(data?: IEnable2FAResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["recoveryCodes"])) {
                this.recoveryCodes = [] as any;
                for (let item of _data["recoveryCodes"])
                    this.recoveryCodes!.push(item);
            }
        }
    }

    static fromJS(data: any): Enable2FAResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new Enable2FAResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.recoveryCodes)) {
            data["recoveryCodes"] = [];
            for (let item of this.recoveryCodes)
                data["recoveryCodes"].push(item);
        }
        return data;
    }
}

export interface IEnable2FAResultDto {
    recoveryCodes?: string[] | undefined;
}

export class FacebookLoginDto implements IFacebookLoginDto {
    code?: string | undefined;
    accessToken?: string | undefined;

    constructor(data?: IFacebookLoginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.accessToken = _data["accessToken"];
        }
    }

    static fromJS(data: any): FacebookLoginDto {
        data = typeof data === 'object' ? data : {};
        let result = new FacebookLoginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["accessToken"] = this.accessToken;
        return data;
    }
}

export interface IFacebookLoginDto {
    code?: string | undefined;
    accessToken?: string | undefined;
}

export class FamilyCreateChildDto implements IFamilyCreateChildDto {
    username?: string | undefined;
    password?: string | undefined;
    fullName?: string | undefined;

    constructor(data?: IFamilyCreateChildDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): FamilyCreateChildDto {
        data = typeof data === 'object' ? data : {};
        let result = new FamilyCreateChildDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface IFamilyCreateChildDto {
    username?: string | undefined;
    password?: string | undefined;
    fullName?: string | undefined;
}

export class FamilyLinkByIdentifierDto implements IFamilyLinkByIdentifierDto {
    usernameOrEmail?: string | undefined;

    constructor(data?: IFamilyLinkByIdentifierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.usernameOrEmail = _data["usernameOrEmail"];
        }
    }

    static fromJS(data: any): FamilyLinkByIdentifierDto {
        data = typeof data === 'object' ? data : {};
        let result = new FamilyLinkByIdentifierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["usernameOrEmail"] = this.usernameOrEmail;
        return data;
    }
}

export interface IFamilyLinkByIdentifierDto {
    usernameOrEmail?: string | undefined;
}

export class FamilyMemberDto implements IFamilyMemberDto {
    familyLinkId?: number;
    userId?: number;
    userName?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    avatar?: string | undefined;
    status?: FamilyLinkStatusEnum;
    createdByParent?: boolean;
    isKid?: boolean;
    initiatedByMe?: boolean;
    createdDate?: Date;
    acceptedDate?: Date | undefined;

    constructor(data?: IFamilyMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.familyLinkId = _data["familyLinkId"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.avatar = _data["avatar"];
            this.status = _data["status"];
            this.createdByParent = _data["createdByParent"];
            this.isKid = _data["isKid"];
            this.initiatedByMe = _data["initiatedByMe"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.acceptedDate = _data["acceptedDate"] ? new Date(_data["acceptedDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): FamilyMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new FamilyMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["familyLinkId"] = this.familyLinkId;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["avatar"] = this.avatar;
        data["status"] = this.status;
        data["createdByParent"] = this.createdByParent;
        data["isKid"] = this.isKid;
        data["initiatedByMe"] = this.initiatedByMe;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["acceptedDate"] = this.acceptedDate ? this.acceptedDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IFamilyMemberDto {
    familyLinkId?: number;
    userId?: number;
    userName?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    avatar?: string | undefined;
    status?: FamilyLinkStatusEnum;
    createdByParent?: boolean;
    isKid?: boolean;
    initiatedByMe?: boolean;
    createdDate?: Date;
    acceptedDate?: Date | undefined;
}

export class FamilyQuotaDto implements IFamilyQuotaDto {
    linkedChildrenCount?: number;
    maxLinkedChildren?: number;
    createdChildrenCount?: number;
    maxCreatedChildren?: number;
    linkedParentsCount?: number;
    maxLinkedParents?: number;

    constructor(data?: IFamilyQuotaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.linkedChildrenCount = _data["linkedChildrenCount"];
            this.maxLinkedChildren = _data["maxLinkedChildren"];
            this.createdChildrenCount = _data["createdChildrenCount"];
            this.maxCreatedChildren = _data["maxCreatedChildren"];
            this.linkedParentsCount = _data["linkedParentsCount"];
            this.maxLinkedParents = _data["maxLinkedParents"];
        }
    }

    static fromJS(data: any): FamilyQuotaDto {
        data = typeof data === 'object' ? data : {};
        let result = new FamilyQuotaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkedChildrenCount"] = this.linkedChildrenCount;
        data["maxLinkedChildren"] = this.maxLinkedChildren;
        data["createdChildrenCount"] = this.createdChildrenCount;
        data["maxCreatedChildren"] = this.maxCreatedChildren;
        data["linkedParentsCount"] = this.linkedParentsCount;
        data["maxLinkedParents"] = this.maxLinkedParents;
        return data;
    }
}

export interface IFamilyQuotaDto {
    linkedChildrenCount?: number;
    maxLinkedChildren?: number;
    createdChildrenCount?: number;
    maxCreatedChildren?: number;
    linkedParentsCount?: number;
    maxLinkedParents?: number;
}

export class FamilyResetChildPasswordDto implements IFamilyResetChildPasswordDto {
    childUserId?: number;
    newPassword?: string | undefined;
    otp?: string | undefined;

    constructor(data?: IFamilyResetChildPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.childUserId = _data["childUserId"];
            this.newPassword = _data["newPassword"];
            this.otp = _data["otp"];
        }
    }

    static fromJS(data: any): FamilyResetChildPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new FamilyResetChildPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["childUserId"] = this.childUserId;
        data["newPassword"] = this.newPassword;
        data["otp"] = this.otp;
        return data;
    }
}

export interface IFamilyResetChildPasswordDto {
    childUserId?: number;
    newPassword?: string | undefined;
    otp?: string | undefined;
}

export class ForgotPasswordCheckOTPResource implements IForgotPasswordCheckOTPResource {
    username?: string | undefined;
    otp?: string | undefined;

    constructor(data?: IForgotPasswordCheckOTPResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.otp = _data["otp"];
        }
    }

    static fromJS(data: any): ForgotPasswordCheckOTPResource {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordCheckOTPResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["otp"] = this.otp;
        return data;
    }
}

export interface IForgotPasswordCheckOTPResource {
    username?: string | undefined;
    otp?: string | undefined;
}

export class ForgotPasswordOtpVerifiedDto implements IForgotPasswordOtpVerifiedDto {
    token?: string | undefined;

    constructor(data?: IForgotPasswordOtpVerifiedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): ForgotPasswordOtpVerifiedDto {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordOtpVerifiedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        return data;
    }
}

export interface IForgotPasswordOtpVerifiedDto {
    token?: string | undefined;
}

export class GoogleLinkStatusDto implements IGoogleLinkStatusDto {
    isLinked?: boolean;
    email?: string | undefined;

    constructor(data?: IGoogleLinkStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isLinked = _data["isLinked"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): GoogleLinkStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new GoogleLinkStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isLinked"] = this.isLinked;
        data["email"] = this.email;
        return data;
    }
}

export interface IGoogleLinkStatusDto {
    isLinked?: boolean;
    email?: string | undefined;
}

export class GoogleLoginDto implements IGoogleLoginDto {
    code?: string | undefined;
    accessToken?: string | undefined;

    constructor(data?: IGoogleLoginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.accessToken = _data["accessToken"];
        }
    }

    static fromJS(data: any): GoogleLoginDto {
        data = typeof data === 'object' ? data : {};
        let result = new GoogleLoginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["accessToken"] = this.accessToken;
        return data;
    }
}

export interface IGoogleLoginDto {
    code?: string | undefined;
    accessToken?: string | undefined;
}

export class LoginDto implements ILoginDto {
    userName?: string | undefined;
    password?: string | undefined;
    rememberMe?: boolean;
    captchaText?: string | undefined;
    captchaToken?: string | undefined;
    captchaInputText?: string | undefined;

    constructor(data?: ILoginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.rememberMe = _data["rememberMe"];
            this.captchaText = _data["captchaText"];
            this.captchaToken = _data["captchaToken"];
            this.captchaInputText = _data["captchaInputText"];
        }
    }

    static fromJS(data: any): LoginDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["rememberMe"] = this.rememberMe;
        data["captchaText"] = this.captchaText;
        data["captchaToken"] = this.captchaToken;
        data["captchaInputText"] = this.captchaInputText;
        return data;
    }
}

export interface ILoginDto {
    userName?: string | undefined;
    password?: string | undefined;
    rememberMe?: boolean;
    captchaText?: string | undefined;
    captchaToken?: string | undefined;
    captchaInputText?: string | undefined;
}

export class LoginResponseDto implements ILoginResponseDto {
    require2Fa?: boolean;
    twoFactorToken?: string | undefined;
    token?: string | undefined;
    refreshToken?: string | undefined;
    userInfo?: UserInfoDto;
    isNewUser?: boolean;

    constructor(data?: ILoginResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.require2Fa = _data["require2Fa"];
            this.twoFactorToken = _data["twoFactorToken"];
            this.token = _data["token"];
            this.refreshToken = _data["refreshToken"];
            this.userInfo = _data["userInfo"] ? UserInfoDto.fromJS(_data["userInfo"]) : undefined as any;
            this.isNewUser = _data["isNewUser"];
        }
    }

    static fromJS(data: any): LoginResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoginResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["require2Fa"] = this.require2Fa;
        data["twoFactorToken"] = this.twoFactorToken;
        data["token"] = this.token;
        data["refreshToken"] = this.refreshToken;
        data["userInfo"] = this.userInfo ? this.userInfo.toJSON() : undefined as any;
        data["isNewUser"] = this.isNewUser;
        return data;
    }
}

export interface ILoginResponseDto {
    require2Fa?: boolean;
    twoFactorToken?: string | undefined;
    token?: string | undefined;
    refreshToken?: string | undefined;
    userInfo?: UserInfoDto;
    isNewUser?: boolean;
}

export class LoginWith2FADto implements ILoginWith2FADto {
    userName?: string | undefined;
    code?: string | undefined;
    twoFactorToken?: string | undefined;
    rememberDevice?: boolean;

    constructor(data?: ILoginWith2FADto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.code = _data["code"];
            this.twoFactorToken = _data["twoFactorToken"];
            this.rememberDevice = _data["rememberDevice"];
        }
    }

    static fromJS(data: any): LoginWith2FADto {
        data = typeof data === 'object' ? data : {};
        let result = new LoginWith2FADto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["code"] = this.code;
        data["twoFactorToken"] = this.twoFactorToken;
        data["rememberDevice"] = this.rememberDevice;
        return data;
    }
}

export interface ILoginWith2FADto {
    userName?: string | undefined;
    code?: string | undefined;
    twoFactorToken?: string | undefined;
    rememberDevice?: boolean;
}

export class OtpSendResultDto implements IOtpSendResultDto {
    targetEmail?: string | undefined;
    isNew?: boolean;
    cooldownSeconds?: number;

    constructor(data?: IOtpSendResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetEmail = _data["targetEmail"];
            this.isNew = _data["isNew"];
            this.cooldownSeconds = _data["cooldownSeconds"];
        }
    }

    static fromJS(data: any): OtpSendResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OtpSendResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetEmail"] = this.targetEmail;
        data["isNew"] = this.isNew;
        data["cooldownSeconds"] = this.cooldownSeconds;
        return data;
    }
}

export interface IOtpSendResultDto {
    targetEmail?: string | undefined;
    isNew?: boolean;
    cooldownSeconds?: number;
}

export class OtpTargetEmailOptionDto implements IOtpTargetEmailOptionDto {
    id?: string | undefined;
    email?: string | undefined;
    label?: string | undefined;
    source?: OtpTargetEmailSource;
    parentUserId?: number | undefined;

    constructor(data?: IOtpTargetEmailOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.label = _data["label"];
            this.source = _data["source"];
            this.parentUserId = _data["parentUserId"];
        }
    }

    static fromJS(data: any): OtpTargetEmailOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new OtpTargetEmailOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["label"] = this.label;
        data["source"] = this.source;
        data["parentUserId"] = this.parentUserId;
        return data;
    }
}

export interface IOtpTargetEmailOptionDto {
    id?: string | undefined;
    email?: string | undefined;
    label?: string | undefined;
    source?: OtpTargetEmailSource;
    parentUserId?: number | undefined;
}

export class OtpTargetEmailOptionsDto implements IOtpTargetEmailOptionsDto {
    isKid?: boolean;
    requiresSelection?: boolean;
    options?: OtpTargetEmailOptionDto[] | undefined;

    constructor(data?: IOtpTargetEmailOptionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isKid = _data["isKid"];
            this.requiresSelection = _data["requiresSelection"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(OtpTargetEmailOptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OtpTargetEmailOptionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new OtpTargetEmailOptionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isKid"] = this.isKid;
        data["requiresSelection"] = this.requiresSelection;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOtpTargetEmailOptionsDto {
    isKid?: boolean;
    requiresSelection?: boolean;
    options?: OtpTargetEmailOptionDto[] | undefined;
}

export enum OtpTargetEmailSource {
    Own = 0,
    Parent = 1,
}

export class Recover2FaSendOtpDto implements IRecover2FaSendOtpDto {
    userName?: string | undefined;
    twoFactorToken?: string | undefined;
    targetEmail?: string | undefined;

    constructor(data?: IRecover2FaSendOtpDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.twoFactorToken = _data["twoFactorToken"];
            this.targetEmail = _data["targetEmail"];
        }
    }

    static fromJS(data: any): Recover2FaSendOtpDto {
        data = typeof data === 'object' ? data : {};
        let result = new Recover2FaSendOtpDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["twoFactorToken"] = this.twoFactorToken;
        data["targetEmail"] = this.targetEmail;
        return data;
    }
}

export interface IRecover2FaSendOtpDto {
    userName?: string | undefined;
    twoFactorToken?: string | undefined;
    targetEmail?: string | undefined;
}

export class RecoveryCodesStatusDto implements IRecoveryCodesStatusDto {
    twoFactorEnabled?: boolean;
    remainingCount?: number;
    recoveryCodes?: string[] | undefined;

    constructor(data?: IRecoveryCodesStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.twoFactorEnabled = _data["twoFactorEnabled"];
            this.remainingCount = _data["remainingCount"];
            if (Array.isArray(_data["recoveryCodes"])) {
                this.recoveryCodes = [] as any;
                for (let item of _data["recoveryCodes"])
                    this.recoveryCodes!.push(item);
            }
        }
    }

    static fromJS(data: any): RecoveryCodesStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecoveryCodesStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["twoFactorEnabled"] = this.twoFactorEnabled;
        data["remainingCount"] = this.remainingCount;
        if (Array.isArray(this.recoveryCodes)) {
            data["recoveryCodes"] = [];
            for (let item of this.recoveryCodes)
                data["recoveryCodes"].push(item);
        }
        return data;
    }
}

export interface IRecoveryCodesStatusDto {
    twoFactorEnabled?: boolean;
    remainingCount?: number;
    recoveryCodes?: string[] | undefined;
}

export class RefreshTokenResponseDto implements IRefreshTokenResponseDto {
    token?: string | undefined;
    refreshToken?: string | undefined;

    constructor(data?: IRefreshTokenResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): RefreshTokenResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface IRefreshTokenResponseDto {
    token?: string | undefined;
    refreshToken?: string | undefined;
}

export class RegisterDto implements IRegisterDto {
    isSuperAdmin?: boolean;
    userName?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    roles?: number[] | undefined;
    id?: number;
    avatar?: string | undefined;
    status?: number | undefined;
    type?: UserTypeEnum;
    objectId?: number;
    provinceId?: number;
    schoolId?: number | undefined;
    identifierCode?: string | undefined;
    birthDay?: Date | undefined;
    gender?: number | undefined;
    address?: string | undefined;
    isSystem?: boolean;
    departments?: UserDepartmentDto[] | undefined;

    constructor(data?: IRegisterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuperAdmin = _data["isSuperAdmin"];
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.password = _data["password"];
            this.fullName = _data["fullName"];
            this.phoneNumber = _data["phoneNumber"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.id = _data["id"];
            this.avatar = _data["avatar"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.objectId = _data["objectId"];
            this.provinceId = _data["provinceId"];
            this.schoolId = _data["schoolId"];
            this.identifierCode = _data["identifierCode"];
            this.birthDay = _data["birthDay"] ? new Date(_data["birthDay"].toString()) : undefined as any;
            this.gender = _data["gender"];
            this.address = _data["address"];
            this.isSystem = _data["isSystem"];
            if (Array.isArray(_data["departments"])) {
                this.departments = [] as any;
                for (let item of _data["departments"])
                    this.departments!.push(UserDepartmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RegisterDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuperAdmin"] = this.isSuperAdmin;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["password"] = this.password;
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["id"] = this.id;
        data["avatar"] = this.avatar;
        data["status"] = this.status;
        data["type"] = this.type;
        data["objectId"] = this.objectId;
        data["provinceId"] = this.provinceId;
        data["schoolId"] = this.schoolId;
        data["identifierCode"] = this.identifierCode;
        data["birthDay"] = this.birthDay ? this.birthDay.toISOString() : undefined as any;
        data["gender"] = this.gender;
        data["address"] = this.address;
        data["isSystem"] = this.isSystem;
        if (Array.isArray(this.departments)) {
            data["departments"] = [];
            for (let item of this.departments)
                data["departments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRegisterDto {
    isSuperAdmin?: boolean;
    userName?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    roles?: number[] | undefined;
    id?: number;
    avatar?: string | undefined;
    status?: number | undefined;
    type?: UserTypeEnum;
    objectId?: number;
    provinceId?: number;
    schoolId?: number | undefined;
    identifierCode?: string | undefined;
    birthDay?: Date | undefined;
    gender?: number | undefined;
    address?: string | undefined;
    isSystem?: boolean;
    departments?: UserDepartmentDto[] | undefined;
}

export class RenameUsernameDto implements IRenameUsernameDto {
    newUsername?: string | undefined;

    constructor(data?: IRenameUsernameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newUsername = _data["newUsername"];
        }
    }

    static fromJS(data: any): RenameUsernameDto {
        data = typeof data === 'object' ? data : {};
        let result = new RenameUsernameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newUsername"] = this.newUsername;
        return data;
    }
}

export interface IRenameUsernameDto {
    newUsername?: string | undefined;
}

export class ResetPasswordByUserNameResource implements IResetPasswordByUserNameResource {
    username?: string | undefined;
    password?: string | undefined;
    rePassword?: string | undefined;
    token?: string | undefined;

    constructor(data?: IResetPasswordByUserNameResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
            this.rePassword = _data["rePassword"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): ResetPasswordByUserNameResource {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordByUserNameResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        data["rePassword"] = this.rePassword;
        data["token"] = this.token;
        return data;
    }
}

export interface IResetPasswordByUserNameResource {
    username?: string | undefined;
    password?: string | undefined;
    rePassword?: string | undefined;
    token?: string | undefined;
}

export class SetDefaultIdentifierDto implements ISetDefaultIdentifierDto {
    identifierId?: number;

    constructor(data?: ISetDefaultIdentifierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifierId = _data["identifierId"];
        }
    }

    static fromJS(data: any): SetDefaultIdentifierDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetDefaultIdentifierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifierId"] = this.identifierId;
        return data;
    }
}

export interface ISetDefaultIdentifierDto {
    identifierId?: number;
}

export class SetPasswordDto implements ISetPasswordDto {
    password?: string | undefined;
    newUsername?: string | undefined;

    constructor(data?: ISetPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.password = _data["password"];
            this.newUsername = _data["newUsername"];
        }
    }

    static fromJS(data: any): SetPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        data["newUsername"] = this.newUsername;
        return data;
    }
}

export interface ISetPasswordDto {
    password?: string | undefined;
    newUsername?: string | undefined;
}

export class Setup2FADto implements ISetup2FADto {
    sharedKey?: string | undefined;
    authenticatorUri?: string | undefined;

    constructor(data?: ISetup2FADto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sharedKey = _data["sharedKey"];
            this.authenticatorUri = _data["authenticatorUri"];
        }
    }

    static fromJS(data: any): Setup2FADto {
        data = typeof data === 'object' ? data : {};
        let result = new Setup2FADto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sharedKey"] = this.sharedKey;
        data["authenticatorUri"] = this.authenticatorUri;
        return data;
    }
}

export interface ISetup2FADto {
    sharedKey?: string | undefined;
    authenticatorUri?: string | undefined;
}

export class TeacherCreateDto implements ITeacherCreateDto {
    userName?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    roles?: number[] | undefined;
    id?: number;
    avatar?: string | undefined;
    status?: number | undefined;
    type?: UserTypeEnum;
    objectId?: number;
    provinceId?: number;
    birthDay?: Date | undefined;
    gender?: number | undefined;
    identifierCode?: string | undefined;
    isTemp?: boolean;
    classId?: number | undefined;
    className?: string | undefined;
    ethnic?: string | undefined;
    rowIndex?: number;
    address?: string | undefined;
    isSystem?: boolean;
    classListStr?: string | undefined;
    classManageStr?: string | undefined;
    subject?: string | undefined;

    constructor(data?: ITeacherCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.password = _data["password"];
            this.fullName = _data["fullName"];
            this.phoneNumber = _data["phoneNumber"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.id = _data["id"];
            this.avatar = _data["avatar"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.objectId = _data["objectId"];
            this.provinceId = _data["provinceId"];
            this.birthDay = _data["birthDay"] ? new Date(_data["birthDay"].toString()) : undefined as any;
            this.gender = _data["gender"];
            this.identifierCode = _data["identifierCode"];
            this.isTemp = _data["isTemp"];
            this.classId = _data["classId"];
            this.className = _data["className"];
            this.ethnic = _data["ethnic"];
            this.rowIndex = _data["rowIndex"];
            this.address = _data["address"];
            this.isSystem = _data["isSystem"];
            this.classListStr = _data["classListStr"];
            this.classManageStr = _data["classManageStr"];
            this.subject = _data["subject"];
        }
    }

    static fromJS(data: any): TeacherCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeacherCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["password"] = this.password;
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["id"] = this.id;
        data["avatar"] = this.avatar;
        data["status"] = this.status;
        data["type"] = this.type;
        data["objectId"] = this.objectId;
        data["provinceId"] = this.provinceId;
        data["birthDay"] = this.birthDay ? this.birthDay.toISOString() : undefined as any;
        data["gender"] = this.gender;
        data["identifierCode"] = this.identifierCode;
        data["isTemp"] = this.isTemp;
        data["classId"] = this.classId;
        data["className"] = this.className;
        data["ethnic"] = this.ethnic;
        data["rowIndex"] = this.rowIndex;
        data["address"] = this.address;
        data["isSystem"] = this.isSystem;
        data["classListStr"] = this.classListStr;
        data["classManageStr"] = this.classManageStr;
        data["subject"] = this.subject;
        return data;
    }
}

export interface ITeacherCreateDto {
    userName?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    roles?: number[] | undefined;
    id?: number;
    avatar?: string | undefined;
    status?: number | undefined;
    type?: UserTypeEnum;
    objectId?: number;
    provinceId?: number;
    birthDay?: Date | undefined;
    gender?: number | undefined;
    identifierCode?: string | undefined;
    isTemp?: boolean;
    classId?: number | undefined;
    className?: string | undefined;
    ethnic?: string | undefined;
    rowIndex?: number;
    address?: string | undefined;
    isSystem?: boolean;
    classListStr?: string | undefined;
    classManageStr?: string | undefined;
    subject?: string | undefined;
}

export class UpdateAvatarDto implements IUpdateAvatarDto {
    avatar?: string | undefined;

    constructor(data?: IUpdateAvatarDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.avatar = _data["avatar"];
        }
    }

    static fromJS(data: any): UpdateAvatarDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAvatarDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["avatar"] = this.avatar;
        return data;
    }
}

export interface IUpdateAvatarDto {
    avatar?: string | undefined;
}

export class UpdateInfoDto implements IUpdateInfoDto {
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    avatar?: string | undefined;
    address?: string | undefined;
    birthDay?: Date | undefined;
    gender?: number | undefined;

    constructor(data?: IUpdateInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.phoneNumber = _data["phoneNumber"];
            this.avatar = _data["avatar"];
            this.address = _data["address"];
            this.birthDay = _data["birthDay"] ? new Date(_data["birthDay"].toString()) : undefined as any;
            this.gender = _data["gender"];
        }
    }

    static fromJS(data: any): UpdateInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        data["avatar"] = this.avatar;
        data["address"] = this.address;
        data["birthDay"] = this.birthDay ? this.birthDay.toISOString() : undefined as any;
        data["gender"] = this.gender;
        return data;
    }
}

export interface IUpdateInfoDto {
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    avatar?: string | undefined;
    address?: string | undefined;
    birthDay?: Date | undefined;
    gender?: number | undefined;
}

export class UserCreateDto implements IUserCreateDto {
    userName?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    roles?: number[] | undefined;
    id?: number;
    avatar?: string | undefined;
    status?: number | undefined;
    type?: UserTypeEnum;
    objectId?: number;
    provinceId?: number;
    birthDay?: Date | undefined;
    gender?: number | undefined;
    identifierCode?: string | undefined;
    isTemp?: boolean;
    classId?: number | undefined;
    className?: string | undefined;
    ethnic?: string | undefined;
    rowIndex?: number;
    address?: string | undefined;
    isSystem?: boolean;

    constructor(data?: IUserCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.password = _data["password"];
            this.fullName = _data["fullName"];
            this.phoneNumber = _data["phoneNumber"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.id = _data["id"];
            this.avatar = _data["avatar"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.objectId = _data["objectId"];
            this.provinceId = _data["provinceId"];
            this.birthDay = _data["birthDay"] ? new Date(_data["birthDay"].toString()) : undefined as any;
            this.gender = _data["gender"];
            this.identifierCode = _data["identifierCode"];
            this.isTemp = _data["isTemp"];
            this.classId = _data["classId"];
            this.className = _data["className"];
            this.ethnic = _data["ethnic"];
            this.rowIndex = _data["rowIndex"];
            this.address = _data["address"];
            this.isSystem = _data["isSystem"];
        }
    }

    static fromJS(data: any): UserCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["password"] = this.password;
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["id"] = this.id;
        data["avatar"] = this.avatar;
        data["status"] = this.status;
        data["type"] = this.type;
        data["objectId"] = this.objectId;
        data["provinceId"] = this.provinceId;
        data["birthDay"] = this.birthDay ? this.birthDay.toISOString() : undefined as any;
        data["gender"] = this.gender;
        data["identifierCode"] = this.identifierCode;
        data["isTemp"] = this.isTemp;
        data["classId"] = this.classId;
        data["className"] = this.className;
        data["ethnic"] = this.ethnic;
        data["rowIndex"] = this.rowIndex;
        data["address"] = this.address;
        data["isSystem"] = this.isSystem;
        return data;
    }
}

export interface IUserCreateDto {
    userName?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    roles?: number[] | undefined;
    id?: number;
    avatar?: string | undefined;
    status?: number | undefined;
    type?: UserTypeEnum;
    objectId?: number;
    provinceId?: number;
    birthDay?: Date | undefined;
    gender?: number | undefined;
    identifierCode?: string | undefined;
    isTemp?: boolean;
    classId?: number | undefined;
    className?: string | undefined;
    ethnic?: string | undefined;
    rowIndex?: number;
    address?: string | undefined;
    isSystem?: boolean;
}

export class UserDepartmentDto implements IUserDepartmentDto {
    departmentUserId?: number;
    departmentId?: number;
    departmentName?: string | undefined;
    title?: string | undefined;
    titleId?: number;
    isPrimary?: boolean;
    roleIds?: number[] | undefined;

    constructor(data?: IUserDepartmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departmentUserId = _data["departmentUserId"];
            this.departmentId = _data["departmentId"];
            this.departmentName = _data["departmentName"];
            this.title = _data["title"];
            this.titleId = _data["titleId"];
            this.isPrimary = _data["isPrimary"];
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UserDepartmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDepartmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departmentUserId"] = this.departmentUserId;
        data["departmentId"] = this.departmentId;
        data["departmentName"] = this.departmentName;
        data["title"] = this.title;
        data["titleId"] = this.titleId;
        data["isPrimary"] = this.isPrimary;
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        return data;
    }
}

export interface IUserDepartmentDto {
    departmentUserId?: number;
    departmentId?: number;
    departmentName?: string | undefined;
    title?: string | undefined;
    titleId?: number;
    isPrimary?: boolean;
    roleIds?: number[] | undefined;
}

export class UserIdentifierDto implements IUserIdentifierDto {
    id?: number;
    type?: UserIdentifierType;
    value?: string | undefined;
    isDefault?: boolean;
    isConfirmed?: boolean;
    requiresRename?: boolean;
    confirmedDate?: Date | undefined;
    createdDate?: Date;

    constructor(data?: IUserIdentifierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.value = _data["value"];
            this.isDefault = _data["isDefault"];
            this.isConfirmed = _data["isConfirmed"];
            this.requiresRename = _data["requiresRename"];
            this.confirmedDate = _data["confirmedDate"] ? new Date(_data["confirmedDate"].toString()) : undefined as any;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UserIdentifierDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserIdentifierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["value"] = this.value;
        data["isDefault"] = this.isDefault;
        data["isConfirmed"] = this.isConfirmed;
        data["requiresRename"] = this.requiresRename;
        data["confirmedDate"] = this.confirmedDate ? this.confirmedDate.toISOString() : undefined as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IUserIdentifierDto {
    id?: number;
    type?: UserIdentifierType;
    value?: string | undefined;
    isDefault?: boolean;
    isConfirmed?: boolean;
    requiresRename?: boolean;
    confirmedDate?: Date | undefined;
    createdDate?: Date;
}

export class UserInfoDto implements IUserInfoDto {
    id?: number;
    userName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    fullName?: string | undefined;
    avatar?: string | undefined;
    lastLoginDate?: string | undefined;
    type?: UserTypeEnum;
    objectId?: number;
    isKid?: boolean;
    hasLocalPassword?: boolean;
    hasGoogleLinked?: boolean;
    address?: string | undefined;
    birthDay?: Date | undefined;
    gender?: number | undefined;
    twoFactorEnabled?: boolean;
    languageCode?: string | undefined;

    constructor(data?: IUserInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.fullName = _data["fullName"];
            this.avatar = _data["avatar"];
            this.lastLoginDate = _data["lastLoginDate"];
            this.type = _data["type"];
            this.objectId = _data["objectId"];
            this.isKid = _data["isKid"];
            this.hasLocalPassword = _data["hasLocalPassword"];
            this.hasGoogleLinked = _data["hasGoogleLinked"];
            this.address = _data["address"];
            this.birthDay = _data["birthDay"] ? new Date(_data["birthDay"].toString()) : undefined as any;
            this.gender = _data["gender"];
            this.twoFactorEnabled = _data["twoFactorEnabled"];
            this.languageCode = _data["languageCode"];
        }
    }

    static fromJS(data: any): UserInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["fullName"] = this.fullName;
        data["avatar"] = this.avatar;
        data["lastLoginDate"] = this.lastLoginDate;
        data["type"] = this.type;
        data["objectId"] = this.objectId;
        data["isKid"] = this.isKid;
        data["hasLocalPassword"] = this.hasLocalPassword;
        data["hasGoogleLinked"] = this.hasGoogleLinked;
        data["address"] = this.address;
        data["birthDay"] = this.birthDay ? this.birthDay.toISOString() : undefined as any;
        data["gender"] = this.gender;
        data["twoFactorEnabled"] = this.twoFactorEnabled;
        data["languageCode"] = this.languageCode;
        return data;
    }
}

export interface IUserInfoDto {
    id?: number;
    userName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    fullName?: string | undefined;
    avatar?: string | undefined;
    lastLoginDate?: string | undefined;
    type?: UserTypeEnum;
    objectId?: number;
    isKid?: boolean;
    hasLocalPassword?: boolean;
    hasGoogleLinked?: boolean;
    address?: string | undefined;
    birthDay?: Date | undefined;
    gender?: number | undefined;
    twoFactorEnabled?: boolean;
    languageCode?: string | undefined;
}

export class ValidationRulesDto implements IValidationRulesDto {
    usernameRegex?: string | undefined;
    passwordRegex?: string | undefined;
    identifierMaxUsernames?: number;
    identifierMaxEmails?: number;

    constructor(data?: IValidationRulesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.usernameRegex = _data["usernameRegex"];
            this.passwordRegex = _data["passwordRegex"];
            this.identifierMaxUsernames = _data["identifierMaxUsernames"];
            this.identifierMaxEmails = _data["identifierMaxEmails"];
        }
    }

    static fromJS(data: any): ValidationRulesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationRulesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["usernameRegex"] = this.usernameRegex;
        data["passwordRegex"] = this.passwordRegex;
        data["identifierMaxUsernames"] = this.identifierMaxUsernames;
        data["identifierMaxEmails"] = this.identifierMaxEmails;
        return data;
    }
}

export interface IValidationRulesDto {
    usernameRegex?: string | undefined;
    passwordRegex?: string | undefined;
    identifierMaxUsernames?: number;
    identifierMaxEmails?: number;
}

export class SystemConfigAdminDto implements ISystemConfigAdminDto {
    id?: number;
    key?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    value?: string | undefined;
    defaultValue?: string | undefined;
    dataType?: SystemConfigDataTypeEnum;
    group?: SystemConfigGroupEnum;
    displayOrder?: number;
    isRequired?: boolean;
    isReadOnly?: boolean;
    isVisible?: boolean;
    isEncrypted?: boolean;
    validationPattern?: string | undefined;
    validationMessage?: string | undefined;
    minValue?: number | undefined;
    maxValue?: number | undefined;
    selectOptions?: string | undefined;
    placeholderText?: string | undefined;
    helpText?: string | undefined;
    organizationId?: number;
    scope?: SystemConfigScopeEnum;

    constructor(data?: ISystemConfigAdminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.key = _data["key"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.value = _data["value"];
            this.defaultValue = _data["defaultValue"];
            this.dataType = _data["dataType"];
            this.group = _data["group"];
            this.displayOrder = _data["displayOrder"];
            this.isRequired = _data["isRequired"];
            this.isReadOnly = _data["isReadOnly"];
            this.isVisible = _data["isVisible"];
            this.isEncrypted = _data["isEncrypted"];
            this.validationPattern = _data["validationPattern"];
            this.validationMessage = _data["validationMessage"];
            this.minValue = _data["minValue"];
            this.maxValue = _data["maxValue"];
            this.selectOptions = _data["selectOptions"];
            this.placeholderText = _data["placeholderText"];
            this.helpText = _data["helpText"];
            this.organizationId = _data["organizationId"];
            this.scope = _data["scope"];
        }
    }

    static fromJS(data: any): SystemConfigAdminDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemConfigAdminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["key"] = this.key;
        data["name"] = this.name;
        data["description"] = this.description;
        data["value"] = this.value;
        data["defaultValue"] = this.defaultValue;
        data["dataType"] = this.dataType;
        data["group"] = this.group;
        data["displayOrder"] = this.displayOrder;
        data["isRequired"] = this.isRequired;
        data["isReadOnly"] = this.isReadOnly;
        data["isVisible"] = this.isVisible;
        data["isEncrypted"] = this.isEncrypted;
        data["validationPattern"] = this.validationPattern;
        data["validationMessage"] = this.validationMessage;
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        data["selectOptions"] = this.selectOptions;
        data["placeholderText"] = this.placeholderText;
        data["helpText"] = this.helpText;
        data["organizationId"] = this.organizationId;
        data["scope"] = this.scope;
        return data;
    }
}

export interface ISystemConfigAdminDto {
    id?: number;
    key?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    value?: string | undefined;
    defaultValue?: string | undefined;
    dataType?: SystemConfigDataTypeEnum;
    group?: SystemConfigGroupEnum;
    displayOrder?: number;
    isRequired?: boolean;
    isReadOnly?: boolean;
    isVisible?: boolean;
    isEncrypted?: boolean;
    validationPattern?: string | undefined;
    validationMessage?: string | undefined;
    minValue?: number | undefined;
    maxValue?: number | undefined;
    selectOptions?: string | undefined;
    placeholderText?: string | undefined;
    helpText?: string | undefined;
    organizationId?: number;
    scope?: SystemConfigScopeEnum;
}

export class SystemConfigFilterDto implements ISystemConfigFilterDto {
    keyword?: string | undefined;
    group?: SystemConfigGroupEnum;
    pageIndex?: number;
    pageSize?: number;

    constructor(data?: ISystemConfigFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keyword = _data["keyword"];
            this.group = _data["group"];
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): SystemConfigFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemConfigFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyword"] = this.keyword;
        data["group"] = this.group;
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface ISystemConfigFilterDto {
    keyword?: string | undefined;
    group?: SystemConfigGroupEnum;
    pageIndex?: number;
    pageSize?: number;
}

export class SystemConfigSaveDto implements ISystemConfigSaveDto {
    id?: number;
    value?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    displayOrder?: number;
    isVisible?: boolean;
    helpText?: string | undefined;
    key?: string | undefined;
    defaultValue?: string | undefined;
    dataType?: SystemConfigDataTypeEnum;
    group?: SystemConfigGroupEnum;
    isRequired?: boolean;
    validationPattern?: string | undefined;
    validationMessage?: string | undefined;
    minValue?: number | undefined;
    maxValue?: number | undefined;
    selectOptions?: string | undefined;
    placeholderText?: string | undefined;

    constructor(data?: ISystemConfigSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.displayOrder = _data["displayOrder"];
            this.isVisible = _data["isVisible"];
            this.helpText = _data["helpText"];
            this.key = _data["key"];
            this.defaultValue = _data["defaultValue"];
            this.dataType = _data["dataType"];
            this.group = _data["group"];
            this.isRequired = _data["isRequired"];
            this.validationPattern = _data["validationPattern"];
            this.validationMessage = _data["validationMessage"];
            this.minValue = _data["minValue"];
            this.maxValue = _data["maxValue"];
            this.selectOptions = _data["selectOptions"];
            this.placeholderText = _data["placeholderText"];
        }
    }

    static fromJS(data: any): SystemConfigSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemConfigSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["name"] = this.name;
        data["description"] = this.description;
        data["displayOrder"] = this.displayOrder;
        data["isVisible"] = this.isVisible;
        data["helpText"] = this.helpText;
        data["key"] = this.key;
        data["defaultValue"] = this.defaultValue;
        data["dataType"] = this.dataType;
        data["group"] = this.group;
        data["isRequired"] = this.isRequired;
        data["validationPattern"] = this.validationPattern;
        data["validationMessage"] = this.validationMessage;
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        data["selectOptions"] = this.selectOptions;
        data["placeholderText"] = this.placeholderText;
        return data;
    }
}

export interface ISystemConfigSaveDto {
    id?: number;
    value?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    displayOrder?: number;
    isVisible?: boolean;
    helpText?: string | undefined;
    key?: string | undefined;
    defaultValue?: string | undefined;
    dataType?: SystemConfigDataTypeEnum;
    group?: SystemConfigGroupEnum;
    isRequired?: boolean;
    validationPattern?: string | undefined;
    validationMessage?: string | undefined;
    minValue?: number | undefined;
    maxValue?: number | undefined;
    selectOptions?: string | undefined;
    placeholderText?: string | undefined;
}

export class UserIdentifierAdminAssignDto implements IUserIdentifierAdminAssignDto {
    scope?: UserIdentifierAdminScopeEnum;
    userId?: number | undefined;
    userLookup?: string | undefined;
    email?: string | undefined;
    username?: string | undefined;
    isDefault?: boolean;
    isConfirmed?: boolean;

    constructor(data?: IUserIdentifierAdminAssignDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scope = _data["scope"];
            this.userId = _data["userId"];
            this.userLookup = _data["userLookup"];
            this.email = _data["email"];
            this.username = _data["username"];
            this.isDefault = _data["isDefault"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): UserIdentifierAdminAssignDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserIdentifierAdminAssignDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scope"] = this.scope;
        data["userId"] = this.userId;
        data["userLookup"] = this.userLookup;
        data["email"] = this.email;
        data["username"] = this.username;
        data["isDefault"] = this.isDefault;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IUserIdentifierAdminAssignDto {
    scope?: UserIdentifierAdminScopeEnum;
    userId?: number | undefined;
    userLookup?: string | undefined;
    email?: string | undefined;
    username?: string | undefined;
    isDefault?: boolean;
    isConfirmed?: boolean;
}

export class UserIdentifierAdminDto implements IUserIdentifierAdminDto {
    id?: number;
    userId?: number;
    type?: UserIdentifierType;
    value?: string | undefined;
    isDefault?: boolean;
    isConfirmed?: boolean;
    requiresRename?: boolean;
    confirmedDate?: Date | undefined;
    createdDate?: Date;
    userName?: string | undefined;
    userFullName?: string | undefined;
    userEmail?: string | undefined;

    constructor(data?: IUserIdentifierAdminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.type = _data["type"];
            this.value = _data["value"];
            this.isDefault = _data["isDefault"];
            this.isConfirmed = _data["isConfirmed"];
            this.requiresRename = _data["requiresRename"];
            this.confirmedDate = _data["confirmedDate"] ? new Date(_data["confirmedDate"].toString()) : undefined as any;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.userName = _data["userName"];
            this.userFullName = _data["userFullName"];
            this.userEmail = _data["userEmail"];
        }
    }

    static fromJS(data: any): UserIdentifierAdminDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserIdentifierAdminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["type"] = this.type;
        data["value"] = this.value;
        data["isDefault"] = this.isDefault;
        data["isConfirmed"] = this.isConfirmed;
        data["requiresRename"] = this.requiresRename;
        data["confirmedDate"] = this.confirmedDate ? this.confirmedDate.toISOString() : undefined as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["userName"] = this.userName;
        data["userFullName"] = this.userFullName;
        data["userEmail"] = this.userEmail;
        return data;
    }
}

export interface IUserIdentifierAdminDto {
    id?: number;
    userId?: number;
    type?: UserIdentifierType;
    value?: string | undefined;
    isDefault?: boolean;
    isConfirmed?: boolean;
    requiresRename?: boolean;
    confirmedDate?: Date | undefined;
    createdDate?: Date;
    userName?: string | undefined;
    userFullName?: string | undefined;
    userEmail?: string | undefined;
}

export class UserIdentifierAdminFilterDto implements IUserIdentifierAdminFilterDto {
    scope?: UserIdentifierAdminScopeEnum;
    keyword?: string | undefined;
    userId?: number | undefined;
    pageIndex?: number;
    pageSize?: number;

    constructor(data?: IUserIdentifierAdminFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scope = _data["scope"];
            this.keyword = _data["keyword"];
            this.userId = _data["userId"];
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): UserIdentifierAdminFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserIdentifierAdminFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scope"] = this.scope;
        data["keyword"] = this.keyword;
        data["userId"] = this.userId;
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IUserIdentifierAdminFilterDto {
    scope?: UserIdentifierAdminScopeEnum;
    keyword?: string | undefined;
    userId?: number | undefined;
    pageIndex?: number;
    pageSize?: number;
}

export class UserIdentifierAdminResolveUserDto implements IUserIdentifierAdminResolveUserDto {
    userId?: number;
    userName?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;

    constructor(data?: IUserIdentifierAdminResolveUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): UserIdentifierAdminResolveUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserIdentifierAdminResolveUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        return data;
    }
}

export interface IUserIdentifierAdminResolveUserDto {
    userId?: number;
    userName?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
}

export class UserIdentifierAdminSaveDto implements IUserIdentifierAdminSaveDto {
    id?: number;
    scope?: UserIdentifierAdminScopeEnum;
    userId?: number;
    value?: string | undefined;
    isDefault?: boolean;
    isConfirmed?: boolean;
    conflictAcknowledged?: boolean;
    markConflictingRequiresRename?: boolean;

    constructor(data?: IUserIdentifierAdminSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.scope = _data["scope"];
            this.userId = _data["userId"];
            this.value = _data["value"];
            this.isDefault = _data["isDefault"];
            this.isConfirmed = _data["isConfirmed"];
            this.conflictAcknowledged = _data["conflictAcknowledged"];
            this.markConflictingRequiresRename = _data["markConflictingRequiresRename"];
        }
    }

    static fromJS(data: any): UserIdentifierAdminSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserIdentifierAdminSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["scope"] = this.scope;
        data["userId"] = this.userId;
        data["value"] = this.value;
        data["isDefault"] = this.isDefault;
        data["isConfirmed"] = this.isConfirmed;
        data["conflictAcknowledged"] = this.conflictAcknowledged;
        data["markConflictingRequiresRename"] = this.markConflictingRequiresRename;
        return data;
    }
}

export interface IUserIdentifierAdminSaveDto {
    id?: number;
    scope?: UserIdentifierAdminScopeEnum;
    userId?: number;
    value?: string | undefined;
    isDefault?: boolean;
    isConfirmed?: boolean;
    conflictAcknowledged?: boolean;
    markConflictingRequiresRename?: boolean;
}

export enum UserIdentifierAdminScopeEnum {
    ForbiddenUsername = 1,
    UserEmail = 2,
}

export class FileUploadByUrlResponseDto implements IFileUploadByUrlResponseDto {
    path?: string | undefined;

    constructor(data?: IFileUploadByUrlResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.path = _data["path"];
        }
    }

    static fromJS(data: any): FileUploadByUrlResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadByUrlResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["path"] = this.path;
        return data;
    }
}

export interface IFileUploadByUrlResponseDto {
    path?: string | undefined;
}

export class FolderNodeDataDto implements IFolderNodeDataDto {
    id?: number;
    parentId?: number;
    fileCount?: number;
    createdBy?: number;

    constructor(data?: IFolderNodeDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentId = _data["parentId"];
            this.fileCount = _data["fileCount"];
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any): FolderNodeDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new FolderNodeDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentId"] = this.parentId;
        data["fileCount"] = this.fileCount;
        data["createdBy"] = this.createdBy;
        return data;
    }
}

export interface IFolderNodeDataDto {
    id?: number;
    parentId?: number;
    fileCount?: number;
    createdBy?: number;
}

export class FolderNodeDto implements IFolderNodeDto {
    id?: string | undefined;
    text?: string | undefined;
    data?: FolderNodeDataDto;
    children?: FolderNodeDto[] | undefined;
    state?: FolderNodeStateDto;

    constructor(data?: IFolderNodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            this.data = _data["data"] ? FolderNodeDataDto.fromJS(_data["data"]) : undefined as any;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(FolderNodeDto.fromJS(item));
            }
            this.state = _data["state"] ? FolderNodeStateDto.fromJS(_data["state"]) : undefined as any;
        }
    }

    static fromJS(data: any): FolderNodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new FolderNodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        data["state"] = this.state ? this.state.toJSON() : undefined as any;
        return data;
    }
}

export interface IFolderNodeDto {
    id?: string | undefined;
    text?: string | undefined;
    data?: FolderNodeDataDto;
    children?: FolderNodeDto[] | undefined;
    state?: FolderNodeStateDto;
}

export class FolderNodeStateDto implements IFolderNodeStateDto {
    selected?: boolean;
    opened?: boolean;
    disabled?: boolean;

    constructor(data?: IFolderNodeStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selected = _data["selected"];
            this.opened = _data["opened"];
            this.disabled = _data["disabled"];
        }
    }

    static fromJS(data: any): FolderNodeStateDto {
        data = typeof data === 'object' ? data : {};
        let result = new FolderNodeStateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selected"] = this.selected;
        data["opened"] = this.opened;
        data["disabled"] = this.disabled;
        return data;
    }
}

export interface IFolderNodeStateDto {
    selected?: boolean;
    opened?: boolean;
    disabled?: boolean;
}

export class FolderUpdateDto implements IFolderUpdateDto {
    id?: number;
    name?: string | undefined;
    parentId?: number;

    constructor(data?: IFolderUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): FolderUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new FolderUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        return data;
    }
}

export interface IFolderUpdateDto {
    id?: number;
    name?: string | undefined;
    parentId?: number;
}

export class PupilClassItemDto implements IPupilClassItemDto {
    id?: number;
    name?: string | undefined;
    grade?: number;
    status?: ClassUserStatusEnum;
    academicYearName?: string | undefined;
    joinedAt?: Date | undefined;
    note?: string | undefined;

    constructor(data?: IPupilClassItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.grade = _data["grade"];
            this.status = _data["status"];
            this.academicYearName = _data["academicYearName"];
            this.joinedAt = _data["joinedAt"] ? new Date(_data["joinedAt"].toString()) : undefined as any;
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): PupilClassItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PupilClassItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["grade"] = this.grade;
        data["status"] = this.status;
        data["academicYearName"] = this.academicYearName;
        data["joinedAt"] = this.joinedAt ? this.joinedAt.toISOString() : undefined as any;
        data["note"] = this.note;
        return data;
    }
}

export interface IPupilClassItemDto {
    id?: number;
    name?: string | undefined;
    grade?: number;
    status?: ClassUserStatusEnum;
    academicYearName?: string | undefined;
    joinedAt?: Date | undefined;
    note?: string | undefined;
}

export class PupilCourseItemDto implements IPupilCourseItemDto {
    productId?: number;
    productName?: string | undefined;
    enrollmentDate?: Date;
    expiryDate?: Date | undefined;
    status?: EnrollmentStatusEnum;

    constructor(data?: IPupilCourseItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.enrollmentDate = _data["enrollmentDate"] ? new Date(_data["enrollmentDate"].toString()) : undefined as any;
            this.expiryDate = _data["expiryDate"] ? new Date(_data["expiryDate"].toString()) : undefined as any;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): PupilCourseItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PupilCourseItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["enrollmentDate"] = this.enrollmentDate ? this.enrollmentDate.toISOString() : undefined as any;
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : undefined as any;
        data["status"] = this.status;
        return data;
    }
}

export interface IPupilCourseItemDto {
    productId?: number;
    productName?: string | undefined;
    enrollmentDate?: Date;
    expiryDate?: Date | undefined;
    status?: EnrollmentStatusEnum;
}

export class PupilDetailDto implements IPupilDetailDto {
    id?: number;
    userName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    avatar?: string | undefined;
    accountStatus?: number;
    createdDate?: Date;
    lastLoginDate?: Date | undefined;
    isKid?: boolean;
    type?: UserTypeEnum;
    profile?: UserProfileDto;
    classes?: PupilClassItemDto[] | undefined;
    courses?: PupilCourseItemDto[] | undefined;
    parents?: FamilyMemberDto[] | undefined;

    constructor(data?: IPupilDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.avatar = _data["avatar"];
            this.accountStatus = _data["accountStatus"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastLoginDate = _data["lastLoginDate"] ? new Date(_data["lastLoginDate"].toString()) : undefined as any;
            this.isKid = _data["isKid"];
            this.type = _data["type"];
            this.profile = _data["profile"] ? UserProfileDto.fromJS(_data["profile"]) : undefined as any;
            if (Array.isArray(_data["classes"])) {
                this.classes = [] as any;
                for (let item of _data["classes"])
                    this.classes!.push(PupilClassItemDto.fromJS(item));
            }
            if (Array.isArray(_data["courses"])) {
                this.courses = [] as any;
                for (let item of _data["courses"])
                    this.courses!.push(PupilCourseItemDto.fromJS(item));
            }
            if (Array.isArray(_data["parents"])) {
                this.parents = [] as any;
                for (let item of _data["parents"])
                    this.parents!.push(FamilyMemberDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PupilDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new PupilDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["avatar"] = this.avatar;
        data["accountStatus"] = this.accountStatus;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastLoginDate"] = this.lastLoginDate ? this.lastLoginDate.toISOString() : undefined as any;
        data["isKid"] = this.isKid;
        data["type"] = this.type;
        data["profile"] = this.profile ? this.profile.toJSON() : undefined as any;
        if (Array.isArray(this.classes)) {
            data["classes"] = [];
            for (let item of this.classes)
                data["classes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.courses)) {
            data["courses"] = [];
            for (let item of this.courses)
                data["courses"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.parents)) {
            data["parents"] = [];
            for (let item of this.parents)
                data["parents"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPupilDetailDto {
    id?: number;
    userName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    avatar?: string | undefined;
    accountStatus?: number;
    createdDate?: Date;
    lastLoginDate?: Date | undefined;
    isKid?: boolean;
    type?: UserTypeEnum;
    profile?: UserProfileDto;
    classes?: PupilClassItemDto[] | undefined;
    courses?: PupilCourseItemDto[] | undefined;
    parents?: FamilyMemberDto[] | undefined;
}

export class UserProfileDto implements IUserProfileDto {
    id?: number;
    userId?: number;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    fullName?: string | undefined;
    avatar?: string | undefined;
    code?: string | undefined;
    birthDay?: Date | undefined;
    gender?: number | undefined;
    identifierCode?: string | undefined;
    address?: string | undefined;
    ethnic?: string | undefined;
    title?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    isActive?: boolean;

    constructor(data?: IUserProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.objectType = _data["objectType"];
            this.objectId = _data["objectId"];
            this.fullName = _data["fullName"];
            this.avatar = _data["avatar"];
            this.code = _data["code"];
            this.birthDay = _data["birthDay"] ? new Date(_data["birthDay"].toString()) : undefined as any;
            this.gender = _data["gender"];
            this.identifierCode = _data["identifierCode"];
            this.address = _data["address"];
            this.ethnic = _data["ethnic"];
            this.title = _data["title"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UserProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["objectType"] = this.objectType;
        data["objectId"] = this.objectId;
        data["fullName"] = this.fullName;
        data["avatar"] = this.avatar;
        data["code"] = this.code;
        data["birthDay"] = this.birthDay ? this.birthDay.toISOString() : undefined as any;
        data["gender"] = this.gender;
        data["identifierCode"] = this.identifierCode;
        data["address"] = this.address;
        data["ethnic"] = this.ethnic;
        data["title"] = this.title;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUserProfileDto {
    id?: number;
    userId?: number;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    fullName?: string | undefined;
    avatar?: string | undefined;
    code?: string | undefined;
    birthDay?: Date | undefined;
    gender?: number | undefined;
    identifierCode?: string | undefined;
    address?: string | undefined;
    ethnic?: string | undefined;
    title?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    isActive?: boolean;
}

export class UserGetListQuery implements IUserGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    status?: number;
    keyword?: string | undefined;
    roleIds?: number[] | undefined;
    type?: UserTypeEnum;
    objectId?: number;
    isSystem?: boolean | undefined;
    objectOwnerType?: ObjectOwnerTypeEnum;
    userObjectTypes?: UserTypeEnum[] | undefined;

    constructor(data?: IUserGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.status = _data["status"];
            this.keyword = _data["keyword"];
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
            this.type = _data["type"];
            this.objectId = _data["objectId"];
            this.isSystem = _data["isSystem"];
            this.objectOwnerType = _data["objectOwnerType"];
            if (Array.isArray(_data["userObjectTypes"])) {
                this.userObjectTypes = [] as any;
                for (let item of _data["userObjectTypes"])
                    this.userObjectTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): UserGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new UserGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["status"] = this.status;
        data["keyword"] = this.keyword;
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        data["type"] = this.type;
        data["objectId"] = this.objectId;
        data["isSystem"] = this.isSystem;
        data["objectOwnerType"] = this.objectOwnerType;
        if (Array.isArray(this.userObjectTypes)) {
            data["userObjectTypes"] = [];
            for (let item of this.userObjectTypes)
                data["userObjectTypes"].push(item);
        }
        return data;
    }
}

export interface IUserGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    status?: number;
    keyword?: string | undefined;
    roleIds?: number[] | undefined;
    type?: UserTypeEnum;
    objectId?: number;
    isSystem?: boolean | undefined;
    objectOwnerType?: ObjectOwnerTypeEnum;
    userObjectTypes?: UserTypeEnum[] | undefined;
}

export class GetListLogQuery implements IGetListLogQuery {
    keyword?: string | undefined;
    objectType?: string | undefined;
    pageIndex?: number;
    pageSize?: number;

    constructor(data?: IGetListLogQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keyword = _data["keyword"];
            this.objectType = _data["objectType"];
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GetListLogQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetListLogQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyword"] = this.keyword;
        data["objectType"] = this.objectType;
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGetListLogQuery {
    keyword?: string | undefined;
    objectType?: string | undefined;
    pageIndex?: number;
    pageSize?: number;
}

export class AssignExamListByClassQuery implements IAssignExamListByClassQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    subjectId?: number | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    classId?: number;
    type?: AssignExamTypeEnum;
    userId?: number | undefined;
    isGetAll?: boolean;
    status?: number | undefined;

    constructor(data?: IAssignExamListByClassQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.keyword = _data["keyword"];
            this.subjectId = _data["subjectId"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : undefined as any;
            this.classId = _data["classId"];
            this.type = _data["type"];
            this.userId = _data["userId"];
            this.isGetAll = _data["isGetAll"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): AssignExamListByClassQuery {
        data = typeof data === 'object' ? data : {};
        let result = new AssignExamListByClassQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["keyword"] = this.keyword;
        data["subjectId"] = this.subjectId;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : undefined as any;
        data["classId"] = this.classId;
        data["type"] = this.type;
        data["userId"] = this.userId;
        data["isGetAll"] = this.isGetAll;
        data["status"] = this.status;
        return data;
    }
}

export interface IAssignExamListByClassQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    subjectId?: number | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    classId?: number;
    type?: AssignExamTypeEnum;
    userId?: number | undefined;
    isGetAll?: boolean;
    status?: number | undefined;
}

export class CategoryReorderItemDto implements ICategoryReorderItemDto {
    id?: number;
    parentId?: number;
    priority?: number;

    constructor(data?: ICategoryReorderItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentId = _data["parentId"];
            this.priority = _data["priority"];
        }
    }

    static fromJS(data: any): CategoryReorderItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryReorderItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentId"] = this.parentId;
        data["priority"] = this.priority;
        return data;
    }
}

export interface ICategoryReorderItemDto {
    id?: number;
    parentId?: number;
    priority?: number;
}

export class GetListUserForCreateChatGroupQuery implements IGetListUserForCreateChatGroupQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    status?: number;
    chatGroupType?: number;
    keyword?: string | undefined;
    roleIds?: number[] | undefined;
    type?: UserTypeEnum;
    objectId?: number;

    constructor(data?: IGetListUserForCreateChatGroupQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.status = _data["status"];
            this.chatGroupType = _data["chatGroupType"];
            this.keyword = _data["keyword"];
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
            this.type = _data["type"];
            this.objectId = _data["objectId"];
        }
    }

    static fromJS(data: any): GetListUserForCreateChatGroupQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetListUserForCreateChatGroupQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["status"] = this.status;
        data["chatGroupType"] = this.chatGroupType;
        data["keyword"] = this.keyword;
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        data["type"] = this.type;
        data["objectId"] = this.objectId;
        return data;
    }
}

export interface IGetListUserForCreateChatGroupQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    status?: number;
    chatGroupType?: number;
    keyword?: string | undefined;
    roleIds?: number[] | undefined;
    type?: UserTypeEnum;
    objectId?: number;
}

export class ClassAddListUserCommand implements IClassAddListUserCommand {
    userIds?: number[] | undefined;
    classId?: number;
    role?: ClassUserRoleEnum;

    constructor(data?: IClassAddListUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            this.classId = _data["classId"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): ClassAddListUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ClassAddListUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["classId"] = this.classId;
        data["role"] = this.role;
        return data;
    }
}

export interface IClassAddListUserCommand {
    userIds?: number[] | undefined;
    classId?: number;
    role?: ClassUserRoleEnum;
}

export class ClassChangeClassCommand implements IClassChangeClassCommand {
    userIds?: number[] | undefined;
    oldClassId?: number;
    newClassId?: number;
    status?: ClassUserStatusEnum;
    note?: string | undefined;

    constructor(data?: IClassChangeClassCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            this.oldClassId = _data["oldClassId"];
            this.newClassId = _data["newClassId"];
            this.status = _data["status"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): ClassChangeClassCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ClassChangeClassCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["oldClassId"] = this.oldClassId;
        data["newClassId"] = this.newClassId;
        data["status"] = this.status;
        data["note"] = this.note;
        return data;
    }
}

export interface IClassChangeClassCommand {
    userIds?: number[] | undefined;
    oldClassId?: number;
    newClassId?: number;
    status?: ClassUserStatusEnum;
    note?: string | undefined;
}

export class ClassEnrollPupilByOrderCommand implements IClassEnrollPupilByOrderCommand {
    classId?: number;

    constructor(data?: IClassEnrollPupilByOrderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.classId = _data["classId"];
        }
    }

    static fromJS(data: any): ClassEnrollPupilByOrderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ClassEnrollPupilByOrderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["classId"] = this.classId;
        return data;
    }
}

export interface IClassEnrollPupilByOrderCommand {
    classId?: number;
}

export class ClassRemoveProductCommand implements IClassRemoveProductCommand {
    classId?: number;
    productId?: number;

    constructor(data?: IClassRemoveProductCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.classId = _data["classId"];
            this.productId = _data["productId"];
        }
    }

    static fromJS(data: any): ClassRemoveProductCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ClassRemoveProductCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["classId"] = this.classId;
        data["productId"] = this.productId;
        return data;
    }
}

export interface IClassRemoveProductCommand {
    classId?: number;
    productId?: number;
}

export class ClassRemoveUserCommand implements IClassRemoveUserCommand {
    userId?: number;
    classId?: number;

    constructor(data?: IClassRemoveUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.classId = _data["classId"];
        }
    }

    static fromJS(data: any): ClassRemoveUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ClassRemoveUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["classId"] = this.classId;
        return data;
    }
}

export interface IClassRemoveUserCommand {
    userId?: number;
    classId?: number;
}

export class ClassCheckZoomSlotCommand implements IClassCheckZoomSlotCommand {
    classId?: number;
    startTime?: Date;
    endTime?: Date;

    constructor(data?: IClassCheckZoomSlotCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.classId = _data["classId"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ClassCheckZoomSlotCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ClassCheckZoomSlotCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["classId"] = this.classId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        return data;
    }
}

export interface IClassCheckZoomSlotCommand {
    classId?: number;
    startTime?: Date;
    endTime?: Date;
}

export class ClassLinkProductCommand implements IClassLinkProductCommand {
    classId?: number;
    productId?: number;
    classSessions?: ClassSessionEntity[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: IClassLinkProductCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.classId = _data["classId"];
            this.productId = _data["productId"];
            if (Array.isArray(_data["classSessions"])) {
                this.classSessions = [] as any;
                for (let item of _data["classSessions"])
                    this.classSessions!.push(ClassSessionEntity.fromJS(item));
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ClassLinkProductCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ClassLinkProductCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["classId"] = this.classId;
        data["productId"] = this.productId;
        if (Array.isArray(this.classSessions)) {
            data["classSessions"] = [];
            for (let item of this.classSessions)
                data["classSessions"].push(item ? item.toJSON() : undefined as any);
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IClassLinkProductCommand {
    classId?: number;
    productId?: number;
    classSessions?: ClassSessionEntity[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export class DepartmentRoleSaveListRequest implements IDepartmentRoleSaveListRequest {
    departmentId?: number;
    items?: DepartmentRoleSaveRequest[] | undefined;

    constructor(data?: IDepartmentRoleSaveListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departmentId = _data["departmentId"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DepartmentRoleSaveRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DepartmentRoleSaveListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentRoleSaveListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departmentId"] = this.departmentId;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDepartmentRoleSaveListRequest {
    departmentId?: number;
    items?: DepartmentRoleSaveRequest[] | undefined;
}

export class DepartmentRoleSaveRequest implements IDepartmentRoleSaveRequest {
    id?: number;
    departmentId?: number;
    name!: string;
    code?: string | undefined;
    rank?: number;
    listModule?: RoleModuleDto[] | undefined;

    constructor(data?: IDepartmentRoleSaveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.departmentId = _data["departmentId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.rank = _data["rank"];
            if (Array.isArray(_data["listModule"])) {
                this.listModule = [] as any;
                for (let item of _data["listModule"])
                    this.listModule!.push(RoleModuleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DepartmentRoleSaveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentRoleSaveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["departmentId"] = this.departmentId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["rank"] = this.rank;
        if (Array.isArray(this.listModule)) {
            data["listModule"] = [];
            for (let item of this.listModule)
                data["listModule"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDepartmentRoleSaveRequest {
    id?: number;
    departmentId?: number;
    name: string;
    code?: string | undefined;
    rank?: number;
    listModule?: RoleModuleDto[] | undefined;
}

export class DepartmentSaveListRequest implements IDepartmentSaveListRequest {
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    items?: DepartmentSaveRequest[] | undefined;

    constructor(data?: IDepartmentSaveListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objectType = _data["objectType"];
            this.objectId = _data["objectId"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DepartmentSaveRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DepartmentSaveListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentSaveListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objectType"] = this.objectType;
        data["objectId"] = this.objectId;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDepartmentSaveListRequest {
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    items?: DepartmentSaveRequest[] | undefined;
}

export class DepartmentSaveRequest implements IDepartmentSaveRequest {
    id?: number;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    parentId?: number;
    name!: string;
    code?: string | undefined;
    sortOrder?: number;
    isActive?: boolean;
    isDefault?: boolean;

    constructor(data?: IDepartmentSaveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.objectType = _data["objectType"];
            this.objectId = _data["objectId"];
            this.parentId = _data["parentId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.sortOrder = _data["sortOrder"];
            this.isActive = _data["isActive"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): DepartmentSaveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentSaveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["objectType"] = this.objectType;
        data["objectId"] = this.objectId;
        data["parentId"] = this.parentId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["sortOrder"] = this.sortOrder;
        data["isActive"] = this.isActive;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface IDepartmentSaveRequest {
    id?: number;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    parentId?: number;
    name: string;
    code?: string | undefined;
    sortOrder?: number;
    isActive?: boolean;
    isDefault?: boolean;
}

export class DepartmentUserSaveByUserItem implements IDepartmentUserSaveByUserItem {
    departmentId?: number;
    titleId?: number;
    isPrimary?: boolean;
    roleIds?: number[] | undefined;

    constructor(data?: IDepartmentUserSaveByUserItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departmentId = _data["departmentId"];
            this.titleId = _data["titleId"];
            this.isPrimary = _data["isPrimary"];
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DepartmentUserSaveByUserItem {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentUserSaveByUserItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departmentId"] = this.departmentId;
        data["titleId"] = this.titleId;
        data["isPrimary"] = this.isPrimary;
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        return data;
    }
}

export interface IDepartmentUserSaveByUserItem {
    departmentId?: number;
    titleId?: number;
    isPrimary?: boolean;
    roleIds?: number[] | undefined;
}

export class DepartmentUserSaveByUserRequest implements IDepartmentUserSaveByUserRequest {
    userId?: number;
    objectId?: number;
    items?: DepartmentUserSaveByUserItem[] | undefined;

    constructor(data?: IDepartmentUserSaveByUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.objectId = _data["objectId"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DepartmentUserSaveByUserItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DepartmentUserSaveByUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentUserSaveByUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["objectId"] = this.objectId;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDepartmentUserSaveByUserRequest {
    userId?: number;
    objectId?: number;
    items?: DepartmentUserSaveByUserItem[] | undefined;
}

export class DepartmentUserSaveListRequest implements IDepartmentUserSaveListRequest {
    departmentId?: number;
    objectId?: number;
    titleId?: number;
    isPrimary?: boolean;
    userIds?: number[] | undefined;
    roleIds?: number[] | undefined;

    constructor(data?: IDepartmentUserSaveListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departmentId = _data["departmentId"];
            this.objectId = _data["objectId"];
            this.titleId = _data["titleId"];
            this.isPrimary = _data["isPrimary"];
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DepartmentUserSaveListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentUserSaveListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departmentId"] = this.departmentId;
        data["objectId"] = this.objectId;
        data["titleId"] = this.titleId;
        data["isPrimary"] = this.isPrimary;
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        return data;
    }
}

export interface IDepartmentUserSaveListRequest {
    departmentId?: number;
    objectId?: number;
    titleId?: number;
    isPrimary?: boolean;
    userIds?: number[] | undefined;
    roleIds?: number[] | undefined;
}

export class DepartmentUserSaveRequest implements IDepartmentUserSaveRequest {
    id?: number;
    departmentId?: number;
    userId?: number;
    objectId?: number;
    titleId?: number;
    isPrimary?: boolean;
    roleIds?: number[] | undefined;

    constructor(data?: IDepartmentUserSaveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.departmentId = _data["departmentId"];
            this.userId = _data["userId"];
            this.objectId = _data["objectId"];
            this.titleId = _data["titleId"];
            this.isPrimary = _data["isPrimary"];
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DepartmentUserSaveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentUserSaveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["departmentId"] = this.departmentId;
        data["userId"] = this.userId;
        data["objectId"] = this.objectId;
        data["titleId"] = this.titleId;
        data["isPrimary"] = this.isPrimary;
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        return data;
    }
}

export interface IDepartmentUserSaveRequest {
    id?: number;
    departmentId?: number;
    userId?: number;
    objectId?: number;
    titleId?: number;
    isPrimary?: boolean;
    roleIds?: number[] | undefined;
}

export class DepartmentMenuNodeDto implements IDepartmentMenuNodeDto {
    id?: number;
    parentId?: number;
    code?: string | undefined;
    name?: string | undefined;
    isFixed?: boolean;
    isDefault?: boolean;
    isActive?: boolean;
    sortOrder?: number;
    featureKey?: string | undefined;
    children?: DepartmentMenuNodeDto[] | undefined;

    constructor(data?: IDepartmentMenuNodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentId = _data["parentId"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.isFixed = _data["isFixed"];
            this.isDefault = _data["isDefault"];
            this.isActive = _data["isActive"];
            this.sortOrder = _data["sortOrder"];
            this.featureKey = _data["featureKey"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(DepartmentMenuNodeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DepartmentMenuNodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentMenuNodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentId"] = this.parentId;
        data["code"] = this.code;
        data["name"] = this.name;
        data["isFixed"] = this.isFixed;
        data["isDefault"] = this.isDefault;
        data["isActive"] = this.isActive;
        data["sortOrder"] = this.sortOrder;
        data["featureKey"] = this.featureKey;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDepartmentMenuNodeDto {
    id?: number;
    parentId?: number;
    code?: string | undefined;
    name?: string | undefined;
    isFixed?: boolean;
    isDefault?: boolean;
    isActive?: boolean;
    sortOrder?: number;
    featureKey?: string | undefined;
    children?: DepartmentMenuNodeDto[] | undefined;
}

export class DepartmentRoleDto implements IDepartmentRoleDto {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    isSystemDefault?: boolean;
    isProtected?: boolean;
    rank?: number;
    departmentId?: number;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    listModule?: RoleModuleDto[] | undefined;

    constructor(data?: IDepartmentRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.isSystemDefault = _data["isSystemDefault"];
            this.isProtected = _data["isProtected"];
            this.rank = _data["rank"];
            this.departmentId = _data["departmentId"];
            this.objectType = _data["objectType"];
            this.objectId = _data["objectId"];
            if (Array.isArray(_data["listModule"])) {
                this.listModule = [] as any;
                for (let item of _data["listModule"])
                    this.listModule!.push(RoleModuleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DepartmentRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["isSystemDefault"] = this.isSystemDefault;
        data["isProtected"] = this.isProtected;
        data["rank"] = this.rank;
        data["departmentId"] = this.departmentId;
        data["objectType"] = this.objectType;
        data["objectId"] = this.objectId;
        if (Array.isArray(this.listModule)) {
            data["listModule"] = [];
            for (let item of this.listModule)
                data["listModule"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDepartmentRoleDto {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    isSystemDefault?: boolean;
    isProtected?: boolean;
    rank?: number;
    departmentId?: number;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    listModule?: RoleModuleDto[] | undefined;
}

export class ExamGetListQuery implements IExamGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    objectId?: number | undefined;
    objectType?: ObjectOwnerTypeEnum;
    userId?: number | undefined;
    classLevel?: number | undefined;
    type?: ExamTypeEnum;
    status?: ExamStatusEnum;
    format?: ExamFormatEnum;
    subjectId?: number | undefined;
    filterType?: ObjectListFilterTypeEnum;
    shareStatus?: ShareStatusEnum;
    ids?: number[] | undefined;

    constructor(data?: IExamGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.keyword = _data["keyword"];
            this.objectId = _data["objectId"];
            this.objectType = _data["objectType"];
            this.userId = _data["userId"];
            this.classLevel = _data["classLevel"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.format = _data["format"];
            this.subjectId = _data["subjectId"];
            this.filterType = _data["filterType"];
            this.shareStatus = _data["shareStatus"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): ExamGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ExamGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["keyword"] = this.keyword;
        data["objectId"] = this.objectId;
        data["objectType"] = this.objectType;
        data["userId"] = this.userId;
        data["classLevel"] = this.classLevel;
        data["type"] = this.type;
        data["status"] = this.status;
        data["format"] = this.format;
        data["subjectId"] = this.subjectId;
        data["filterType"] = this.filterType;
        data["shareStatus"] = this.shareStatus;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface IExamGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    objectId?: number | undefined;
    objectType?: ObjectOwnerTypeEnum;
    userId?: number | undefined;
    classLevel?: number | undefined;
    type?: ExamTypeEnum;
    status?: ExamStatusEnum;
    format?: ExamFormatEnum;
    subjectId?: number | undefined;
    filterType?: ObjectListFilterTypeEnum;
    shareStatus?: ShareStatusEnum;
    ids?: number[] | undefined;
}

export class FileUpdateAvatarCommand implements IFileUpdateAvatarCommand {
    id?: number;
    avatar?: string | undefined;

    constructor(data?: IFileUpdateAvatarCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.avatar = _data["avatar"];
        }
    }

    static fromJS(data: any): FileUpdateAvatarCommand {
        data = typeof data === 'object' ? data : {};
        let result = new FileUpdateAvatarCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["avatar"] = this.avatar;
        return data;
    }
}

export interface IFileUpdateAvatarCommand {
    id?: number;
    avatar?: string | undefined;
}

export class FileUpdateCommand implements IFileUpdateCommand {
    file?: FileEntity;

    constructor(data?: IFileUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.file = _data["file"] ? FileEntity.fromJS(_data["file"]) : undefined as any;
        }
    }

    static fromJS(data: any): FileUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new FileUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["file"] = this.file ? this.file.toJSON() : undefined as any;
        return data;
    }
}

export interface IFileUpdateCommand {
    file?: FileEntity;
}

export class FileUpdateNameCommand implements IFileUpdateNameCommand {
    id?: number;
    name?: string | undefined;

    constructor(data?: IFileUpdateNameCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): FileUpdateNameCommand {
        data = typeof data === 'object' ? data : {};
        let result = new FileUpdateNameCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IFileUpdateNameCommand {
    id?: number;
    name?: string | undefined;
}

export class FileUpdateStatusCommand implements IFileUpdateStatusCommand {
    id?: number;
    status?: FileStatusEnum;

    constructor(data?: IFileUpdateStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): FileUpdateStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new FileUpdateStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        return data;
    }
}

export interface IFileUpdateStatusCommand {
    id?: number;
    status?: FileStatusEnum;
}

export class FolderDeleteCommand implements IFolderDeleteCommand {
    id?: number;
    moveFileToFolderId?: number;

    constructor(data?: IFolderDeleteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.moveFileToFolderId = _data["moveFileToFolderId"];
        }
    }

    static fromJS(data: any): FolderDeleteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new FolderDeleteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["moveFileToFolderId"] = this.moveFileToFolderId;
        return data;
    }
}

export interface IFolderDeleteCommand {
    id?: number;
    moveFileToFolderId?: number;
}

export class FolderUpdateCommand implements IFolderUpdateCommand {
    folder?: FolderUpdateDto;

    constructor(data?: IFolderUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.folder = _data["folder"] ? FolderUpdateDto.fromJS(_data["folder"]) : undefined as any;
        }
    }

    static fromJS(data: any): FolderUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new FolderUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["folder"] = this.folder ? this.folder.toJSON() : undefined as any;
        return data;
    }
}

export interface IFolderUpdateCommand {
    folder?: FolderUpdateDto;
}

export class UserMobileTokenUpdateCommand implements IUserMobileTokenUpdateCommand {
    token?: UserMobileTokenEntity;

    constructor(data?: IUserMobileTokenUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"] ? UserMobileTokenEntity.fromJS(_data["token"]) : undefined as any;
        }
    }

    static fromJS(data: any): UserMobileTokenUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UserMobileTokenUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token ? this.token.toJSON() : undefined as any;
        return data;
    }
}

export interface IUserMobileTokenUpdateCommand {
    token?: UserMobileTokenEntity;
}

export class UserWebTokenDeleteCommand implements IUserWebTokenDeleteCommand {
    id?: number;

    constructor(data?: IUserWebTokenDeleteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserWebTokenDeleteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UserWebTokenDeleteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUserWebTokenDeleteCommand {
    id?: number;
}

export class UserWebTokenUpdateCommand implements IUserWebTokenUpdateCommand {
    token?: UserWebTokenEntity;

    constructor(data?: IUserWebTokenUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"] ? UserWebTokenEntity.fromJS(_data["token"]) : undefined as any;
        }
    }

    static fromJS(data: any): UserWebTokenUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UserWebTokenUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token ? this.token.toJSON() : undefined as any;
        return data;
    }
}

export interface IUserWebTokenUpdateCommand {
    token?: UserWebTokenEntity;
}

export class FileGetListQuery implements IFileGetListQuery {
    userId?: number;
    keyword?: string | undefined;
    folderId?: number;
    extensions?: string | undefined;
    isGetAll?: boolean;
    status?: number;
    sortBy?: string | undefined;
    sortDirection?: string | undefined;
    pageIndex?: number;
    pageSize?: number;

    constructor(data?: IFileGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.keyword = _data["keyword"];
            this.folderId = _data["folderId"];
            this.extensions = _data["extensions"];
            this.isGetAll = _data["isGetAll"];
            this.status = _data["status"];
            this.sortBy = _data["sortBy"];
            this.sortDirection = _data["sortDirection"];
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): FileGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new FileGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["keyword"] = this.keyword;
        data["folderId"] = this.folderId;
        data["extensions"] = this.extensions;
        data["isGetAll"] = this.isGetAll;
        data["status"] = this.status;
        data["sortBy"] = this.sortBy;
        data["sortDirection"] = this.sortDirection;
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IFileGetListQuery {
    userId?: number;
    keyword?: string | undefined;
    folderId?: number;
    extensions?: string | undefined;
    isGetAll?: boolean;
    status?: number;
    sortBy?: string | undefined;
    sortDirection?: string | undefined;
    pageIndex?: number;
    pageSize?: number;
}

export class FolderGetAllQuery implements IFolderGetAllQuery {

    constructor(data?: IFolderGetAllQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): FolderGetAllQuery {
        data = typeof data === 'object' ? data : {};
        let result = new FolderGetAllQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IFolderGetAllQuery {
}

export class FolderGetListQuery implements IFolderGetListQuery {
    keyword?: string | undefined;
    isGetAll?: boolean;

    constructor(data?: IFolderGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keyword = _data["keyword"];
            this.isGetAll = _data["isGetAll"];
        }
    }

    static fromJS(data: any): FolderGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new FolderGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyword"] = this.keyword;
        data["isGetAll"] = this.isGetAll;
        return data;
    }
}

export interface IFolderGetListQuery {
    keyword?: string | undefined;
    isGetAll?: boolean;
}

export class LessonHistorySaveCommand implements ILessonHistorySaveCommand {
    productId?: number;
    productLessonId?: number;
    startTime?: Date;
    endTime?: Date;
    zoomJoinLink?: string | undefined;
    examScore?: number | undefined;
    userExamResultId?: number | undefined;

    constructor(data?: ILessonHistorySaveCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.productLessonId = _data["productLessonId"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
            this.zoomJoinLink = _data["zoomJoinLink"];
            this.examScore = _data["examScore"];
            this.userExamResultId = _data["userExamResultId"];
        }
    }

    static fromJS(data: any): LessonHistorySaveCommand {
        data = typeof data === 'object' ? data : {};
        let result = new LessonHistorySaveCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["productLessonId"] = this.productLessonId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        data["zoomJoinLink"] = this.zoomJoinLink;
        data["examScore"] = this.examScore;
        data["userExamResultId"] = this.userExamResultId;
        return data;
    }
}

export interface ILessonHistorySaveCommand {
    productId?: number;
    productLessonId?: number;
    startTime?: Date;
    endTime?: Date;
    zoomJoinLink?: string | undefined;
    examScore?: number | undefined;
    userExamResultId?: number | undefined;
}

export class LessonCompletionDto implements ILessonCompletionDto {
    productLessonId?: number;
    isCompleted?: boolean;
    lastStartTime?: Date | undefined;
    completedTime?: Date | undefined;

    constructor(data?: ILessonCompletionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productLessonId = _data["productLessonId"];
            this.isCompleted = _data["isCompleted"];
            this.lastStartTime = _data["lastStartTime"] ? new Date(_data["lastStartTime"].toString()) : undefined as any;
            this.completedTime = _data["completedTime"] ? new Date(_data["completedTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): LessonCompletionDto {
        data = typeof data === 'object' ? data : {};
        let result = new LessonCompletionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productLessonId"] = this.productLessonId;
        data["isCompleted"] = this.isCompleted;
        data["lastStartTime"] = this.lastStartTime ? this.lastStartTime.toISOString() : undefined as any;
        data["completedTime"] = this.completedTime ? this.completedTime.toISOString() : undefined as any;
        return data;
    }
}

export interface ILessonCompletionDto {
    productLessonId?: number;
    isCompleted?: boolean;
    lastStartTime?: Date | undefined;
    completedTime?: Date | undefined;
}

export class LessonHistoryGetOrCreateZoomLinkQuery implements ILessonHistoryGetOrCreateZoomLinkQuery {
    productId?: number;
    productLessonId?: number;
    classId?: number | undefined;

    constructor(data?: ILessonHistoryGetOrCreateZoomLinkQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.productLessonId = _data["productLessonId"];
            this.classId = _data["classId"];
        }
    }

    static fromJS(data: any): LessonHistoryGetOrCreateZoomLinkQuery {
        data = typeof data === 'object' ? data : {};
        let result = new LessonHistoryGetOrCreateZoomLinkQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["productLessonId"] = this.productLessonId;
        data["classId"] = this.classId;
        return data;
    }
}

export interface ILessonHistoryGetOrCreateZoomLinkQuery {
    productId?: number;
    productLessonId?: number;
    classId?: number | undefined;
}

export class LessonHistoryGetZoomJoinCredentialsQuery implements ILessonHistoryGetZoomJoinCredentialsQuery {
    sessionId?: number;
    productId?: number;
    productLessonId?: number;
    classId?: number | undefined;
    joinAs?: SessionDeliveryModeEnum;

    constructor(data?: ILessonHistoryGetZoomJoinCredentialsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.productId = _data["productId"];
            this.productLessonId = _data["productLessonId"];
            this.classId = _data["classId"];
            this.joinAs = _data["joinAs"];
        }
    }

    static fromJS(data: any): LessonHistoryGetZoomJoinCredentialsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new LessonHistoryGetZoomJoinCredentialsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["productId"] = this.productId;
        data["productLessonId"] = this.productLessonId;
        data["classId"] = this.classId;
        data["joinAs"] = this.joinAs;
        return data;
    }
}

export interface ILessonHistoryGetZoomJoinCredentialsQuery {
    sessionId?: number;
    productId?: number;
    productLessonId?: number;
    classId?: number | undefined;
    joinAs?: SessionDeliveryModeEnum;
}

export class LessonHistoryZoomCredentialsResultDto implements ILessonHistoryZoomCredentialsResultDto {
    sessionId?: number;
    sessionName?: string | undefined;
    productName?: string | undefined;
    startTime?: Date;
    endTime?: Date;
    productId?: number;
    classId?: number;
    productLessonId?: number | undefined;
    deliveryMode?: SessionDeliveryModeEnum;
    meetingNumber?: string | undefined;
    password?: string | undefined;
    signature?: string | undefined;
    sdkKey?: string | undefined;
    userName?: string | undefined;
    zoomJoinLink?: string | undefined;
    isHost?: boolean;
    zak?: string | undefined;
    zoomStartLink?: string | undefined;

    constructor(data?: ILessonHistoryZoomCredentialsResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.sessionName = _data["sessionName"];
            this.productName = _data["productName"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
            this.productId = _data["productId"];
            this.classId = _data["classId"];
            this.productLessonId = _data["productLessonId"];
            this.deliveryMode = _data["deliveryMode"];
            this.meetingNumber = _data["meetingNumber"];
            this.password = _data["password"];
            this.signature = _data["signature"];
            this.sdkKey = _data["sdkKey"];
            this.userName = _data["userName"];
            this.zoomJoinLink = _data["zoomJoinLink"];
            this.isHost = _data["isHost"];
            this.zak = _data["zak"];
            this.zoomStartLink = _data["zoomStartLink"];
        }
    }

    static fromJS(data: any): LessonHistoryZoomCredentialsResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new LessonHistoryZoomCredentialsResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["sessionName"] = this.sessionName;
        data["productName"] = this.productName;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        data["productId"] = this.productId;
        data["classId"] = this.classId;
        data["productLessonId"] = this.productLessonId;
        data["deliveryMode"] = this.deliveryMode;
        data["meetingNumber"] = this.meetingNumber;
        data["password"] = this.password;
        data["signature"] = this.signature;
        data["sdkKey"] = this.sdkKey;
        data["userName"] = this.userName;
        data["zoomJoinLink"] = this.zoomJoinLink;
        data["isHost"] = this.isHost;
        data["zak"] = this.zak;
        data["zoomStartLink"] = this.zoomStartLink;
        return data;
    }
}

export interface ILessonHistoryZoomCredentialsResultDto {
    sessionId?: number;
    sessionName?: string | undefined;
    productName?: string | undefined;
    startTime?: Date;
    endTime?: Date;
    productId?: number;
    classId?: number;
    productLessonId?: number | undefined;
    deliveryMode?: SessionDeliveryModeEnum;
    meetingNumber?: string | undefined;
    password?: string | undefined;
    signature?: string | undefined;
    sdkKey?: string | undefined;
    userName?: string | undefined;
    zoomJoinLink?: string | undefined;
    isHost?: boolean;
    zak?: string | undefined;
    zoomStartLink?: string | undefined;
}

export class LessonHistoryZoomLinkResultDto implements ILessonHistoryZoomLinkResultDto {
    zoomJoinLink?: string | undefined;
    deliveryMode?: SessionDeliveryModeEnum;
    zoomMeetingId?: string | undefined;
    zoomWebinarId?: string | undefined;
    meetingNumber?: string | undefined;

    constructor(data?: ILessonHistoryZoomLinkResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.zoomJoinLink = _data["zoomJoinLink"];
            this.deliveryMode = _data["deliveryMode"];
            this.zoomMeetingId = _data["zoomMeetingId"];
            this.zoomWebinarId = _data["zoomWebinarId"];
            this.meetingNumber = _data["meetingNumber"];
        }
    }

    static fromJS(data: any): LessonHistoryZoomLinkResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new LessonHistoryZoomLinkResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zoomJoinLink"] = this.zoomJoinLink;
        data["deliveryMode"] = this.deliveryMode;
        data["zoomMeetingId"] = this.zoomMeetingId;
        data["zoomWebinarId"] = this.zoomWebinarId;
        data["meetingNumber"] = this.meetingNumber;
        return data;
    }
}

export interface ILessonHistoryZoomLinkResultDto {
    zoomJoinLink?: string | undefined;
    deliveryMode?: SessionDeliveryModeEnum;
    zoomMeetingId?: string | undefined;
    zoomWebinarId?: string | undefined;
    meetingNumber?: string | undefined;
}

export class LocalityGetListQuery implements ILocalityGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    type?: LocalityTypeEnum;
    parentId?: number | undefined;
    status?: LocalityStatusEnum;

    constructor(data?: ILocalityGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.keyword = _data["keyword"];
            this.type = _data["type"];
            this.parentId = _data["parentId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): LocalityGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new LocalityGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["keyword"] = this.keyword;
        data["type"] = this.type;
        data["parentId"] = this.parentId;
        data["status"] = this.status;
        return data;
    }
}

export interface ILocalityGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    type?: LocalityTypeEnum;
    parentId?: number | undefined;
    status?: LocalityStatusEnum;
}

export class OfficeGetListQuery implements IOfficeGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    parentId?: number;

    constructor(data?: IOfficeGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.keyword = _data["keyword"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): OfficeGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new OfficeGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["keyword"] = this.keyword;
        data["parentId"] = this.parentId;
        return data;
    }
}

export interface IOfficeGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    parentId?: number;
}

export class OrderCreateWithClassDto implements IOrderCreateWithClassDto {
    productId?: number;
    classId?: number;
    fullName?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    notes?: string | undefined;

    constructor(data?: IOrderCreateWithClassDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.classId = _data["classId"];
            this.fullName = _data["fullName"];
            this.phone = _data["phone"];
            this.address = _data["address"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): OrderCreateWithClassDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderCreateWithClassDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["classId"] = this.classId;
        data["fullName"] = this.fullName;
        data["phone"] = this.phone;
        data["address"] = this.address;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IOrderCreateWithClassDto {
    productId?: number;
    classId?: number;
    fullName?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    notes?: string | undefined;
}

export class OrganizationCreateRequest implements IOrganizationCreateRequest {
    name!: string;
    code?: string | undefined;
    type?: string | undefined;
    countryId?: number;
    provinceId?: number;
    districtId?: number;
    wardId?: number;
    address?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    description?: string | undefined;
    templateOrganizationId?: number;
    ownerUserId?: number | undefined;
    maxStudentCount?: number;
    maxStaffCount?: number;

    constructor(data?: IOrganizationCreateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.type = _data["type"];
            this.countryId = _data["countryId"];
            this.provinceId = _data["provinceId"];
            this.districtId = _data["districtId"];
            this.wardId = _data["wardId"];
            this.address = _data["address"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.description = _data["description"];
            this.templateOrganizationId = _data["templateOrganizationId"];
            this.ownerUserId = _data["ownerUserId"];
            this.maxStudentCount = _data["maxStudentCount"];
            this.maxStaffCount = _data["maxStaffCount"];
        }
    }

    static fromJS(data: any): OrganizationCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["type"] = this.type;
        data["countryId"] = this.countryId;
        data["provinceId"] = this.provinceId;
        data["districtId"] = this.districtId;
        data["wardId"] = this.wardId;
        data["address"] = this.address;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["description"] = this.description;
        data["templateOrganizationId"] = this.templateOrganizationId;
        data["ownerUserId"] = this.ownerUserId;
        data["maxStudentCount"] = this.maxStudentCount;
        data["maxStaffCount"] = this.maxStaffCount;
        return data;
    }
}

export interface IOrganizationCreateRequest {
    name: string;
    code?: string | undefined;
    type?: string | undefined;
    countryId?: number;
    provinceId?: number;
    districtId?: number;
    wardId?: number;
    address?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    description?: string | undefined;
    templateOrganizationId?: number;
    ownerUserId?: number | undefined;
    maxStudentCount?: number;
    maxStaffCount?: number;
}

export class OwnershipTransferDto implements IOwnershipTransferDto {
    id?: number;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    fromUserId?: number;
    toUserId?: number;
    status?: OwnershipTransferStatusEnum;
    requestedAt?: Date;
    respondedAt?: Date | undefined;
    objectName?: string | undefined;
    fromUserName?: string | undefined;
    toUserName?: string | undefined;

    constructor(data?: IOwnershipTransferDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.objectType = _data["objectType"];
            this.objectId = _data["objectId"];
            this.fromUserId = _data["fromUserId"];
            this.toUserId = _data["toUserId"];
            this.status = _data["status"];
            this.requestedAt = _data["requestedAt"] ? new Date(_data["requestedAt"].toString()) : undefined as any;
            this.respondedAt = _data["respondedAt"] ? new Date(_data["respondedAt"].toString()) : undefined as any;
            this.objectName = _data["objectName"];
            this.fromUserName = _data["fromUserName"];
            this.toUserName = _data["toUserName"];
        }
    }

    static fromJS(data: any): OwnershipTransferDto {
        data = typeof data === 'object' ? data : {};
        let result = new OwnershipTransferDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["objectType"] = this.objectType;
        data["objectId"] = this.objectId;
        data["fromUserId"] = this.fromUserId;
        data["toUserId"] = this.toUserId;
        data["status"] = this.status;
        data["requestedAt"] = this.requestedAt ? this.requestedAt.toISOString() : undefined as any;
        data["respondedAt"] = this.respondedAt ? this.respondedAt.toISOString() : undefined as any;
        data["objectName"] = this.objectName;
        data["fromUserName"] = this.fromUserName;
        data["toUserName"] = this.toUserName;
        return data;
    }
}

export interface IOwnershipTransferDto {
    id?: number;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    fromUserId?: number;
    toUserId?: number;
    status?: OwnershipTransferStatusEnum;
    requestedAt?: Date;
    respondedAt?: Date | undefined;
    objectName?: string | undefined;
    fromUserName?: string | undefined;
    toUserName?: string | undefined;
}

export class OwnershipTransferRequestDto implements IOwnershipTransferRequestDto {
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    toUserId?: number;

    constructor(data?: IOwnershipTransferRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objectType = _data["objectType"];
            this.objectId = _data["objectId"];
            this.toUserId = _data["toUserId"];
        }
    }

    static fromJS(data: any): OwnershipTransferRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new OwnershipTransferRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objectType"] = this.objectType;
        data["objectId"] = this.objectId;
        data["toUserId"] = this.toUserId;
        return data;
    }
}

export interface IOwnershipTransferRequestDto {
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    toUserId?: number;
}

export class ProductReviewApproveCommand implements IProductReviewApproveCommand {
    id?: number;
    status?: ProductReviewStatusEnum;

    constructor(data?: IProductReviewApproveCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ProductReviewApproveCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ProductReviewApproveCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        return data;
    }
}

export interface IProductReviewApproveCommand {
    id?: number;
    status?: ProductReviewStatusEnum;
}

export class ProductGetByIdsQuery implements IProductGetByIdsQuery {
    ids?: number[] | undefined;

    constructor(data?: IProductGetByIdsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): ProductGetByIdsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ProductGetByIdsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface IProductGetByIdsQuery {
    ids?: number[] | undefined;
}

export class ProductClassDto implements IProductClassDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    maxStudents?: number | undefined;
    currentStudents?: number;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    status?: ClassStatusEnum;
    teacherName?: string | undefined;
    readonly isFull?: boolean;

    constructor(data?: IProductClassDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.maxStudents = _data["maxStudents"];
            this.currentStudents = _data["currentStudents"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.status = _data["status"];
            this.teacherName = _data["teacherName"];
            (this as any).isFull = _data["isFull"];
        }
    }

    static fromJS(data: any): ProductClassDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductClassDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["maxStudents"] = this.maxStudents;
        data["currentStudents"] = this.currentStudents;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["status"] = this.status;
        data["teacherName"] = this.teacherName;
        data["isFull"] = this.isFull;
        return data;
    }
}

export interface IProductClassDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    maxStudents?: number | undefined;
    currentStudents?: number;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    status?: ClassStatusEnum;
    teacherName?: string | undefined;
    isFull?: boolean;
}

export class ObjectLikeSaveCommand implements IObjectLikeSaveCommand {
    objectId?: number;
    objectType?: ObjectTypeEnum;

    constructor(data?: IObjectLikeSaveCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objectId = _data["objectId"];
            this.objectType = _data["objectType"];
        }
    }

    static fromJS(data: any): ObjectLikeSaveCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectLikeSaveCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objectId"] = this.objectId;
        data["objectType"] = this.objectType;
        return data;
    }
}

export interface IObjectLikeSaveCommand {
    objectId?: number;
    objectType?: ObjectTypeEnum;
}

export class PupilAddMultiCommand implements IPupilAddMultiCommand {
    pupils?: PupilAddDto[] | undefined;
    password?: string | undefined;
    classId?: number;

    constructor(data?: IPupilAddMultiCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pupils"])) {
                this.pupils = [] as any;
                for (let item of _data["pupils"])
                    this.pupils!.push(PupilAddDto.fromJS(item));
            }
            this.password = _data["password"];
            this.classId = _data["classId"];
        }
    }

    static fromJS(data: any): PupilAddMultiCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PupilAddMultiCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pupils)) {
            data["pupils"] = [];
            for (let item of this.pupils)
                data["pupils"].push(item ? item.toJSON() : undefined as any);
        }
        data["password"] = this.password;
        data["classId"] = this.classId;
        return data;
    }
}

export interface IPupilAddMultiCommand {
    pupils?: PupilAddDto[] | undefined;
    password?: string | undefined;
    classId?: number;
}

export class PupilChangePasswordCommand implements IPupilChangePasswordCommand {
    classId?: number;
    userId?: number;
    password?: string | undefined;

    constructor(data?: IPupilChangePasswordCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.classId = _data["classId"];
            this.userId = _data["userId"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): PupilChangePasswordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PupilChangePasswordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["classId"] = this.classId;
        data["userId"] = this.userId;
        data["password"] = this.password;
        return data;
    }
}

export interface IPupilChangePasswordCommand {
    classId?: number;
    userId?: number;
    password?: string | undefined;
}

export class PupilCopyFromClassCommand implements IPupilCopyFromClassCommand {
    classId?: number;
    newClassId?: number;

    constructor(data?: IPupilCopyFromClassCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.classId = _data["classId"];
            this.newClassId = _data["newClassId"];
        }
    }

    static fromJS(data: any): PupilCopyFromClassCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PupilCopyFromClassCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["classId"] = this.classId;
        data["newClassId"] = this.newClassId;
        return data;
    }
}

export interface IPupilCopyFromClassCommand {
    classId?: number;
    newClassId?: number;
}

export class PupilGoToClassCommand implements IPupilGoToClassCommand {
    classId?: number;
    checkGoToClass?: PupilCheckGoToClassDto;

    constructor(data?: IPupilGoToClassCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.classId = _data["classId"];
            this.checkGoToClass = _data["checkGoToClass"] ? PupilCheckGoToClassDto.fromJS(_data["checkGoToClass"]) : undefined as any;
        }
    }

    static fromJS(data: any): PupilGoToClassCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PupilGoToClassCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["classId"] = this.classId;
        data["checkGoToClass"] = this.checkGoToClass ? this.checkGoToClass.toJSON() : undefined as any;
        return data;
    }
}

export interface IPupilGoToClassCommand {
    classId?: number;
    checkGoToClass?: PupilCheckGoToClassDto;
}

export class QuestionGetListQuery implements IQuestionGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    type?: string | undefined;
    userId?: number | undefined;
    objectId?: number | undefined;
    objectType?: ObjectOwnerTypeEnum;
    subjectId?: number | undefined;
    classLevel?: number | undefined;
    level?: QuestionLevelEnum;
    status?: QuestionStatusEnum;
    filterType?: ObjectListFilterTypeEnum;
    shareStatus?: ShareStatusEnum;
    ids?: number[] | undefined;

    constructor(data?: IQuestionGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.keyword = _data["keyword"];
            this.type = _data["type"];
            this.userId = _data["userId"];
            this.objectId = _data["objectId"];
            this.objectType = _data["objectType"];
            this.subjectId = _data["subjectId"];
            this.classLevel = _data["classLevel"];
            this.level = _data["level"];
            this.status = _data["status"];
            this.filterType = _data["filterType"];
            this.shareStatus = _data["shareStatus"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): QuestionGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["keyword"] = this.keyword;
        data["type"] = this.type;
        data["userId"] = this.userId;
        data["objectId"] = this.objectId;
        data["objectType"] = this.objectType;
        data["subjectId"] = this.subjectId;
        data["classLevel"] = this.classLevel;
        data["level"] = this.level;
        data["status"] = this.status;
        data["filterType"] = this.filterType;
        data["shareStatus"] = this.shareStatus;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface IQuestionGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    type?: string | undefined;
    userId?: number | undefined;
    objectId?: number | undefined;
    objectType?: ObjectOwnerTypeEnum;
    subjectId?: number | undefined;
    classLevel?: number | undefined;
    level?: QuestionLevelEnum;
    status?: QuestionStatusEnum;
    filterType?: ObjectListFilterTypeEnum;
    shareStatus?: ShareStatusEnum;
    ids?: number[] | undefined;
}

export class SchoolCreateRequest implements ISchoolCreateRequest {
    name!: string;
    code?: string | undefined;
    type?: number;
    levels?: string | undefined;
    objectId?: number;
    parentId?: number;
    countryId?: number;
    provinceId?: number;
    districtId?: number;
    wardId?: number;
    address?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    url?: string | undefined;
    description?: string | undefined;
    templateSchoolId?: number;
    ownerUserId?: number | undefined;
    submitForApproval?: boolean;
    maxStudentCount?: number;
    maxStaffCount?: number;

    constructor(data?: ISchoolCreateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.type = _data["type"];
            this.levels = _data["levels"];
            this.objectId = _data["objectId"];
            this.parentId = _data["parentId"];
            this.countryId = _data["countryId"];
            this.provinceId = _data["provinceId"];
            this.districtId = _data["districtId"];
            this.wardId = _data["wardId"];
            this.address = _data["address"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.url = _data["url"];
            this.description = _data["description"];
            this.templateSchoolId = _data["templateSchoolId"];
            this.ownerUserId = _data["ownerUserId"];
            this.submitForApproval = _data["submitForApproval"];
            this.maxStudentCount = _data["maxStudentCount"];
            this.maxStaffCount = _data["maxStaffCount"];
        }
    }

    static fromJS(data: any): SchoolCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SchoolCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["type"] = this.type;
        data["levels"] = this.levels;
        data["objectId"] = this.objectId;
        data["parentId"] = this.parentId;
        data["countryId"] = this.countryId;
        data["provinceId"] = this.provinceId;
        data["districtId"] = this.districtId;
        data["wardId"] = this.wardId;
        data["address"] = this.address;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["url"] = this.url;
        data["description"] = this.description;
        data["templateSchoolId"] = this.templateSchoolId;
        data["ownerUserId"] = this.ownerUserId;
        data["submitForApproval"] = this.submitForApproval;
        data["maxStudentCount"] = this.maxStudentCount;
        data["maxStaffCount"] = this.maxStaffCount;
        return data;
    }
}

export interface ISchoolCreateRequest {
    name: string;
    code?: string | undefined;
    type?: number;
    levels?: string | undefined;
    objectId?: number;
    parentId?: number;
    countryId?: number;
    provinceId?: number;
    districtId?: number;
    wardId?: number;
    address?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    url?: string | undefined;
    description?: string | undefined;
    templateSchoolId?: number;
    ownerUserId?: number | undefined;
    submitForApproval?: boolean;
    maxStudentCount?: number;
    maxStaffCount?: number;
}

export class SchoolUpdateByPersonalRequest implements ISchoolUpdateByPersonalRequest {
    id!: number;
    name!: string;
    code?: string | undefined;
    type?: number;
    levels?: string | undefined;
    objectId?: number;
    countryId?: number;
    provinceId?: number;
    districtId?: number;
    wardId?: number;
    address?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    url?: string | undefined;
    description?: string | undefined;
    logo?: string | undefined;
    parentId?: number;
    submitForApproval?: boolean;

    constructor(data?: ISchoolUpdateByPersonalRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.type = _data["type"];
            this.levels = _data["levels"];
            this.objectId = _data["objectId"];
            this.countryId = _data["countryId"];
            this.provinceId = _data["provinceId"];
            this.districtId = _data["districtId"];
            this.wardId = _data["wardId"];
            this.address = _data["address"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.url = _data["url"];
            this.description = _data["description"];
            this.logo = _data["logo"];
            this.parentId = _data["parentId"];
            this.submitForApproval = _data["submitForApproval"];
        }
    }

    static fromJS(data: any): SchoolUpdateByPersonalRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SchoolUpdateByPersonalRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["type"] = this.type;
        data["levels"] = this.levels;
        data["objectId"] = this.objectId;
        data["countryId"] = this.countryId;
        data["provinceId"] = this.provinceId;
        data["districtId"] = this.districtId;
        data["wardId"] = this.wardId;
        data["address"] = this.address;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["url"] = this.url;
        data["description"] = this.description;
        data["logo"] = this.logo;
        data["parentId"] = this.parentId;
        data["submitForApproval"] = this.submitForApproval;
        return data;
    }
}

export interface ISchoolUpdateByPersonalRequest {
    id: number;
    name: string;
    code?: string | undefined;
    type?: number;
    levels?: string | undefined;
    objectId?: number;
    countryId?: number;
    provinceId?: number;
    districtId?: number;
    wardId?: number;
    address?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    url?: string | undefined;
    description?: string | undefined;
    logo?: string | undefined;
    parentId?: number;
    submitForApproval?: boolean;
}

export class AssignExistingTeacherDto implements IAssignExistingTeacherDto {
    schoolId?: number;
    userId?: number;
    subject?: number[] | undefined;
    classManage?: number[] | undefined;
    classList?: number[] | undefined;

    constructor(data?: IAssignExistingTeacherDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.schoolId = _data["schoolId"];
            this.userId = _data["userId"];
            if (Array.isArray(_data["subject"])) {
                this.subject = [] as any;
                for (let item of _data["subject"])
                    this.subject!.push(item);
            }
            if (Array.isArray(_data["classManage"])) {
                this.classManage = [] as any;
                for (let item of _data["classManage"])
                    this.classManage!.push(item);
            }
            if (Array.isArray(_data["classList"])) {
                this.classList = [] as any;
                for (let item of _data["classList"])
                    this.classList!.push(item);
            }
        }
    }

    static fromJS(data: any): AssignExistingTeacherDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignExistingTeacherDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["schoolId"] = this.schoolId;
        data["userId"] = this.userId;
        if (Array.isArray(this.subject)) {
            data["subject"] = [];
            for (let item of this.subject)
                data["subject"].push(item);
        }
        if (Array.isArray(this.classManage)) {
            data["classManage"] = [];
            for (let item of this.classManage)
                data["classManage"].push(item);
        }
        if (Array.isArray(this.classList)) {
            data["classList"] = [];
            for (let item of this.classList)
                data["classList"].push(item);
        }
        return data;
    }
}

export interface IAssignExistingTeacherDto {
    schoolId?: number;
    userId?: number;
    subject?: number[] | undefined;
    classManage?: number[] | undefined;
    classList?: number[] | undefined;
}

export class SchoolCodeCheckDto implements ISchoolCodeCheckDto {
    valid?: boolean;
    available?: boolean;
    message?: string | undefined;

    constructor(data?: ISchoolCodeCheckDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valid = _data["valid"];
            this.available = _data["available"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SchoolCodeCheckDto {
        data = typeof data === 'object' ? data : {};
        let result = new SchoolCodeCheckDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valid"] = this.valid;
        data["available"] = this.available;
        data["message"] = this.message;
        return data;
    }
}

export interface ISchoolCodeCheckDto {
    valid?: boolean;
    available?: boolean;
    message?: string | undefined;
}

export class SchoolUserDto implements ISchoolUserDto {
    userTypes?: number[] | undefined;
    userObjectId?: number;
    userId?: number;
    fullName?: string | undefined;
    userName?: string | undefined;
    avatar?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    userType?: UserTypeEnum;
    departmentUserId?: number | undefined;
    departmentId?: number | undefined;
    departmentName?: string | undefined;
    departmentCode?: string | undefined;
    title?: string | undefined;
    titleId?: number;
    isPrimary?: boolean;
    joinedAt?: Date;
    leftAt?: Date | undefined;
    roleIds?: number[] | undefined;
    roleNames?: string[] | undefined;
    subjectIds?: number[] | undefined;
    classNames?: string | undefined;
    homeroomClassName?: string | undefined;

    constructor(data?: ISchoolUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userTypes = _data["userTypes"];
            this.userObjectId = _data["userObjectId"];
            this.userId = _data["userId"];
            this.fullName = _data["fullName"];
            this.userName = _data["userName"];
            this.avatar = _data["avatar"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.userType = _data["userType"];
            this.departmentUserId = _data["departmentUserId"];
            this.departmentId = _data["departmentId"];
            this.departmentName = _data["departmentName"];
            this.departmentCode = _data["departmentCode"];
            this.title = _data["title"];
            this.titleId = _data["titleId"];
            this.isPrimary = _data["isPrimary"];
            this.joinedAt = _data["joinedAt"] ? new Date(_data["joinedAt"].toString()) : undefined as any;
            this.leftAt = _data["leftAt"] ? new Date(_data["leftAt"].toString()) : undefined as any;
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
            if (Array.isArray(_data["subjectIds"])) {
                this.subjectIds = [] as any;
                for (let item of _data["subjectIds"])
                    this.subjectIds!.push(item);
            }
            this.classNames = _data["classNames"];
            this.homeroomClassName = _data["homeroomClassName"];
        }
    }

    static fromJS(data: any): SchoolUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new SchoolUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userTypes"] = this.userTypes;
        data["userObjectId"] = this.userObjectId;
        data["userId"] = this.userId;
        data["fullName"] = this.fullName;
        data["userName"] = this.userName;
        data["avatar"] = this.avatar;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["userType"] = this.userType;
        data["departmentUserId"] = this.departmentUserId;
        data["departmentId"] = this.departmentId;
        data["departmentName"] = this.departmentName;
        data["departmentCode"] = this.departmentCode;
        data["title"] = this.title;
        data["titleId"] = this.titleId;
        data["isPrimary"] = this.isPrimary;
        data["joinedAt"] = this.joinedAt ? this.joinedAt.toISOString() : undefined as any;
        data["leftAt"] = this.leftAt ? this.leftAt.toISOString() : undefined as any;
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        if (Array.isArray(this.subjectIds)) {
            data["subjectIds"] = [];
            for (let item of this.subjectIds)
                data["subjectIds"].push(item);
        }
        data["classNames"] = this.classNames;
        data["homeroomClassName"] = this.homeroomClassName;
        return data;
    }
}

export interface ISchoolUserDto {
    userTypes?: number[] | undefined;
    userObjectId?: number;
    userId?: number;
    fullName?: string | undefined;
    userName?: string | undefined;
    avatar?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    userType?: UserTypeEnum;
    departmentUserId?: number | undefined;
    departmentId?: number | undefined;
    departmentName?: string | undefined;
    departmentCode?: string | undefined;
    title?: string | undefined;
    titleId?: number;
    isPrimary?: boolean;
    joinedAt?: Date;
    leftAt?: Date | undefined;
    roleIds?: number[] | undefined;
    roleNames?: string[] | undefined;
    subjectIds?: number[] | undefined;
    classNames?: string | undefined;
    homeroomClassName?: string | undefined;
}

export class TeacherUpdateManagerCommand implements ITeacherUpdateManagerCommand {
    classId?: number;
    userId?: number;

    constructor(data?: ITeacherUpdateManagerCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.classId = _data["classId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): TeacherUpdateManagerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TeacherUpdateManagerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["classId"] = this.classId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface ITeacherUpdateManagerCommand {
    classId?: number;
    userId?: number;
}

export class TeacherUpdateSubjectsCommand implements ITeacherUpdateSubjectsCommand {
    classId?: number;
    userId?: number;
    subjectIds?: number[] | undefined;

    constructor(data?: ITeacherUpdateSubjectsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.classId = _data["classId"];
            this.userId = _data["userId"];
            if (Array.isArray(_data["subjectIds"])) {
                this.subjectIds = [] as any;
                for (let item of _data["subjectIds"])
                    this.subjectIds!.push(item);
            }
        }
    }

    static fromJS(data: any): TeacherUpdateSubjectsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TeacherUpdateSubjectsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["classId"] = this.classId;
        data["userId"] = this.userId;
        if (Array.isArray(this.subjectIds)) {
            data["subjectIds"] = [];
            for (let item of this.subjectIds)
                data["subjectIds"].push(item);
        }
        return data;
    }
}

export interface ITeacherUpdateSubjectsCommand {
    classId?: number;
    userId?: number;
    subjectIds?: number[] | undefined;
}

export class UserObjectInviteDto implements IUserObjectInviteDto {
    id?: number;
    userId?: number;
    userName?: string | undefined;
    fullName?: string | undefined;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    objectName?: string | undefined;
    objectSlug?: string | undefined;
    userType?: UserTypeEnum;
    status?: UserObjectStatusEnum;
    createdDate?: Date;

    constructor(data?: IUserObjectInviteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.fullName = _data["fullName"];
            this.objectType = _data["objectType"];
            this.objectId = _data["objectId"];
            this.objectName = _data["objectName"];
            this.objectSlug = _data["objectSlug"];
            this.userType = _data["userType"];
            this.status = _data["status"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UserObjectInviteDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserObjectInviteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["fullName"] = this.fullName;
        data["objectType"] = this.objectType;
        data["objectId"] = this.objectId;
        data["objectName"] = this.objectName;
        data["objectSlug"] = this.objectSlug;
        data["userType"] = this.userType;
        data["status"] = this.status;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IUserObjectInviteDto {
    id?: number;
    userId?: number;
    userName?: string | undefined;
    fullName?: string | undefined;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    objectName?: string | undefined;
    objectSlug?: string | undefined;
    userType?: UserTypeEnum;
    status?: UserObjectStatusEnum;
    createdDate?: Date;
}

export class ZoomAccountDetailDto implements IZoomAccountDetailDto {
    id?: number;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    name?: string | undefined;
    accountId?: string | undefined;
    clientId?: string | undefined;
    clientSecret?: string | undefined;
    userId?: string | undefined;
    maxConcurrentMeetings?: number;
    isActive?: boolean;

    constructor(data?: IZoomAccountDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.objectId = _data["objectId"];
            this.objectType = _data["objectType"];
            this.name = _data["name"];
            this.accountId = _data["accountId"];
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
            this.userId = _data["userId"];
            this.maxConcurrentMeetings = _data["maxConcurrentMeetings"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ZoomAccountDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ZoomAccountDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["objectId"] = this.objectId;
        data["objectType"] = this.objectType;
        data["name"] = this.name;
        data["accountId"] = this.accountId;
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["userId"] = this.userId;
        data["maxConcurrentMeetings"] = this.maxConcurrentMeetings;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IZoomAccountDetailDto {
    id?: number;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    name?: string | undefined;
    accountId?: string | undefined;
    clientId?: string | undefined;
    clientSecret?: string | undefined;
    userId?: string | undefined;
    maxConcurrentMeetings?: number;
    isActive?: boolean;
}

export class ZoomAccountListDto implements IZoomAccountListDto {
    id?: number;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    name?: string | undefined;
    userId?: string | undefined;
    maxConcurrentMeetings?: number;
    isActive?: boolean;

    constructor(data?: IZoomAccountListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.objectId = _data["objectId"];
            this.objectType = _data["objectType"];
            this.name = _data["name"];
            this.userId = _data["userId"];
            this.maxConcurrentMeetings = _data["maxConcurrentMeetings"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ZoomAccountListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ZoomAccountListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["objectId"] = this.objectId;
        data["objectType"] = this.objectType;
        data["name"] = this.name;
        data["userId"] = this.userId;
        data["maxConcurrentMeetings"] = this.maxConcurrentMeetings;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IZoomAccountListDto {
    id?: number;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    name?: string | undefined;
    userId?: string | undefined;
    maxConcurrentMeetings?: number;
    isActive?: boolean;
}

export class ZoomAccountSaveDto implements IZoomAccountSaveDto {
    id?: number;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    name?: string | undefined;
    accountId?: string | undefined;
    clientId?: string | undefined;
    clientSecret?: string | undefined;
    userId?: string | undefined;
    maxConcurrentMeetings?: number;
    isActive?: boolean;

    constructor(data?: IZoomAccountSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.objectId = _data["objectId"];
            this.objectType = _data["objectType"];
            this.name = _data["name"];
            this.accountId = _data["accountId"];
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
            this.userId = _data["userId"];
            this.maxConcurrentMeetings = _data["maxConcurrentMeetings"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ZoomAccountSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new ZoomAccountSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["objectId"] = this.objectId;
        data["objectType"] = this.objectType;
        data["name"] = this.name;
        data["accountId"] = this.accountId;
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["userId"] = this.userId;
        data["maxConcurrentMeetings"] = this.maxConcurrentMeetings;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IZoomAccountSaveDto {
    id?: number;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    name?: string | undefined;
    accountId?: string | undefined;
    clientId?: string | undefined;
    clientSecret?: string | undefined;
    userId?: string | undefined;
    maxConcurrentMeetings?: number;
    isActive?: boolean;
}

export class EnumItemEntity implements IEnumItemEntity {
    id?: number;
    name?: string | undefined;
    readonly code?: string | undefined;

    constructor(data?: IEnumItemEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            (this as any).code = _data["code"];
        }
    }

    static fromJS(data: any): EnumItemEntity {
        data = typeof data === 'object' ? data : {};
        let result = new EnumItemEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }
}

export interface IEnumItemEntity {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
}

export class EnumListEntity implements IEnumListEntity {
    value?: number;
    code?: string | undefined;
    name?: string | undefined;
    isZone?: boolean;
    permissions?: EnumListEntity[] | undefined;

    constructor(data?: IEnumListEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.isZone = _data["isZone"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(EnumListEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnumListEntity {
        data = typeof data === 'object' ? data : {};
        let result = new EnumListEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["code"] = this.code;
        data["name"] = this.name;
        data["isZone"] = this.isZone;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEnumListEntity {
    value?: number;
    code?: string | undefined;
    name?: string | undefined;
    isZone?: boolean;
    permissions?: EnumListEntity[] | undefined;
}

export class ClassLevel implements IClassLevel {
    id?: number;
    grade?: number;
    name!: string | undefined;
    subjects?: Subject[] | undefined;

    constructor(data?: IClassLevel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.grade = _data["grade"];
            this.name = _data["name"];
            if (Array.isArray(_data["subjects"])) {
                this.subjects = [] as any;
                for (let item of _data["subjects"])
                    this.subjects!.push(Subject.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClassLevel {
        data = typeof data === 'object' ? data : {};
        let result = new ClassLevel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["grade"] = this.grade;
        data["name"] = this.name;
        if (Array.isArray(this.subjects)) {
            data["subjects"] = [];
            for (let item of this.subjects)
                data["subjects"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IClassLevel {
    id?: number;
    grade?: number;
    name: string | undefined;
    subjects?: Subject[] | undefined;
}

export class SchoolLevel implements ISchoolLevel {
    id?: number;
    name!: string | undefined;
    classLevels?: ClassLevel[] | undefined;

    constructor(data?: ISchoolLevel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["classLevels"])) {
                this.classLevels = [] as any;
                for (let item of _data["classLevels"])
                    this.classLevels!.push(ClassLevel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SchoolLevel {
        data = typeof data === 'object' ? data : {};
        let result = new SchoolLevel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.classLevels)) {
            data["classLevels"] = [];
            for (let item of this.classLevels)
                data["classLevels"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISchoolLevel {
    id?: number;
    name: string | undefined;
    classLevels?: ClassLevel[] | undefined;
}

export class Subject implements ISubject {
    id?: number;
    name!: string | undefined;

    constructor(data?: ISubject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Subject {
        data = typeof data === 'object' ? data : {};
        let result = new Subject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ISubject {
    id?: number;
    name: string | undefined;
}

export class ApiResponse_1OfDocumentInfo implements IApiResponse_1OfDocumentInfo {
    data?: DocumentInfo;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfDocumentInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? DocumentInfo.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfDocumentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfDocumentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfDocumentInfo {
    data?: DocumentInfo;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfDocumentPreviewResponse implements IApiResponse_1OfDocumentPreviewResponse {
    data?: DocumentPreviewResponse;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfDocumentPreviewResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? DocumentPreviewResponse.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfDocumentPreviewResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfDocumentPreviewResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfDocumentPreviewResponse {
    data?: DocumentPreviewResponse;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfResponseX implements IApiResponse_1OfResponseX {
    data?: ResponseX;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfResponseX) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ResponseX.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfResponseX {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfResponseX();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfResponseX {
    data?: ResponseX;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfSystemInitDto implements IApiResponse_1OfSystemInitDto {
    data?: SystemInitDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfSystemInitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? SystemInitDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfSystemInitDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfSystemInitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfSystemInitDto {
    data?: SystemInitDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfChangePasswordInitiateResultDto implements IApiResponse_1OfChangePasswordInitiateResultDto {
    data?: ChangePasswordInitiateResultDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfChangePasswordInitiateResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ChangePasswordInitiateResultDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfChangePasswordInitiateResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfChangePasswordInitiateResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfChangePasswordInitiateResultDto {
    data?: ChangePasswordInitiateResultDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfCurrentObjectDto implements IApiResponse_1OfCurrentObjectDto {
    data?: CurrentObjectDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfCurrentObjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? CurrentObjectDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfCurrentObjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfCurrentObjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfCurrentObjectDto {
    data?: CurrentObjectDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfEnable2FAResultDto implements IApiResponse_1OfEnable2FAResultDto {
    data?: Enable2FAResultDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfEnable2FAResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? Enable2FAResultDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfEnable2FAResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfEnable2FAResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfEnable2FAResultDto {
    data?: Enable2FAResultDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFamilyQuotaDto implements IApiResponse_1OfFamilyQuotaDto {
    data?: FamilyQuotaDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFamilyQuotaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FamilyQuotaDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFamilyQuotaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFamilyQuotaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFamilyQuotaDto {
    data?: FamilyQuotaDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfForgotPasswordOtpVerifiedDto implements IApiResponse_1OfForgotPasswordOtpVerifiedDto {
    data?: ForgotPasswordOtpVerifiedDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfForgotPasswordOtpVerifiedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ForgotPasswordOtpVerifiedDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfForgotPasswordOtpVerifiedDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfForgotPasswordOtpVerifiedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfForgotPasswordOtpVerifiedDto {
    data?: ForgotPasswordOtpVerifiedDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfGoogleLinkStatusDto implements IApiResponse_1OfGoogleLinkStatusDto {
    data?: GoogleLinkStatusDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfGoogleLinkStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? GoogleLinkStatusDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfGoogleLinkStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfGoogleLinkStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfGoogleLinkStatusDto {
    data?: GoogleLinkStatusDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfLoginResponseDto implements IApiResponse_1OfLoginResponseDto {
    data?: LoginResponseDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfLoginResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? LoginResponseDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfLoginResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfLoginResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfLoginResponseDto {
    data?: LoginResponseDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfOtpSendResultDto implements IApiResponse_1OfOtpSendResultDto {
    data?: OtpSendResultDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfOtpSendResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? OtpSendResultDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfOtpSendResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfOtpSendResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfOtpSendResultDto {
    data?: OtpSendResultDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfOtpTargetEmailOptionsDto implements IApiResponse_1OfOtpTargetEmailOptionsDto {
    data?: OtpTargetEmailOptionsDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfOtpTargetEmailOptionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? OtpTargetEmailOptionsDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfOtpTargetEmailOptionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfOtpTargetEmailOptionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfOtpTargetEmailOptionsDto {
    data?: OtpTargetEmailOptionsDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfRecoveryCodesStatusDto implements IApiResponse_1OfRecoveryCodesStatusDto {
    data?: RecoveryCodesStatusDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfRecoveryCodesStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? RecoveryCodesStatusDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfRecoveryCodesStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfRecoveryCodesStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfRecoveryCodesStatusDto {
    data?: RecoveryCodesStatusDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfRefreshTokenResponseDto implements IApiResponse_1OfRefreshTokenResponseDto {
    data?: RefreshTokenResponseDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfRefreshTokenResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? RefreshTokenResponseDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfRefreshTokenResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfRefreshTokenResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfRefreshTokenResponseDto {
    data?: RefreshTokenResponseDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfRegisterDto implements IApiResponse_1OfRegisterDto {
    data?: RegisterDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfRegisterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? RegisterDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfRegisterDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfRegisterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfRegisterDto {
    data?: RegisterDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfUserInfoDto implements IApiResponse_1OfUserInfoDto {
    data?: UserInfoDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfUserInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? UserInfoDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfUserInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfUserInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfUserInfoDto {
    data?: UserInfoDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfValidationRulesDto implements IApiResponse_1OfValidationRulesDto {
    data?: ValidationRulesDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfValidationRulesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ValidationRulesDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfValidationRulesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfValidationRulesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfValidationRulesDto {
    data?: ValidationRulesDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfSystemConfigAdminDto implements IApiResponse_1OfSystemConfigAdminDto {
    data?: SystemConfigAdminDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfSystemConfigAdminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? SystemConfigAdminDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfSystemConfigAdminDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfSystemConfigAdminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfSystemConfigAdminDto {
    data?: SystemConfigAdminDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfUserIdentifierAdminDto implements IApiResponse_1OfUserIdentifierAdminDto {
    data?: UserIdentifierAdminDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfUserIdentifierAdminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? UserIdentifierAdminDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfUserIdentifierAdminDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfUserIdentifierAdminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfUserIdentifierAdminDto {
    data?: UserIdentifierAdminDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfUserIdentifierAdminResolveUserDto implements IApiResponse_1OfUserIdentifierAdminResolveUserDto {
    data?: UserIdentifierAdminResolveUserDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfUserIdentifierAdminResolveUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? UserIdentifierAdminResolveUserDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfUserIdentifierAdminResolveUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfUserIdentifierAdminResolveUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfUserIdentifierAdminResolveUserDto {
    data?: UserIdentifierAdminResolveUserDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFileUploadByUrlResponseDto implements IApiResponse_1OfFileUploadByUrlResponseDto {
    data?: FileUploadByUrlResponseDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFileUploadByUrlResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FileUploadByUrlResponseDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFileUploadByUrlResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFileUploadByUrlResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFileUploadByUrlResponseDto {
    data?: FileUploadByUrlResponseDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfPupilDetailDto implements IApiResponse_1OfPupilDetailDto {
    data?: PupilDetailDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfPupilDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? PupilDetailDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfPupilDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfPupilDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfPupilDetailDto {
    data?: PupilDetailDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfUserProfileDto implements IApiResponse_1OfUserProfileDto {
    data?: UserProfileDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfUserProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? UserProfileDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfUserProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfUserProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfUserProfileDto {
    data?: UserProfileDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfDepartmentRoleDto implements IApiResponse_1OfDepartmentRoleDto {
    data?: DepartmentRoleDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfDepartmentRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? DepartmentRoleDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfDepartmentRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfDepartmentRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfDepartmentRoleDto {
    data?: DepartmentRoleDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfLessonHistoryZoomCredentialsResultDto implements IApiResponse_1OfLessonHistoryZoomCredentialsResultDto {
    data?: LessonHistoryZoomCredentialsResultDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfLessonHistoryZoomCredentialsResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? LessonHistoryZoomCredentialsResultDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfLessonHistoryZoomCredentialsResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfLessonHistoryZoomCredentialsResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfLessonHistoryZoomCredentialsResultDto {
    data?: LessonHistoryZoomCredentialsResultDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfLessonHistoryZoomLinkResultDto implements IApiResponse_1OfLessonHistoryZoomLinkResultDto {
    data?: LessonHistoryZoomLinkResultDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfLessonHistoryZoomLinkResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? LessonHistoryZoomLinkResultDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfLessonHistoryZoomLinkResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfLessonHistoryZoomLinkResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfLessonHistoryZoomLinkResultDto {
    data?: LessonHistoryZoomLinkResultDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfSchoolCodeCheckDto implements IApiResponse_1OfSchoolCodeCheckDto {
    data?: SchoolCodeCheckDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfSchoolCodeCheckDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? SchoolCodeCheckDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfSchoolCodeCheckDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfSchoolCodeCheckDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfSchoolCodeCheckDto {
    data?: SchoolCodeCheckDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfZoomAccountDetailDto implements IApiResponse_1OfZoomAccountDetailDto {
    data?: ZoomAccountDetailDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfZoomAccountDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ZoomAccountDetailDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfZoomAccountDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfZoomAccountDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfZoomAccountDetailDto {
    data?: ZoomAccountDetailDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfZoomAccountListDto implements IApiResponse_1OfZoomAccountListDto {
    data?: ZoomAccountListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfZoomAccountListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ZoomAccountListDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfZoomAccountListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfZoomAccountListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfZoomAccountListDto {
    data?: ZoomAccountListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfAiResponse implements IApiResponse_1OfAiResponse {
    data?: AiResponse;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfAiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? AiResponse.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfAiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfAiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfAiResponse {
    data?: AiResponse;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfZoomMeetingDto implements IApiResponse_1OfZoomMeetingDto {
    data?: ZoomMeetingDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfZoomMeetingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ZoomMeetingDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfZoomMeetingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfZoomMeetingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfZoomMeetingDto {
    data?: ZoomMeetingDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfActionRuleDto implements IApiResponse_1OfActionRuleDto {
    data?: ActionRuleDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfActionRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ActionRuleDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfActionRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfActionRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfActionRuleDto {
    data?: ActionRuleDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfActivitySaveDto implements IApiResponse_1OfActivitySaveDto {
    data?: ActivitySaveDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfActivitySaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ActivitySaveDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfActivitySaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfActivitySaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfActivitySaveDto {
    data?: ActivitySaveDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfAssignExamCheckDoExamDto implements IApiResponse_1OfAssignExamCheckDoExamDto {
    data?: AssignExamCheckDoExamDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfAssignExamCheckDoExamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? AssignExamCheckDoExamDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfAssignExamCheckDoExamDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfAssignExamCheckDoExamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfAssignExamCheckDoExamDto {
    data?: AssignExamCheckDoExamDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfAssignExamCountDto implements IApiResponse_1OfAssignExamCountDto {
    data?: AssignExamCountDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfAssignExamCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? AssignExamCountDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfAssignExamCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfAssignExamCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfAssignExamCountDto {
    data?: AssignExamCountDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfCartDto implements IApiResponse_1OfCartDto {
    data?: CartDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfCartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? CartDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfCartDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfCartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfCartDto {
    data?: CartDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfCategoryConfigListDto implements IApiResponse_1OfCategoryConfigListDto {
    data?: CategoryConfigListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfCategoryConfigListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? CategoryConfigListDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfCategoryConfigListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfCategoryConfigListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfCategoryConfigListDto {
    data?: CategoryConfigListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfChatGroupDetailDto implements IApiResponse_1OfChatGroupDetailDto {
    data?: ChatGroupDetailDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfChatGroupDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ChatGroupDetailDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfChatGroupDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfChatGroupDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfChatGroupDetailDto {
    data?: ChatGroupDetailDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfExamDataBeforeDeleteDto implements IApiResponse_1OfExamDataBeforeDeleteDto {
    data?: ExamDataBeforeDeleteDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfExamDataBeforeDeleteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ExamDataBeforeDeleteDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfExamDataBeforeDeleteDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfExamDataBeforeDeleteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfExamDataBeforeDeleteDto {
    data?: ExamDataBeforeDeleteDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfExamDto implements IApiResponse_1OfExamDto {
    data?: ExamDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfExamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ExamDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfExamDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfExamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfExamDto {
    data?: ExamDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfExamSaveDto implements IApiResponse_1OfExamSaveDto {
    data?: ExamSaveDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfExamSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ExamSaveDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfExamSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfExamSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfExamSaveDto {
    data?: ExamSaveDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfGallerySaveDto implements IApiResponse_1OfGallerySaveDto {
    data?: GallerySaveDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfGallerySaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? GallerySaveDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfGallerySaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfGallerySaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfGallerySaveDto {
    data?: GallerySaveDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfLanguageListDto implements IApiResponse_1OfLanguageListDto {
    data?: LanguageListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfLanguageListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? LanguageListDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfLanguageListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfLanguageListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfLanguageListDto {
    data?: LanguageListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfModuleDefinitionDto implements IApiResponse_1OfModuleDefinitionDto {
    data?: ModuleDefinitionDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfModuleDefinitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ModuleDefinitionDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfModuleDefinitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfModuleDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfModuleDefinitionDto {
    data?: ModuleDefinitionDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfNewsDetailDto implements IApiResponse_1OfNewsDetailDto {
    data?: NewsDetailDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfNewsDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? NewsDetailDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfNewsDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfNewsDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfNewsDetailDto {
    data?: NewsDetailDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfOrderDto implements IApiResponse_1OfOrderDto {
    data?: OrderDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? OrderDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfOrderDto {
    data?: OrderDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfOrderPaymentDto implements IApiResponse_1OfOrderPaymentDto {
    data?: OrderPaymentDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfOrderPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? OrderPaymentDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfOrderPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfOrderPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfOrderPaymentDto {
    data?: OrderPaymentDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfOrganizationDto implements IApiResponse_1OfOrganizationDto {
    data?: OrganizationDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfOrganizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? OrganizationDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfOrganizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfOrganizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfOrganizationDto {
    data?: OrganizationDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfProductChapterSaveDto implements IApiResponse_1OfProductChapterSaveDto {
    data?: ProductChapterSaveDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfProductChapterSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ProductChapterSaveDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfProductChapterSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfProductChapterSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfProductChapterSaveDto {
    data?: ProductChapterSaveDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfProductDetailDto implements IApiResponse_1OfProductDetailDto {
    data?: ProductDetailDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfProductDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ProductDetailDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfProductDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfProductDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfProductDetailDto {
    data?: ProductDetailDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfProductLessonSaveDto implements IApiResponse_1OfProductLessonSaveDto {
    data?: ProductLessonSaveDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfProductLessonSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ProductLessonSaveDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfProductLessonSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfProductLessonSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfProductLessonSaveDto {
    data?: ProductLessonSaveDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfProductSaveDto implements IApiResponse_1OfProductSaveDto {
    data?: ProductSaveDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfProductSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ProductSaveDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfProductSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfProductSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfProductSaveDto {
    data?: ProductSaveDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfPupilCheckGoToClassDto implements IApiResponse_1OfPupilCheckGoToClassDto {
    data?: PupilCheckGoToClassDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfPupilCheckGoToClassDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? PupilCheckGoToClassDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfPupilCheckGoToClassDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfPupilCheckGoToClassDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfPupilCheckGoToClassDto {
    data?: PupilCheckGoToClassDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfPupilDashboardStatisticalDto implements IApiResponse_1OfPupilDashboardStatisticalDto {
    data?: PupilDashboardStatisticalDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfPupilDashboardStatisticalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? PupilDashboardStatisticalDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfPupilDashboardStatisticalDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfPupilDashboardStatisticalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfPupilDashboardStatisticalDto {
    data?: PupilDashboardStatisticalDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfPupilStaticDto implements IApiResponse_1OfPupilStaticDto {
    data?: PupilStaticDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfPupilStaticDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? PupilStaticDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfPupilStaticDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfPupilStaticDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfPupilStaticDto {
    data?: PupilStaticDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfPupilStatisticalDto implements IApiResponse_1OfPupilStatisticalDto {
    data?: PupilStatisticalDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfPupilStatisticalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? PupilStatisticalDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfPupilStatisticalDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfPupilStatisticalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfPupilStatisticalDto {
    data?: PupilStatisticalDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfQuestionDto implements IApiResponse_1OfQuestionDto {
    data?: QuestionDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? QuestionDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfQuestionDto {
    data?: QuestionDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfRoleDto implements IApiResponse_1OfRoleDto {
    data?: RoleDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? RoleDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfRoleDto {
    data?: RoleDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfSchoolDto implements IApiResponse_1OfSchoolDto {
    data?: SchoolDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfSchoolDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? SchoolDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfSchoolDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfSchoolDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfSchoolDto {
    data?: SchoolDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfSchoolStaticCountDto implements IApiResponse_1OfSchoolStaticCountDto {
    data?: SchoolStaticCountDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfSchoolStaticCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? SchoolStaticCountDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfSchoolStaticCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfSchoolStaticCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfSchoolStaticCountDto {
    data?: SchoolStaticCountDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfSessionStatusDto implements IApiResponse_1OfSessionStatusDto {
    data?: SessionStatusDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfSessionStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? SessionStatusDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfSessionStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfSessionStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfSessionStatusDto {
    data?: SessionStatusDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfStaticPageDetailDto implements IApiResponse_1OfStaticPageDetailDto {
    data?: StaticPageDetailDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfStaticPageDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? StaticPageDetailDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfStaticPageDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfStaticPageDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfStaticPageDetailDto {
    data?: StaticPageDetailDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfStaticPageSectionContentDto implements IApiResponse_1OfStaticPageSectionContentDto {
    data?: StaticPageSectionContentDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfStaticPageSectionContentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? StaticPageSectionContentDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfStaticPageSectionContentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfStaticPageSectionContentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfStaticPageSectionContentDto {
    data?: StaticPageSectionContentDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfStatisticalDto implements IApiResponse_1OfStatisticalDto {
    data?: StatisticalDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfStatisticalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? StatisticalDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfStatisticalDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfStatisticalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfStatisticalDto {
    data?: StatisticalDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfTagDto implements IApiResponse_1OfTagDto {
    data?: TagDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? TagDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfTagDto {
    data?: TagDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfTranslationBundleDto implements IApiResponse_1OfTranslationBundleDto {
    data?: TranslationBundleDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfTranslationBundleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? TranslationBundleDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfTranslationBundleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfTranslationBundleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfTranslationBundleDto {
    data?: TranslationBundleDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfTranslationDetailDto implements IApiResponse_1OfTranslationDetailDto {
    data?: TranslationDetailDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfTranslationDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? TranslationDetailDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfTranslationDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfTranslationDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfTranslationDetailDto {
    data?: TranslationDetailDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfUserPointSummaryDto implements IApiResponse_1OfUserPointSummaryDto {
    data?: UserPointSummaryDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfUserPointSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? UserPointSummaryDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfUserPointSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfUserPointSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfUserPointSummaryDto {
    data?: UserPointSummaryDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfVanityOwnerDto implements IApiResponse_1OfVanityOwnerDto {
    data?: VanityOwnerDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfVanityOwnerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? VanityOwnerDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfVanityOwnerDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfVanityOwnerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfVanityOwnerDto {
    data?: VanityOwnerDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfActivityEntity implements IApiResponse_1OfActivityEntity {
    data?: ActivityEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfActivityEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ActivityEntity.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfActivityEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfActivityEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfActivityEntity {
    data?: ActivityEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfActivityLogEntity implements IApiResponse_1OfActivityLogEntity {
    data?: ActivityLogEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfActivityLogEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ActivityLogEntity.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfActivityLogEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfActivityLogEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfActivityLogEntity {
    data?: ActivityLogEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfAiPromptEntity implements IApiResponse_1OfAiPromptEntity {
    data?: AiPromptEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfAiPromptEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? AiPromptEntity.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfAiPromptEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfAiPromptEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfAiPromptEntity {
    data?: AiPromptEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfSystemConfigAdminDto implements IApiResponse_1OfFilterResult_1OfSystemConfigAdminDto {
    data?: FilterResult_1OfSystemConfigAdminDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfSystemConfigAdminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfSystemConfigAdminDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfSystemConfigAdminDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfSystemConfigAdminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfSystemConfigAdminDto {
    data?: FilterResult_1OfSystemConfigAdminDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfUserIdentifierAdminDto implements IApiResponse_1OfFilterResult_1OfUserIdentifierAdminDto {
    data?: FilterResult_1OfUserIdentifierAdminDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfUserIdentifierAdminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfUserIdentifierAdminDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfUserIdentifierAdminDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfUserIdentifierAdminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfUserIdentifierAdminDto {
    data?: FilterResult_1OfUserIdentifierAdminDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfActionRuleDto implements IApiResponse_1OfFilterResult_1OfActionRuleDto {
    data?: FilterResult_1OfActionRuleDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfActionRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfActionRuleDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfActionRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfActionRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfActionRuleDto {
    data?: FilterResult_1OfActionRuleDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfActivityListDto implements IApiResponse_1OfFilterResult_1OfActivityListDto {
    data?: FilterResult_1OfActivityListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfActivityListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfActivityListDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfActivityListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfActivityListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfActivityListDto {
    data?: FilterResult_1OfActivityListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfActivityStatsDailyItemDto implements IApiResponse_1OfFilterResult_1OfActivityStatsDailyItemDto {
    data?: FilterResult_1OfActivityStatsDailyItemDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfActivityStatsDailyItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfActivityStatsDailyItemDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfActivityStatsDailyItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfActivityStatsDailyItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfActivityStatsDailyItemDto {
    data?: FilterResult_1OfActivityStatsDailyItemDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfAiPromptListDto implements IApiResponse_1OfFilterResult_1OfAiPromptListDto {
    data?: FilterResult_1OfAiPromptListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfAiPromptListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfAiPromptListDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfAiPromptListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfAiPromptListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfAiPromptListDto {
    data?: FilterResult_1OfAiPromptListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfAssignExamListExamDto implements IApiResponse_1OfFilterResult_1OfAssignExamListExamDto {
    data?: FilterResult_1OfAssignExamListExamDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfAssignExamListExamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfAssignExamListExamDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfAssignExamListExamDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfAssignExamListExamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfAssignExamListExamDto {
    data?: FilterResult_1OfAssignExamListExamDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfCategoryConfigListDto implements IApiResponse_1OfFilterResult_1OfCategoryConfigListDto {
    data?: FilterResult_1OfCategoryConfigListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfCategoryConfigListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfCategoryConfigListDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfCategoryConfigListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfCategoryConfigListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfCategoryConfigListDto {
    data?: FilterResult_1OfCategoryConfigListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfCategoryListDto implements IApiResponse_1OfFilterResult_1OfCategoryListDto {
    data?: FilterResult_1OfCategoryListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfCategoryListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfCategoryListDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfCategoryListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfCategoryListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfCategoryListDto {
    data?: FilterResult_1OfCategoryListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfConsultationRegistrationListDto implements IApiResponse_1OfFilterResult_1OfConsultationRegistrationListDto {
    data?: FilterResult_1OfConsultationRegistrationListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfConsultationRegistrationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfConsultationRegistrationListDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfConsultationRegistrationListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfConsultationRegistrationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfConsultationRegistrationListDto {
    data?: FilterResult_1OfConsultationRegistrationListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfContactListDto implements IApiResponse_1OfFilterResult_1OfContactListDto {
    data?: FilterResult_1OfContactListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfContactListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfContactListDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfContactListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfContactListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfContactListDto {
    data?: FilterResult_1OfContactListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfExamListDto implements IApiResponse_1OfFilterResult_1OfExamListDto {
    data?: FilterResult_1OfExamListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfExamListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfExamListDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfExamListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfExamListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfExamListDto {
    data?: FilterResult_1OfExamListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfGalleryListDto implements IApiResponse_1OfFilterResult_1OfGalleryListDto {
    data?: FilterResult_1OfGalleryListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfGalleryListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfGalleryListDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfGalleryListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfGalleryListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfGalleryListDto {
    data?: FilterResult_1OfGalleryListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfLanguageListDto implements IApiResponse_1OfFilterResult_1OfLanguageListDto {
    data?: FilterResult_1OfLanguageListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfLanguageListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfLanguageListDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfLanguageListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfLanguageListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfLanguageListDto {
    data?: FilterResult_1OfLanguageListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfListActivityLogDto implements IApiResponse_1OfFilterResult_1OfListActivityLogDto {
    data?: FilterResult_1OfListActivityLogDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfListActivityLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfListActivityLogDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfListActivityLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfListActivityLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfListActivityLogDto {
    data?: FilterResult_1OfListActivityLogDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfListChatGroupDto implements IApiResponse_1OfFilterResult_1OfListChatGroupDto {
    data?: FilterResult_1OfListChatGroupDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfListChatGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfListChatGroupDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfListChatGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfListChatGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfListChatGroupDto {
    data?: FilterResult_1OfListChatGroupDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfListChatMessageByGroupDto implements IApiResponse_1OfFilterResult_1OfListChatMessageByGroupDto {
    data?: FilterResult_1OfListChatMessageByGroupDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfListChatMessageByGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfListChatMessageByGroupDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfListChatMessageByGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfListChatMessageByGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfListChatMessageByGroupDto {
    data?: FilterResult_1OfListChatMessageByGroupDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfNewsListDto implements IApiResponse_1OfFilterResult_1OfNewsListDto {
    data?: FilterResult_1OfNewsListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfNewsListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfNewsListDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfNewsListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfNewsListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfNewsListDto {
    data?: FilterResult_1OfNewsListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfOfficeDto implements IApiResponse_1OfFilterResult_1OfOfficeDto {
    data?: FilterResult_1OfOfficeDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfOfficeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfOfficeDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfOfficeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfOfficeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfOfficeDto {
    data?: FilterResult_1OfOfficeDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfOrderDto implements IApiResponse_1OfFilterResult_1OfOrderDto {
    data?: FilterResult_1OfOrderDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfOrderDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfOrderDto {
    data?: FilterResult_1OfOrderDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfOrganizationListDto implements IApiResponse_1OfFilterResult_1OfOrganizationListDto {
    data?: FilterResult_1OfOrganizationListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfOrganizationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfOrganizationListDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfOrganizationListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfOrganizationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfOrganizationListDto {
    data?: FilterResult_1OfOrganizationListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfProductDashboardListDto implements IApiResponse_1OfFilterResult_1OfProductDashboardListDto {
    data?: FilterResult_1OfProductDashboardListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfProductDashboardListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfProductDashboardListDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfProductDashboardListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfProductDashboardListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfProductDashboardListDto {
    data?: FilterResult_1OfProductDashboardListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfProductListDto implements IApiResponse_1OfFilterResult_1OfProductListDto {
    data?: FilterResult_1OfProductListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfProductListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfProductListDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfProductListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfProductListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfProductListDto {
    data?: FilterResult_1OfProductListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfProductReviewListDto implements IApiResponse_1OfFilterResult_1OfProductReviewListDto {
    data?: FilterResult_1OfProductReviewListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfProductReviewListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfProductReviewListDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfProductReviewListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfProductReviewListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfProductReviewListDto {
    data?: FilterResult_1OfProductReviewListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfPupilHistoryDoExamDto implements IApiResponse_1OfFilterResult_1OfPupilHistoryDoExamDto {
    data?: FilterResult_1OfPupilHistoryDoExamDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfPupilHistoryDoExamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfPupilHistoryDoExamDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfPupilHistoryDoExamDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfPupilHistoryDoExamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfPupilHistoryDoExamDto {
    data?: FilterResult_1OfPupilHistoryDoExamDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfQuestionListDto implements IApiResponse_1OfFilterResult_1OfQuestionListDto {
    data?: FilterResult_1OfQuestionListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfQuestionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfQuestionListDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfQuestionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfQuestionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfQuestionListDto {
    data?: FilterResult_1OfQuestionListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfSchoolListDto implements IApiResponse_1OfFilterResult_1OfSchoolListDto {
    data?: FilterResult_1OfSchoolListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfSchoolListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfSchoolListDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfSchoolListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfSchoolListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfSchoolListDto {
    data?: FilterResult_1OfSchoolListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfStaticPageListDto implements IApiResponse_1OfFilterResult_1OfStaticPageListDto {
    data?: FilterResult_1OfStaticPageListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfStaticPageListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfStaticPageListDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfStaticPageListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfStaticPageListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfStaticPageListDto {
    data?: FilterResult_1OfStaticPageListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfTagListDto implements IApiResponse_1OfFilterResult_1OfTagListDto {
    data?: FilterResult_1OfTagListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfTagListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfTagListDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfTagListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfTagListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfTagListDto {
    data?: FilterResult_1OfTagListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfTeacherGetBySchoolDto implements IApiResponse_1OfFilterResult_1OfTeacherGetBySchoolDto {
    data?: FilterResult_1OfTeacherGetBySchoolDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfTeacherGetBySchoolDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfTeacherGetBySchoolDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfTeacherGetBySchoolDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfTeacherGetBySchoolDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfTeacherGetBySchoolDto {
    data?: FilterResult_1OfTeacherGetBySchoolDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfTranslationListDto implements IApiResponse_1OfFilterResult_1OfTranslationListDto {
    data?: FilterResult_1OfTranslationListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfTranslationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfTranslationListDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfTranslationListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfTranslationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfTranslationListDto {
    data?: FilterResult_1OfTranslationListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfUserActivityLogAdminItemDto implements IApiResponse_1OfFilterResult_1OfUserActivityLogAdminItemDto {
    data?: FilterResult_1OfUserActivityLogAdminItemDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfUserActivityLogAdminItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfUserActivityLogAdminItemDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfUserActivityLogAdminItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfUserActivityLogAdminItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfUserActivityLogAdminItemDto {
    data?: FilterResult_1OfUserActivityLogAdminItemDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfUserListDto implements IApiResponse_1OfFilterResult_1OfUserListDto {
    data?: FilterResult_1OfUserListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfUserListDto.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfUserListDto {
    data?: FilterResult_1OfUserListDto;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfFileEntity implements IApiResponse_1OfFilterResult_1OfFileEntity {
    data?: FilterResult_1OfFileEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfFileEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfFileEntity.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfFileEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfFileEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfFileEntity {
    data?: FilterResult_1OfFileEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfLocalityEntity implements IApiResponse_1OfFilterResult_1OfLocalityEntity {
    data?: FilterResult_1OfLocalityEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfLocalityEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfLocalityEntity.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfLocalityEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfLocalityEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfLocalityEntity {
    data?: FilterResult_1OfLocalityEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfCategoryConfigEntity implements IApiResponse_1OfCategoryConfigEntity {
    data?: CategoryConfigEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfCategoryConfigEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? CategoryConfigEntity.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfCategoryConfigEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfCategoryConfigEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfCategoryConfigEntity {
    data?: CategoryConfigEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfCategoryEntity implements IApiResponse_1OfCategoryEntity {
    data?: CategoryEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfCategoryEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? CategoryEntity.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfCategoryEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfCategoryEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfCategoryEntity {
    data?: CategoryEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfChatGroupEntity implements IApiResponse_1OfChatGroupEntity {
    data?: ChatGroupEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfChatGroupEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ChatGroupEntity.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfChatGroupEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfChatGroupEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfChatGroupEntity {
    data?: ChatGroupEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfConsultationRegistrationEntity implements IApiResponse_1OfConsultationRegistrationEntity {
    data?: ConsultationRegistrationEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfConsultationRegistrationEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ConsultationRegistrationEntity.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfConsultationRegistrationEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfConsultationRegistrationEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfConsultationRegistrationEntity {
    data?: ConsultationRegistrationEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfContactEntity implements IApiResponse_1OfContactEntity {
    data?: ContactEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfContactEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ContactEntity.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfContactEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfContactEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfContactEntity {
    data?: ContactEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfDepartmentEntity implements IApiResponse_1OfDepartmentEntity {
    data?: DepartmentEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfDepartmentEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? DepartmentEntity.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfDepartmentEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfDepartmentEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfDepartmentEntity {
    data?: DepartmentEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfDepartmentUserEntity implements IApiResponse_1OfDepartmentUserEntity {
    data?: DepartmentUserEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfDepartmentUserEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? DepartmentUserEntity.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfDepartmentUserEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfDepartmentUserEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfDepartmentUserEntity {
    data?: DepartmentUserEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfUserExamResultEntity implements IApiResponse_1OfUserExamResultEntity {
    data?: UserExamResultEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfUserExamResultEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? UserExamResultEntity.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfUserExamResultEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfUserExamResultEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfUserExamResultEntity {
    data?: UserExamResultEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFolderEntity implements IApiResponse_1OfFolderEntity {
    data?: FolderEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFolderEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FolderEntity.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFolderEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFolderEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFolderEntity {
    data?: FolderEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfGalleryEntity implements IApiResponse_1OfGalleryEntity {
    data?: GalleryEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfGalleryEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? GalleryEntity.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfGalleryEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfGalleryEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfGalleryEntity {
    data?: GalleryEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfOwnershipTransferEntity implements IApiResponse_1OfOwnershipTransferEntity {
    data?: OwnershipTransferEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfOwnershipTransferEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? OwnershipTransferEntity.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfOwnershipTransferEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfOwnershipTransferEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfOwnershipTransferEntity {
    data?: OwnershipTransferEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfLocalityEntity implements IApiResponse_1OfLocalityEntity {
    data?: LocalityEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfLocalityEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? LocalityEntity.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfLocalityEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfLocalityEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfLocalityEntity {
    data?: LocalityEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfNewsEntity implements IApiResponse_1OfNewsEntity {
    data?: NewsEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfNewsEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? NewsEntity.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfNewsEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfNewsEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfNewsEntity {
    data?: NewsEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfUserMobileTokenEntity implements IApiResponse_1OfUserMobileTokenEntity {
    data?: UserMobileTokenEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfUserMobileTokenEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? UserMobileTokenEntity.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfUserMobileTokenEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfUserMobileTokenEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfUserMobileTokenEntity {
    data?: UserMobileTokenEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfUserWebTokenEntity implements IApiResponse_1OfUserWebTokenEntity {
    data?: UserWebTokenEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfUserWebTokenEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? UserWebTokenEntity.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfUserWebTokenEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfUserWebTokenEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfUserWebTokenEntity {
    data?: UserWebTokenEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfOrderEntity implements IApiResponse_1OfOrderEntity {
    data?: OrderEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfOrderEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? OrderEntity.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfOrderEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfOrderEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfOrderEntity {
    data?: OrderEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfOrganizationEntity implements IApiResponse_1OfOrganizationEntity {
    data?: OrganizationEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfOrganizationEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? OrganizationEntity.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfOrganizationEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfOrganizationEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfOrganizationEntity {
    data?: OrganizationEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfProductEntity implements IApiResponse_1OfProductEntity {
    data?: ProductEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfProductEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ProductEntity.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfProductEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfProductEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfProductEntity {
    data?: ProductEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfProductReviewEntity implements IApiResponse_1OfProductReviewEntity {
    data?: ProductReviewEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfProductReviewEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ProductReviewEntity.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfProductReviewEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfProductReviewEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfProductReviewEntity {
    data?: ProductReviewEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfAcademicYearEntity implements IApiResponse_1OfAcademicYearEntity {
    data?: AcademicYearEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfAcademicYearEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? AcademicYearEntity.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfAcademicYearEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfAcademicYearEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfAcademicYearEntity {
    data?: AcademicYearEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfClassProgramTypeEntity implements IApiResponse_1OfClassProgramTypeEntity {
    data?: ClassProgramTypeEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfClassProgramTypeEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ClassProgramTypeEntity.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfClassProgramTypeEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfClassProgramTypeEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfClassProgramTypeEntity {
    data?: ClassProgramTypeEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfSchoolEntity implements IApiResponse_1OfSchoolEntity {
    data?: SchoolEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfSchoolEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? SchoolEntity.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfSchoolEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfSchoolEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfSchoolEntity {
    data?: SchoolEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfStaticPageEntity implements IApiResponse_1OfStaticPageEntity {
    data?: StaticPageEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfStaticPageEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? StaticPageEntity.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfStaticPageEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfStaticPageEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfStaticPageEntity {
    data?: StaticPageEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfStaticPageLocaleEntity implements IApiResponse_1OfStaticPageLocaleEntity {
    data?: StaticPageLocaleEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfStaticPageLocaleEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? StaticPageLocaleEntity.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfStaticPageLocaleEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfStaticPageLocaleEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfStaticPageLocaleEntity {
    data?: StaticPageLocaleEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfStaticPageSectionContentEntity implements IApiResponse_1OfStaticPageSectionContentEntity {
    data?: StaticPageSectionContentEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfStaticPageSectionContentEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? StaticPageSectionContentEntity.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfStaticPageSectionContentEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfStaticPageSectionContentEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfStaticPageSectionContentEntity {
    data?: StaticPageSectionContentEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfStaticPageSectionEntity implements IApiResponse_1OfStaticPageSectionEntity {
    data?: StaticPageSectionEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfStaticPageSectionEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? StaticPageSectionEntity.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfStaticPageSectionEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfStaticPageSectionEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfStaticPageSectionEntity {
    data?: StaticPageSectionEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfLanguageEntity implements IApiResponse_1OfLanguageEntity {
    data?: LanguageEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfLanguageEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? LanguageEntity.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfLanguageEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfLanguageEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfLanguageEntity {
    data?: LanguageEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfTranslationKeyEntity implements IApiResponse_1OfTranslationKeyEntity {
    data?: TranslationKeyEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfTranslationKeyEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? TranslationKeyEntity.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfTranslationKeyEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfTranslationKeyEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfTranslationKeyEntity {
    data?: TranslationKeyEntity;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfPermissionMigrationResult implements IApiResponse_1OfPermissionMigrationResult {
    data?: PermissionMigrationResult;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfPermissionMigrationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? PermissionMigrationResult.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfPermissionMigrationResult {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfPermissionMigrationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfPermissionMigrationResult {
    data?: PermissionMigrationResult;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfBoolean implements IApiResponse_1OfBoolean {
    data?: boolean;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfBoolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"];
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfBoolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfBoolean {
    data?: boolean;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfFamilyMemberDto implements IApiResponse_1OfList_1OfFamilyMemberDto {
    data?: FamilyMemberDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfFamilyMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FamilyMemberDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfFamilyMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfFamilyMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfFamilyMemberDto {
    data?: FamilyMemberDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfUserIdentifierDto implements IApiResponse_1OfList_1OfUserIdentifierDto {
    data?: UserIdentifierDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfUserIdentifierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserIdentifierDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfUserIdentifierDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfUserIdentifierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfUserIdentifierDto {
    data?: UserIdentifierDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfFolderNodeDto implements IApiResponse_1OfList_1OfFolderNodeDto {
    data?: FolderNodeDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfFolderNodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FolderNodeDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfFolderNodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfFolderNodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfFolderNodeDto {
    data?: FolderNodeDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfPupilClassItemDto implements IApiResponse_1OfList_1OfPupilClassItemDto {
    data?: PupilClassItemDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfPupilClassItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PupilClassItemDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfPupilClassItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfPupilClassItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfPupilClassItemDto {
    data?: PupilClassItemDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfPupilCourseItemDto implements IApiResponse_1OfList_1OfPupilCourseItemDto {
    data?: PupilCourseItemDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfPupilCourseItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PupilCourseItemDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfPupilCourseItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfPupilCourseItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfPupilCourseItemDto {
    data?: PupilCourseItemDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfDepartmentMenuNodeDto implements IApiResponse_1OfList_1OfDepartmentMenuNodeDto {
    data?: DepartmentMenuNodeDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfDepartmentMenuNodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DepartmentMenuNodeDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfDepartmentMenuNodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfDepartmentMenuNodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfDepartmentMenuNodeDto {
    data?: DepartmentMenuNodeDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfDepartmentRoleDto implements IApiResponse_1OfList_1OfDepartmentRoleDto {
    data?: DepartmentRoleDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfDepartmentRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DepartmentRoleDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfDepartmentRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfDepartmentRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfDepartmentRoleDto {
    data?: DepartmentRoleDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfLessonCompletionDto implements IApiResponse_1OfList_1OfLessonCompletionDto {
    data?: LessonCompletionDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfLessonCompletionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(LessonCompletionDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfLessonCompletionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfLessonCompletionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfLessonCompletionDto {
    data?: LessonCompletionDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfOwnershipTransferDto implements IApiResponse_1OfList_1OfOwnershipTransferDto {
    data?: OwnershipTransferDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfOwnershipTransferDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(OwnershipTransferDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfOwnershipTransferDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfOwnershipTransferDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfOwnershipTransferDto {
    data?: OwnershipTransferDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfProductClassDto implements IApiResponse_1OfList_1OfProductClassDto {
    data?: ProductClassDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfProductClassDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ProductClassDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfProductClassDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfProductClassDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfProductClassDto {
    data?: ProductClassDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfSchoolUserDto implements IApiResponse_1OfList_1OfSchoolUserDto {
    data?: SchoolUserDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfSchoolUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SchoolUserDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfSchoolUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfSchoolUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfSchoolUserDto {
    data?: SchoolUserDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfUserObjectInviteDto implements IApiResponse_1OfList_1OfUserObjectInviteDto {
    data?: UserObjectInviteDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfUserObjectInviteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserObjectInviteDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfUserObjectInviteDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfUserObjectInviteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfUserObjectInviteDto {
    data?: UserObjectInviteDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfZoomAccountListDto implements IApiResponse_1OfList_1OfZoomAccountListDto {
    data?: ZoomAccountListDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfZoomAccountListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ZoomAccountListDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfZoomAccountListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfZoomAccountListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfZoomAccountListDto {
    data?: ZoomAccountListDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfEnumListEntity implements IApiResponse_1OfList_1OfEnumListEntity {
    data?: EnumListEntity[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfEnumListEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(EnumListEntity.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfEnumListEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfEnumListEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfEnumListEntity {
    data?: EnumListEntity[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfZoomInviteLinkDto implements IApiResponse_1OfList_1OfZoomInviteLinkDto {
    data?: ZoomInviteLinkDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfZoomInviteLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ZoomInviteLinkDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfZoomInviteLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfZoomInviteLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfZoomInviteLinkDto {
    data?: ZoomInviteLinkDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfAssignExamDoneDto implements IApiResponse_1OfList_1OfAssignExamDoneDto {
    data?: AssignExamDoneDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfAssignExamDoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AssignExamDoneDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfAssignExamDoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfAssignExamDoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfAssignExamDoneDto {
    data?: AssignExamDoneDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfAssignExamNeedDoDto implements IApiResponse_1OfList_1OfAssignExamNeedDoDto {
    data?: AssignExamNeedDoDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfAssignExamNeedDoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AssignExamNeedDoDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfAssignExamNeedDoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfAssignExamNeedDoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfAssignExamNeedDoDto {
    data?: AssignExamNeedDoDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfAssignExamScoreDistributionDto implements IApiResponse_1OfList_1OfAssignExamScoreDistributionDto {
    data?: AssignExamScoreDistributionDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfAssignExamScoreDistributionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AssignExamScoreDistributionDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfAssignExamScoreDistributionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfAssignExamScoreDistributionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfAssignExamScoreDistributionDto {
    data?: AssignExamScoreDistributionDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfAssignExamTopDifficultQuestionDto implements IApiResponse_1OfList_1OfAssignExamTopDifficultQuestionDto {
    data?: AssignExamTopDifficultQuestionDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfAssignExamTopDifficultQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AssignExamTopDifficultQuestionDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfAssignExamTopDifficultQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfAssignExamTopDifficultQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfAssignExamTopDifficultQuestionDto {
    data?: AssignExamTopDifficultQuestionDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfCategoryConfigListDto implements IApiResponse_1OfList_1OfCategoryConfigListDto {
    data?: CategoryConfigListDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfCategoryConfigListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CategoryConfigListDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfCategoryConfigListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfCategoryConfigListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfCategoryConfigListDto {
    data?: CategoryConfigListDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfCategoryWithGalleryCountDto implements IApiResponse_1OfList_1OfCategoryWithGalleryCountDto {
    data?: CategoryWithGalleryCountDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfCategoryWithGalleryCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CategoryWithGalleryCountDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfCategoryWithGalleryCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfCategoryWithGalleryCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfCategoryWithGalleryCountDto {
    data?: CategoryWithGalleryCountDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfCategoryWithNewsCountDto implements IApiResponse_1OfList_1OfCategoryWithNewsCountDto {
    data?: CategoryWithNewsCountDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfCategoryWithNewsCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CategoryWithNewsCountDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfCategoryWithNewsCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfCategoryWithNewsCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfCategoryWithNewsCountDto {
    data?: CategoryWithNewsCountDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfClassSessionDto implements IApiResponse_1OfList_1OfClassSessionDto {
    data?: ClassSessionDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfClassSessionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ClassSessionDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfClassSessionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfClassSessionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfClassSessionDto {
    data?: ClassSessionDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfDailyStudyTimeDto implements IApiResponse_1OfList_1OfDailyStudyTimeDto {
    data?: DailyStudyTimeDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfDailyStudyTimeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DailyStudyTimeDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfDailyStudyTimeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfDailyStudyTimeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfDailyStudyTimeDto {
    data?: DailyStudyTimeDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfDashBoardClassStatisticalDto implements IApiResponse_1OfList_1OfDashBoardClassStatisticalDto {
    data?: DashBoardClassStatisticalDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfDashBoardClassStatisticalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DashBoardClassStatisticalDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfDashBoardClassStatisticalDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfDashBoardClassStatisticalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfDashBoardClassStatisticalDto {
    data?: DashBoardClassStatisticalDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfDashBoardExamListDto implements IApiResponse_1OfList_1OfDashBoardExamListDto {
    data?: DashBoardExamListDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfDashBoardExamListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DashBoardExamListDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfDashBoardExamListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfDashBoardExamListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfDashBoardExamListDto {
    data?: DashBoardExamListDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfDashBoardPupilListDto implements IApiResponse_1OfList_1OfDashBoardPupilListDto {
    data?: DashBoardPupilListDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfDashBoardPupilListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DashBoardPupilListDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfDashBoardPupilListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfDashBoardPupilListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfDashBoardPupilListDto {
    data?: DashBoardPupilListDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfDashBoardQuestionListDto implements IApiResponse_1OfList_1OfDashBoardQuestionListDto {
    data?: DashBoardQuestionListDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfDashBoardQuestionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DashBoardQuestionListDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfDashBoardQuestionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfDashBoardQuestionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfDashBoardQuestionListDto {
    data?: DashBoardQuestionListDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfLanguageListDto implements IApiResponse_1OfList_1OfLanguageListDto {
    data?: LanguageListDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfLanguageListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(LanguageListDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfLanguageListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfLanguageListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfLanguageListDto {
    data?: LanguageListDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfLeaderboardItemDto implements IApiResponse_1OfList_1OfLeaderboardItemDto {
    data?: LeaderboardItemDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfLeaderboardItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(LeaderboardItemDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfLeaderboardItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfLeaderboardItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfLeaderboardItemDto {
    data?: LeaderboardItemDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfLoginHistoryListItemDto implements IApiResponse_1OfList_1OfLoginHistoryListItemDto {
    data?: LoginHistoryListItemDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfLoginHistoryListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(LoginHistoryListItemDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfLoginHistoryListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfLoginHistoryListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfLoginHistoryListItemDto {
    data?: LoginHistoryListItemDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfModuleDefinitionDto implements IApiResponse_1OfList_1OfModuleDefinitionDto {
    data?: ModuleDefinitionDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfModuleDefinitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ModuleDefinitionDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfModuleDefinitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfModuleDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfModuleDefinitionDto {
    data?: ModuleDefinitionDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfProductListDto implements IApiResponse_1OfList_1OfProductListDto {
    data?: ProductListDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfProductListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ProductListDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfProductListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfProductListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfProductListDto {
    data?: ProductListDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfPupilStaticByTypeExamDto implements IApiResponse_1OfList_1OfPupilStaticByTypeExamDto {
    data?: PupilStaticByTypeExamDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfPupilStaticByTypeExamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PupilStaticByTypeExamDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfPupilStaticByTypeExamDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfPupilStaticByTypeExamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfPupilStaticByTypeExamDto {
    data?: PupilStaticByTypeExamDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfPurchaseTargetDto implements IApiResponse_1OfList_1OfPurchaseTargetDto {
    data?: PurchaseTargetDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfPurchaseTargetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PurchaseTargetDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfPurchaseTargetDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfPurchaseTargetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfPurchaseTargetDto {
    data?: PurchaseTargetDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfQuestionDto implements IApiResponse_1OfList_1OfQuestionDto {
    data?: QuestionDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(QuestionDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfQuestionDto {
    data?: QuestionDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfRoleDto implements IApiResponse_1OfList_1OfRoleDto {
    data?: RoleDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(RoleDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfRoleDto {
    data?: RoleDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfRoleModuleDto implements IApiResponse_1OfList_1OfRoleModuleDto {
    data?: RoleModuleDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfRoleModuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(RoleModuleDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfRoleModuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfRoleModuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfRoleModuleDto {
    data?: RoleModuleDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfSchoolListDto implements IApiResponse_1OfList_1OfSchoolListDto {
    data?: SchoolListDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfSchoolListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SchoolListDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfSchoolListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfSchoolListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfSchoolListDto {
    data?: SchoolListDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfStaticPageLocaleDto implements IApiResponse_1OfList_1OfStaticPageLocaleDto {
    data?: StaticPageLocaleDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfStaticPageLocaleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(StaticPageLocaleDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfStaticPageLocaleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfStaticPageLocaleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfStaticPageLocaleDto {
    data?: StaticPageLocaleDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfStaticPageLocaleStatusDto implements IApiResponse_1OfList_1OfStaticPageLocaleStatusDto {
    data?: StaticPageLocaleStatusDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfStaticPageLocaleStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(StaticPageLocaleStatusDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfStaticPageLocaleStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfStaticPageLocaleStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfStaticPageLocaleStatusDto {
    data?: StaticPageLocaleStatusDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfStaticPageSectionListDto implements IApiResponse_1OfList_1OfStaticPageSectionListDto {
    data?: StaticPageSectionListDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfStaticPageSectionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(StaticPageSectionListDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfStaticPageSectionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfStaticPageSectionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfStaticPageSectionListDto {
    data?: StaticPageSectionListDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfTagDto implements IApiResponse_1OfList_1OfTagDto {
    data?: TagDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TagDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfTagDto {
    data?: TagDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfTagListDto implements IApiResponse_1OfList_1OfTagListDto {
    data?: TagListDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfTagListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TagListDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfTagListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfTagListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfTagListDto {
    data?: TagListDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfTeacherStaticByTypeExamDto implements IApiResponse_1OfList_1OfTeacherStaticByTypeExamDto {
    data?: TeacherStaticByTypeExamDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfTeacherStaticByTypeExamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TeacherStaticByTypeExamDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfTeacherStaticByTypeExamDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfTeacherStaticByTypeExamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfTeacherStaticByTypeExamDto {
    data?: TeacherStaticByTypeExamDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfTopCourseStatisticalDto implements IApiResponse_1OfList_1OfTopCourseStatisticalDto {
    data?: TopCourseStatisticalDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfTopCourseStatisticalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TopCourseStatisticalDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfTopCourseStatisticalDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfTopCourseStatisticalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfTopCourseStatisticalDto {
    data?: TopCourseStatisticalDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfTrackingActionCodeItemDto implements IApiResponse_1OfList_1OfTrackingActionCodeItemDto {
    data?: TrackingActionCodeItemDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfTrackingActionCodeItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TrackingActionCodeItemDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfTrackingActionCodeItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfTrackingActionCodeItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfTrackingActionCodeItemDto {
    data?: TrackingActionCodeItemDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfUserActivityLogItemDto implements IApiResponse_1OfList_1OfUserActivityLogItemDto {
    data?: UserActivityLogItemDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfUserActivityLogItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserActivityLogItemDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfUserActivityLogItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfUserActivityLogItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfUserActivityLogItemDto {
    data?: UserActivityLogItemDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfUserDeviceListItemDto implements IApiResponse_1OfList_1OfUserDeviceListItemDto {
    data?: UserDeviceListItemDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfUserDeviceListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserDeviceListItemDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfUserDeviceListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfUserDeviceListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfUserDeviceListItemDto {
    data?: UserDeviceListItemDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfUserExamAttemptListItemDto implements IApiResponse_1OfList_1OfUserExamAttemptListItemDto {
    data?: UserExamAttemptListItemDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfUserExamAttemptListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserExamAttemptListItemDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfUserExamAttemptListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfUserExamAttemptListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfUserExamAttemptListItemDto {
    data?: UserExamAttemptListItemDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfUserObjectDto implements IApiResponse_1OfList_1OfUserObjectDto {
    data?: UserObjectDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfUserObjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserObjectDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfUserObjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfUserObjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfUserObjectDto {
    data?: UserObjectDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfUserProductDto implements IApiResponse_1OfList_1OfUserProductDto {
    data?: UserProductDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfUserProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserProductDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfUserProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfUserProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfUserProductDto {
    data?: UserProductDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfUserScheduleDto implements IApiResponse_1OfList_1OfUserScheduleDto {
    data?: UserScheduleDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfUserScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserScheduleDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfUserScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfUserScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfUserScheduleDto {
    data?: UserScheduleDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfUserSessionListItemDto implements IApiResponse_1OfList_1OfUserSessionListItemDto {
    data?: UserSessionListItemDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfUserSessionListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserSessionListItemDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfUserSessionListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfUserSessionListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfUserSessionListItemDto {
    data?: UserSessionListItemDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfUserWithSimpleInfoDto implements IApiResponse_1OfList_1OfUserWithSimpleInfoDto {
    data?: UserWithSimpleInfoDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfUserWithSimpleInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserWithSimpleInfoDto.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfUserWithSimpleInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfUserWithSimpleInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfUserWithSimpleInfoDto {
    data?: UserWithSimpleInfoDto[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfDepartmentEntity implements IApiResponse_1OfList_1OfDepartmentEntity {
    data?: DepartmentEntity[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfDepartmentEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DepartmentEntity.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfDepartmentEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfDepartmentEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfDepartmentEntity {
    data?: DepartmentEntity[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfDepartmentUserEntity implements IApiResponse_1OfList_1OfDepartmentUserEntity {
    data?: DepartmentUserEntity[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfDepartmentUserEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DepartmentUserEntity.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfDepartmentUserEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfDepartmentUserEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfDepartmentUserEntity {
    data?: DepartmentUserEntity[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfFileMetaDataEntity implements IApiResponse_1OfList_1OfFileMetaDataEntity {
    data?: FileMetaDataEntity[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfFileMetaDataEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FileMetaDataEntity.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfFileMetaDataEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfFileMetaDataEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfFileMetaDataEntity {
    data?: FileMetaDataEntity[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfLocalityEntity implements IApiResponse_1OfList_1OfLocalityEntity {
    data?: LocalityEntity[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfLocalityEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(LocalityEntity.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfLocalityEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfLocalityEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfLocalityEntity {
    data?: LocalityEntity[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfProductReviewEntity implements IApiResponse_1OfList_1OfProductReviewEntity {
    data?: ProductReviewEntity[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfProductReviewEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ProductReviewEntity.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfProductReviewEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfProductReviewEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfProductReviewEntity {
    data?: ProductReviewEntity[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfAcademicYearEntity implements IApiResponse_1OfList_1OfAcademicYearEntity {
    data?: AcademicYearEntity[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfAcademicYearEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AcademicYearEntity.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfAcademicYearEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfAcademicYearEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfAcademicYearEntity {
    data?: AcademicYearEntity[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfClassProgramTypeEntity implements IApiResponse_1OfList_1OfClassProgramTypeEntity {
    data?: ClassProgramTypeEntity[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfClassProgramTypeEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ClassProgramTypeEntity.fromJS(item));
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfClassProgramTypeEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfClassProgramTypeEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfClassProgramTypeEntity {
    data?: ClassProgramTypeEntity[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfInt64 implements IApiResponse_1OfList_1OfInt64 {
    data?: number[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfInt64) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(item);
            }
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfInt64 {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfInt64();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfInt64 {
    data?: number[] | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfInt64 implements IApiResponse_1OfInt64 {
    data?: number;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfInt64) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"];
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfInt64 {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfInt64();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfInt64 {
    data?: number;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfObject implements IApiResponse_1OfObject {
    data?: any | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"];
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfObject {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfObject {
    data?: any | undefined;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfVapidDetails implements IApiResponse_1OfVapidDetails {
    data?: VapidDetails;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfVapidDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? VapidDetails.fromJS(_data["data"]) : undefined as any;
            this.message = _data["message"];
            this.messageKey = _data["messageKey"];
            if (Array.isArray(_data["messageArgs"])) {
                this.messageArgs = [] as any;
                for (let item of _data["messageArgs"])
                    this.messageArgs!.push(item);
            }
            (this as any).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfVapidDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfVapidDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["message"] = this.message;
        data["messageKey"] = this.messageKey;
        if (Array.isArray(this.messageArgs)) {
            data["messageArgs"] = [];
            for (let item of this.messageArgs)
                data["messageArgs"].push(item);
        }
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfVapidDetails {
    data?: VapidDetails;
    message?: string | undefined;
    messageKey?: string | undefined;
    messageArgs?: any[] | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export enum ApplicationEnum {
    Cms = 1,
    Web = 2,
    Shared = 3,
}

export enum AssignExamStatusEnum {
    Draft = 0,
    Delivered = 1,
    Deleted = 2,
}

export enum AssignExamTypeEnum {
    Homework = 0,
    Test = 1,
    Exam = 2,
}

export enum AssignExamUserStatusEnum {
    NotStarted = 0,
    PendingGrading = 1,
    Graded = 2,
}

export enum ClassListSearchTypeEnum {
    All = 0,
    SelfManaged = 1,
    School = 2,
    Free = 3,
}

export enum ClassStatusEnum {
    Active = 1,
    Complete = 2,
}

export enum ClassUserRoleEnum {
    None = 0,
    Admin = 1,
    Teacher = 2,
    Pupil = 3,
}

export enum ClassUserStatusEnum {
    Unknown = 0,
    Studying = 1,
    Change = 2,
    Leave = 3,
    UpTo = 4,
    WaitApproved = 5,
}

export enum CommonStatusEnum {
    Active = 1,
    Deactivate = 2,
}

export enum DeviceTypeEnum {
    WebBrowser = 1,
    Android = 2,
    Ios = 3,
    DesktopApp = 4,
}

export enum ErrorCodeEnum {
    Success = 0,
    Exception = 100,
    BusinessError = 101,
    InvalidRequest = 102,
    TimeOutSession = 103,
    DocumentFlow_CannotChangeStatus = 104,
    Document_NotFound = 105,
    DocumentFlow_CurrentStatusNotAllowChangeToOtherStatus = 106,
    DocumentFlow_CurrentUserNotAllowChangeStatus = 107,
    UpdateDocumentDocumentNotFound = 108,
    UpdateDocumentInvalidPrimaryZone = 109,
    UpdateDocumentInvalidTitle = 110,
    UpdateDocumentInvalidAvatar = 111,
    UpdateDocumentInvalidSapo = 112,
    UpdateDocumentInvalidBody = 113,
    UpdateDocumentNotAllowEdit = 114,
    UpdateDocumentNotAllowDelete = 115,
    UpdateDocumentDuplicateId = 116,
    UpdateDocumentLockedByOtherUserForEdit = 117,
    UpdateDocumentInvalidTag = 118,
    UpdateDocumentInvalidDocumentData = 119,
    UpdateDocumentNotAllowAddNew = 120,
    UpdateDocumentNotAllowUpdateRoyalty = 121,
    DocumentLock = 122,
    DocumentFlow_UserNotAllowChangeStatus = 123,
    OK = 200,
    Created = 201,
    Accepted = 202,
    NonAuthoritativeInformation = 203,
    NoContent = 204,
    ResetContent = 205,
    PartialContent = 206,
    MultiStatus = 207,
    AlreadyReported = 208,
    IMUsed = 226,
    Ambiguous = 300,
    MultipleChoices = 301,
    Moved = 302,
    MovedPermanently = 303,
    Redirect = 304,
    Found = 305,
    RedirectMethod = 306,
    SeeOther = 307,
    NotModified = 308,
    UseProxy = 400,
    Unused = 401,
    RedirectKeepVerb = 402,
    TemporaryRedirect = 403,
    PermanentRedirect = 404,
    BadRequest = 405,
    Unauthorized = 406,
    PaymentRequired = 407,
    Forbidden = 408,
    NotFound = 409,
    MethodNotAllowed = 410,
    NotAcceptable = 411,
    ProxyAuthenticationRequired = 412,
    RequestTimeout = 413,
    Conflict = 414,
    Gone = 415,
    LengthRequired = 416,
    PreconditionFailed = 417,
    RequestEntityTooLarge = 421,
    RequestUriTooLong = 422,
    UnsupportedMediaType = 423,
    RequestedRangeNotSatisfiable = 424,
    ExpectationFailed = 426,
    MisdirectedRequest = 428,
    UnprocessableEntity = 429,
    UnprocessableContent = 431,
    Locked = 451,
    FailedDependency = 500,
    UpgradeRequired = 501,
    PreconditionRequired = 502,
    TooManyRequests = 503,
    RequestHeaderFieldsTooLarge = 504,
    UnavailableForLegalReasons = 505,
    InternalServerError = 506,
    NotImplemented = 507,
    BadGateway = 508,
    ServiceUnavailable = 510,
    GatewayTimeout = 511,
    HttpVersionNotSupported = 512,
    VariantAlsoNegotiates = 513,
    InsufficientStorage = -1,
}

export enum ExamFileChoiceTypeEnum {
    ABC = 1,
    Number = 2,
}

export enum ExamFormatEnum {
    Exam = 1,
    File = 2,
}

export enum ExamStatusEnum {
    Temporary = 1,
    WaitApproved = 2,
    Published = 3,
    Refuse = 4,
}

export enum ExamTypeEnum {
    Homework = 0,
    Exam = 1,
    Test = 2,
    Quiz = 3,
}

export enum FamilyLinkStatusEnum {
    PendingParent = 1,
    PendingChild = 2,
    Accepted = 3,
    Rejected = 4,
    Removed = 5,
}

export enum LocalityStatusEnum {
    NotUsed = 0,
    Active = 1,
    StopUsing = 2,
}

export enum LoginResultEnum {
    Success = 1,
    InvalidPassword = 2,
    Locked = 3,
    InvalidOtp = 4,
    ExternalLoginFailed = 5,
}

export enum ModuleEnum {
    Department = 1,
    School = 3,
    AcademicYear = 4,
    Question = 5,
    Exam = 6,
    Category = 7,
    News = 8,
    Gallery = 9,
    Product = 10,
    Organization = 11,
    Order = 12,
    Contact = 13,
    StaticPage = 14,
    Translation = 15,
    Class = 16,
    ConsultationRegistration = 17,
    Tracking = 18,
    SystemConfig = 19,
    UserIdentifier = 20,
    Departments = 21,
    SchoolOwnership = 22,
    Role = 98,
    User = 99,
}

export enum ObjectListFilterTypeEnum {
    Created = 0,
    System = 1,
    Liked = 2,
    Organization = 3,
}

export enum ObjectOwnerTypeEnum {
    None = 0,
    School = 1,
    Organization = 2,
    Personal = 3,
    Class = 4,
    System = 5,
}

export enum ObjectTypeEnum {
    Default = 0,
    Question = 1,
    Exam = 2,
}

export enum OrderPurchaseTargetEnum {
    Personal = 0,
    Organization = 1,
}

export enum OrganizationStatusEnum {
    NotUsed = 0,
    Active = 1,
    StopUsing = 2,
    PendingApproval = 3,
}

export enum OwnershipTransferStatusEnum {
    Pending = 0,
    Accepted = 1,
    Rejected = 2,
    Cancelled = 3,
}

export enum ProductSourceEnum {
    Owned = 0,
    Purchased = 1,
}

export enum QuestionLevelEnum {
    Easy = 1,
    Average = 2,
    Difficult = 3,
    VeryDifficult = 4,
}

export enum QuestionStatusEnum {
    Unknown = 0,
    Temporary = 1,
    WaitApproved = 2,
    Published = 3,
    Refuse = 4,
}

export enum RefreshTokenRevokedReasonEnum {
    Logout = 1,
    PasswordChanged = 2,
    DeviceRevoked = 3,
    Expired = 4,
    AdminRevoked = 5,
    ReplacedByRotation = 6,
}

export enum SchoolEstablishmentDecisionTypeEnum {
    None = 0,
    Establishment = 1,
    PermissionToEstablish = 2,
}

export enum SchoolStatusEnum {
    NotUsed = 0,
    Active = 1,
    StopUsing = 2,
    PendingApproval = 3,
}

export enum ShareStatusEnum {
    None = 0,
    Pending = 1,
    Approved = 2,
    Rejected = 3,
}

export enum ShareTargetEnum {
    System = 1,
    Organization = 2,
}

export enum SystemConfigDataTypeEnum {
    String = 1,
    Int = 2,
    Decimal = 3,
    Boolean = 4,
    Regex = 5,
    Json = 6,
    Select = 7,
    Secret = 8,
}

export enum SystemConfigGroupEnum {
    General = 0,
    Username = 1,
    Password = 2,
    Family = 3,
    Identifier = 4,
}

export enum SystemConfigScopeEnum {
    Global = 0,
    Organization = 1,
}

export enum UserExamResultStatus {
    Pending = 1,
    Graded = 2,
}

export enum UserIdentifierType {
    Username = 1,
    Email = 2,
}

export enum UserObjectStatusEnum {
    Pending = 0,
    Active = 1,
    Rejected = 2,
    Cancelled = 3,
}

export enum UserTypeEnum {
    All = 0,
    ConanEdu_System = 1,
    Student = 2,
    Teacher = 3,
    Staff = 4,
    Parent = 5,
    Department = 6,
}

export enum VanityTypeEnum {
    User = 1,
    School = 2,
    Organization = 3,
    Page = 4,
    Group = 5,
    Website = 6,
}

export class AiChatRequest implements IAiChatRequest {
    systemPrompt?: string | undefined;
    userMessage?: string | undefined;
    userMessageContent?: AiMessageContent[] | undefined;
    model?: string | undefined;
    temperature?: number | undefined;
    maxTokens?: number | undefined;

    constructor(data?: IAiChatRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.systemPrompt = _data["systemPrompt"];
            this.userMessage = _data["userMessage"];
            if (Array.isArray(_data["userMessageContent"])) {
                this.userMessageContent = [] as any;
                for (let item of _data["userMessageContent"])
                    this.userMessageContent!.push(AiMessageContent.fromJS(item));
            }
            this.model = _data["model"];
            this.temperature = _data["temperature"];
            this.maxTokens = _data["maxTokens"];
        }
    }

    static fromJS(data: any): AiChatRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AiChatRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["systemPrompt"] = this.systemPrompt;
        data["userMessage"] = this.userMessage;
        if (Array.isArray(this.userMessageContent)) {
            data["userMessageContent"] = [];
            for (let item of this.userMessageContent)
                data["userMessageContent"].push(item ? item.toJSON() : undefined as any);
        }
        data["model"] = this.model;
        data["temperature"] = this.temperature;
        data["maxTokens"] = this.maxTokens;
        return data;
    }
}

export interface IAiChatRequest {
    systemPrompt?: string | undefined;
    userMessage?: string | undefined;
    userMessageContent?: AiMessageContent[] | undefined;
    model?: string | undefined;
    temperature?: number | undefined;
    maxTokens?: number | undefined;
}

export class AiMessageContent implements IAiMessageContent {
    type?: string | undefined;

    constructor(data?: IAiMessageContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): AiMessageContent {
        data = typeof data === 'object' ? data : {};
        let result = new AiMessageContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        return data;
    }
}

export interface IAiMessageContent {
    type?: string | undefined;
}

export class AiPromptRequest implements IAiPromptRequest {
    promptCode?: string | undefined;
    grade?: number | undefined;
    categoryId?: number | undefined;
    variables?: { [key: string]: string; } | undefined;
    userMessage?: string | undefined;
    userMessageContent?: AiMessageContent[] | undefined;
    model?: string | undefined;
    temperature?: number | undefined;
    maxTokens?: number | undefined;

    constructor(data?: IAiPromptRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.promptCode = _data["promptCode"];
            this.grade = _data["grade"];
            this.categoryId = _data["categoryId"];
            if (_data["variables"]) {
                this.variables = {} as any;
                for (let key in _data["variables"]) {
                    if (_data["variables"].hasOwnProperty(key))
                        (this.variables as any)![key] = _data["variables"][key];
                }
            }
            this.userMessage = _data["userMessage"];
            if (Array.isArray(_data["userMessageContent"])) {
                this.userMessageContent = [] as any;
                for (let item of _data["userMessageContent"])
                    this.userMessageContent!.push(AiMessageContent.fromJS(item));
            }
            this.model = _data["model"];
            this.temperature = _data["temperature"];
            this.maxTokens = _data["maxTokens"];
        }
    }

    static fromJS(data: any): AiPromptRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AiPromptRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["promptCode"] = this.promptCode;
        data["grade"] = this.grade;
        data["categoryId"] = this.categoryId;
        if (this.variables) {
            data["variables"] = {};
            for (let key in this.variables) {
                if (this.variables.hasOwnProperty(key))
                    (data["variables"] as any)[key] = (this.variables as any)[key];
            }
        }
        data["userMessage"] = this.userMessage;
        if (Array.isArray(this.userMessageContent)) {
            data["userMessageContent"] = [];
            for (let item of this.userMessageContent)
                data["userMessageContent"].push(item ? item.toJSON() : undefined as any);
        }
        data["model"] = this.model;
        data["temperature"] = this.temperature;
        data["maxTokens"] = this.maxTokens;
        return data;
    }
}

export interface IAiPromptRequest {
    promptCode?: string | undefined;
    grade?: number | undefined;
    categoryId?: number | undefined;
    variables?: { [key: string]: string; } | undefined;
    userMessage?: string | undefined;
    userMessageContent?: AiMessageContent[] | undefined;
    model?: string | undefined;
    temperature?: number | undefined;
    maxTokens?: number | undefined;
}

export class AiResponse implements IAiResponse {
    success?: boolean;
    content?: string | undefined;
    error?: string | undefined;
    model?: string | undefined;
    promptTokens?: number;
    completionTokens?: number;
    totalTokens?: number;

    constructor(data?: IAiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.content = _data["content"];
            this.error = _data["error"];
            this.model = _data["model"];
            this.promptTokens = _data["promptTokens"];
            this.completionTokens = _data["completionTokens"];
            this.totalTokens = _data["totalTokens"];
        }
    }

    static fromJS(data: any): AiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["content"] = this.content;
        data["error"] = this.error;
        data["model"] = this.model;
        data["promptTokens"] = this.promptTokens;
        data["completionTokens"] = this.completionTokens;
        data["totalTokens"] = this.totalTokens;
        return data;
    }
}

export interface IAiResponse {
    success?: boolean;
    content?: string | undefined;
    error?: string | undefined;
    model?: string | undefined;
    promptTokens?: number;
    completionTokens?: number;
    totalTokens?: number;
}

export class ZoomInviteLinkDto implements IZoomInviteLinkDto {
    name?: string | undefined;
    joinUrl?: string | undefined;

    constructor(data?: IZoomInviteLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.joinUrl = _data["joinUrl"];
        }
    }

    static fromJS(data: any): ZoomInviteLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new ZoomInviteLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["joinUrl"] = this.joinUrl;
        return data;
    }
}

export interface IZoomInviteLinkDto {
    name?: string | undefined;
    joinUrl?: string | undefined;
}

export class ZoomMeetingDto implements IZoomMeetingDto {
    meetingId?: string | undefined;
    topic?: string | undefined;
    joinUrl?: string | undefined;
    startUrl?: string | undefined;
    password?: string | undefined;
    startTime?: Date;
    duration?: number;
    agenda?: string | undefined;
    status?: string | undefined;

    constructor(data?: IZoomMeetingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meetingId = _data["meetingId"];
            this.topic = _data["topic"];
            this.joinUrl = _data["joinUrl"];
            this.startUrl = _data["startUrl"];
            this.password = _data["password"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            this.duration = _data["duration"];
            this.agenda = _data["agenda"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ZoomMeetingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ZoomMeetingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meetingId"] = this.meetingId;
        data["topic"] = this.topic;
        data["joinUrl"] = this.joinUrl;
        data["startUrl"] = this.startUrl;
        data["password"] = this.password;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["duration"] = this.duration;
        data["agenda"] = this.agenda;
        data["status"] = this.status;
        return data;
    }
}

export interface IZoomMeetingDto {
    meetingId?: string | undefined;
    topic?: string | undefined;
    joinUrl?: string | undefined;
    startUrl?: string | undefined;
    password?: string | undefined;
    startTime?: Date;
    duration?: number;
    agenda?: string | undefined;
    status?: string | undefined;
}

export class ActionRuleDto implements IActionRuleDto {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    category?: string | undefined;
    pointValue?: number;
    maxPointsPerDay?: number | undefined;
    maxPointsPerWeek?: number | undefined;
    cooldownSeconds?: number | undefined;
    requireServerValidation?: boolean;
    isActive?: boolean;
    conditionsJson?: string | undefined;
    organizationId?: number | undefined;

    constructor(data?: IActionRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.category = _data["category"];
            this.pointValue = _data["pointValue"];
            this.maxPointsPerDay = _data["maxPointsPerDay"];
            this.maxPointsPerWeek = _data["maxPointsPerWeek"];
            this.cooldownSeconds = _data["cooldownSeconds"];
            this.requireServerValidation = _data["requireServerValidation"];
            this.isActive = _data["isActive"];
            this.conditionsJson = _data["conditionsJson"];
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): ActionRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["category"] = this.category;
        data["pointValue"] = this.pointValue;
        data["maxPointsPerDay"] = this.maxPointsPerDay;
        data["maxPointsPerWeek"] = this.maxPointsPerWeek;
        data["cooldownSeconds"] = this.cooldownSeconds;
        data["requireServerValidation"] = this.requireServerValidation;
        data["isActive"] = this.isActive;
        data["conditionsJson"] = this.conditionsJson;
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface IActionRuleDto {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    category?: string | undefined;
    pointValue?: number;
    maxPointsPerDay?: number | undefined;
    maxPointsPerWeek?: number | undefined;
    cooldownSeconds?: number | undefined;
    requireServerValidation?: boolean;
    isActive?: boolean;
    conditionsJson?: string | undefined;
    organizationId?: number | undefined;
}

export class ActionRuleFilterDto implements IActionRuleFilterDto {
    keyword?: string | undefined;
    category?: string | undefined;
    isActive?: boolean | undefined;
    pageIndex?: number;
    pageSize?: number;

    constructor(data?: IActionRuleFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keyword = _data["keyword"];
            this.category = _data["category"];
            this.isActive = _data["isActive"];
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): ActionRuleFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionRuleFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyword"] = this.keyword;
        data["category"] = this.category;
        data["isActive"] = this.isActive;
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IActionRuleFilterDto {
    keyword?: string | undefined;
    category?: string | undefined;
    isActive?: boolean | undefined;
    pageIndex?: number;
    pageSize?: number;
}

export class ActivityGetListQuery implements IActivityGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    status?: CommonStatusEnum;
    tag?: string | undefined;
    type?: string | undefined;

    constructor(data?: IActivityGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.keyword = _data["keyword"];
            this.status = _data["status"];
            this.tag = _data["tag"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ActivityGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["keyword"] = this.keyword;
        data["status"] = this.status;
        data["tag"] = this.tag;
        data["type"] = this.type;
        return data;
    }
}

export interface IActivityGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    status?: CommonStatusEnum;
    tag?: string | undefined;
    type?: string | undefined;
}

export class ActivityListDto implements IActivityListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    title?: string | undefined;
    description?: string | undefined;
    videoUrl?: string | undefined;
    tag?: string | undefined;
    type?: string | undefined;
    imageUrl?: string | undefined;
    status?: CommonStatusEnum;
    displayOrder?: number;

    constructor(data?: IActivityListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.videoUrl = _data["videoUrl"];
            this.tag = _data["tag"];
            this.type = _data["type"];
            this.imageUrl = _data["imageUrl"];
            this.status = _data["status"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): ActivityListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["title"] = this.title;
        data["description"] = this.description;
        data["videoUrl"] = this.videoUrl;
        data["tag"] = this.tag;
        data["type"] = this.type;
        data["imageUrl"] = this.imageUrl;
        data["status"] = this.status;
        data["displayOrder"] = this.displayOrder;
        return data;
    }
}

export interface IActivityListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    title?: string | undefined;
    description?: string | undefined;
    videoUrl?: string | undefined;
    tag?: string | undefined;
    type?: string | undefined;
    imageUrl?: string | undefined;
    status?: CommonStatusEnum;
    displayOrder?: number;
}

export class ActivityLogFilterDto implements IActivityLogFilterDto {
    keyword?: string | undefined;
    actionCode?: string | undefined;
    userId?: number | undefined;
    source?: string | undefined;
    trustLevel?: string | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    pageIndex?: number;
    pageSize?: number;

    constructor(data?: IActivityLogFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keyword = _data["keyword"];
            this.actionCode = _data["actionCode"];
            this.userId = _data["userId"];
            this.source = _data["source"];
            this.trustLevel = _data["trustLevel"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : undefined as any;
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): ActivityLogFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityLogFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyword"] = this.keyword;
        data["actionCode"] = this.actionCode;
        data["userId"] = this.userId;
        data["source"] = this.source;
        data["trustLevel"] = this.trustLevel;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : undefined as any;
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IActivityLogFilterDto {
    keyword?: string | undefined;
    actionCode?: string | undefined;
    userId?: number | undefined;
    source?: string | undefined;
    trustLevel?: string | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    pageIndex?: number;
    pageSize?: number;
}

export class ActivitySaveDto implements IActivitySaveDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    title?: string | undefined;
    description?: string | undefined;
    videoUrl?: string | undefined;
    tag?: string | undefined;
    type?: string | undefined;
    imageUrl?: string | undefined;
    status?: CommonStatusEnum;
    displayOrder?: number;

    constructor(data?: IActivitySaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.videoUrl = _data["videoUrl"];
            this.tag = _data["tag"];
            this.type = _data["type"];
            this.imageUrl = _data["imageUrl"];
            this.status = _data["status"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): ActivitySaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivitySaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["title"] = this.title;
        data["description"] = this.description;
        data["videoUrl"] = this.videoUrl;
        data["tag"] = this.tag;
        data["type"] = this.type;
        data["imageUrl"] = this.imageUrl;
        data["status"] = this.status;
        data["displayOrder"] = this.displayOrder;
        return data;
    }
}

export interface IActivitySaveDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    title?: string | undefined;
    description?: string | undefined;
    videoUrl?: string | undefined;
    tag?: string | undefined;
    type?: string | undefined;
    imageUrl?: string | undefined;
    status?: CommonStatusEnum;
    displayOrder?: number;
}

export class ActivityStatsDailyFilterDto implements IActivityStatsDailyFilterDto {
    keyword?: string | undefined;
    actionCode?: string | undefined;
    userId?: number | undefined;
    pageType?: string | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    pageIndex?: number;
    pageSize?: number;

    constructor(data?: IActivityStatsDailyFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keyword = _data["keyword"];
            this.actionCode = _data["actionCode"];
            this.userId = _data["userId"];
            this.pageType = _data["pageType"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : undefined as any;
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): ActivityStatsDailyFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityStatsDailyFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyword"] = this.keyword;
        data["actionCode"] = this.actionCode;
        data["userId"] = this.userId;
        data["pageType"] = this.pageType;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : undefined as any;
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IActivityStatsDailyFilterDto {
    keyword?: string | undefined;
    actionCode?: string | undefined;
    userId?: number | undefined;
    pageType?: string | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    pageIndex?: number;
    pageSize?: number;
}

export class ActivityStatsDailyItemDto implements IActivityStatsDailyItemDto {
    date?: string | undefined;
    organizationId?: number | undefined;
    userId?: number;
    userFullName?: string | undefined;
    actionCode?: string | undefined;
    pageType?: string | undefined;
    pagePath?: string | undefined;
    objectType?: string | undefined;
    objectId?: string | undefined;
    eventCount?: number;
    uniqueSessionCount?: number;
    totalPointsAwarded?: number;
    aggregatedAt?: Date;

    constructor(data?: IActivityStatsDailyItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
            this.organizationId = _data["organizationId"];
            this.userId = _data["userId"];
            this.userFullName = _data["userFullName"];
            this.actionCode = _data["actionCode"];
            this.pageType = _data["pageType"];
            this.pagePath = _data["pagePath"];
            this.objectType = _data["objectType"];
            this.objectId = _data["objectId"];
            this.eventCount = _data["eventCount"];
            this.uniqueSessionCount = _data["uniqueSessionCount"];
            this.totalPointsAwarded = _data["totalPointsAwarded"];
            this.aggregatedAt = _data["aggregatedAt"] ? new Date(_data["aggregatedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ActivityStatsDailyItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityStatsDailyItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["organizationId"] = this.organizationId;
        data["userId"] = this.userId;
        data["userFullName"] = this.userFullName;
        data["actionCode"] = this.actionCode;
        data["pageType"] = this.pageType;
        data["pagePath"] = this.pagePath;
        data["objectType"] = this.objectType;
        data["objectId"] = this.objectId;
        data["eventCount"] = this.eventCount;
        data["uniqueSessionCount"] = this.uniqueSessionCount;
        data["totalPointsAwarded"] = this.totalPointsAwarded;
        data["aggregatedAt"] = this.aggregatedAt ? this.aggregatedAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IActivityStatsDailyItemDto {
    date?: string | undefined;
    organizationId?: number | undefined;
    userId?: number;
    userFullName?: string | undefined;
    actionCode?: string | undefined;
    pageType?: string | undefined;
    pagePath?: string | undefined;
    objectType?: string | undefined;
    objectId?: string | undefined;
    eventCount?: number;
    uniqueSessionCount?: number;
    totalPointsAwarded?: number;
    aggregatedAt?: Date;
}

export class AiPromptGetListQuery implements IAiPromptGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    code?: string | undefined;
    grade?: number | undefined;
    categoryId?: number | undefined;

    constructor(data?: IAiPromptGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.keyword = _data["keyword"];
            this.code = _data["code"];
            this.grade = _data["grade"];
            this.categoryId = _data["categoryId"];
        }
    }

    static fromJS(data: any): AiPromptGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new AiPromptGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["keyword"] = this.keyword;
        data["code"] = this.code;
        data["grade"] = this.grade;
        data["categoryId"] = this.categoryId;
        return data;
    }
}

export interface IAiPromptGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    code?: string | undefined;
    grade?: number | undefined;
    categoryId?: number | undefined;
}

export class AiPromptListDto implements IAiPromptListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    grade?: number | undefined;
    categoryId?: number | undefined;
    code!: string;
    name?: string | undefined;
    description?: string | undefined;
    prompt!: string;
    category?: CategoryEntity;
    categoryName?: string | undefined;

    constructor(data?: IAiPromptListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.grade = _data["grade"];
            this.categoryId = _data["categoryId"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.prompt = _data["prompt"];
            this.category = _data["category"] ? CategoryEntity.fromJS(_data["category"]) : undefined as any;
            this.categoryName = _data["categoryName"];
        }
    }

    static fromJS(data: any): AiPromptListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AiPromptListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["grade"] = this.grade;
        data["categoryId"] = this.categoryId;
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["prompt"] = this.prompt;
        data["category"] = this.category ? this.category.toJSON() : undefined as any;
        data["categoryName"] = this.categoryName;
        return data;
    }
}

export interface IAiPromptListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    grade?: number | undefined;
    categoryId?: number | undefined;
    code: string;
    name?: string | undefined;
    description?: string | undefined;
    prompt: string;
    category?: CategoryEntity;
    categoryName?: string | undefined;
}

export class AssignExamAddDto implements IAssignExamAddDto {
    id?: number;
    classId?: number;
    title?: string | undefined;
    examId?: number;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    allowDeadline?: boolean;
    status?: AssignExamStatusEnum;
    type?: AssignExamTypeEnum;
    allowViewAnswer?: boolean;
    duration?: number;

    constructor(data?: IAssignExamAddDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.classId = _data["classId"];
            this.title = _data["title"];
            this.examId = _data["examId"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : undefined as any;
            this.allowDeadline = _data["allowDeadline"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.allowViewAnswer = _data["allowViewAnswer"];
            this.duration = _data["duration"];
        }
    }

    static fromJS(data: any): AssignExamAddDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignExamAddDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["classId"] = this.classId;
        data["title"] = this.title;
        data["examId"] = this.examId;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : undefined as any;
        data["allowDeadline"] = this.allowDeadline;
        data["status"] = this.status;
        data["type"] = this.type;
        data["allowViewAnswer"] = this.allowViewAnswer;
        data["duration"] = this.duration;
        return data;
    }
}

export interface IAssignExamAddDto {
    id?: number;
    classId?: number;
    title?: string | undefined;
    examId?: number;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    allowDeadline?: boolean;
    status?: AssignExamStatusEnum;
    type?: AssignExamTypeEnum;
    allowViewAnswer?: boolean;
    duration?: number;
}

export class AssignExamAddMultipleDto implements IAssignExamAddMultipleDto {
    classes?: ClassShortDto[] | undefined;
    assignExam?: AssignExamAddDto;

    constructor(data?: IAssignExamAddMultipleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["classes"])) {
                this.classes = [] as any;
                for (let item of _data["classes"])
                    this.classes!.push(ClassShortDto.fromJS(item));
            }
            this.assignExam = _data["assignExam"] ? AssignExamAddDto.fromJS(_data["assignExam"]) : undefined as any;
        }
    }

    static fromJS(data: any): AssignExamAddMultipleDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignExamAddMultipleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.classes)) {
            data["classes"] = [];
            for (let item of this.classes)
                data["classes"].push(item ? item.toJSON() : undefined as any);
        }
        data["assignExam"] = this.assignExam ? this.assignExam.toJSON() : undefined as any;
        return data;
    }
}

export interface IAssignExamAddMultipleDto {
    classes?: ClassShortDto[] | undefined;
    assignExam?: AssignExamAddDto;
}

export class AssignExamCheckDoExamDto implements IAssignExamCheckDoExamDto {
    message?: string | undefined;
    isCanViewResult?: boolean;
    classId?: number;

    constructor(data?: IAssignExamCheckDoExamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.isCanViewResult = _data["isCanViewResult"];
            this.classId = _data["classId"];
        }
    }

    static fromJS(data: any): AssignExamCheckDoExamDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignExamCheckDoExamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["isCanViewResult"] = this.isCanViewResult;
        data["classId"] = this.classId;
        return data;
    }
}

export interface IAssignExamCheckDoExamDto {
    message?: string | undefined;
    isCanViewResult?: boolean;
    classId?: number;
}

export class AssignExamCountDto implements IAssignExamCountDto {
    countExam?: number;
    countTest?: number;
    countExercise?: number;

    constructor(data?: IAssignExamCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countExam = _data["countExam"];
            this.countTest = _data["countTest"];
            this.countExercise = _data["countExercise"];
        }
    }

    static fromJS(data: any): AssignExamCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignExamCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countExam"] = this.countExam;
        data["countTest"] = this.countTest;
        data["countExercise"] = this.countExercise;
        return data;
    }
}

export interface IAssignExamCountDto {
    countExam?: number;
    countTest?: number;
    countExercise?: number;
}

export class AssignExamDetailDto implements IAssignExamDetailDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    title?: string | undefined;
    classId?: number;
    examId?: number;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    allowDeadline?: boolean;
    allowViewAnswer?: boolean;
    duration?: number;
    status?: AssignExamStatusEnum;
    type?: AssignExamTypeEnum;
    assignExamUsers?: AssignExamUserEntity[] | undefined;
    subject?: string | undefined;
    questionCount?: number;
    canEdit?: boolean;

    constructor(data?: IAssignExamDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.title = _data["title"];
            this.classId = _data["classId"];
            this.examId = _data["examId"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : undefined as any;
            this.allowDeadline = _data["allowDeadline"];
            this.allowViewAnswer = _data["allowViewAnswer"];
            this.duration = _data["duration"];
            this.status = _data["status"];
            this.type = _data["type"];
            if (Array.isArray(_data["assignExamUsers"])) {
                this.assignExamUsers = [] as any;
                for (let item of _data["assignExamUsers"])
                    this.assignExamUsers!.push(AssignExamUserEntity.fromJS(item));
            }
            this.subject = _data["subject"];
            this.questionCount = _data["questionCount"];
            this.canEdit = _data["canEdit"];
        }
    }

    static fromJS(data: any): AssignExamDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignExamDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["title"] = this.title;
        data["classId"] = this.classId;
        data["examId"] = this.examId;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : undefined as any;
        data["allowDeadline"] = this.allowDeadline;
        data["allowViewAnswer"] = this.allowViewAnswer;
        data["duration"] = this.duration;
        data["status"] = this.status;
        data["type"] = this.type;
        if (Array.isArray(this.assignExamUsers)) {
            data["assignExamUsers"] = [];
            for (let item of this.assignExamUsers)
                data["assignExamUsers"].push(item ? item.toJSON() : undefined as any);
        }
        data["subject"] = this.subject;
        data["questionCount"] = this.questionCount;
        data["canEdit"] = this.canEdit;
        return data;
    }
}

export interface IAssignExamDetailDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    title?: string | undefined;
    classId?: number;
    examId?: number;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    allowDeadline?: boolean;
    allowViewAnswer?: boolean;
    duration?: number;
    status?: AssignExamStatusEnum;
    type?: AssignExamTypeEnum;
    assignExamUsers?: AssignExamUserEntity[] | undefined;
    subject?: string | undefined;
    questionCount?: number;
    canEdit?: boolean;
}

export class AssignExamDoneDto implements IAssignExamDoneDto {
    id?: number;
    title?: string | undefined;
    endDate?: Date | undefined;
    mark?: number;
    totalMark?: number;
    examId?: number;
    examResultId?: number;
    status?: AssignExamUserStatusEnum;

    constructor(data?: IAssignExamDoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.mark = _data["mark"];
            this.totalMark = _data["totalMark"];
            this.examId = _data["examId"];
            this.examResultId = _data["examResultId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): AssignExamDoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignExamDoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["mark"] = this.mark;
        data["totalMark"] = this.totalMark;
        data["examId"] = this.examId;
        data["examResultId"] = this.examResultId;
        data["status"] = this.status;
        return data;
    }
}

export interface IAssignExamDoneDto {
    id?: number;
    title?: string | undefined;
    endDate?: Date | undefined;
    mark?: number;
    totalMark?: number;
    examId?: number;
    examResultId?: number;
    status?: AssignExamUserStatusEnum;
}

export class AssignExamEditDto implements IAssignExamEditDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    title?: string | undefined;
    classId?: number;
    examId?: number;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    allowDeadline?: boolean;
    allowViewAnswer?: boolean;
    duration?: number;
    status?: AssignExamStatusEnum;
    type?: AssignExamTypeEnum;
    assignExamUsers?: AssignExamUserEntity[] | undefined;
    assignUsers?: AssignExamUserEditDto[] | undefined;

    constructor(data?: IAssignExamEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.title = _data["title"];
            this.classId = _data["classId"];
            this.examId = _data["examId"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : undefined as any;
            this.allowDeadline = _data["allowDeadline"];
            this.allowViewAnswer = _data["allowViewAnswer"];
            this.duration = _data["duration"];
            this.status = _data["status"];
            this.type = _data["type"];
            if (Array.isArray(_data["assignExamUsers"])) {
                this.assignExamUsers = [] as any;
                for (let item of _data["assignExamUsers"])
                    this.assignExamUsers!.push(AssignExamUserEntity.fromJS(item));
            }
            if (Array.isArray(_data["assignUsers"])) {
                this.assignUsers = [] as any;
                for (let item of _data["assignUsers"])
                    this.assignUsers!.push(AssignExamUserEditDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssignExamEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignExamEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["title"] = this.title;
        data["classId"] = this.classId;
        data["examId"] = this.examId;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : undefined as any;
        data["allowDeadline"] = this.allowDeadline;
        data["allowViewAnswer"] = this.allowViewAnswer;
        data["duration"] = this.duration;
        data["status"] = this.status;
        data["type"] = this.type;
        if (Array.isArray(this.assignExamUsers)) {
            data["assignExamUsers"] = [];
            for (let item of this.assignExamUsers)
                data["assignExamUsers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.assignUsers)) {
            data["assignUsers"] = [];
            for (let item of this.assignUsers)
                data["assignUsers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAssignExamEditDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    title?: string | undefined;
    classId?: number;
    examId?: number;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    allowDeadline?: boolean;
    allowViewAnswer?: boolean;
    duration?: number;
    status?: AssignExamStatusEnum;
    type?: AssignExamTypeEnum;
    assignExamUsers?: AssignExamUserEntity[] | undefined;
    assignUsers?: AssignExamUserEditDto[] | undefined;
}

export class AssignExamListByExamIdDto implements IAssignExamListByExamIdDto {
    id?: number;
    examId?: number;
    className?: string | undefined;
    type?: AssignExamTypeEnum;
    fromDate?: Date | undefined;
    countPupilDone?: number;
    countPupil?: number;
    countNeedMark?: number;
    classId?: number;
    createdBy?: number | undefined;

    constructor(data?: IAssignExamListByExamIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.examId = _data["examId"];
            this.className = _data["className"];
            this.type = _data["type"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : undefined as any;
            this.countPupilDone = _data["countPupilDone"];
            this.countPupil = _data["countPupil"];
            this.countNeedMark = _data["countNeedMark"];
            this.classId = _data["classId"];
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any): AssignExamListByExamIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignExamListByExamIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["examId"] = this.examId;
        data["className"] = this.className;
        data["type"] = this.type;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : undefined as any;
        data["countPupilDone"] = this.countPupilDone;
        data["countPupil"] = this.countPupil;
        data["countNeedMark"] = this.countNeedMark;
        data["classId"] = this.classId;
        data["createdBy"] = this.createdBy;
        return data;
    }
}

export interface IAssignExamListByExamIdDto {
    id?: number;
    examId?: number;
    className?: string | undefined;
    type?: AssignExamTypeEnum;
    fromDate?: Date | undefined;
    countPupilDone?: number;
    countPupil?: number;
    countNeedMark?: number;
    classId?: number;
    createdBy?: number | undefined;
}

export class AssignExamListByExamIdFilterDto implements IAssignExamListByExamIdFilterDto {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    examId?: number;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    type?: AssignExamTypeEnum;
    classId?: number | undefined;

    constructor(data?: IAssignExamListByExamIdFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.examId = _data["examId"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : undefined as any;
            this.type = _data["type"];
            this.classId = _data["classId"];
        }
    }

    static fromJS(data: any): AssignExamListByExamIdFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignExamListByExamIdFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["examId"] = this.examId;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : undefined as any;
        data["type"] = this.type;
        data["classId"] = this.classId;
        return data;
    }
}

export interface IAssignExamListByExamIdFilterDto {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    examId?: number;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    type?: AssignExamTypeEnum;
    classId?: number | undefined;
}

export class AssignExamListDto implements IAssignExamListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    classId?: number;
    title?: string | undefined;
    subjectId?: number;
    subject?: string | undefined;
    fromDate?: Date | undefined;
    readonly isHot?: boolean;
    toDate?: Date | undefined;
    status?: AssignExamStatusEnum;
    countPupil?: number;
    countPupilDone?: number;
    isOwner?: boolean;
    isTeacher?: boolean;
    examId?: number;
    mark?: number;
    userStatus?: AssignExamUserStatusEnum;
    examResultId?: number;
    allowViewAnswer?: boolean;
    pupilSubmissionTime?: Date | undefined;
    countNeedMark?: number;
    duration?: number;

    constructor(data?: IAssignExamListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.classId = _data["classId"];
            this.title = _data["title"];
            this.subjectId = _data["subjectId"];
            this.subject = _data["subject"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : undefined as any;
            (this as any).isHot = _data["isHot"];
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : undefined as any;
            this.status = _data["status"];
            this.countPupil = _data["countPupil"];
            this.countPupilDone = _data["countPupilDone"];
            this.isOwner = _data["isOwner"];
            this.isTeacher = _data["isTeacher"];
            this.examId = _data["examId"];
            this.mark = _data["mark"];
            this.userStatus = _data["userStatus"];
            this.examResultId = _data["examResultId"];
            this.allowViewAnswer = _data["allowViewAnswer"];
            this.pupilSubmissionTime = _data["pupilSubmissionTime"] ? new Date(_data["pupilSubmissionTime"].toString()) : undefined as any;
            this.countNeedMark = _data["countNeedMark"];
            this.duration = _data["duration"];
        }
    }

    static fromJS(data: any): AssignExamListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignExamListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["classId"] = this.classId;
        data["title"] = this.title;
        data["subjectId"] = this.subjectId;
        data["subject"] = this.subject;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : undefined as any;
        data["isHot"] = this.isHot;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : undefined as any;
        data["status"] = this.status;
        data["countPupil"] = this.countPupil;
        data["countPupilDone"] = this.countPupilDone;
        data["isOwner"] = this.isOwner;
        data["isTeacher"] = this.isTeacher;
        data["examId"] = this.examId;
        data["mark"] = this.mark;
        data["userStatus"] = this.userStatus;
        data["examResultId"] = this.examResultId;
        data["allowViewAnswer"] = this.allowViewAnswer;
        data["pupilSubmissionTime"] = this.pupilSubmissionTime ? this.pupilSubmissionTime.toISOString() : undefined as any;
        data["countNeedMark"] = this.countNeedMark;
        data["duration"] = this.duration;
        return data;
    }
}

export interface IAssignExamListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    classId?: number;
    title?: string | undefined;
    subjectId?: number;
    subject?: string | undefined;
    fromDate?: Date | undefined;
    isHot?: boolean;
    toDate?: Date | undefined;
    status?: AssignExamStatusEnum;
    countPupil?: number;
    countPupilDone?: number;
    isOwner?: boolean;
    isTeacher?: boolean;
    examId?: number;
    mark?: number;
    userStatus?: AssignExamUserStatusEnum;
    examResultId?: number;
    allowViewAnswer?: boolean;
    pupilSubmissionTime?: Date | undefined;
    countNeedMark?: number;
    duration?: number;
}

export class AssignExamListExamDto implements IAssignExamListExamDto {
    id?: number;
    title?: string | undefined;
    subject?: string | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    status?: AssignExamStatusEnum;
    type?: AssignExamTypeEnum;

    constructor(data?: IAssignExamListExamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.subject = _data["subject"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : undefined as any;
            this.status = _data["status"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): AssignExamListExamDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignExamListExamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["subject"] = this.subject;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : undefined as any;
        data["status"] = this.status;
        data["type"] = this.type;
        return data;
    }
}

export interface IAssignExamListExamDto {
    id?: number;
    title?: string | undefined;
    subject?: string | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    status?: AssignExamStatusEnum;
    type?: AssignExamTypeEnum;
}

export class AssignExamListExamFilterDto implements IAssignExamListExamFilterDto {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    userId?: number;
    userStatus?: AssignExamUserStatusEnum;

    constructor(data?: IAssignExamListExamFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.keyword = _data["keyword"];
            this.userId = _data["userId"];
            this.userStatus = _data["userStatus"];
        }
    }

    static fromJS(data: any): AssignExamListExamFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignExamListExamFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["keyword"] = this.keyword;
        data["userId"] = this.userId;
        data["userStatus"] = this.userStatus;
        return data;
    }
}

export interface IAssignExamListExamFilterDto {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    userId?: number;
    userStatus?: AssignExamUserStatusEnum;
}

export class AssignExamListUserDto implements IAssignExamListUserDto {
    assignExamId?: number;
    userId?: number;
    status?: AssignExamUserStatusEnum;
    examResultId?: number;
    startDate?: Date | undefined;
    mark?: number;
    duration?: number;
    endDate?: Date | undefined;
    note?: string | undefined;
    avatar?: string | undefined;
    fullName?: string | undefined;
    overdue?: boolean;
    timeMarking?: Date | undefined;

    constructor(data?: IAssignExamListUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignExamId = _data["assignExamId"];
            this.userId = _data["userId"];
            this.status = _data["status"];
            this.examResultId = _data["examResultId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.mark = _data["mark"];
            this.duration = _data["duration"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.note = _data["note"];
            this.avatar = _data["avatar"];
            this.fullName = _data["fullName"];
            this.overdue = _data["overdue"];
            this.timeMarking = _data["timeMarking"] ? new Date(_data["timeMarking"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AssignExamListUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignExamListUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignExamId"] = this.assignExamId;
        data["userId"] = this.userId;
        data["status"] = this.status;
        data["examResultId"] = this.examResultId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["mark"] = this.mark;
        data["duration"] = this.duration;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["note"] = this.note;
        data["avatar"] = this.avatar;
        data["fullName"] = this.fullName;
        data["overdue"] = this.overdue;
        data["timeMarking"] = this.timeMarking ? this.timeMarking.toISOString() : undefined as any;
        return data;
    }
}

export interface IAssignExamListUserDto {
    assignExamId?: number;
    userId?: number;
    status?: AssignExamUserStatusEnum;
    examResultId?: number;
    startDate?: Date | undefined;
    mark?: number;
    duration?: number;
    endDate?: Date | undefined;
    note?: string | undefined;
    avatar?: string | undefined;
    fullName?: string | undefined;
    overdue?: boolean;
    timeMarking?: Date | undefined;
}

export class AssignExamListUserFilterDto implements IAssignExamListUserFilterDto {
    keyword?: string | undefined;
    id?: number;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    status?: AssignExamUserStatusEnum;
    sortExpression?: string | undefined;

    constructor(data?: IAssignExamListUserFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keyword = _data["keyword"];
            this.id = _data["id"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : undefined as any;
            this.status = _data["status"];
            this.sortExpression = _data["sortExpression"];
        }
    }

    static fromJS(data: any): AssignExamListUserFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignExamListUserFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyword"] = this.keyword;
        data["id"] = this.id;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : undefined as any;
        data["status"] = this.status;
        data["sortExpression"] = this.sortExpression;
        return data;
    }
}

export interface IAssignExamListUserFilterDto {
    keyword?: string | undefined;
    id?: number;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    status?: AssignExamUserStatusEnum;
    sortExpression?: string | undefined;
}

export class AssignExamNeedDoDto implements IAssignExamNeedDoDto {
    examId?: number;
    id?: number;
    title?: string | undefined;
    subjectId?: number;
    subject?: string | undefined;
    toDate?: Date | undefined;
    type?: AssignExamTypeEnum;
    duration?: number;

    constructor(data?: IAssignExamNeedDoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.examId = _data["examId"];
            this.id = _data["id"];
            this.title = _data["title"];
            this.subjectId = _data["subjectId"];
            this.subject = _data["subject"];
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : undefined as any;
            this.type = _data["type"];
            this.duration = _data["duration"];
        }
    }

    static fromJS(data: any): AssignExamNeedDoDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignExamNeedDoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["examId"] = this.examId;
        data["id"] = this.id;
        data["title"] = this.title;
        data["subjectId"] = this.subjectId;
        data["subject"] = this.subject;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : undefined as any;
        data["type"] = this.type;
        data["duration"] = this.duration;
        return data;
    }
}

export interface IAssignExamNeedDoDto {
    examId?: number;
    id?: number;
    title?: string | undefined;
    subjectId?: number;
    subject?: string | undefined;
    toDate?: Date | undefined;
    type?: AssignExamTypeEnum;
    duration?: number;
}

export class AssignExamScoreDistributionDto implements IAssignExamScoreDistributionDto {
    scoreName?: string | undefined;
    count?: number;

    constructor(data?: IAssignExamScoreDistributionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scoreName = _data["scoreName"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): AssignExamScoreDistributionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignExamScoreDistributionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scoreName"] = this.scoreName;
        data["count"] = this.count;
        return data;
    }
}

export interface IAssignExamScoreDistributionDto {
    scoreName?: string | undefined;
    count?: number;
}

export class AssignExamTopDifficultQuestionDto implements IAssignExamTopDifficultQuestionDto {
    questionId?: number;
    question?: string | undefined;
    count?: number;

    constructor(data?: IAssignExamTopDifficultQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["questionId"];
            this.question = _data["question"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): AssignExamTopDifficultQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignExamTopDifficultQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["question"] = this.question;
        data["count"] = this.count;
        return data;
    }
}

export interface IAssignExamTopDifficultQuestionDto {
    questionId?: number;
    question?: string | undefined;
    count?: number;
}

export class AssignExamUpdateNoteDto implements IAssignExamUpdateNoteDto {
    id?: number;
    userId?: number;
    note?: string | undefined;

    constructor(data?: IAssignExamUpdateNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): AssignExamUpdateNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignExamUpdateNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["note"] = this.note;
        return data;
    }
}

export interface IAssignExamUpdateNoteDto {
    id?: number;
    userId?: number;
    note?: string | undefined;
}

export class AssignExamUpdateTimeDto implements IAssignExamUpdateTimeDto {
    id?: number;
    time?: Date;

    constructor(data?: IAssignExamUpdateTimeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.time = _data["time"] ? new Date(_data["time"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AssignExamUpdateTimeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignExamUpdateTimeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["time"] = this.time ? this.time.toISOString() : undefined as any;
        return data;
    }
}

export interface IAssignExamUpdateTimeDto {
    id?: number;
    time?: Date;
}

export class AssignExamUserEditDto implements IAssignExamUserEditDto {
    assignExamId?: number;
    userId?: number;
    status?: AssignExamUserStatusEnum;
    examResultId?: number;
    startDate?: Date | undefined;
    mark?: number;
    duration?: number;
    endDate?: Date | undefined;
    note?: string | undefined;
    classUserId?: number;

    constructor(data?: IAssignExamUserEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignExamId = _data["assignExamId"];
            this.userId = _data["userId"];
            this.status = _data["status"];
            this.examResultId = _data["examResultId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.mark = _data["mark"];
            this.duration = _data["duration"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.note = _data["note"];
            this.classUserId = _data["classUserId"];
        }
    }

    static fromJS(data: any): AssignExamUserEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignExamUserEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignExamId"] = this.assignExamId;
        data["userId"] = this.userId;
        data["status"] = this.status;
        data["examResultId"] = this.examResultId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["mark"] = this.mark;
        data["duration"] = this.duration;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["note"] = this.note;
        data["classUserId"] = this.classUserId;
        return data;
    }
}

export interface IAssignExamUserEditDto {
    assignExamId?: number;
    userId?: number;
    status?: AssignExamUserStatusEnum;
    examResultId?: number;
    startDate?: Date | undefined;
    mark?: number;
    duration?: number;
    endDate?: Date | undefined;
    note?: string | undefined;
    classUserId?: number;
}

export class CartAddItemDto implements ICartAddItemDto {
    productId?: number;
    quantity?: number;

    constructor(data?: ICartAddItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): CartAddItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CartAddItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface ICartAddItemDto {
    productId?: number;
    quantity?: number;
}

export class CartDto implements ICartDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    userId?: number;
    notes?: string | undefined;
    items?: CartItemDto[] | undefined;

    constructor(data?: ICartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.userId = _data["userId"];
            this.notes = _data["notes"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CartItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CartDto {
        data = typeof data === 'object' ? data : {};
        let result = new CartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["userId"] = this.userId;
        data["notes"] = this.notes;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICartDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    userId?: number;
    notes?: string | undefined;
    items?: CartItemDto[] | undefined;
}

export class CartItemDto implements ICartItemDto {
    id?: number;
    cartId?: number;
    productId?: number;
    quantity?: number;
    product?: ProductListDto;

    constructor(data?: ICartItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cartId = _data["cartId"];
            this.productId = _data["productId"];
            this.quantity = _data["quantity"];
            this.product = _data["product"] ? ProductListDto.fromJS(_data["product"]) : undefined as any;
        }
    }

    static fromJS(data: any): CartItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CartItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cartId"] = this.cartId;
        data["productId"] = this.productId;
        data["quantity"] = this.quantity;
        data["product"] = this.product ? this.product.toJSON() : undefined as any;
        return data;
    }
}

export interface ICartItemDto {
    id?: number;
    cartId?: number;
    productId?: number;
    quantity?: number;
    product?: ProductListDto;
}

export class CartUpdateItemDto implements ICartUpdateItemDto {
    cartItemId?: number;
    quantity?: number;

    constructor(data?: ICartUpdateItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cartItemId = _data["cartItemId"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): CartUpdateItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CartUpdateItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cartItemId"] = this.cartItemId;
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface ICartUpdateItemDto {
    cartItemId?: number;
    quantity?: number;
}

export class CategoryConfigGetListQuery implements ICategoryConfigGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    allowCreate?: boolean | undefined;

    constructor(data?: ICategoryConfigGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.keyword = _data["keyword"];
            this.allowCreate = _data["allowCreate"];
        }
    }

    static fromJS(data: any): CategoryConfigGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryConfigGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["keyword"] = this.keyword;
        data["allowCreate"] = this.allowCreate;
        return data;
    }
}

export interface ICategoryConfigGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    allowCreate?: boolean | undefined;
}

export class CategoryConfigListDto implements ICategoryConfigListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    code?: string | undefined;
    name?: string | undefined;
    priority?: number;
    allowCreate?: boolean;
    allowTree?: boolean;

    constructor(data?: ICategoryConfigListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.priority = _data["priority"];
            this.allowCreate = _data["allowCreate"];
            this.allowTree = _data["allowTree"];
        }
    }

    static fromJS(data: any): CategoryConfigListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryConfigListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["code"] = this.code;
        data["name"] = this.name;
        data["priority"] = this.priority;
        data["allowCreate"] = this.allowCreate;
        data["allowTree"] = this.allowTree;
        return data;
    }
}

export interface ICategoryConfigListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    code?: string | undefined;
    name?: string | undefined;
    priority?: number;
    allowCreate?: boolean;
    allowTree?: boolean;
}

export class CategoryConfigSaveDto implements ICategoryConfigSaveDto {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    priority?: number;
    allowCreate?: boolean;
    allowTree?: boolean;

    constructor(data?: ICategoryConfigSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.priority = _data["priority"];
            this.allowCreate = _data["allowCreate"];
            this.allowTree = _data["allowTree"];
        }
    }

    static fromJS(data: any): CategoryConfigSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryConfigSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["priority"] = this.priority;
        data["allowCreate"] = this.allowCreate;
        data["allowTree"] = this.allowTree;
        return data;
    }
}

export interface ICategoryConfigSaveDto {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    priority?: number;
    allowCreate?: boolean;
    allowTree?: boolean;
}

export class CategoryGetListQuery implements ICategoryGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    zoneId?: number | undefined;
    code?: string | undefined;
    objectId?: number | undefined;
    objectType?: ObjectOwnerTypeEnum;

    constructor(data?: ICategoryGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.keyword = _data["keyword"];
            this.zoneId = _data["zoneId"];
            this.code = _data["code"];
            this.objectId = _data["objectId"];
            this.objectType = _data["objectType"];
        }
    }

    static fromJS(data: any): CategoryGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["keyword"] = this.keyword;
        data["zoneId"] = this.zoneId;
        data["code"] = this.code;
        data["objectId"] = this.objectId;
        data["objectType"] = this.objectType;
        return data;
    }
}

export interface ICategoryGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    zoneId?: number | undefined;
    code?: string | undefined;
    objectId?: number | undefined;
    objectType?: ObjectOwnerTypeEnum;
}

export class CategoryGetListWithGalleryCountQuery implements ICategoryGetListWithGalleryCountQuery {
    code?: string | undefined;
    includeTotal?: boolean;

    constructor(data?: ICategoryGetListWithGalleryCountQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.includeTotal = _data["includeTotal"];
        }
    }

    static fromJS(data: any): CategoryGetListWithGalleryCountQuery {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryGetListWithGalleryCountQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["includeTotal"] = this.includeTotal;
        return data;
    }
}

export interface ICategoryGetListWithGalleryCountQuery {
    code?: string | undefined;
    includeTotal?: boolean;
}

export class CategoryGetListWithNewsCountQuery implements ICategoryGetListWithNewsCountQuery {
    code?: string | undefined;
    includeTotal?: boolean;

    constructor(data?: ICategoryGetListWithNewsCountQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.includeTotal = _data["includeTotal"];
        }
    }

    static fromJS(data: any): CategoryGetListWithNewsCountQuery {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryGetListWithNewsCountQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["includeTotal"] = this.includeTotal;
        return data;
    }
}

export interface ICategoryGetListWithNewsCountQuery {
    code?: string | undefined;
    includeTotal?: boolean;
}

export class CategoryListDto implements ICategoryListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    nameViVN?: string | undefined;
    nameEnUS?: string | undefined;
    nameZhCN?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;
    code?: string | undefined;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    parentId?: number;
    level?: number;
    path?: string | undefined;
    icon?: string | undefined;
    status?: CommonStatusEnum;
    priority?: number;
    categoryClassLevels?: CategoryClassLevelEntity[] | undefined;

    constructor(data?: ICategoryListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.nameViVN = _data["nameViVN"];
            this.nameEnUS = _data["nameEnUS"];
            this.nameZhCN = _data["nameZhCN"];
            this.description = _data["description"];
            this.url = _data["url"];
            this.code = _data["code"];
            this.objectType = _data["objectType"];
            this.objectId = _data["objectId"];
            this.parentId = _data["parentId"];
            this.level = _data["level"];
            this.path = _data["path"];
            this.icon = _data["icon"];
            this.status = _data["status"];
            this.priority = _data["priority"];
            if (Array.isArray(_data["categoryClassLevels"])) {
                this.categoryClassLevels = [] as any;
                for (let item of _data["categoryClassLevels"])
                    this.categoryClassLevels!.push(CategoryClassLevelEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CategoryListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["nameViVN"] = this.nameViVN;
        data["nameEnUS"] = this.nameEnUS;
        data["nameZhCN"] = this.nameZhCN;
        data["description"] = this.description;
        data["url"] = this.url;
        data["code"] = this.code;
        data["objectType"] = this.objectType;
        data["objectId"] = this.objectId;
        data["parentId"] = this.parentId;
        data["level"] = this.level;
        data["path"] = this.path;
        data["icon"] = this.icon;
        data["status"] = this.status;
        data["priority"] = this.priority;
        if (Array.isArray(this.categoryClassLevels)) {
            data["categoryClassLevels"] = [];
            for (let item of this.categoryClassLevels)
                data["categoryClassLevels"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICategoryListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    nameViVN?: string | undefined;
    nameEnUS?: string | undefined;
    nameZhCN?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;
    code?: string | undefined;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    parentId?: number;
    level?: number;
    path?: string | undefined;
    icon?: string | undefined;
    status?: CommonStatusEnum;
    priority?: number;
    categoryClassLevels?: CategoryClassLevelEntity[] | undefined;
}

export class CategoryWithGalleryCountDto implements ICategoryWithGalleryCountDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    nameViVN?: string | undefined;
    nameEnUS?: string | undefined;
    nameZhCN?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;
    code?: string | undefined;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    parentId?: number;
    level?: number;
    path?: string | undefined;
    icon?: string | undefined;
    status?: CommonStatusEnum;
    priority?: number;
    categoryClassLevels?: CategoryClassLevelEntity[] | undefined;
    galleryCount?: number;

    constructor(data?: ICategoryWithGalleryCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.nameViVN = _data["nameViVN"];
            this.nameEnUS = _data["nameEnUS"];
            this.nameZhCN = _data["nameZhCN"];
            this.description = _data["description"];
            this.url = _data["url"];
            this.code = _data["code"];
            this.objectType = _data["objectType"];
            this.objectId = _data["objectId"];
            this.parentId = _data["parentId"];
            this.level = _data["level"];
            this.path = _data["path"];
            this.icon = _data["icon"];
            this.status = _data["status"];
            this.priority = _data["priority"];
            if (Array.isArray(_data["categoryClassLevels"])) {
                this.categoryClassLevels = [] as any;
                for (let item of _data["categoryClassLevels"])
                    this.categoryClassLevels!.push(CategoryClassLevelEntity.fromJS(item));
            }
            this.galleryCount = _data["galleryCount"];
        }
    }

    static fromJS(data: any): CategoryWithGalleryCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryWithGalleryCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["nameViVN"] = this.nameViVN;
        data["nameEnUS"] = this.nameEnUS;
        data["nameZhCN"] = this.nameZhCN;
        data["description"] = this.description;
        data["url"] = this.url;
        data["code"] = this.code;
        data["objectType"] = this.objectType;
        data["objectId"] = this.objectId;
        data["parentId"] = this.parentId;
        data["level"] = this.level;
        data["path"] = this.path;
        data["icon"] = this.icon;
        data["status"] = this.status;
        data["priority"] = this.priority;
        if (Array.isArray(this.categoryClassLevels)) {
            data["categoryClassLevels"] = [];
            for (let item of this.categoryClassLevels)
                data["categoryClassLevels"].push(item ? item.toJSON() : undefined as any);
        }
        data["galleryCount"] = this.galleryCount;
        return data;
    }
}

export interface ICategoryWithGalleryCountDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    nameViVN?: string | undefined;
    nameEnUS?: string | undefined;
    nameZhCN?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;
    code?: string | undefined;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    parentId?: number;
    level?: number;
    path?: string | undefined;
    icon?: string | undefined;
    status?: CommonStatusEnum;
    priority?: number;
    categoryClassLevels?: CategoryClassLevelEntity[] | undefined;
    galleryCount?: number;
}

export class CategoryWithNewsCountDto implements ICategoryWithNewsCountDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    nameViVN?: string | undefined;
    nameEnUS?: string | undefined;
    nameZhCN?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;
    code?: string | undefined;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    parentId?: number;
    level?: number;
    path?: string | undefined;
    icon?: string | undefined;
    status?: CommonStatusEnum;
    priority?: number;
    categoryClassLevels?: CategoryClassLevelEntity[] | undefined;
    newsCount?: number;

    constructor(data?: ICategoryWithNewsCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.nameViVN = _data["nameViVN"];
            this.nameEnUS = _data["nameEnUS"];
            this.nameZhCN = _data["nameZhCN"];
            this.description = _data["description"];
            this.url = _data["url"];
            this.code = _data["code"];
            this.objectType = _data["objectType"];
            this.objectId = _data["objectId"];
            this.parentId = _data["parentId"];
            this.level = _data["level"];
            this.path = _data["path"];
            this.icon = _data["icon"];
            this.status = _data["status"];
            this.priority = _data["priority"];
            if (Array.isArray(_data["categoryClassLevels"])) {
                this.categoryClassLevels = [] as any;
                for (let item of _data["categoryClassLevels"])
                    this.categoryClassLevels!.push(CategoryClassLevelEntity.fromJS(item));
            }
            this.newsCount = _data["newsCount"];
        }
    }

    static fromJS(data: any): CategoryWithNewsCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryWithNewsCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["nameViVN"] = this.nameViVN;
        data["nameEnUS"] = this.nameEnUS;
        data["nameZhCN"] = this.nameZhCN;
        data["description"] = this.description;
        data["url"] = this.url;
        data["code"] = this.code;
        data["objectType"] = this.objectType;
        data["objectId"] = this.objectId;
        data["parentId"] = this.parentId;
        data["level"] = this.level;
        data["path"] = this.path;
        data["icon"] = this.icon;
        data["status"] = this.status;
        data["priority"] = this.priority;
        if (Array.isArray(this.categoryClassLevels)) {
            data["categoryClassLevels"] = [];
            for (let item of this.categoryClassLevels)
                data["categoryClassLevels"].push(item ? item.toJSON() : undefined as any);
        }
        data["newsCount"] = this.newsCount;
        return data;
    }
}

export interface ICategoryWithNewsCountDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    nameViVN?: string | undefined;
    nameEnUS?: string | undefined;
    nameZhCN?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;
    code?: string | undefined;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    parentId?: number;
    level?: number;
    path?: string | undefined;
    icon?: string | undefined;
    status?: CommonStatusEnum;
    priority?: number;
    categoryClassLevels?: CategoryClassLevelEntity[] | undefined;
    newsCount?: number;
}

export class ChatGroupDetailDto implements IChatGroupDetailDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    avatar?: string | undefined;
    status?: number | undefined;
    type?: number | undefined;
    documentId?: number | undefined;
    listUserOfGroup?: UserWithSimpleInfoDto[] | undefined;
    isOnline?: boolean;

    constructor(data?: IChatGroupDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.avatar = _data["avatar"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.documentId = _data["documentId"];
            if (Array.isArray(_data["listUserOfGroup"])) {
                this.listUserOfGroup = [] as any;
                for (let item of _data["listUserOfGroup"])
                    this.listUserOfGroup!.push(UserWithSimpleInfoDto.fromJS(item));
            }
            this.isOnline = _data["isOnline"];
        }
    }

    static fromJS(data: any): ChatGroupDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChatGroupDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["avatar"] = this.avatar;
        data["status"] = this.status;
        data["type"] = this.type;
        data["documentId"] = this.documentId;
        if (Array.isArray(this.listUserOfGroup)) {
            data["listUserOfGroup"] = [];
            for (let item of this.listUserOfGroup)
                data["listUserOfGroup"].push(item ? item.toJSON() : undefined as any);
        }
        data["isOnline"] = this.isOnline;
        return data;
    }
}

export interface IChatGroupDetailDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    avatar?: string | undefined;
    status?: number | undefined;
    type?: number | undefined;
    documentId?: number | undefined;
    listUserOfGroup?: UserWithSimpleInfoDto[] | undefined;
    isOnline?: boolean;
}

export class ClassAssignTeacherDto implements IClassAssignTeacherDto {
    userId?: number;
    classes?: ClassAssignTeacherItemDto[] | undefined;

    constructor(data?: IClassAssignTeacherDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            if (Array.isArray(_data["classes"])) {
                this.classes = [] as any;
                for (let item of _data["classes"])
                    this.classes!.push(ClassAssignTeacherItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClassAssignTeacherDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClassAssignTeacherDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        if (Array.isArray(this.classes)) {
            data["classes"] = [];
            for (let item of this.classes)
                data["classes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IClassAssignTeacherDto {
    userId?: number;
    classes?: ClassAssignTeacherItemDto[] | undefined;
}

export class ClassAssignTeacherItemDto implements IClassAssignTeacherItemDto {
    classId?: number;
    subjectIds?: number[] | undefined;
    isManager?: boolean;

    constructor(data?: IClassAssignTeacherItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.classId = _data["classId"];
            if (Array.isArray(_data["subjectIds"])) {
                this.subjectIds = [] as any;
                for (let item of _data["subjectIds"])
                    this.subjectIds!.push(item);
            }
            this.isManager = _data["isManager"];
        }
    }

    static fromJS(data: any): ClassAssignTeacherItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClassAssignTeacherItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["classId"] = this.classId;
        if (Array.isArray(this.subjectIds)) {
            data["subjectIds"] = [];
            for (let item of this.subjectIds)
                data["subjectIds"].push(item);
        }
        data["isManager"] = this.isManager;
        return data;
    }
}

export interface IClassAssignTeacherItemDto {
    classId?: number;
    subjectIds?: number[] | undefined;
    isManager?: boolean;
}

export class ClassByUserDto implements IClassByUserDto {
    id?: number;
    name?: string | undefined;
    subjectIds?: number[] | undefined;
    isManager?: boolean;

    constructor(data?: IClassByUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["subjectIds"])) {
                this.subjectIds = [] as any;
                for (let item of _data["subjectIds"])
                    this.subjectIds!.push(item);
            }
            this.isManager = _data["isManager"];
        }
    }

    static fromJS(data: any): ClassByUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClassByUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.subjectIds)) {
            data["subjectIds"] = [];
            for (let item of this.subjectIds)
                data["subjectIds"].push(item);
        }
        data["isManager"] = this.isManager;
        return data;
    }
}

export interface IClassByUserDto {
    id?: number;
    name?: string | undefined;
    subjectIds?: number[] | undefined;
    isManager?: boolean;
}

export class ClassCourseDto implements IClassCourseDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    academicYearId?: number | undefined;
    status?: ClassStatusEnum;
    grade?: number;
    priority?: number;
    educationSystemId?: number | undefined;
    classType?: ClassTypeEnum;
    maxStudents?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    zoomMeetingId?: string | undefined;
    zoomPassword?: string | undefined;
    description?: string | undefined;
    allowRegistration?: boolean;
    zoomHostVideo?: boolean;
    zoomParticipantVideo?: boolean;
    zoomJoinBeforeHost?: boolean;
    zoomMuteUponEntry?: boolean;
    zoomAutoRecording?: string | undefined;
    defaultSessionDeliveryMode?: SessionDeliveryModeEnum;
    classUsers?: ClassUserEntity[] | undefined;
    assignExams?: AssignExamEntity[] | undefined;
    classSessions?: ClassSessionEntity[] | undefined;
    classProducts?: ClassProductEntity[] | undefined;
    productId?: number | undefined;
    productName?: string | undefined;
    currentSession?: ClassSessionEntity;

    constructor(data?: IClassCourseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.objectId = _data["objectId"];
            this.objectType = _data["objectType"];
            this.academicYearId = _data["academicYearId"];
            this.status = _data["status"];
            this.grade = _data["grade"];
            this.priority = _data["priority"];
            this.educationSystemId = _data["educationSystemId"];
            this.classType = _data["classType"];
            this.maxStudents = _data["maxStudents"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.zoomMeetingId = _data["zoomMeetingId"];
            this.zoomPassword = _data["zoomPassword"];
            this.description = _data["description"];
            this.allowRegistration = _data["allowRegistration"];
            this.zoomHostVideo = _data["zoomHostVideo"];
            this.zoomParticipantVideo = _data["zoomParticipantVideo"];
            this.zoomJoinBeforeHost = _data["zoomJoinBeforeHost"];
            this.zoomMuteUponEntry = _data["zoomMuteUponEntry"];
            this.zoomAutoRecording = _data["zoomAutoRecording"];
            this.defaultSessionDeliveryMode = _data["defaultSessionDeliveryMode"];
            if (Array.isArray(_data["classUsers"])) {
                this.classUsers = [] as any;
                for (let item of _data["classUsers"])
                    this.classUsers!.push(ClassUserEntity.fromJS(item));
            }
            if (Array.isArray(_data["assignExams"])) {
                this.assignExams = [] as any;
                for (let item of _data["assignExams"])
                    this.assignExams!.push(AssignExamEntity.fromJS(item));
            }
            if (Array.isArray(_data["classSessions"])) {
                this.classSessions = [] as any;
                for (let item of _data["classSessions"])
                    this.classSessions!.push(ClassSessionEntity.fromJS(item));
            }
            if (Array.isArray(_data["classProducts"])) {
                this.classProducts = [] as any;
                for (let item of _data["classProducts"])
                    this.classProducts!.push(ClassProductEntity.fromJS(item));
            }
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.currentSession = _data["currentSession"] ? ClassSessionEntity.fromJS(_data["currentSession"]) : undefined as any;
        }
    }

    static fromJS(data: any): ClassCourseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClassCourseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["objectId"] = this.objectId;
        data["objectType"] = this.objectType;
        data["academicYearId"] = this.academicYearId;
        data["status"] = this.status;
        data["grade"] = this.grade;
        data["priority"] = this.priority;
        data["educationSystemId"] = this.educationSystemId;
        data["classType"] = this.classType;
        data["maxStudents"] = this.maxStudents;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["zoomMeetingId"] = this.zoomMeetingId;
        data["zoomPassword"] = this.zoomPassword;
        data["description"] = this.description;
        data["allowRegistration"] = this.allowRegistration;
        data["zoomHostVideo"] = this.zoomHostVideo;
        data["zoomParticipantVideo"] = this.zoomParticipantVideo;
        data["zoomJoinBeforeHost"] = this.zoomJoinBeforeHost;
        data["zoomMuteUponEntry"] = this.zoomMuteUponEntry;
        data["zoomAutoRecording"] = this.zoomAutoRecording;
        data["defaultSessionDeliveryMode"] = this.defaultSessionDeliveryMode;
        if (Array.isArray(this.classUsers)) {
            data["classUsers"] = [];
            for (let item of this.classUsers)
                data["classUsers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.assignExams)) {
            data["assignExams"] = [];
            for (let item of this.assignExams)
                data["assignExams"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.classSessions)) {
            data["classSessions"] = [];
            for (let item of this.classSessions)
                data["classSessions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.classProducts)) {
            data["classProducts"] = [];
            for (let item of this.classProducts)
                data["classProducts"].push(item ? item.toJSON() : undefined as any);
        }
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["currentSession"] = this.currentSession ? this.currentSession.toJSON() : undefined as any;
        return data;
    }
}

export interface IClassCourseDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    academicYearId?: number | undefined;
    status?: ClassStatusEnum;
    grade?: number;
    priority?: number;
    educationSystemId?: number | undefined;
    classType?: ClassTypeEnum;
    maxStudents?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    zoomMeetingId?: string | undefined;
    zoomPassword?: string | undefined;
    description?: string | undefined;
    allowRegistration?: boolean;
    zoomHostVideo?: boolean;
    zoomParticipantVideo?: boolean;
    zoomJoinBeforeHost?: boolean;
    zoomMuteUponEntry?: boolean;
    zoomAutoRecording?: string | undefined;
    defaultSessionDeliveryMode?: SessionDeliveryModeEnum;
    classUsers?: ClassUserEntity[] | undefined;
    assignExams?: AssignExamEntity[] | undefined;
    classSessions?: ClassSessionEntity[] | undefined;
    classProducts?: ClassProductEntity[] | undefined;
    productId?: number | undefined;
    productName?: string | undefined;
    currentSession?: ClassSessionEntity;
}

export class ClassDetailDto implements IClassDetailDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    academicYearId?: number | undefined;
    status?: ClassStatusEnum;
    grade?: number;
    priority?: number;
    educationSystemId?: number | undefined;
    classType?: ClassTypeEnum;
    maxStudents?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    zoomMeetingId?: string | undefined;
    zoomPassword?: string | undefined;
    description?: string | undefined;
    allowRegistration?: boolean;
    zoomHostVideo?: boolean;
    zoomParticipantVideo?: boolean;
    zoomJoinBeforeHost?: boolean;
    zoomMuteUponEntry?: boolean;
    zoomAutoRecording?: string | undefined;
    defaultSessionDeliveryMode?: SessionDeliveryModeEnum;
    classUsers?: ClassUserEntity[] | undefined;
    assignExams?: AssignExamEntity[] | undefined;
    classSessions?: ClassSessionEntity[] | undefined;
    classProducts?: ClassProductEntity[] | undefined;
    currentRole?: ClassUserRoleEnum;
    products?: ProductListDto[] | undefined;

    constructor(data?: IClassDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.objectId = _data["objectId"];
            this.objectType = _data["objectType"];
            this.academicYearId = _data["academicYearId"];
            this.status = _data["status"];
            this.grade = _data["grade"];
            this.priority = _data["priority"];
            this.educationSystemId = _data["educationSystemId"];
            this.classType = _data["classType"];
            this.maxStudents = _data["maxStudents"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.zoomMeetingId = _data["zoomMeetingId"];
            this.zoomPassword = _data["zoomPassword"];
            this.description = _data["description"];
            this.allowRegistration = _data["allowRegistration"];
            this.zoomHostVideo = _data["zoomHostVideo"];
            this.zoomParticipantVideo = _data["zoomParticipantVideo"];
            this.zoomJoinBeforeHost = _data["zoomJoinBeforeHost"];
            this.zoomMuteUponEntry = _data["zoomMuteUponEntry"];
            this.zoomAutoRecording = _data["zoomAutoRecording"];
            this.defaultSessionDeliveryMode = _data["defaultSessionDeliveryMode"];
            if (Array.isArray(_data["classUsers"])) {
                this.classUsers = [] as any;
                for (let item of _data["classUsers"])
                    this.classUsers!.push(ClassUserEntity.fromJS(item));
            }
            if (Array.isArray(_data["assignExams"])) {
                this.assignExams = [] as any;
                for (let item of _data["assignExams"])
                    this.assignExams!.push(AssignExamEntity.fromJS(item));
            }
            if (Array.isArray(_data["classSessions"])) {
                this.classSessions = [] as any;
                for (let item of _data["classSessions"])
                    this.classSessions!.push(ClassSessionEntity.fromJS(item));
            }
            if (Array.isArray(_data["classProducts"])) {
                this.classProducts = [] as any;
                for (let item of _data["classProducts"])
                    this.classProducts!.push(ClassProductEntity.fromJS(item));
            }
            this.currentRole = _data["currentRole"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(ProductListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClassDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClassDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["objectId"] = this.objectId;
        data["objectType"] = this.objectType;
        data["academicYearId"] = this.academicYearId;
        data["status"] = this.status;
        data["grade"] = this.grade;
        data["priority"] = this.priority;
        data["educationSystemId"] = this.educationSystemId;
        data["classType"] = this.classType;
        data["maxStudents"] = this.maxStudents;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["zoomMeetingId"] = this.zoomMeetingId;
        data["zoomPassword"] = this.zoomPassword;
        data["description"] = this.description;
        data["allowRegistration"] = this.allowRegistration;
        data["zoomHostVideo"] = this.zoomHostVideo;
        data["zoomParticipantVideo"] = this.zoomParticipantVideo;
        data["zoomJoinBeforeHost"] = this.zoomJoinBeforeHost;
        data["zoomMuteUponEntry"] = this.zoomMuteUponEntry;
        data["zoomAutoRecording"] = this.zoomAutoRecording;
        data["defaultSessionDeliveryMode"] = this.defaultSessionDeliveryMode;
        if (Array.isArray(this.classUsers)) {
            data["classUsers"] = [];
            for (let item of this.classUsers)
                data["classUsers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.assignExams)) {
            data["assignExams"] = [];
            for (let item of this.assignExams)
                data["assignExams"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.classSessions)) {
            data["classSessions"] = [];
            for (let item of this.classSessions)
                data["classSessions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.classProducts)) {
            data["classProducts"] = [];
            for (let item of this.classProducts)
                data["classProducts"].push(item ? item.toJSON() : undefined as any);
        }
        data["currentRole"] = this.currentRole;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IClassDetailDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    academicYearId?: number | undefined;
    status?: ClassStatusEnum;
    grade?: number;
    priority?: number;
    educationSystemId?: number | undefined;
    classType?: ClassTypeEnum;
    maxStudents?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    zoomMeetingId?: string | undefined;
    zoomPassword?: string | undefined;
    description?: string | undefined;
    allowRegistration?: boolean;
    zoomHostVideo?: boolean;
    zoomParticipantVideo?: boolean;
    zoomJoinBeforeHost?: boolean;
    zoomMuteUponEntry?: boolean;
    zoomAutoRecording?: string | undefined;
    defaultSessionDeliveryMode?: SessionDeliveryModeEnum;
    classUsers?: ClassUserEntity[] | undefined;
    assignExams?: AssignExamEntity[] | undefined;
    classSessions?: ClassSessionEntity[] | undefined;
    classProducts?: ClassProductEntity[] | undefined;
    currentRole?: ClassUserRoleEnum;
    products?: ProductListDto[] | undefined;
}

export class ClassGetListFilter implements IClassGetListFilter {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    objectId?: number | undefined;
    objectType?: ObjectOwnerTypeEnum;
    academicYearId?: number | undefined;
    status?: ClassStatusEnum;
    isGetAll?: boolean;
    userId?: number | undefined;
    grade?: number | undefined;
    educationSystemId?: number | undefined;
    searchType?: ClassListSearchTypeEnum;

    constructor(data?: IClassGetListFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.keyword = _data["keyword"];
            this.objectId = _data["objectId"];
            this.objectType = _data["objectType"];
            this.academicYearId = _data["academicYearId"];
            this.status = _data["status"];
            this.isGetAll = _data["isGetAll"];
            this.userId = _data["userId"];
            this.grade = _data["grade"];
            this.educationSystemId = _data["educationSystemId"];
            this.searchType = _data["searchType"];
        }
    }

    static fromJS(data: any): ClassGetListFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ClassGetListFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["keyword"] = this.keyword;
        data["objectId"] = this.objectId;
        data["objectType"] = this.objectType;
        data["academicYearId"] = this.academicYearId;
        data["status"] = this.status;
        data["isGetAll"] = this.isGetAll;
        data["userId"] = this.userId;
        data["grade"] = this.grade;
        data["educationSystemId"] = this.educationSystemId;
        data["searchType"] = this.searchType;
        return data;
    }
}

export interface IClassGetListFilter {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    objectId?: number | undefined;
    objectType?: ObjectOwnerTypeEnum;
    academicYearId?: number | undefined;
    status?: ClassStatusEnum;
    isGetAll?: boolean;
    userId?: number | undefined;
    grade?: number | undefined;
    educationSystemId?: number | undefined;
    searchType?: ClassListSearchTypeEnum;
}

export class ClassListDto implements IClassListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    academicYearId?: number | undefined;
    status?: ClassStatusEnum;
    grade?: number;
    priority?: number;
    educationSystemId?: number | undefined;
    classType?: ClassTypeEnum;
    maxStudents?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    zoomMeetingId?: string | undefined;
    zoomPassword?: string | undefined;
    description?: string | undefined;
    allowRegistration?: boolean;
    zoomHostVideo?: boolean;
    zoomParticipantVideo?: boolean;
    zoomJoinBeforeHost?: boolean;
    zoomMuteUponEntry?: boolean;
    zoomAutoRecording?: string | undefined;
    defaultSessionDeliveryMode?: SessionDeliveryModeEnum;
    classUsers?: ClassUserEntity[] | undefined;
    assignExams?: AssignExamEntity[] | undefined;
    classSessions?: ClassSessionEntity[] | undefined;
    classProducts?: ClassProductEntity[] | undefined;
    countPupil?: number;
    countExercise?: number;
    countTest?: number;
    countNeedMark?: number;
    testAverageScore?: number;
    studentCountTest?: number;
    studentCountTestDone?: number;
    currentRole?: ClassUserRoleEnum;
    isManager?: boolean;
    schoolName?: string | undefined;
    subject?: string | undefined;
    zoomSessionCount?: number;
    courseLearningCount?: number;
    courseCompletedCount?: number;
    courseCount?: number;
    productNames?: string[] | undefined;
    teachers?: ClassTeacherShortDto[] | undefined;

    constructor(data?: IClassListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.objectId = _data["objectId"];
            this.objectType = _data["objectType"];
            this.academicYearId = _data["academicYearId"];
            this.status = _data["status"];
            this.grade = _data["grade"];
            this.priority = _data["priority"];
            this.educationSystemId = _data["educationSystemId"];
            this.classType = _data["classType"];
            this.maxStudents = _data["maxStudents"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.zoomMeetingId = _data["zoomMeetingId"];
            this.zoomPassword = _data["zoomPassword"];
            this.description = _data["description"];
            this.allowRegistration = _data["allowRegistration"];
            this.zoomHostVideo = _data["zoomHostVideo"];
            this.zoomParticipantVideo = _data["zoomParticipantVideo"];
            this.zoomJoinBeforeHost = _data["zoomJoinBeforeHost"];
            this.zoomMuteUponEntry = _data["zoomMuteUponEntry"];
            this.zoomAutoRecording = _data["zoomAutoRecording"];
            this.defaultSessionDeliveryMode = _data["defaultSessionDeliveryMode"];
            if (Array.isArray(_data["classUsers"])) {
                this.classUsers = [] as any;
                for (let item of _data["classUsers"])
                    this.classUsers!.push(ClassUserEntity.fromJS(item));
            }
            if (Array.isArray(_data["assignExams"])) {
                this.assignExams = [] as any;
                for (let item of _data["assignExams"])
                    this.assignExams!.push(AssignExamEntity.fromJS(item));
            }
            if (Array.isArray(_data["classSessions"])) {
                this.classSessions = [] as any;
                for (let item of _data["classSessions"])
                    this.classSessions!.push(ClassSessionEntity.fromJS(item));
            }
            if (Array.isArray(_data["classProducts"])) {
                this.classProducts = [] as any;
                for (let item of _data["classProducts"])
                    this.classProducts!.push(ClassProductEntity.fromJS(item));
            }
            this.countPupil = _data["countPupil"];
            this.countExercise = _data["countExercise"];
            this.countTest = _data["countTest"];
            this.countNeedMark = _data["countNeedMark"];
            this.testAverageScore = _data["testAverageScore"];
            this.studentCountTest = _data["studentCountTest"];
            this.studentCountTestDone = _data["studentCountTestDone"];
            this.currentRole = _data["currentRole"];
            this.isManager = _data["isManager"];
            this.schoolName = _data["schoolName"];
            this.subject = _data["subject"];
            this.zoomSessionCount = _data["zoomSessionCount"];
            this.courseLearningCount = _data["courseLearningCount"];
            this.courseCompletedCount = _data["courseCompletedCount"];
            this.courseCount = _data["courseCount"];
            if (Array.isArray(_data["productNames"])) {
                this.productNames = [] as any;
                for (let item of _data["productNames"])
                    this.productNames!.push(item);
            }
            if (Array.isArray(_data["teachers"])) {
                this.teachers = [] as any;
                for (let item of _data["teachers"])
                    this.teachers!.push(ClassTeacherShortDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClassListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClassListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["objectId"] = this.objectId;
        data["objectType"] = this.objectType;
        data["academicYearId"] = this.academicYearId;
        data["status"] = this.status;
        data["grade"] = this.grade;
        data["priority"] = this.priority;
        data["educationSystemId"] = this.educationSystemId;
        data["classType"] = this.classType;
        data["maxStudents"] = this.maxStudents;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["zoomMeetingId"] = this.zoomMeetingId;
        data["zoomPassword"] = this.zoomPassword;
        data["description"] = this.description;
        data["allowRegistration"] = this.allowRegistration;
        data["zoomHostVideo"] = this.zoomHostVideo;
        data["zoomParticipantVideo"] = this.zoomParticipantVideo;
        data["zoomJoinBeforeHost"] = this.zoomJoinBeforeHost;
        data["zoomMuteUponEntry"] = this.zoomMuteUponEntry;
        data["zoomAutoRecording"] = this.zoomAutoRecording;
        data["defaultSessionDeliveryMode"] = this.defaultSessionDeliveryMode;
        if (Array.isArray(this.classUsers)) {
            data["classUsers"] = [];
            for (let item of this.classUsers)
                data["classUsers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.assignExams)) {
            data["assignExams"] = [];
            for (let item of this.assignExams)
                data["assignExams"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.classSessions)) {
            data["classSessions"] = [];
            for (let item of this.classSessions)
                data["classSessions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.classProducts)) {
            data["classProducts"] = [];
            for (let item of this.classProducts)
                data["classProducts"].push(item ? item.toJSON() : undefined as any);
        }
        data["countPupil"] = this.countPupil;
        data["countExercise"] = this.countExercise;
        data["countTest"] = this.countTest;
        data["countNeedMark"] = this.countNeedMark;
        data["testAverageScore"] = this.testAverageScore;
        data["studentCountTest"] = this.studentCountTest;
        data["studentCountTestDone"] = this.studentCountTestDone;
        data["currentRole"] = this.currentRole;
        data["isManager"] = this.isManager;
        data["schoolName"] = this.schoolName;
        data["subject"] = this.subject;
        data["zoomSessionCount"] = this.zoomSessionCount;
        data["courseLearningCount"] = this.courseLearningCount;
        data["courseCompletedCount"] = this.courseCompletedCount;
        data["courseCount"] = this.courseCount;
        if (Array.isArray(this.productNames)) {
            data["productNames"] = [];
            for (let item of this.productNames)
                data["productNames"].push(item);
        }
        if (Array.isArray(this.teachers)) {
            data["teachers"] = [];
            for (let item of this.teachers)
                data["teachers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IClassListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    academicYearId?: number | undefined;
    status?: ClassStatusEnum;
    grade?: number;
    priority?: number;
    educationSystemId?: number | undefined;
    classType?: ClassTypeEnum;
    maxStudents?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    zoomMeetingId?: string | undefined;
    zoomPassword?: string | undefined;
    description?: string | undefined;
    allowRegistration?: boolean;
    zoomHostVideo?: boolean;
    zoomParticipantVideo?: boolean;
    zoomJoinBeforeHost?: boolean;
    zoomMuteUponEntry?: boolean;
    zoomAutoRecording?: string | undefined;
    defaultSessionDeliveryMode?: SessionDeliveryModeEnum;
    classUsers?: ClassUserEntity[] | undefined;
    assignExams?: AssignExamEntity[] | undefined;
    classSessions?: ClassSessionEntity[] | undefined;
    classProducts?: ClassProductEntity[] | undefined;
    countPupil?: number;
    countExercise?: number;
    countTest?: number;
    countNeedMark?: number;
    testAverageScore?: number;
    studentCountTest?: number;
    studentCountTestDone?: number;
    currentRole?: ClassUserRoleEnum;
    isManager?: boolean;
    schoolName?: string | undefined;
    subject?: string | undefined;
    zoomSessionCount?: number;
    courseLearningCount?: number;
    courseCompletedCount?: number;
    courseCount?: number;
    productNames?: string[] | undefined;
    teachers?: ClassTeacherShortDto[] | undefined;
}

export class ClassListOfSchoolDto implements IClassListOfSchoolDto {
    id?: number;
    name?: string | undefined;
    grade?: number;
    priority?: number;
    educationSystemId?: number | undefined;
    countPupil?: number;
    countTeacher?: number;
    countProduct?: number;
    countProductActive?: number;
    countProductCompleted?: number;

    constructor(data?: IClassListOfSchoolDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.grade = _data["grade"];
            this.priority = _data["priority"];
            this.educationSystemId = _data["educationSystemId"];
            this.countPupil = _data["countPupil"];
            this.countTeacher = _data["countTeacher"];
            this.countProduct = _data["countProduct"];
            this.countProductActive = _data["countProductActive"];
            this.countProductCompleted = _data["countProductCompleted"];
        }
    }

    static fromJS(data: any): ClassListOfSchoolDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClassListOfSchoolDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["grade"] = this.grade;
        data["priority"] = this.priority;
        data["educationSystemId"] = this.educationSystemId;
        data["countPupil"] = this.countPupil;
        data["countTeacher"] = this.countTeacher;
        data["countProduct"] = this.countProduct;
        data["countProductActive"] = this.countProductActive;
        data["countProductCompleted"] = this.countProductCompleted;
        return data;
    }
}

export interface IClassListOfSchoolDto {
    id?: number;
    name?: string | undefined;
    grade?: number;
    priority?: number;
    educationSystemId?: number | undefined;
    countPupil?: number;
    countTeacher?: number;
    countProduct?: number;
    countProductActive?: number;
    countProductCompleted?: number;
}

export class ClassListOfSchoolFilter implements IClassListOfSchoolFilter {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    keyword?: string | undefined;
    grade?: number | undefined;
    educationSystemId?: number | undefined;

    constructor(data?: IClassListOfSchoolFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.objectId = _data["objectId"];
            this.objectType = _data["objectType"];
            this.keyword = _data["keyword"];
            this.grade = _data["grade"];
            this.educationSystemId = _data["educationSystemId"];
        }
    }

    static fromJS(data: any): ClassListOfSchoolFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ClassListOfSchoolFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["objectId"] = this.objectId;
        data["objectType"] = this.objectType;
        data["keyword"] = this.keyword;
        data["grade"] = this.grade;
        data["educationSystemId"] = this.educationSystemId;
        return data;
    }
}

export interface IClassListOfSchoolFilter {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    keyword?: string | undefined;
    grade?: number | undefined;
    educationSystemId?: number | undefined;
}

export class ClassPupilDto implements IClassPupilDto {
    id?: number;
    name?: string | undefined;
    countExamNeedDo?: number;
    countUser?: number;

    constructor(data?: IClassPupilDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.countExamNeedDo = _data["countExamNeedDo"];
            this.countUser = _data["countUser"];
        }
    }

    static fromJS(data: any): ClassPupilDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClassPupilDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["countExamNeedDo"] = this.countExamNeedDo;
        data["countUser"] = this.countUser;
        return data;
    }
}

export interface IClassPupilDto {
    id?: number;
    name?: string | undefined;
    countExamNeedDo?: number;
    countUser?: number;
}

export class ClassPupilStatisticalDto implements IClassPupilStatisticalDto {
    userId?: number;
    avatar?: string | undefined;
    fullName?: string | undefined;
    fullNameNonAccent?: string | undefined;
    joinDate?: Date | undefined;
    percentHomeWorkDone?: number;
    countExam?: number;
    averageScoreExam?: number;
    averageScoreTest?: number;

    constructor(data?: IClassPupilStatisticalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.avatar = _data["avatar"];
            this.fullName = _data["fullName"];
            this.fullNameNonAccent = _data["fullNameNonAccent"];
            this.joinDate = _data["joinDate"] ? new Date(_data["joinDate"].toString()) : undefined as any;
            this.percentHomeWorkDone = _data["percentHomeWorkDone"];
            this.countExam = _data["countExam"];
            this.averageScoreExam = _data["averageScoreExam"];
            this.averageScoreTest = _data["averageScoreTest"];
        }
    }

    static fromJS(data: any): ClassPupilStatisticalDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClassPupilStatisticalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["avatar"] = this.avatar;
        data["fullName"] = this.fullName;
        data["fullNameNonAccent"] = this.fullNameNonAccent;
        data["joinDate"] = this.joinDate ? this.joinDate.toISOString() : undefined as any;
        data["percentHomeWorkDone"] = this.percentHomeWorkDone;
        data["countExam"] = this.countExam;
        data["averageScoreExam"] = this.averageScoreExam;
        data["averageScoreTest"] = this.averageScoreTest;
        return data;
    }
}

export interface IClassPupilStatisticalDto {
    userId?: number;
    avatar?: string | undefined;
    fullName?: string | undefined;
    fullNameNonAccent?: string | undefined;
    joinDate?: Date | undefined;
    percentHomeWorkDone?: number;
    countExam?: number;
    averageScoreExam?: number;
    averageScoreTest?: number;
}

export class ClassPupilStatisticalFilter implements IClassPupilStatisticalFilter {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    classId?: number;
    keyword?: string | undefined;
    subjectId?: number | undefined;

    constructor(data?: IClassPupilStatisticalFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.classId = _data["classId"];
            this.keyword = _data["keyword"];
            this.subjectId = _data["subjectId"];
        }
    }

    static fromJS(data: any): ClassPupilStatisticalFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ClassPupilStatisticalFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["classId"] = this.classId;
        data["keyword"] = this.keyword;
        data["subjectId"] = this.subjectId;
        return data;
    }
}

export interface IClassPupilStatisticalFilter {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    classId?: number;
    keyword?: string | undefined;
    subjectId?: number | undefined;
}

export class ClassSaveSessionDto implements IClassSaveSessionDto {
    id?: number;
    classId?: number;
    productId?: number;
    productLessonId?: number | undefined;
    sessionNumber?: number;
    sessionName?: string | undefined;
    description?: string | undefined;
    startTime?: Date;
    endTime?: Date;
    status?: SessionStatusEnum;
    deliveryMode?: SessionDeliveryModeEnum;
    zoomMeetingId?: string | undefined;
    zoomJoinLink?: string | undefined;
    zoomStartLink?: string | undefined;
    zoomPassword?: string | undefined;
    notes?: string | undefined;

    constructor(data?: IClassSaveSessionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.classId = _data["classId"];
            this.productId = _data["productId"];
            this.productLessonId = _data["productLessonId"];
            this.sessionNumber = _data["sessionNumber"];
            this.sessionName = _data["sessionName"];
            this.description = _data["description"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
            this.status = _data["status"];
            this.deliveryMode = _data["deliveryMode"];
            this.zoomMeetingId = _data["zoomMeetingId"];
            this.zoomJoinLink = _data["zoomJoinLink"];
            this.zoomStartLink = _data["zoomStartLink"];
            this.zoomPassword = _data["zoomPassword"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): ClassSaveSessionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClassSaveSessionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["classId"] = this.classId;
        data["productId"] = this.productId;
        data["productLessonId"] = this.productLessonId;
        data["sessionNumber"] = this.sessionNumber;
        data["sessionName"] = this.sessionName;
        data["description"] = this.description;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        data["status"] = this.status;
        data["deliveryMode"] = this.deliveryMode;
        data["zoomMeetingId"] = this.zoomMeetingId;
        data["zoomJoinLink"] = this.zoomJoinLink;
        data["zoomStartLink"] = this.zoomStartLink;
        data["zoomPassword"] = this.zoomPassword;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IClassSaveSessionDto {
    id?: number;
    classId?: number;
    productId?: number;
    productLessonId?: number | undefined;
    sessionNumber?: number;
    sessionName?: string | undefined;
    description?: string | undefined;
    startTime?: Date;
    endTime?: Date;
    status?: SessionStatusEnum;
    deliveryMode?: SessionDeliveryModeEnum;
    zoomMeetingId?: string | undefined;
    zoomJoinLink?: string | undefined;
    zoomStartLink?: string | undefined;
    zoomPassword?: string | undefined;
    notes?: string | undefined;
}

export class ClassSessionDto implements IClassSessionDto {
    id?: number;
    sessionNumber?: number;
    sessionName?: string | undefined;
    startTime?: Date;
    endTime?: Date;
    status?: SessionStatusEnum;
    zoomJoinLink?: string | undefined;
    productLessonId?: number | undefined;
    productId?: number;
    deliveryMode?: SessionDeliveryModeEnum;

    constructor(data?: IClassSessionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sessionNumber = _data["sessionNumber"];
            this.sessionName = _data["sessionName"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
            this.status = _data["status"];
            this.zoomJoinLink = _data["zoomJoinLink"];
            this.productLessonId = _data["productLessonId"];
            this.productId = _data["productId"];
            this.deliveryMode = _data["deliveryMode"];
        }
    }

    static fromJS(data: any): ClassSessionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClassSessionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sessionNumber"] = this.sessionNumber;
        data["sessionName"] = this.sessionName;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        data["status"] = this.status;
        data["zoomJoinLink"] = this.zoomJoinLink;
        data["productLessonId"] = this.productLessonId;
        data["productId"] = this.productId;
        data["deliveryMode"] = this.deliveryMode;
        return data;
    }
}

export interface IClassSessionDto {
    id?: number;
    sessionNumber?: number;
    sessionName?: string | undefined;
    startTime?: Date;
    endTime?: Date;
    status?: SessionStatusEnum;
    zoomJoinLink?: string | undefined;
    productLessonId?: number | undefined;
    productId?: number;
    deliveryMode?: SessionDeliveryModeEnum;
}

export class ClassSessionInfoDto implements IClassSessionInfoDto {
    id?: number;
    sessionNumber?: number;
    sessionName?: string | undefined;
    description?: string | undefined;
    startTime?: Date;
    endTime?: Date;
    zoomMeetingId?: string | undefined;
    zoomWebinarId?: string | undefined;
    zoomJoinLink?: string | undefined;
    deliveryMode?: SessionDeliveryModeEnum;
    recordingUrl?: string | undefined;
    actualDurationMinutes?: number | undefined;
    status?: SessionStatusEnum;
    notes?: string | undefined;
    zoomStartLink?: string | undefined;
    zoomAccountId?: number | undefined;

    constructor(data?: IClassSessionInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sessionNumber = _data["sessionNumber"];
            this.sessionName = _data["sessionName"];
            this.description = _data["description"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
            this.zoomMeetingId = _data["zoomMeetingId"];
            this.zoomWebinarId = _data["zoomWebinarId"];
            this.zoomJoinLink = _data["zoomJoinLink"];
            this.deliveryMode = _data["deliveryMode"];
            this.recordingUrl = _data["recordingUrl"];
            this.actualDurationMinutes = _data["actualDurationMinutes"];
            this.status = _data["status"];
            this.notes = _data["notes"];
            this.zoomStartLink = _data["zoomStartLink"];
            this.zoomAccountId = _data["zoomAccountId"];
        }
    }

    static fromJS(data: any): ClassSessionInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClassSessionInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sessionNumber"] = this.sessionNumber;
        data["sessionName"] = this.sessionName;
        data["description"] = this.description;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        data["zoomMeetingId"] = this.zoomMeetingId;
        data["zoomWebinarId"] = this.zoomWebinarId;
        data["zoomJoinLink"] = this.zoomJoinLink;
        data["deliveryMode"] = this.deliveryMode;
        data["recordingUrl"] = this.recordingUrl;
        data["actualDurationMinutes"] = this.actualDurationMinutes;
        data["status"] = this.status;
        data["notes"] = this.notes;
        data["zoomStartLink"] = this.zoomStartLink;
        data["zoomAccountId"] = this.zoomAccountId;
        return data;
    }
}

export interface IClassSessionInfoDto {
    id?: number;
    sessionNumber?: number;
    sessionName?: string | undefined;
    description?: string | undefined;
    startTime?: Date;
    endTime?: Date;
    zoomMeetingId?: string | undefined;
    zoomWebinarId?: string | undefined;
    zoomJoinLink?: string | undefined;
    deliveryMode?: SessionDeliveryModeEnum;
    recordingUrl?: string | undefined;
    actualDurationMinutes?: number | undefined;
    status?: SessionStatusEnum;
    notes?: string | undefined;
    zoomStartLink?: string | undefined;
    zoomAccountId?: number | undefined;
}

export class ClassShortDto implements IClassShortDto {
    id?: number;
    name?: string | undefined;
    grade?: string | undefined;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    classUsers?: ClassUserShortDto[] | undefined;

    constructor(data?: IClassShortDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.grade = _data["grade"];
            this.objectId = _data["objectId"];
            this.objectType = _data["objectType"];
            if (Array.isArray(_data["classUsers"])) {
                this.classUsers = [] as any;
                for (let item of _data["classUsers"])
                    this.classUsers!.push(ClassUserShortDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClassShortDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClassShortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["grade"] = this.grade;
        data["objectId"] = this.objectId;
        data["objectType"] = this.objectType;
        if (Array.isArray(this.classUsers)) {
            data["classUsers"] = [];
            for (let item of this.classUsers)
                data["classUsers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IClassShortDto {
    id?: number;
    name?: string | undefined;
    grade?: string | undefined;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    classUsers?: ClassUserShortDto[] | undefined;
}

export class ClassStatisticalDto implements IClassStatisticalDto {
    waitingGrading?: number;
    countTeacher?: number;
    countPupil?: number;
    countExam?: number;

    constructor(data?: IClassStatisticalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.waitingGrading = _data["waitingGrading"];
            this.countTeacher = _data["countTeacher"];
            this.countPupil = _data["countPupil"];
            this.countExam = _data["countExam"];
        }
    }

    static fromJS(data: any): ClassStatisticalDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClassStatisticalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["waitingGrading"] = this.waitingGrading;
        data["countTeacher"] = this.countTeacher;
        data["countPupil"] = this.countPupil;
        data["countExam"] = this.countExam;
        return data;
    }
}

export interface IClassStatisticalDto {
    waitingGrading?: number;
    countTeacher?: number;
    countPupil?: number;
    countExam?: number;
}

export class ClassTeacherShortDto implements IClassTeacherShortDto {
    userId?: number;
    fullName?: string | undefined;
    avatar?: string | undefined;
    isManager?: boolean;

    constructor(data?: IClassTeacherShortDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.fullName = _data["fullName"];
            this.avatar = _data["avatar"];
            this.isManager = _data["isManager"];
        }
    }

    static fromJS(data: any): ClassTeacherShortDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClassTeacherShortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["fullName"] = this.fullName;
        data["avatar"] = this.avatar;
        data["isManager"] = this.isManager;
        return data;
    }
}

export interface IClassTeacherShortDto {
    userId?: number;
    fullName?: string | undefined;
    avatar?: string | undefined;
    isManager?: boolean;
}

export class ClassUserShortDto implements IClassUserShortDto {
    id?: number;
    fullName?: string | undefined;
    avatar?: string | undefined;

    constructor(data?: IClassUserShortDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.avatar = _data["avatar"];
        }
    }

    static fromJS(data: any): ClassUserShortDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClassUserShortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["avatar"] = this.avatar;
        return data;
    }
}

export interface IClassUserShortDto {
    id?: number;
    fullName?: string | undefined;
    avatar?: string | undefined;
}

export class ConsultationRegistrationGetListQuery implements IConsultationRegistrationGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    status?: ConsultationStatusEnum;
    planType?: string | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;

    constructor(data?: IConsultationRegistrationGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.keyword = _data["keyword"];
            this.status = _data["status"];
            this.planType = _data["planType"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ConsultationRegistrationGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationRegistrationGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["keyword"] = this.keyword;
        data["status"] = this.status;
        data["planType"] = this.planType;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IConsultationRegistrationGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    status?: ConsultationStatusEnum;
    planType?: string | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
}

export class ConsultationRegistrationListDto implements IConsultationRegistrationListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    message?: string | undefined;
    planType?: string | undefined;
    productId?: number | undefined;
    status?: ConsultationStatusEnum;
    adminNote?: string | undefined;
    contactedDate?: Date | undefined;
    contactedBy?: number | undefined;
    productName?: string | undefined;
    contactedByName?: string | undefined;

    constructor(data?: IConsultationRegistrationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.message = _data["message"];
            this.planType = _data["planType"];
            this.productId = _data["productId"];
            this.status = _data["status"];
            this.adminNote = _data["adminNote"];
            this.contactedDate = _data["contactedDate"] ? new Date(_data["contactedDate"].toString()) : undefined as any;
            this.contactedBy = _data["contactedBy"];
            this.productName = _data["productName"];
            this.contactedByName = _data["contactedByName"];
        }
    }

    static fromJS(data: any): ConsultationRegistrationListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationRegistrationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["message"] = this.message;
        data["planType"] = this.planType;
        data["productId"] = this.productId;
        data["status"] = this.status;
        data["adminNote"] = this.adminNote;
        data["contactedDate"] = this.contactedDate ? this.contactedDate.toISOString() : undefined as any;
        data["contactedBy"] = this.contactedBy;
        data["productName"] = this.productName;
        data["contactedByName"] = this.contactedByName;
        return data;
    }
}

export interface IConsultationRegistrationListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    message?: string | undefined;
    planType?: string | undefined;
    productId?: number | undefined;
    status?: ConsultationStatusEnum;
    adminNote?: string | undefined;
    contactedDate?: Date | undefined;
    contactedBy?: number | undefined;
    productName?: string | undefined;
    contactedByName?: string | undefined;
}

export class ConsultationRegistrationSaveDto implements IConsultationRegistrationSaveDto {
    name?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    message?: string | undefined;
    planType?: string | undefined;
    productId?: number | undefined;

    constructor(data?: IConsultationRegistrationSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.message = _data["message"];
            this.planType = _data["planType"];
            this.productId = _data["productId"];
        }
    }

    static fromJS(data: any): ConsultationRegistrationSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationRegistrationSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["message"] = this.message;
        data["planType"] = this.planType;
        data["productId"] = this.productId;
        return data;
    }
}

export interface IConsultationRegistrationSaveDto {
    name?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    message?: string | undefined;
    planType?: string | undefined;
    productId?: number | undefined;
}

export class ContactGetListQuery implements IContactGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    status?: ContactStatusEnum;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;

    constructor(data?: IContactGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.keyword = _data["keyword"];
            this.status = _data["status"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ContactGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ContactGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["keyword"] = this.keyword;
        data["status"] = this.status;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IContactGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    status?: ContactStatusEnum;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
}

export class ContactListDto implements IContactListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    fullName?: string | undefined;
    phone?: string | undefined;
    message?: string | undefined;
    status?: ContactStatusEnum;
    adminNote?: string | undefined;
    contactedDate?: Date | undefined;
    contactedBy?: number | undefined;
    contactedByName?: string | undefined;

    constructor(data?: IContactListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.fullName = _data["fullName"];
            this.phone = _data["phone"];
            this.message = _data["message"];
            this.status = _data["status"];
            this.adminNote = _data["adminNote"];
            this.contactedDate = _data["contactedDate"] ? new Date(_data["contactedDate"].toString()) : undefined as any;
            this.contactedBy = _data["contactedBy"];
            this.contactedByName = _data["contactedByName"];
        }
    }

    static fromJS(data: any): ContactListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["fullName"] = this.fullName;
        data["phone"] = this.phone;
        data["message"] = this.message;
        data["status"] = this.status;
        data["adminNote"] = this.adminNote;
        data["contactedDate"] = this.contactedDate ? this.contactedDate.toISOString() : undefined as any;
        data["contactedBy"] = this.contactedBy;
        data["contactedByName"] = this.contactedByName;
        return data;
    }
}

export interface IContactListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    fullName?: string | undefined;
    phone?: string | undefined;
    message?: string | undefined;
    status?: ContactStatusEnum;
    adminNote?: string | undefined;
    contactedDate?: Date | undefined;
    contactedBy?: number | undefined;
    contactedByName?: string | undefined;
}

export class ContactSaveDto implements IContactSaveDto {
    fullName?: string | undefined;
    phone?: string | undefined;
    message?: string | undefined;

    constructor(data?: IContactSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.phone = _data["phone"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ContactSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["phone"] = this.phone;
        data["message"] = this.message;
        return data;
    }
}

export interface IContactSaveDto {
    fullName?: string | undefined;
    phone?: string | undefined;
    message?: string | undefined;
}

export class CreateChatGroupDto implements ICreateChatGroupDto {
    userIds?: number[] | undefined;
    name?: string | undefined;
    type?: number;
    documentId?: number | undefined;

    constructor(data?: ICreateChatGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            this.name = _data["name"];
            this.type = _data["type"];
            this.documentId = _data["documentId"];
        }
    }

    static fromJS(data: any): CreateChatGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateChatGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["name"] = this.name;
        data["type"] = this.type;
        data["documentId"] = this.documentId;
        return data;
    }
}

export interface ICreateChatGroupDto {
    userIds?: number[] | undefined;
    name?: string | undefined;
    type?: number;
    documentId?: number | undefined;
}

export class DailyStudyTimeDto implements IDailyStudyTimeDto {
    date?: Date;
    totalMinutes?: number;

    constructor(data?: IDailyStudyTimeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.totalMinutes = _data["totalMinutes"];
        }
    }

    static fromJS(data: any): DailyStudyTimeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DailyStudyTimeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["totalMinutes"] = this.totalMinutes;
        return data;
    }
}

export interface IDailyStudyTimeDto {
    date?: Date;
    totalMinutes?: number;
}

export class DashBoardClassStatisticalDto implements IDashBoardClassStatisticalDto {
    id?: number;
    name?: string | undefined;
    totalStudent?: number;
    totalExamNeedMark?: number;

    constructor(data?: IDashBoardClassStatisticalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.totalStudent = _data["totalStudent"];
            this.totalExamNeedMark = _data["totalExamNeedMark"];
        }
    }

    static fromJS(data: any): DashBoardClassStatisticalDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashBoardClassStatisticalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["totalStudent"] = this.totalStudent;
        data["totalExamNeedMark"] = this.totalExamNeedMark;
        return data;
    }
}

export interface IDashBoardClassStatisticalDto {
    id?: number;
    name?: string | undefined;
    totalStudent?: number;
    totalExamNeedMark?: number;
}

export class DashBoardExamListDto implements IDashBoardExamListDto {
    id?: number;
    title?: string | undefined;
    status?: ExamStatusEnum;
    createdDate?: Date;

    constructor(data?: IDashBoardExamListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): DashBoardExamListDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashBoardExamListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["status"] = this.status;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IDashBoardExamListDto {
    id?: number;
    title?: string | undefined;
    status?: ExamStatusEnum;
    createdDate?: Date;
}

export class DashBoardPupilListDto implements IDashBoardPupilListDto {
    userId?: number;
    avatar?: string | undefined;
    fullName?: string | undefined;
    countExam?: number;
    countExamDone?: number;
    classId?: number;
    className?: string | undefined;
    percentDone?: number;

    constructor(data?: IDashBoardPupilListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.avatar = _data["avatar"];
            this.fullName = _data["fullName"];
            this.countExam = _data["countExam"];
            this.countExamDone = _data["countExamDone"];
            this.classId = _data["classId"];
            this.className = _data["className"];
            this.percentDone = _data["percentDone"];
        }
    }

    static fromJS(data: any): DashBoardPupilListDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashBoardPupilListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["avatar"] = this.avatar;
        data["fullName"] = this.fullName;
        data["countExam"] = this.countExam;
        data["countExamDone"] = this.countExamDone;
        data["classId"] = this.classId;
        data["className"] = this.className;
        data["percentDone"] = this.percentDone;
        return data;
    }
}

export interface IDashBoardPupilListDto {
    userId?: number;
    avatar?: string | undefined;
    fullName?: string | undefined;
    countExam?: number;
    countExamDone?: number;
    classId?: number;
    className?: string | undefined;
    percentDone?: number;
}

export class DashBoardQuestionListDto implements IDashBoardQuestionListDto {
    id?: number;
    type?: string | undefined;
    classLevel?: number;
    subjectId?: number;
    level?: QuestionLevelEnum;

    constructor(data?: IDashBoardQuestionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.classLevel = _data["classLevel"];
            this.subjectId = _data["subjectId"];
            this.level = _data["level"];
        }
    }

    static fromJS(data: any): DashBoardQuestionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashBoardQuestionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["classLevel"] = this.classLevel;
        data["subjectId"] = this.subjectId;
        data["level"] = this.level;
        return data;
    }
}

export interface IDashBoardQuestionListDto {
    id?: number;
    type?: string | undefined;
    classLevel?: number;
    subjectId?: number;
    level?: QuestionLevelEnum;
}

export class EssaySuggestionMarkDto implements IEssaySuggestionMarkDto {
    categoryId?: number;
    grade?: number;
    result?: string | undefined;
    content?: string | undefined;
    mark?: number;
    images?: string[] | undefined;

    constructor(data?: IEssaySuggestionMarkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"];
            this.grade = _data["grade"];
            this.result = _data["result"];
            this.content = _data["content"];
            this.mark = _data["mark"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(item);
            }
        }
    }

    static fromJS(data: any): EssaySuggestionMarkDto {
        data = typeof data === 'object' ? data : {};
        let result = new EssaySuggestionMarkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["grade"] = this.grade;
        data["result"] = this.result;
        data["content"] = this.content;
        data["mark"] = this.mark;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item);
        }
        return data;
    }
}

export interface IEssaySuggestionMarkDto {
    categoryId?: number;
    grade?: number;
    result?: string | undefined;
    content?: string | undefined;
    mark?: number;
    images?: string[] | undefined;
}

export class ExamDataBeforeDeleteDto implements IExamDataBeforeDeleteDto {
    countPupil?: number;
    countPupilDone?: number;

    constructor(data?: IExamDataBeforeDeleteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countPupil = _data["countPupil"];
            this.countPupilDone = _data["countPupilDone"];
        }
    }

    static fromJS(data: any): ExamDataBeforeDeleteDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExamDataBeforeDeleteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countPupil"] = this.countPupil;
        data["countPupilDone"] = this.countPupilDone;
        return data;
    }
}

export interface IExamDataBeforeDeleteDto {
    countPupil?: number;
    countPupilDone?: number;
}

export class ExamDataDto implements IExamDataDto {
    parts?: ExamPartDto[] | undefined;

    constructor(data?: IExamDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["parts"])) {
                this.parts = [] as any;
                for (let item of _data["parts"])
                    this.parts!.push(ExamPartDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExamDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExamDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.parts)) {
            data["parts"] = [];
            for (let item of this.parts)
                data["parts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IExamDataDto {
    parts?: ExamPartDto[] | undefined;
}

export class ExamDataSaveDto implements IExamDataSaveDto {
    parts?: ExamPartSaveDto[] | undefined;

    constructor(data?: IExamDataSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["parts"])) {
                this.parts = [] as any;
                for (let item of _data["parts"])
                    this.parts!.push(ExamPartSaveDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExamDataSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExamDataSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.parts)) {
            data["parts"] = [];
            for (let item of this.parts)
                data["parts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IExamDataSaveDto {
    parts?: ExamPartSaveDto[] | undefined;
}

export class ExamDto implements IExamDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    title?: string | undefined;
    avatar?: string | undefined;
    duration?: number;
    type?: ExamTypeEnum;
    status?: ExamStatusEnum;
    totalMark?: number;
    totalQuestion?: number;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    classLevel?: number;
    subjectId?: number;
    format?: ExamFormatEnum;
    fileUrl?: string | undefined;
    data?: ExamDataDto;
    categoryId?: number;
    isSystem?: boolean;
    shareStatus?: ShareStatusEnum;
    sharedAt?: Date | undefined;
    isHidden?: boolean;
    isAutoScoring?: boolean;
    fileChoiceType?: ExamFileChoiceTypeEnum;
    questions?: ExamQuestionEntity[] | undefined;
    assignExams?: AssignExamEntity[] | undefined;
    tagIds?: number[] | undefined;
    tags?: TagDto[] | undefined;
    canEdit?: boolean;

    constructor(data?: IExamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.title = _data["title"];
            this.avatar = _data["avatar"];
            this.duration = _data["duration"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.totalMark = _data["totalMark"];
            this.totalQuestion = _data["totalQuestion"];
            this.objectId = _data["objectId"];
            this.objectType = _data["objectType"];
            this.classLevel = _data["classLevel"];
            this.subjectId = _data["subjectId"];
            this.format = _data["format"];
            this.fileUrl = _data["fileUrl"];
            this.data = _data["data"] ? ExamDataDto.fromJS(_data["data"]) : undefined as any;
            this.categoryId = _data["categoryId"];
            this.isSystem = _data["isSystem"];
            this.shareStatus = _data["shareStatus"];
            this.sharedAt = _data["sharedAt"] ? new Date(_data["sharedAt"].toString()) : undefined as any;
            this.isHidden = _data["isHidden"];
            this.isAutoScoring = _data["isAutoScoring"];
            this.fileChoiceType = _data["fileChoiceType"];
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(ExamQuestionEntity.fromJS(item));
            }
            if (Array.isArray(_data["assignExams"])) {
                this.assignExams = [] as any;
                for (let item of _data["assignExams"])
                    this.assignExams!.push(AssignExamEntity.fromJS(item));
            }
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
            this.canEdit = _data["canEdit"];
        }
    }

    static fromJS(data: any): ExamDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["title"] = this.title;
        data["avatar"] = this.avatar;
        data["duration"] = this.duration;
        data["type"] = this.type;
        data["status"] = this.status;
        data["totalMark"] = this.totalMark;
        data["totalQuestion"] = this.totalQuestion;
        data["objectId"] = this.objectId;
        data["objectType"] = this.objectType;
        data["classLevel"] = this.classLevel;
        data["subjectId"] = this.subjectId;
        data["format"] = this.format;
        data["fileUrl"] = this.fileUrl;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["categoryId"] = this.categoryId;
        data["isSystem"] = this.isSystem;
        data["shareStatus"] = this.shareStatus;
        data["sharedAt"] = this.sharedAt ? this.sharedAt.toISOString() : undefined as any;
        data["isHidden"] = this.isHidden;
        data["isAutoScoring"] = this.isAutoScoring;
        data["fileChoiceType"] = this.fileChoiceType;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.assignExams)) {
            data["assignExams"] = [];
            for (let item of this.assignExams)
                data["assignExams"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : undefined as any);
        }
        data["canEdit"] = this.canEdit;
        return data;
    }
}

export interface IExamDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    title?: string | undefined;
    avatar?: string | undefined;
    duration?: number;
    type?: ExamTypeEnum;
    status?: ExamStatusEnum;
    totalMark?: number;
    totalQuestion?: number;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    classLevel?: number;
    subjectId?: number;
    format?: ExamFormatEnum;
    fileUrl?: string | undefined;
    data?: ExamDataDto;
    categoryId?: number;
    isSystem?: boolean;
    shareStatus?: ShareStatusEnum;
    sharedAt?: Date | undefined;
    isHidden?: boolean;
    isAutoScoring?: boolean;
    fileChoiceType?: ExamFileChoiceTypeEnum;
    questions?: ExamQuestionEntity[] | undefined;
    assignExams?: AssignExamEntity[] | undefined;
    tagIds?: number[] | undefined;
    tags?: TagDto[] | undefined;
    canEdit?: boolean;
}

export class ExamFileSaveDto implements IExamFileSaveDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    title?: string | undefined;
    avatar?: string | undefined;
    duration?: number;
    type?: ExamTypeEnum;
    status?: ExamStatusEnum;
    totalMark?: number;
    totalQuestion?: number;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    classLevel?: number;
    subjectId?: number;
    format?: ExamFormatEnum;
    fileUrl?: string | undefined;
    data?: string | undefined;
    categoryId?: number;
    isSystem?: boolean;
    shareStatus?: ShareStatusEnum;
    sharedAt?: Date | undefined;
    isHidden?: boolean;
    isAutoScoring?: boolean;
    fileChoiceType?: ExamFileChoiceTypeEnum;
    questions?: QuestionDto[] | undefined;
    assignExams?: AssignExamEntity[] | undefined;

    constructor(data?: IExamFileSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.title = _data["title"];
            this.avatar = _data["avatar"];
            this.duration = _data["duration"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.totalMark = _data["totalMark"];
            this.totalQuestion = _data["totalQuestion"];
            this.objectId = _data["objectId"];
            this.objectType = _data["objectType"];
            this.classLevel = _data["classLevel"];
            this.subjectId = _data["subjectId"];
            this.format = _data["format"];
            this.fileUrl = _data["fileUrl"];
            this.data = _data["data"];
            this.categoryId = _data["categoryId"];
            this.isSystem = _data["isSystem"];
            this.shareStatus = _data["shareStatus"];
            this.sharedAt = _data["sharedAt"] ? new Date(_data["sharedAt"].toString()) : undefined as any;
            this.isHidden = _data["isHidden"];
            this.isAutoScoring = _data["isAutoScoring"];
            this.fileChoiceType = _data["fileChoiceType"];
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(QuestionDto.fromJS(item));
            }
            if (Array.isArray(_data["assignExams"])) {
                this.assignExams = [] as any;
                for (let item of _data["assignExams"])
                    this.assignExams!.push(AssignExamEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExamFileSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExamFileSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["title"] = this.title;
        data["avatar"] = this.avatar;
        data["duration"] = this.duration;
        data["type"] = this.type;
        data["status"] = this.status;
        data["totalMark"] = this.totalMark;
        data["totalQuestion"] = this.totalQuestion;
        data["objectId"] = this.objectId;
        data["objectType"] = this.objectType;
        data["classLevel"] = this.classLevel;
        data["subjectId"] = this.subjectId;
        data["format"] = this.format;
        data["fileUrl"] = this.fileUrl;
        data["data"] = this.data;
        data["categoryId"] = this.categoryId;
        data["isSystem"] = this.isSystem;
        data["shareStatus"] = this.shareStatus;
        data["sharedAt"] = this.sharedAt ? this.sharedAt.toISOString() : undefined as any;
        data["isHidden"] = this.isHidden;
        data["isAutoScoring"] = this.isAutoScoring;
        data["fileChoiceType"] = this.fileChoiceType;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.assignExams)) {
            data["assignExams"] = [];
            for (let item of this.assignExams)
                data["assignExams"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IExamFileSaveDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    title?: string | undefined;
    avatar?: string | undefined;
    duration?: number;
    type?: ExamTypeEnum;
    status?: ExamStatusEnum;
    totalMark?: number;
    totalQuestion?: number;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    classLevel?: number;
    subjectId?: number;
    format?: ExamFormatEnum;
    fileUrl?: string | undefined;
    data?: string | undefined;
    categoryId?: number;
    isSystem?: boolean;
    shareStatus?: ShareStatusEnum;
    sharedAt?: Date | undefined;
    isHidden?: boolean;
    isAutoScoring?: boolean;
    fileChoiceType?: ExamFileChoiceTypeEnum;
    questions?: QuestionDto[] | undefined;
    assignExams?: AssignExamEntity[] | undefined;
}

export class ExamLearnDto implements IExamLearnDto {
    id?: number;
    title?: string | undefined;
    avatar?: string | undefined;
    duration?: number;
    type?: ExamTypeEnum;
    status?: ExamStatusEnum;
    totalMark?: number;
    totalQuestion?: number;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    classLevel?: number;
    subjectId?: number;
    format?: ExamFormatEnum;
    fileUrl?: string | undefined;
    categoryId?: number;
    fileChoiceType?: ExamFileChoiceTypeEnum;
    data?: ExamDataDto;

    constructor(data?: IExamLearnDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.avatar = _data["avatar"];
            this.duration = _data["duration"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.totalMark = _data["totalMark"];
            this.totalQuestion = _data["totalQuestion"];
            this.objectId = _data["objectId"];
            this.objectType = _data["objectType"];
            this.classLevel = _data["classLevel"];
            this.subjectId = _data["subjectId"];
            this.format = _data["format"];
            this.fileUrl = _data["fileUrl"];
            this.categoryId = _data["categoryId"];
            this.fileChoiceType = _data["fileChoiceType"];
            this.data = _data["data"] ? ExamDataDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ExamLearnDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExamLearnDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["avatar"] = this.avatar;
        data["duration"] = this.duration;
        data["type"] = this.type;
        data["status"] = this.status;
        data["totalMark"] = this.totalMark;
        data["totalQuestion"] = this.totalQuestion;
        data["objectId"] = this.objectId;
        data["objectType"] = this.objectType;
        data["classLevel"] = this.classLevel;
        data["subjectId"] = this.subjectId;
        data["format"] = this.format;
        data["fileUrl"] = this.fileUrl;
        data["categoryId"] = this.categoryId;
        data["fileChoiceType"] = this.fileChoiceType;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IExamLearnDto {
    id?: number;
    title?: string | undefined;
    avatar?: string | undefined;
    duration?: number;
    type?: ExamTypeEnum;
    status?: ExamStatusEnum;
    totalMark?: number;
    totalQuestion?: number;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    classLevel?: number;
    subjectId?: number;
    format?: ExamFormatEnum;
    fileUrl?: string | undefined;
    categoryId?: number;
    fileChoiceType?: ExamFileChoiceTypeEnum;
    data?: ExamDataDto;
}

export class ExamListDto implements IExamListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    title!: string | undefined;
    duration?: number;
    avatar?: string | undefined;
    type?: ExamTypeEnum;
    status?: ExamStatusEnum;
    totalMark?: number;
    totalQuestion?: number;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    classLevel?: number;
    subjectId?: number;
    format?: ExamFormatEnum;
    fileUrl?: string | undefined;
    categoryId?: number;
    isLike?: boolean;
    isSystem?: boolean;
    shareStatus?: ShareStatusEnum;
    sharedAt?: Date | undefined;
    isHidden?: boolean;
    canEdit?: boolean;
    isAutoScoring?: boolean;
    tags?: TagDto[] | undefined;
    assignExamCount?: number;

    constructor(data?: IExamListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.title = _data["title"];
            this.duration = _data["duration"];
            this.avatar = _data["avatar"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.totalMark = _data["totalMark"];
            this.totalQuestion = _data["totalQuestion"];
            this.objectId = _data["objectId"];
            this.objectType = _data["objectType"];
            this.classLevel = _data["classLevel"];
            this.subjectId = _data["subjectId"];
            this.format = _data["format"];
            this.fileUrl = _data["fileUrl"];
            this.categoryId = _data["categoryId"];
            this.isLike = _data["isLike"];
            this.isSystem = _data["isSystem"];
            this.shareStatus = _data["shareStatus"];
            this.sharedAt = _data["sharedAt"] ? new Date(_data["sharedAt"].toString()) : undefined as any;
            this.isHidden = _data["isHidden"];
            this.canEdit = _data["canEdit"];
            this.isAutoScoring = _data["isAutoScoring"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
            this.assignExamCount = _data["assignExamCount"];
        }
    }

    static fromJS(data: any): ExamListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExamListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["title"] = this.title;
        data["duration"] = this.duration;
        data["avatar"] = this.avatar;
        data["type"] = this.type;
        data["status"] = this.status;
        data["totalMark"] = this.totalMark;
        data["totalQuestion"] = this.totalQuestion;
        data["objectId"] = this.objectId;
        data["objectType"] = this.objectType;
        data["classLevel"] = this.classLevel;
        data["subjectId"] = this.subjectId;
        data["format"] = this.format;
        data["fileUrl"] = this.fileUrl;
        data["categoryId"] = this.categoryId;
        data["isLike"] = this.isLike;
        data["isSystem"] = this.isSystem;
        data["shareStatus"] = this.shareStatus;
        data["sharedAt"] = this.sharedAt ? this.sharedAt.toISOString() : undefined as any;
        data["isHidden"] = this.isHidden;
        data["canEdit"] = this.canEdit;
        data["isAutoScoring"] = this.isAutoScoring;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : undefined as any);
        }
        data["assignExamCount"] = this.assignExamCount;
        return data;
    }
}

export interface IExamListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    title: string | undefined;
    duration?: number;
    avatar?: string | undefined;
    type?: ExamTypeEnum;
    status?: ExamStatusEnum;
    totalMark?: number;
    totalQuestion?: number;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    classLevel?: number;
    subjectId?: number;
    format?: ExamFormatEnum;
    fileUrl?: string | undefined;
    categoryId?: number;
    isLike?: boolean;
    isSystem?: boolean;
    shareStatus?: ShareStatusEnum;
    sharedAt?: Date | undefined;
    isHidden?: boolean;
    canEdit?: boolean;
    isAutoScoring?: boolean;
    tags?: TagDto[] | undefined;
    assignExamCount?: number;
}

export class ExamPartDto implements IExamPartDto {
    id?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    partTime?: number;
    totalMark?: number;
    numberOfQuestion?: number;
    questions?: QuestionDto[] | undefined;

    constructor(data?: IExamPartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.partTime = _data["partTime"];
            this.totalMark = _data["totalMark"];
            this.numberOfQuestion = _data["numberOfQuestion"];
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(QuestionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExamPartDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExamPartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["partTime"] = this.partTime;
        data["totalMark"] = this.totalMark;
        data["numberOfQuestion"] = this.numberOfQuestion;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IExamPartDto {
    id?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    partTime?: number;
    totalMark?: number;
    numberOfQuestion?: number;
    questions?: QuestionDto[] | undefined;
}

export class ExamPartQuestionSaveDto implements IExamPartQuestionSaveDto {
    id?: number;
    mark?: number;
    parentId?: number;

    constructor(data?: IExamPartQuestionSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mark = _data["mark"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): ExamPartQuestionSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExamPartQuestionSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mark"] = this.mark;
        data["parentId"] = this.parentId;
        return data;
    }
}

export interface IExamPartQuestionSaveDto {
    id?: number;
    mark?: number;
    parentId?: number;
}

export class ExamPartSaveDto implements IExamPartSaveDto {
    id?: string | undefined;
    title?: string | undefined;
    partTime?: number;
    totalMark?: number;
    description?: string | undefined;
    numberOfQuestion?: number;
    questions?: ExamPartQuestionSaveDto[] | undefined;

    constructor(data?: IExamPartSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.partTime = _data["partTime"];
            this.totalMark = _data["totalMark"];
            this.description = _data["description"];
            this.numberOfQuestion = _data["numberOfQuestion"];
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(ExamPartQuestionSaveDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExamPartSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExamPartSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["partTime"] = this.partTime;
        data["totalMark"] = this.totalMark;
        data["description"] = this.description;
        data["numberOfQuestion"] = this.numberOfQuestion;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IExamPartSaveDto {
    id?: string | undefined;
    title?: string | undefined;
    partTime?: number;
    totalMark?: number;
    description?: string | undefined;
    numberOfQuestion?: number;
    questions?: ExamPartQuestionSaveDto[] | undefined;
}

export class ExamResultDto implements IExamResultDto {
    userId?: number;
    avatar?: string | undefined;
    fullName?: string | undefined;
    totalExam?: number;
    totalExamDone?: number;
    countTest?: number;
    countTestDone?: number;
    averageScoreTest?: number;

    constructor(data?: IExamResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.avatar = _data["avatar"];
            this.fullName = _data["fullName"];
            this.totalExam = _data["totalExam"];
            this.totalExamDone = _data["totalExamDone"];
            this.countTest = _data["countTest"];
            this.countTestDone = _data["countTestDone"];
            this.averageScoreTest = _data["averageScoreTest"];
        }
    }

    static fromJS(data: any): ExamResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExamResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["avatar"] = this.avatar;
        data["fullName"] = this.fullName;
        data["totalExam"] = this.totalExam;
        data["totalExamDone"] = this.totalExamDone;
        data["countTest"] = this.countTest;
        data["countTestDone"] = this.countTestDone;
        data["averageScoreTest"] = this.averageScoreTest;
        return data;
    }
}

export interface IExamResultDto {
    userId?: number;
    avatar?: string | undefined;
    fullName?: string | undefined;
    totalExam?: number;
    totalExamDone?: number;
    countTest?: number;
    countTestDone?: number;
    averageScoreTest?: number;
}

export class ExamResultFilterDto implements IExamResultFilterDto {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    classId?: number;

    constructor(data?: IExamResultFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.keyword = _data["keyword"];
            this.classId = _data["classId"];
        }
    }

    static fromJS(data: any): ExamResultFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExamResultFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["keyword"] = this.keyword;
        data["classId"] = this.classId;
        return data;
    }
}

export interface IExamResultFilterDto {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    classId?: number;
}

export class ExamSaveDto implements IExamSaveDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    title?: string | undefined;
    avatar?: string | undefined;
    duration?: number;
    type?: ExamTypeEnum;
    status?: ExamStatusEnum;
    totalMark?: number;
    totalQuestion?: number;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    classLevel?: number;
    subjectId?: number;
    format?: ExamFormatEnum;
    fileUrl?: string | undefined;
    data?: ExamDataSaveDto;
    categoryId?: number;
    isSystem?: boolean;
    shareStatus?: ShareStatusEnum;
    sharedAt?: Date | undefined;
    isHidden?: boolean;
    isAutoScoring?: boolean;
    fileChoiceType?: ExamFileChoiceTypeEnum;
    questions?: ExamQuestionEntity[] | undefined;
    assignExams?: AssignExamEntity[] | undefined;
    tagIds?: number[] | undefined;

    constructor(data?: IExamSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.title = _data["title"];
            this.avatar = _data["avatar"];
            this.duration = _data["duration"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.totalMark = _data["totalMark"];
            this.totalQuestion = _data["totalQuestion"];
            this.objectId = _data["objectId"];
            this.objectType = _data["objectType"];
            this.classLevel = _data["classLevel"];
            this.subjectId = _data["subjectId"];
            this.format = _data["format"];
            this.fileUrl = _data["fileUrl"];
            this.data = _data["data"] ? ExamDataSaveDto.fromJS(_data["data"]) : undefined as any;
            this.categoryId = _data["categoryId"];
            this.isSystem = _data["isSystem"];
            this.shareStatus = _data["shareStatus"];
            this.sharedAt = _data["sharedAt"] ? new Date(_data["sharedAt"].toString()) : undefined as any;
            this.isHidden = _data["isHidden"];
            this.isAutoScoring = _data["isAutoScoring"];
            this.fileChoiceType = _data["fileChoiceType"];
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(ExamQuestionEntity.fromJS(item));
            }
            if (Array.isArray(_data["assignExams"])) {
                this.assignExams = [] as any;
                for (let item of _data["assignExams"])
                    this.assignExams!.push(AssignExamEntity.fromJS(item));
            }
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ExamSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExamSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["title"] = this.title;
        data["avatar"] = this.avatar;
        data["duration"] = this.duration;
        data["type"] = this.type;
        data["status"] = this.status;
        data["totalMark"] = this.totalMark;
        data["totalQuestion"] = this.totalQuestion;
        data["objectId"] = this.objectId;
        data["objectType"] = this.objectType;
        data["classLevel"] = this.classLevel;
        data["subjectId"] = this.subjectId;
        data["format"] = this.format;
        data["fileUrl"] = this.fileUrl;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["categoryId"] = this.categoryId;
        data["isSystem"] = this.isSystem;
        data["shareStatus"] = this.shareStatus;
        data["sharedAt"] = this.sharedAt ? this.sharedAt.toISOString() : undefined as any;
        data["isHidden"] = this.isHidden;
        data["isAutoScoring"] = this.isAutoScoring;
        data["fileChoiceType"] = this.fileChoiceType;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.assignExams)) {
            data["assignExams"] = [];
            for (let item of this.assignExams)
                data["assignExams"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        return data;
    }
}

export interface IExamSaveDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    title?: string | undefined;
    avatar?: string | undefined;
    duration?: number;
    type?: ExamTypeEnum;
    status?: ExamStatusEnum;
    totalMark?: number;
    totalQuestion?: number;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    classLevel?: number;
    subjectId?: number;
    format?: ExamFormatEnum;
    fileUrl?: string | undefined;
    data?: ExamDataSaveDto;
    categoryId?: number;
    isSystem?: boolean;
    shareStatus?: ShareStatusEnum;
    sharedAt?: Date | undefined;
    isHidden?: boolean;
    isAutoScoring?: boolean;
    fileChoiceType?: ExamFileChoiceTypeEnum;
    questions?: ExamQuestionEntity[] | undefined;
    assignExams?: AssignExamEntity[] | undefined;
    tagIds?: number[] | undefined;
}

export class GalleryGetListQuery implements IGalleryGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    categoryId?: number | undefined;
    categoryUrl?: string | undefined;
    status?: CommonStatusEnum;

    constructor(data?: IGalleryGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.keyword = _data["keyword"];
            this.categoryId = _data["categoryId"];
            this.categoryUrl = _data["categoryUrl"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): GalleryGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GalleryGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["keyword"] = this.keyword;
        data["categoryId"] = this.categoryId;
        data["categoryUrl"] = this.categoryUrl;
        data["status"] = this.status;
        return data;
    }
}

export interface IGalleryGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    categoryId?: number | undefined;
    categoryUrl?: string | undefined;
    status?: CommonStatusEnum;
}

export class GalleryListDto implements IGalleryListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    description?: string | undefined;
    media?: string | undefined;
    categoryId?: number | undefined;
    status?: CommonStatusEnum;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaKeywords?: string | undefined;
    slug?: string | undefined;
    tagIds?: number[] | undefined;

    constructor(data?: IGalleryListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.media = _data["media"];
            this.categoryId = _data["categoryId"];
            this.status = _data["status"];
            this.metaTitle = _data["metaTitle"];
            this.metaDescription = _data["metaDescription"];
            this.metaKeywords = _data["metaKeywords"];
            this.slug = _data["slug"];
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GalleryListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GalleryListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["description"] = this.description;
        data["media"] = this.media;
        data["categoryId"] = this.categoryId;
        data["status"] = this.status;
        data["metaTitle"] = this.metaTitle;
        data["metaDescription"] = this.metaDescription;
        data["metaKeywords"] = this.metaKeywords;
        data["slug"] = this.slug;
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        return data;
    }
}

export interface IGalleryListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    description?: string | undefined;
    media?: string | undefined;
    categoryId?: number | undefined;
    status?: CommonStatusEnum;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaKeywords?: string | undefined;
    slug?: string | undefined;
    tagIds?: number[] | undefined;
}

export class GallerySaveDto implements IGallerySaveDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    description?: string | undefined;
    media?: string | undefined;
    categoryId?: number | undefined;
    status?: CommonStatusEnum;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaKeywords?: string | undefined;
    slug?: string | undefined;
    tagIds?: number[] | undefined;

    constructor(data?: IGallerySaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.media = _data["media"];
            this.categoryId = _data["categoryId"];
            this.status = _data["status"];
            this.metaTitle = _data["metaTitle"];
            this.metaDescription = _data["metaDescription"];
            this.metaKeywords = _data["metaKeywords"];
            this.slug = _data["slug"];
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GallerySaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new GallerySaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["description"] = this.description;
        data["media"] = this.media;
        data["categoryId"] = this.categoryId;
        data["status"] = this.status;
        data["metaTitle"] = this.metaTitle;
        data["metaDescription"] = this.metaDescription;
        data["metaKeywords"] = this.metaKeywords;
        data["slug"] = this.slug;
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        return data;
    }
}

export interface IGallerySaveDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    description?: string | undefined;
    media?: string | undefined;
    categoryId?: number | undefined;
    status?: CommonStatusEnum;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaKeywords?: string | undefined;
    slug?: string | undefined;
    tagIds?: number[] | undefined;
}

export class LanguageGetListQuery implements ILanguageGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: ILanguageGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.keyword = _data["keyword"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): LanguageGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["keyword"] = this.keyword;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ILanguageGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    isActive?: boolean | undefined;
}

export class LanguageListDto implements ILanguageListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    code?: string | undefined;
    name?: string | undefined;
    nativeName?: string | undefined;
    isDefault?: boolean;
    isActive?: boolean;
    sortOrder?: number;
    flagIcon?: string | undefined;

    constructor(data?: ILanguageListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.nativeName = _data["nativeName"];
            this.isDefault = _data["isDefault"];
            this.isActive = _data["isActive"];
            this.sortOrder = _data["sortOrder"];
            this.flagIcon = _data["flagIcon"];
        }
    }

    static fromJS(data: any): LanguageListDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["code"] = this.code;
        data["name"] = this.name;
        data["nativeName"] = this.nativeName;
        data["isDefault"] = this.isDefault;
        data["isActive"] = this.isActive;
        data["sortOrder"] = this.sortOrder;
        data["flagIcon"] = this.flagIcon;
        return data;
    }
}

export interface ILanguageListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    code?: string | undefined;
    name?: string | undefined;
    nativeName?: string | undefined;
    isDefault?: boolean;
    isActive?: boolean;
    sortOrder?: number;
    flagIcon?: string | undefined;
}

export class LanguageSaveDto implements ILanguageSaveDto {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    nativeName?: string | undefined;
    isDefault?: boolean;
    isActive?: boolean;
    sortOrder?: number;
    flagIcon?: string | undefined;

    constructor(data?: ILanguageSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.nativeName = _data["nativeName"];
            this.isDefault = _data["isDefault"];
            this.isActive = _data["isActive"];
            this.sortOrder = _data["sortOrder"];
            this.flagIcon = _data["flagIcon"];
        }
    }

    static fromJS(data: any): LanguageSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["nativeName"] = this.nativeName;
        data["isDefault"] = this.isDefault;
        data["isActive"] = this.isActive;
        data["sortOrder"] = this.sortOrder;
        data["flagIcon"] = this.flagIcon;
        return data;
    }
}

export interface ILanguageSaveDto {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    nativeName?: string | undefined;
    isDefault?: boolean;
    isActive?: boolean;
    sortOrder?: number;
    flagIcon?: string | undefined;
}

export class LeaderboardItemDto implements ILeaderboardItemDto {
    rank?: number;
    userId?: number;
    userFullName?: string | undefined;
    avatar?: string | undefined;
    points?: number;

    constructor(data?: ILeaderboardItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rank = _data["rank"];
            this.userId = _data["userId"];
            this.userFullName = _data["userFullName"];
            this.avatar = _data["avatar"];
            this.points = _data["points"];
        }
    }

    static fromJS(data: any): LeaderboardItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeaderboardItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rank"] = this.rank;
        data["userId"] = this.userId;
        data["userFullName"] = this.userFullName;
        data["avatar"] = this.avatar;
        data["points"] = this.points;
        return data;
    }
}

export interface ILeaderboardItemDto {
    rank?: number;
    userId?: number;
    userFullName?: string | undefined;
    avatar?: string | undefined;
    points?: number;
}

export class ListActivityLogDto implements IListActivityLogDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    title?: string | undefined;
    data?: string | undefined;
    objectType?: string | undefined;
    ip?: string | undefined;
    createdName?: string | undefined;
    createdAvatar?: string | undefined;

    constructor(data?: IListActivityLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.title = _data["title"];
            this.data = _data["data"];
            this.objectType = _data["objectType"];
            this.ip = _data["ip"];
            this.createdName = _data["createdName"];
            this.createdAvatar = _data["createdAvatar"];
        }
    }

    static fromJS(data: any): ListActivityLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListActivityLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["title"] = this.title;
        data["data"] = this.data;
        data["objectType"] = this.objectType;
        data["ip"] = this.ip;
        data["createdName"] = this.createdName;
        data["createdAvatar"] = this.createdAvatar;
        return data;
    }
}

export interface IListActivityLogDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    title?: string | undefined;
    data?: string | undefined;
    objectType?: string | undefined;
    ip?: string | undefined;
    createdName?: string | undefined;
    createdAvatar?: string | undefined;
}

export class ListChatGroupDto implements IListChatGroupDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    avatar?: string | undefined;
    status?: number | undefined;
    type?: number | undefined;
    documentId?: number | undefined;
    lastMessage?: string | undefined;
    lastMessageDate?: Date | undefined;
    isOnline?: boolean;
    lastMessageType?: number;
    friendId?: number | undefined;
    lastMessageId?: number | undefined;
    lastMessageIsRead?: boolean | undefined;

    constructor(data?: IListChatGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.avatar = _data["avatar"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.documentId = _data["documentId"];
            this.lastMessage = _data["lastMessage"];
            this.lastMessageDate = _data["lastMessageDate"] ? new Date(_data["lastMessageDate"].toString()) : undefined as any;
            this.isOnline = _data["isOnline"];
            this.lastMessageType = _data["lastMessageType"];
            this.friendId = _data["friendId"];
            this.lastMessageId = _data["lastMessageId"];
            this.lastMessageIsRead = _data["lastMessageIsRead"];
        }
    }

    static fromJS(data: any): ListChatGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListChatGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["avatar"] = this.avatar;
        data["status"] = this.status;
        data["type"] = this.type;
        data["documentId"] = this.documentId;
        data["lastMessage"] = this.lastMessage;
        data["lastMessageDate"] = this.lastMessageDate ? this.lastMessageDate.toISOString() : undefined as any;
        data["isOnline"] = this.isOnline;
        data["lastMessageType"] = this.lastMessageType;
        data["friendId"] = this.friendId;
        data["lastMessageId"] = this.lastMessageId;
        data["lastMessageIsRead"] = this.lastMessageIsRead;
        return data;
    }
}

export interface IListChatGroupDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    avatar?: string | undefined;
    status?: number | undefined;
    type?: number | undefined;
    documentId?: number | undefined;
    lastMessage?: string | undefined;
    lastMessageDate?: Date | undefined;
    isOnline?: boolean;
    lastMessageType?: number;
    friendId?: number | undefined;
    lastMessageId?: number | undefined;
    lastMessageIsRead?: boolean | undefined;
}

export class ListChatMessageByGroupDto implements IListChatMessageByGroupDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    senderId?: number;
    chatGroupId?: number;
    content?: string | undefined;
    type?: number;
    senderName?: string | undefined;
    senderAvatar?: string | undefined;
    chatGroupName?: string | undefined;
    chatGroupAvatar?: string | undefined;
    listFilePath?: string[] | undefined;
    isOnline?: boolean;
    chatGroupType?: number;
    isRead?: boolean | undefined;

    constructor(data?: IListChatMessageByGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.senderId = _data["senderId"];
            this.chatGroupId = _data["chatGroupId"];
            this.content = _data["content"];
            this.type = _data["type"];
            this.senderName = _data["senderName"];
            this.senderAvatar = _data["senderAvatar"];
            this.chatGroupName = _data["chatGroupName"];
            this.chatGroupAvatar = _data["chatGroupAvatar"];
            if (Array.isArray(_data["listFilePath"])) {
                this.listFilePath = [] as any;
                for (let item of _data["listFilePath"])
                    this.listFilePath!.push(item);
            }
            this.isOnline = _data["isOnline"];
            this.chatGroupType = _data["chatGroupType"];
            this.isRead = _data["isRead"];
        }
    }

    static fromJS(data: any): ListChatMessageByGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListChatMessageByGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["senderId"] = this.senderId;
        data["chatGroupId"] = this.chatGroupId;
        data["content"] = this.content;
        data["type"] = this.type;
        data["senderName"] = this.senderName;
        data["senderAvatar"] = this.senderAvatar;
        data["chatGroupName"] = this.chatGroupName;
        data["chatGroupAvatar"] = this.chatGroupAvatar;
        if (Array.isArray(this.listFilePath)) {
            data["listFilePath"] = [];
            for (let item of this.listFilePath)
                data["listFilePath"].push(item);
        }
        data["isOnline"] = this.isOnline;
        data["chatGroupType"] = this.chatGroupType;
        data["isRead"] = this.isRead;
        return data;
    }
}

export interface IListChatMessageByGroupDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    senderId?: number;
    chatGroupId?: number;
    content?: string | undefined;
    type?: number;
    senderName?: string | undefined;
    senderAvatar?: string | undefined;
    chatGroupName?: string | undefined;
    chatGroupAvatar?: string | undefined;
    listFilePath?: string[] | undefined;
    isOnline?: boolean;
    chatGroupType?: number;
    isRead?: boolean | undefined;
}

export class LoginHistoryListItemDto implements ILoginHistoryListItemDto {
    id?: number;
    userDeviceId?: number | undefined;
    ip?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    loginTime?: Date;
    loginResult?: LoginResultEnum;
    userAgent?: string | undefined;

    constructor(data?: ILoginHistoryListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userDeviceId = _data["userDeviceId"];
            this.ip = _data["ip"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.loginTime = _data["loginTime"] ? new Date(_data["loginTime"].toString()) : undefined as any;
            this.loginResult = _data["loginResult"];
            this.userAgent = _data["userAgent"];
        }
    }

    static fromJS(data: any): LoginHistoryListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoginHistoryListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userDeviceId"] = this.userDeviceId;
        data["ip"] = this.ip;
        data["city"] = this.city;
        data["country"] = this.country;
        data["loginTime"] = this.loginTime ? this.loginTime.toISOString() : undefined as any;
        data["loginResult"] = this.loginResult;
        data["userAgent"] = this.userAgent;
        return data;
    }
}

export interface ILoginHistoryListItemDto {
    id?: number;
    userDeviceId?: number | undefined;
    ip?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    loginTime?: Date;
    loginResult?: LoginResultEnum;
    userAgent?: string | undefined;
}

export class ModuleDefinitionDto implements IModuleDefinitionDto {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    application?: ApplicationEnum;
    isZone?: boolean;
    groupName?: string | undefined;
    sortOrder?: number;
    isActive?: boolean;
    permissions?: ModulePermissionDefinitionDto[] | undefined;

    constructor(data?: IModuleDefinitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.application = _data["application"];
            this.isZone = _data["isZone"];
            this.groupName = _data["groupName"];
            this.sortOrder = _data["sortOrder"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(ModulePermissionDefinitionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ModuleDefinitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["application"] = this.application;
        data["isZone"] = this.isZone;
        data["groupName"] = this.groupName;
        data["sortOrder"] = this.sortOrder;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IModuleDefinitionDto {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    application?: ApplicationEnum;
    isZone?: boolean;
    groupName?: string | undefined;
    sortOrder?: number;
    isActive?: boolean;
    permissions?: ModulePermissionDefinitionDto[] | undefined;
}

export class ModuleDefinitionSaveDto implements IModuleDefinitionSaveDto {
    id?: number;
    name?: string | undefined;
    groupName?: string | undefined;
    sortOrder?: number;
    isActive?: boolean;
    permissions?: ModulePermissionDefinitionSaveDto[] | undefined;

    constructor(data?: IModuleDefinitionSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.groupName = _data["groupName"];
            this.sortOrder = _data["sortOrder"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(ModulePermissionDefinitionSaveDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ModuleDefinitionSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleDefinitionSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["groupName"] = this.groupName;
        data["sortOrder"] = this.sortOrder;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IModuleDefinitionSaveDto {
    id?: number;
    name?: string | undefined;
    groupName?: string | undefined;
    sortOrder?: number;
    isActive?: boolean;
    permissions?: ModulePermissionDefinitionSaveDto[] | undefined;
}

export class ModulePermissionDefinitionDto implements IModulePermissionDefinitionDto {
    id?: number;
    value?: number;
    code?: string | undefined;
    label?: string | undefined;
    description?: string | undefined;
    sortOrder?: number;
    isActive?: boolean;

    constructor(data?: IModulePermissionDefinitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.code = _data["code"];
            this.label = _data["label"];
            this.description = _data["description"];
            this.sortOrder = _data["sortOrder"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ModulePermissionDefinitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModulePermissionDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["code"] = this.code;
        data["label"] = this.label;
        data["description"] = this.description;
        data["sortOrder"] = this.sortOrder;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IModulePermissionDefinitionDto {
    id?: number;
    value?: number;
    code?: string | undefined;
    label?: string | undefined;
    description?: string | undefined;
    sortOrder?: number;
    isActive?: boolean;
}

export class ModulePermissionDefinitionSaveDto implements IModulePermissionDefinitionSaveDto {
    id?: number;
    code?: string | undefined;
    value?: number;
    label?: string | undefined;
    description?: string | undefined;
    sortOrder?: number;
    isActive?: boolean;

    constructor(data?: IModulePermissionDefinitionSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.value = _data["value"];
            this.label = _data["label"];
            this.description = _data["description"];
            this.sortOrder = _data["sortOrder"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ModulePermissionDefinitionSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModulePermissionDefinitionSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["value"] = this.value;
        data["label"] = this.label;
        data["description"] = this.description;
        data["sortOrder"] = this.sortOrder;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IModulePermissionDefinitionSaveDto {
    id?: number;
    code?: string | undefined;
    value?: number;
    label?: string | undefined;
    description?: string | undefined;
    sortOrder?: number;
    isActive?: boolean;
}

export class NewsDetailDto implements INewsDetailDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    title?: string | undefined;
    summary?: string | undefined;
    content?: string | undefined;
    image?: string | undefined;
    author?: string | undefined;
    publishedDate?: Date | undefined;
    viewCount?: number;
    status?: CommonStatusEnum;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaKeywords?: string | undefined;
    slug?: string | undefined;
    categoryId?: number | undefined;
    isFeatured?: boolean;
    relatedNewsIds?: number[] | undefined;
    tagIds?: number[] | undefined;
    tags?: TagDto[] | undefined;
    relatedNews?: NewsListDto[] | undefined;
    category?: any | undefined;

    constructor(data?: INewsDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.title = _data["title"];
            this.summary = _data["summary"];
            this.content = _data["content"];
            this.image = _data["image"];
            this.author = _data["author"];
            this.publishedDate = _data["publishedDate"] ? new Date(_data["publishedDate"].toString()) : undefined as any;
            this.viewCount = _data["viewCount"];
            this.status = _data["status"];
            this.metaTitle = _data["metaTitle"];
            this.metaDescription = _data["metaDescription"];
            this.metaKeywords = _data["metaKeywords"];
            this.slug = _data["slug"];
            this.categoryId = _data["categoryId"];
            this.isFeatured = _data["isFeatured"];
            if (Array.isArray(_data["relatedNewsIds"])) {
                this.relatedNewsIds = [] as any;
                for (let item of _data["relatedNewsIds"])
                    this.relatedNewsIds!.push(item);
            }
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
            if (Array.isArray(_data["relatedNews"])) {
                this.relatedNews = [] as any;
                for (let item of _data["relatedNews"])
                    this.relatedNews!.push(NewsListDto.fromJS(item));
            }
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): NewsDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewsDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["title"] = this.title;
        data["summary"] = this.summary;
        data["content"] = this.content;
        data["image"] = this.image;
        data["author"] = this.author;
        data["publishedDate"] = this.publishedDate ? this.publishedDate.toISOString() : undefined as any;
        data["viewCount"] = this.viewCount;
        data["status"] = this.status;
        data["metaTitle"] = this.metaTitle;
        data["metaDescription"] = this.metaDescription;
        data["metaKeywords"] = this.metaKeywords;
        data["slug"] = this.slug;
        data["categoryId"] = this.categoryId;
        data["isFeatured"] = this.isFeatured;
        if (Array.isArray(this.relatedNewsIds)) {
            data["relatedNewsIds"] = [];
            for (let item of this.relatedNewsIds)
                data["relatedNewsIds"].push(item);
        }
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.relatedNews)) {
            data["relatedNews"] = [];
            for (let item of this.relatedNews)
                data["relatedNews"].push(item ? item.toJSON() : undefined as any);
        }
        data["category"] = this.category;
        return data;
    }
}

export interface INewsDetailDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    title?: string | undefined;
    summary?: string | undefined;
    content?: string | undefined;
    image?: string | undefined;
    author?: string | undefined;
    publishedDate?: Date | undefined;
    viewCount?: number;
    status?: CommonStatusEnum;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaKeywords?: string | undefined;
    slug?: string | undefined;
    categoryId?: number | undefined;
    isFeatured?: boolean;
    relatedNewsIds?: number[] | undefined;
    tagIds?: number[] | undefined;
    tags?: TagDto[] | undefined;
    relatedNews?: NewsListDto[] | undefined;
    category?: any | undefined;
}

export class NewsGetListQuery implements INewsGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    categoryId?: number | undefined;
    categoryUrl?: string | undefined;
    tagId?: number | undefined;
    status?: CommonStatusEnum;
    isFeatured?: boolean | undefined;
    excludeIds?: number[] | undefined;
    includeIds?: number[] | undefined;

    constructor(data?: INewsGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.keyword = _data["keyword"];
            this.categoryId = _data["categoryId"];
            this.categoryUrl = _data["categoryUrl"];
            this.tagId = _data["tagId"];
            this.status = _data["status"];
            this.isFeatured = _data["isFeatured"];
            if (Array.isArray(_data["excludeIds"])) {
                this.excludeIds = [] as any;
                for (let item of _data["excludeIds"])
                    this.excludeIds!.push(item);
            }
            if (Array.isArray(_data["includeIds"])) {
                this.includeIds = [] as any;
                for (let item of _data["includeIds"])
                    this.includeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): NewsGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new NewsGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["keyword"] = this.keyword;
        data["categoryId"] = this.categoryId;
        data["categoryUrl"] = this.categoryUrl;
        data["tagId"] = this.tagId;
        data["status"] = this.status;
        data["isFeatured"] = this.isFeatured;
        if (Array.isArray(this.excludeIds)) {
            data["excludeIds"] = [];
            for (let item of this.excludeIds)
                data["excludeIds"].push(item);
        }
        if (Array.isArray(this.includeIds)) {
            data["includeIds"] = [];
            for (let item of this.includeIds)
                data["includeIds"].push(item);
        }
        return data;
    }
}

export interface INewsGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    categoryId?: number | undefined;
    categoryUrl?: string | undefined;
    tagId?: number | undefined;
    status?: CommonStatusEnum;
    isFeatured?: boolean | undefined;
    excludeIds?: number[] | undefined;
    includeIds?: number[] | undefined;
}

export class NewsListDto implements INewsListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    title?: string | undefined;
    summary?: string | undefined;
    content?: string | undefined;
    image?: string | undefined;
    author?: string | undefined;
    publishedDate?: Date | undefined;
    viewCount?: number;
    status?: CommonStatusEnum;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaKeywords?: string | undefined;
    slug?: string | undefined;
    categoryId?: number | undefined;
    isFeatured?: boolean;
    relatedNewsIds?: number[] | undefined;
    tagIds?: number[] | undefined;

    constructor(data?: INewsListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.title = _data["title"];
            this.summary = _data["summary"];
            this.content = _data["content"];
            this.image = _data["image"];
            this.author = _data["author"];
            this.publishedDate = _data["publishedDate"] ? new Date(_data["publishedDate"].toString()) : undefined as any;
            this.viewCount = _data["viewCount"];
            this.status = _data["status"];
            this.metaTitle = _data["metaTitle"];
            this.metaDescription = _data["metaDescription"];
            this.metaKeywords = _data["metaKeywords"];
            this.slug = _data["slug"];
            this.categoryId = _data["categoryId"];
            this.isFeatured = _data["isFeatured"];
            if (Array.isArray(_data["relatedNewsIds"])) {
                this.relatedNewsIds = [] as any;
                for (let item of _data["relatedNewsIds"])
                    this.relatedNewsIds!.push(item);
            }
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
        }
    }

    static fromJS(data: any): NewsListDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewsListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["title"] = this.title;
        data["summary"] = this.summary;
        data["content"] = this.content;
        data["image"] = this.image;
        data["author"] = this.author;
        data["publishedDate"] = this.publishedDate ? this.publishedDate.toISOString() : undefined as any;
        data["viewCount"] = this.viewCount;
        data["status"] = this.status;
        data["metaTitle"] = this.metaTitle;
        data["metaDescription"] = this.metaDescription;
        data["metaKeywords"] = this.metaKeywords;
        data["slug"] = this.slug;
        data["categoryId"] = this.categoryId;
        data["isFeatured"] = this.isFeatured;
        if (Array.isArray(this.relatedNewsIds)) {
            data["relatedNewsIds"] = [];
            for (let item of this.relatedNewsIds)
                data["relatedNewsIds"].push(item);
        }
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        return data;
    }
}

export interface INewsListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    title?: string | undefined;
    summary?: string | undefined;
    content?: string | undefined;
    image?: string | undefined;
    author?: string | undefined;
    publishedDate?: Date | undefined;
    viewCount?: number;
    status?: CommonStatusEnum;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaKeywords?: string | undefined;
    slug?: string | undefined;
    categoryId?: number | undefined;
    isFeatured?: boolean;
    relatedNewsIds?: number[] | undefined;
    tagIds?: number[] | undefined;
}

export class NewsSaveDto implements INewsSaveDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    title?: string | undefined;
    summary?: string | undefined;
    content?: string | undefined;
    image?: string | undefined;
    author?: string | undefined;
    publishedDate?: Date | undefined;
    viewCount?: number;
    status?: CommonStatusEnum;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaKeywords?: string | undefined;
    slug?: string | undefined;
    categoryId?: number | undefined;
    isFeatured?: boolean;
    relatedNewsIds?: number[] | undefined;
    tagIds?: number[] | undefined;

    constructor(data?: INewsSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.title = _data["title"];
            this.summary = _data["summary"];
            this.content = _data["content"];
            this.image = _data["image"];
            this.author = _data["author"];
            this.publishedDate = _data["publishedDate"] ? new Date(_data["publishedDate"].toString()) : undefined as any;
            this.viewCount = _data["viewCount"];
            this.status = _data["status"];
            this.metaTitle = _data["metaTitle"];
            this.metaDescription = _data["metaDescription"];
            this.metaKeywords = _data["metaKeywords"];
            this.slug = _data["slug"];
            this.categoryId = _data["categoryId"];
            this.isFeatured = _data["isFeatured"];
            if (Array.isArray(_data["relatedNewsIds"])) {
                this.relatedNewsIds = [] as any;
                for (let item of _data["relatedNewsIds"])
                    this.relatedNewsIds!.push(item);
            }
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
        }
    }

    static fromJS(data: any): NewsSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewsSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["title"] = this.title;
        data["summary"] = this.summary;
        data["content"] = this.content;
        data["image"] = this.image;
        data["author"] = this.author;
        data["publishedDate"] = this.publishedDate ? this.publishedDate.toISOString() : undefined as any;
        data["viewCount"] = this.viewCount;
        data["status"] = this.status;
        data["metaTitle"] = this.metaTitle;
        data["metaDescription"] = this.metaDescription;
        data["metaKeywords"] = this.metaKeywords;
        data["slug"] = this.slug;
        data["categoryId"] = this.categoryId;
        data["isFeatured"] = this.isFeatured;
        if (Array.isArray(this.relatedNewsIds)) {
            data["relatedNewsIds"] = [];
            for (let item of this.relatedNewsIds)
                data["relatedNewsIds"].push(item);
        }
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        return data;
    }
}

export interface INewsSaveDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    title?: string | undefined;
    summary?: string | undefined;
    content?: string | undefined;
    image?: string | undefined;
    author?: string | undefined;
    publishedDate?: Date | undefined;
    viewCount?: number;
    status?: CommonStatusEnum;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaKeywords?: string | undefined;
    slug?: string | undefined;
    categoryId?: number | undefined;
    isFeatured?: boolean;
    relatedNewsIds?: number[] | undefined;
    tagIds?: number[] | undefined;
}

export class NotificationDto implements INotificationDto {
    id?: number;
    title?: string | undefined;
    content?: string | undefined;
    type?: string | undefined;
    createdDate?: Date;
    isRead?: boolean;
    url?: string | undefined;

    constructor(data?: INotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.content = _data["content"];
            this.type = _data["type"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.isRead = _data["isRead"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): NotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["content"] = this.content;
        data["type"] = this.type;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["isRead"] = this.isRead;
        data["url"] = this.url;
        return data;
    }
}

export interface INotificationDto {
    id?: number;
    title?: string | undefined;
    content?: string | undefined;
    type?: string | undefined;
    createdDate?: Date;
    isRead?: boolean;
    url?: string | undefined;
}

export class OfficeDto implements IOfficeDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    code?: string | undefined;
    name?: string | undefined;
    nameViVN?: string | undefined;
    nameEnUS?: string | undefined;
    nameZhCN?: string | undefined;
    fullName?: string | undefined;
    otherName?: string | undefined;
    url?: string | undefined;
    unitType?: string | undefined;
    parentId?: number;
    priority?: number;
    type?: LocalityTypeEnum;
    status?: LocalityStatusEnum;
    parentName?: string | undefined;
    schoolCount?: number;
    schoolActiveCount?: number;

    constructor(data?: IOfficeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.nameViVN = _data["nameViVN"];
            this.nameEnUS = _data["nameEnUS"];
            this.nameZhCN = _data["nameZhCN"];
            this.fullName = _data["fullName"];
            this.otherName = _data["otherName"];
            this.url = _data["url"];
            this.unitType = _data["unitType"];
            this.parentId = _data["parentId"];
            this.priority = _data["priority"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.parentName = _data["parentName"];
            this.schoolCount = _data["schoolCount"];
            this.schoolActiveCount = _data["schoolActiveCount"];
        }
    }

    static fromJS(data: any): OfficeDto {
        data = typeof data === 'object' ? data : {};
        let result = new OfficeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["code"] = this.code;
        data["name"] = this.name;
        data["nameViVN"] = this.nameViVN;
        data["nameEnUS"] = this.nameEnUS;
        data["nameZhCN"] = this.nameZhCN;
        data["fullName"] = this.fullName;
        data["otherName"] = this.otherName;
        data["url"] = this.url;
        data["unitType"] = this.unitType;
        data["parentId"] = this.parentId;
        data["priority"] = this.priority;
        data["type"] = this.type;
        data["status"] = this.status;
        data["parentName"] = this.parentName;
        data["schoolCount"] = this.schoolCount;
        data["schoolActiveCount"] = this.schoolActiveCount;
        return data;
    }
}

export interface IOfficeDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    code?: string | undefined;
    name?: string | undefined;
    nameViVN?: string | undefined;
    nameEnUS?: string | undefined;
    nameZhCN?: string | undefined;
    fullName?: string | undefined;
    otherName?: string | undefined;
    url?: string | undefined;
    unitType?: string | undefined;
    parentId?: number;
    priority?: number;
    type?: LocalityTypeEnum;
    status?: LocalityStatusEnum;
    parentName?: string | undefined;
    schoolCount?: number;
    schoolActiveCount?: number;
}

export class OrderCreateDto implements IOrderCreateDto {
    fullName?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    notes?: string | undefined;
    purchaseTarget?: OrderPurchaseTargetEnum;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;

    constructor(data?: IOrderCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.phone = _data["phone"];
            this.address = _data["address"];
            this.notes = _data["notes"];
            this.purchaseTarget = _data["purchaseTarget"];
            this.objectType = _data["objectType"];
            this.objectId = _data["objectId"];
        }
    }

    static fromJS(data: any): OrderCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["phone"] = this.phone;
        data["address"] = this.address;
        data["notes"] = this.notes;
        data["purchaseTarget"] = this.purchaseTarget;
        data["objectType"] = this.objectType;
        data["objectId"] = this.objectId;
        return data;
    }
}

export interface IOrderCreateDto {
    fullName?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    notes?: string | undefined;
    purchaseTarget?: OrderPurchaseTargetEnum;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
}

export class OrderDto implements IOrderDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    userId?: number;
    fullName?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    notes?: string | undefined;
    totalAmount?: number;
    paidDate?: Date | undefined;
    paymentLog?: string | undefined;
    status?: OrderStatusEnum;
    purchaseTarget?: OrderPurchaseTargetEnum;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    items?: OrderItemDto[] | undefined;

    constructor(data?: IOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.userId = _data["userId"];
            this.fullName = _data["fullName"];
            this.phone = _data["phone"];
            this.address = _data["address"];
            this.notes = _data["notes"];
            this.totalAmount = _data["totalAmount"];
            this.paidDate = _data["paidDate"] ? new Date(_data["paidDate"].toString()) : undefined as any;
            this.paymentLog = _data["paymentLog"];
            this.status = _data["status"];
            this.purchaseTarget = _data["purchaseTarget"];
            this.objectType = _data["objectType"];
            this.objectId = _data["objectId"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrderItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["userId"] = this.userId;
        data["fullName"] = this.fullName;
        data["phone"] = this.phone;
        data["address"] = this.address;
        data["notes"] = this.notes;
        data["totalAmount"] = this.totalAmount;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : undefined as any;
        data["paymentLog"] = this.paymentLog;
        data["status"] = this.status;
        data["purchaseTarget"] = this.purchaseTarget;
        data["objectType"] = this.objectType;
        data["objectId"] = this.objectId;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOrderDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    userId?: number;
    fullName?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    notes?: string | undefined;
    totalAmount?: number;
    paidDate?: Date | undefined;
    paymentLog?: string | undefined;
    status?: OrderStatusEnum;
    purchaseTarget?: OrderPurchaseTargetEnum;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    items?: OrderItemDto[] | undefined;
}

export class OrderGetListQuery implements IOrderGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    userId?: number | undefined;
    status?: OrderStatusEnum;

    constructor(data?: IOrderGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.userId = _data["userId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): OrderGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new OrderGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["userId"] = this.userId;
        data["status"] = this.status;
        return data;
    }
}

export interface IOrderGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    userId?: number | undefined;
    status?: OrderStatusEnum;
}

export class OrderItemDto implements IOrderItemDto {
    id?: number;
    orderId?: number;
    productId?: number;
    quantity?: number;
    unitPrice?: number;
    salePrice?: number | undefined;
    totalPrice?: number;
    product?: ProductListDto;

    constructor(data?: IOrderItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.productId = _data["productId"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.salePrice = _data["salePrice"];
            this.totalPrice = _data["totalPrice"];
            this.product = _data["product"] ? ProductListDto.fromJS(_data["product"]) : undefined as any;
        }
    }

    static fromJS(data: any): OrderItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["productId"] = this.productId;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["salePrice"] = this.salePrice;
        data["totalPrice"] = this.totalPrice;
        data["product"] = this.product ? this.product.toJSON() : undefined as any;
        return data;
    }
}

export interface IOrderItemDto {
    id?: number;
    orderId?: number;
    productId?: number;
    quantity?: number;
    unitPrice?: number;
    salePrice?: number | undefined;
    totalPrice?: number;
    product?: ProductListDto;
}

export class OrderPaymentDto implements IOrderPaymentDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    userId?: number;
    fullName?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    notes?: string | undefined;
    totalAmount?: number;
    paidDate?: Date | undefined;
    paymentLog?: string | undefined;
    status?: OrderStatusEnum;
    purchaseTarget?: OrderPurchaseTargetEnum;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    items?: OrderItemEntity[] | undefined;
    bankName?: string | undefined;
    bankNumber?: string | undefined;
    accountName?: string | undefined;
    content?: string | undefined;
    gatewayUrl?: string | undefined;

    constructor(data?: IOrderPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.userId = _data["userId"];
            this.fullName = _data["fullName"];
            this.phone = _data["phone"];
            this.address = _data["address"];
            this.notes = _data["notes"];
            this.totalAmount = _data["totalAmount"];
            this.paidDate = _data["paidDate"] ? new Date(_data["paidDate"].toString()) : undefined as any;
            this.paymentLog = _data["paymentLog"];
            this.status = _data["status"];
            this.purchaseTarget = _data["purchaseTarget"];
            this.objectType = _data["objectType"];
            this.objectId = _data["objectId"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrderItemEntity.fromJS(item));
            }
            this.bankName = _data["bankName"];
            this.bankNumber = _data["bankNumber"];
            this.accountName = _data["accountName"];
            this.content = _data["content"];
            this.gatewayUrl = _data["gatewayUrl"];
        }
    }

    static fromJS(data: any): OrderPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["userId"] = this.userId;
        data["fullName"] = this.fullName;
        data["phone"] = this.phone;
        data["address"] = this.address;
        data["notes"] = this.notes;
        data["totalAmount"] = this.totalAmount;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : undefined as any;
        data["paymentLog"] = this.paymentLog;
        data["status"] = this.status;
        data["purchaseTarget"] = this.purchaseTarget;
        data["objectType"] = this.objectType;
        data["objectId"] = this.objectId;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["bankName"] = this.bankName;
        data["bankNumber"] = this.bankNumber;
        data["accountName"] = this.accountName;
        data["content"] = this.content;
        data["gatewayUrl"] = this.gatewayUrl;
        return data;
    }
}

export interface IOrderPaymentDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    userId?: number;
    fullName?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    notes?: string | undefined;
    totalAmount?: number;
    paidDate?: Date | undefined;
    paymentLog?: string | undefined;
    status?: OrderStatusEnum;
    purchaseTarget?: OrderPurchaseTargetEnum;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    items?: OrderItemEntity[] | undefined;
    bankName?: string | undefined;
    bankNumber?: string | undefined;
    accountName?: string | undefined;
    content?: string | undefined;
    gatewayUrl?: string | undefined;
}

export class OrderUpdateDto implements IOrderUpdateDto {
    status?: OrderStatusEnum;
    notes?: string | undefined;
    fullName?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;

    constructor(data?: IOrderUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.notes = _data["notes"];
            this.fullName = _data["fullName"];
            this.phone = _data["phone"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): OrderUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["notes"] = this.notes;
        data["fullName"] = this.fullName;
        data["phone"] = this.phone;
        data["address"] = this.address;
        return data;
    }
}

export interface IOrderUpdateDto {
    status?: OrderStatusEnum;
    notes?: string | undefined;
    fullName?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
}

export class OrganizationDto implements IOrganizationDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    code?: string | undefined;
    name?: string | undefined;
    status?: OrganizationStatusEnum;
    countryId?: number;
    districtId?: number;
    provinceId?: number;
    wardId?: number;
    address?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    logo?: string | undefined;
    url?: string | undefined;
    description?: string | undefined;
    type?: string | undefined;
    isTemp?: boolean;
    templateOrganizationId?: number;
    ownerUserId?: number;
    languageCode?: string | undefined;
    maxStudentCount?: number;
    maxStaffCount?: number;
    departmentId?: number;

    constructor(data?: IOrganizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.countryId = _data["countryId"];
            this.districtId = _data["districtId"];
            this.provinceId = _data["provinceId"];
            this.wardId = _data["wardId"];
            this.address = _data["address"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.logo = _data["logo"];
            this.url = _data["url"];
            this.description = _data["description"];
            this.type = _data["type"];
            this.isTemp = _data["isTemp"];
            this.templateOrganizationId = _data["templateOrganizationId"];
            this.ownerUserId = _data["ownerUserId"];
            this.languageCode = _data["languageCode"];
            this.maxStudentCount = _data["maxStudentCount"];
            this.maxStaffCount = _data["maxStaffCount"];
            this.departmentId = _data["departmentId"];
        }
    }

    static fromJS(data: any): OrganizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["code"] = this.code;
        data["name"] = this.name;
        data["status"] = this.status;
        data["countryId"] = this.countryId;
        data["districtId"] = this.districtId;
        data["provinceId"] = this.provinceId;
        data["wardId"] = this.wardId;
        data["address"] = this.address;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["logo"] = this.logo;
        data["url"] = this.url;
        data["description"] = this.description;
        data["type"] = this.type;
        data["isTemp"] = this.isTemp;
        data["templateOrganizationId"] = this.templateOrganizationId;
        data["ownerUserId"] = this.ownerUserId;
        data["languageCode"] = this.languageCode;
        data["maxStudentCount"] = this.maxStudentCount;
        data["maxStaffCount"] = this.maxStaffCount;
        data["departmentId"] = this.departmentId;
        return data;
    }
}

export interface IOrganizationDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    code?: string | undefined;
    name?: string | undefined;
    status?: OrganizationStatusEnum;
    countryId?: number;
    districtId?: number;
    provinceId?: number;
    wardId?: number;
    address?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    logo?: string | undefined;
    url?: string | undefined;
    description?: string | undefined;
    type?: string | undefined;
    isTemp?: boolean;
    templateOrganizationId?: number;
    ownerUserId?: number;
    languageCode?: string | undefined;
    maxStudentCount?: number;
    maxStaffCount?: number;
    departmentId?: number;
}

export class OrganizationGetListQuery implements IOrganizationGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    departmentId?: number | undefined;
    officeId?: number | undefined;
    countryId?: number | undefined;
    status?: OrganizationStatusEnum;
    isTemp?: boolean | undefined;

    constructor(data?: IOrganizationGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.keyword = _data["keyword"];
            this.departmentId = _data["departmentId"];
            this.officeId = _data["officeId"];
            this.countryId = _data["countryId"];
            this.status = _data["status"];
            this.isTemp = _data["isTemp"];
        }
    }

    static fromJS(data: any): OrganizationGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["keyword"] = this.keyword;
        data["departmentId"] = this.departmentId;
        data["officeId"] = this.officeId;
        data["countryId"] = this.countryId;
        data["status"] = this.status;
        data["isTemp"] = this.isTemp;
        return data;
    }
}

export interface IOrganizationGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    departmentId?: number | undefined;
    officeId?: number | undefined;
    countryId?: number | undefined;
    status?: OrganizationStatusEnum;
    isTemp?: boolean | undefined;
}

export class OrganizationListDto implements IOrganizationListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    code?: string | undefined;
    name?: string | undefined;
    status?: OrganizationStatusEnum;
    countryId?: number;
    districtId?: number;
    provinceId?: number;
    wardId?: number;
    address?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    logo?: string | undefined;
    url?: string | undefined;
    description?: string | undefined;
    type?: string | undefined;
    isTemp?: boolean;
    templateOrganizationId?: number;
    ownerUserId?: number;
    languageCode?: string | undefined;
    maxStudentCount?: number;
    maxStaffCount?: number;
    departmentName?: string | undefined;
    officeName?: string | undefined;

    constructor(data?: IOrganizationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.countryId = _data["countryId"];
            this.districtId = _data["districtId"];
            this.provinceId = _data["provinceId"];
            this.wardId = _data["wardId"];
            this.address = _data["address"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.logo = _data["logo"];
            this.url = _data["url"];
            this.description = _data["description"];
            this.type = _data["type"];
            this.isTemp = _data["isTemp"];
            this.templateOrganizationId = _data["templateOrganizationId"];
            this.ownerUserId = _data["ownerUserId"];
            this.languageCode = _data["languageCode"];
            this.maxStudentCount = _data["maxStudentCount"];
            this.maxStaffCount = _data["maxStaffCount"];
            this.departmentName = _data["departmentName"];
            this.officeName = _data["officeName"];
        }
    }

    static fromJS(data: any): OrganizationListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["code"] = this.code;
        data["name"] = this.name;
        data["status"] = this.status;
        data["countryId"] = this.countryId;
        data["districtId"] = this.districtId;
        data["provinceId"] = this.provinceId;
        data["wardId"] = this.wardId;
        data["address"] = this.address;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["logo"] = this.logo;
        data["url"] = this.url;
        data["description"] = this.description;
        data["type"] = this.type;
        data["isTemp"] = this.isTemp;
        data["templateOrganizationId"] = this.templateOrganizationId;
        data["ownerUserId"] = this.ownerUserId;
        data["languageCode"] = this.languageCode;
        data["maxStudentCount"] = this.maxStudentCount;
        data["maxStaffCount"] = this.maxStaffCount;
        data["departmentName"] = this.departmentName;
        data["officeName"] = this.officeName;
        return data;
    }
}

export interface IOrganizationListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    code?: string | undefined;
    name?: string | undefined;
    status?: OrganizationStatusEnum;
    countryId?: number;
    districtId?: number;
    provinceId?: number;
    wardId?: number;
    address?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    logo?: string | undefined;
    url?: string | undefined;
    description?: string | undefined;
    type?: string | undefined;
    isTemp?: boolean;
    templateOrganizationId?: number;
    ownerUserId?: number;
    languageCode?: string | undefined;
    maxStudentCount?: number;
    maxStaffCount?: number;
    departmentName?: string | undefined;
    officeName?: string | undefined;
}

export class ProductAttributeSaveDto implements IProductAttributeSaveDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    productId?: number;
    name?: string | undefined;
    icon?: string | undefined;
    sortOrder?: number;

    constructor(data?: IProductAttributeSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.productId = _data["productId"];
            this.name = _data["name"];
            this.icon = _data["icon"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): ProductAttributeSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductAttributeSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["productId"] = this.productId;
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IProductAttributeSaveDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    productId?: number;
    name?: string | undefined;
    icon?: string | undefined;
    sortOrder?: number;
}

export class ProductChapterDetailDto implements IProductChapterDetailDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    productId?: number;
    name?: string | undefined;
    description?: string | undefined;
    sortOrder?: number;
    productLessons?: ProductLessonEntity[] | undefined;
    lessons?: ProductLessonDetailDto[] | undefined;

    constructor(data?: IProductChapterDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.productId = _data["productId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.sortOrder = _data["sortOrder"];
            if (Array.isArray(_data["productLessons"])) {
                this.productLessons = [] as any;
                for (let item of _data["productLessons"])
                    this.productLessons!.push(ProductLessonEntity.fromJS(item));
            }
            if (Array.isArray(_data["lessons"])) {
                this.lessons = [] as any;
                for (let item of _data["lessons"])
                    this.lessons!.push(ProductLessonDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductChapterDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductChapterDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["productId"] = this.productId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["sortOrder"] = this.sortOrder;
        if (Array.isArray(this.productLessons)) {
            data["productLessons"] = [];
            for (let item of this.productLessons)
                data["productLessons"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.lessons)) {
            data["lessons"] = [];
            for (let item of this.lessons)
                data["lessons"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProductChapterDetailDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    productId?: number;
    name?: string | undefined;
    description?: string | undefined;
    sortOrder?: number;
    productLessons?: ProductLessonEntity[] | undefined;
    lessons?: ProductLessonDetailDto[] | undefined;
}

export class ProductChapterSaveDto implements IProductChapterSaveDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    productId?: number;
    name?: string | undefined;
    description?: string | undefined;
    sortOrder?: number;
    productLessons?: ProductLessonEntity[] | undefined;
    lessons?: ProductLessonSaveDto[] | undefined;

    constructor(data?: IProductChapterSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.productId = _data["productId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.sortOrder = _data["sortOrder"];
            if (Array.isArray(_data["productLessons"])) {
                this.productLessons = [] as any;
                for (let item of _data["productLessons"])
                    this.productLessons!.push(ProductLessonEntity.fromJS(item));
            }
            if (Array.isArray(_data["lessons"])) {
                this.lessons = [] as any;
                for (let item of _data["lessons"])
                    this.lessons!.push(ProductLessonSaveDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductChapterSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductChapterSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["productId"] = this.productId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["sortOrder"] = this.sortOrder;
        if (Array.isArray(this.productLessons)) {
            data["productLessons"] = [];
            for (let item of this.productLessons)
                data["productLessons"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.lessons)) {
            data["lessons"] = [];
            for (let item of this.lessons)
                data["lessons"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProductChapterSaveDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    productId?: number;
    name?: string | undefined;
    description?: string | undefined;
    sortOrder?: number;
    productLessons?: ProductLessonEntity[] | undefined;
    lessons?: ProductLessonSaveDto[] | undefined;
}

export class ProductComboItemDto implements IProductComboItemDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    summary?: string | undefined;
    description?: string | undefined;
    image?: string | undefined;
    categoryId?: number | undefined;
    productType?: ProductTypeEnum;
    status?: CommonStatusEnum;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaKeywords?: string | undefined;
    slug?: string | undefined;
    price?: number | undefined;
    salePrice?: number | undefined;
    orgPrice?: number | undefined;
    orgSalePrice?: number | undefined;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    lessonZoomCount?: number;
    productChapters?: ProductChapterEntity[] | undefined;
    totalLessons?: number;
    totalDurationMinutes?: number;

    constructor(data?: IProductComboItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.summary = _data["summary"];
            this.description = _data["description"];
            this.image = _data["image"];
            this.categoryId = _data["categoryId"];
            this.productType = _data["productType"];
            this.status = _data["status"];
            this.metaTitle = _data["metaTitle"];
            this.metaDescription = _data["metaDescription"];
            this.metaKeywords = _data["metaKeywords"];
            this.slug = _data["slug"];
            this.price = _data["price"];
            this.salePrice = _data["salePrice"];
            this.orgPrice = _data["orgPrice"];
            this.orgSalePrice = _data["orgSalePrice"];
            this.objectType = _data["objectType"];
            this.objectId = _data["objectId"];
            this.lessonZoomCount = _data["lessonZoomCount"];
            if (Array.isArray(_data["productChapters"])) {
                this.productChapters = [] as any;
                for (let item of _data["productChapters"])
                    this.productChapters!.push(ProductChapterEntity.fromJS(item));
            }
            this.totalLessons = _data["totalLessons"];
            this.totalDurationMinutes = _data["totalDurationMinutes"];
        }
    }

    static fromJS(data: any): ProductComboItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductComboItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["summary"] = this.summary;
        data["description"] = this.description;
        data["image"] = this.image;
        data["categoryId"] = this.categoryId;
        data["productType"] = this.productType;
        data["status"] = this.status;
        data["metaTitle"] = this.metaTitle;
        data["metaDescription"] = this.metaDescription;
        data["metaKeywords"] = this.metaKeywords;
        data["slug"] = this.slug;
        data["price"] = this.price;
        data["salePrice"] = this.salePrice;
        data["orgPrice"] = this.orgPrice;
        data["orgSalePrice"] = this.orgSalePrice;
        data["objectType"] = this.objectType;
        data["objectId"] = this.objectId;
        data["lessonZoomCount"] = this.lessonZoomCount;
        if (Array.isArray(this.productChapters)) {
            data["productChapters"] = [];
            for (let item of this.productChapters)
                data["productChapters"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalLessons"] = this.totalLessons;
        data["totalDurationMinutes"] = this.totalDurationMinutes;
        return data;
    }
}

export interface IProductComboItemDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    summary?: string | undefined;
    description?: string | undefined;
    image?: string | undefined;
    categoryId?: number | undefined;
    productType?: ProductTypeEnum;
    status?: CommonStatusEnum;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaKeywords?: string | undefined;
    slug?: string | undefined;
    price?: number | undefined;
    salePrice?: number | undefined;
    orgPrice?: number | undefined;
    orgSalePrice?: number | undefined;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    lessonZoomCount?: number;
    productChapters?: ProductChapterEntity[] | undefined;
    totalLessons?: number;
    totalDurationMinutes?: number;
}

export class ProductDashboardListDto implements IProductDashboardListDto {
    id?: number;
    name?: string | undefined;
    image?: string | undefined;
    categoryId?: number | undefined;
    categoryName?: string | undefined;
    status?: CommonStatusEnum;
    lessonCount?: number;
    zoomLessonCount?: number;
    classCount?: number;
    completedStudentCount?: number;
    learningStudentCount?: number;

    constructor(data?: IProductDashboardListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.image = _data["image"];
            this.categoryId = _data["categoryId"];
            this.categoryName = _data["categoryName"];
            this.status = _data["status"];
            this.lessonCount = _data["lessonCount"];
            this.zoomLessonCount = _data["zoomLessonCount"];
            this.classCount = _data["classCount"];
            this.completedStudentCount = _data["completedStudentCount"];
            this.learningStudentCount = _data["learningStudentCount"];
        }
    }

    static fromJS(data: any): ProductDashboardListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDashboardListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["image"] = this.image;
        data["categoryId"] = this.categoryId;
        data["categoryName"] = this.categoryName;
        data["status"] = this.status;
        data["lessonCount"] = this.lessonCount;
        data["zoomLessonCount"] = this.zoomLessonCount;
        data["classCount"] = this.classCount;
        data["completedStudentCount"] = this.completedStudentCount;
        data["learningStudentCount"] = this.learningStudentCount;
        return data;
    }
}

export interface IProductDashboardListDto {
    id?: number;
    name?: string | undefined;
    image?: string | undefined;
    categoryId?: number | undefined;
    categoryName?: string | undefined;
    status?: CommonStatusEnum;
    lessonCount?: number;
    zoomLessonCount?: number;
    classCount?: number;
    completedStudentCount?: number;
    learningStudentCount?: number;
}

export class ProductDashboardListFilter implements IProductDashboardListFilter {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    schoolId?: number;
    keyword?: string | undefined;
    categoryId?: number | undefined;
    status?: CommonStatusEnum;

    constructor(data?: IProductDashboardListFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.schoolId = _data["schoolId"];
            this.keyword = _data["keyword"];
            this.categoryId = _data["categoryId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ProductDashboardListFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDashboardListFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["schoolId"] = this.schoolId;
        data["keyword"] = this.keyword;
        data["categoryId"] = this.categoryId;
        data["status"] = this.status;
        return data;
    }
}

export interface IProductDashboardListFilter {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    schoolId?: number;
    keyword?: string | undefined;
    categoryId?: number | undefined;
    status?: CommonStatusEnum;
}

export class ProductDetailDto implements IProductDetailDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    summary?: string | undefined;
    description?: string | undefined;
    image?: string | undefined;
    categoryId?: number | undefined;
    productType?: ProductTypeEnum;
    status?: CommonStatusEnum;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaKeywords?: string | undefined;
    slug?: string | undefined;
    price?: number | undefined;
    salePrice?: number | undefined;
    orgPrice?: number | undefined;
    orgSalePrice?: number | undefined;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    lessonZoomCount?: number;
    productChapters?: ProductChapterEntity[] | undefined;
    chapters?: ProductChapterDetailDto[] | undefined;
    comboProducts?: ProductComboItemDto[] | undefined;
    attributes?: ProductAttributeSaveDto[] | undefined;
    combos?: ProductEntity[] | undefined;

    constructor(data?: IProductDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.summary = _data["summary"];
            this.description = _data["description"];
            this.image = _data["image"];
            this.categoryId = _data["categoryId"];
            this.productType = _data["productType"];
            this.status = _data["status"];
            this.metaTitle = _data["metaTitle"];
            this.metaDescription = _data["metaDescription"];
            this.metaKeywords = _data["metaKeywords"];
            this.slug = _data["slug"];
            this.price = _data["price"];
            this.salePrice = _data["salePrice"];
            this.orgPrice = _data["orgPrice"];
            this.orgSalePrice = _data["orgSalePrice"];
            this.objectType = _data["objectType"];
            this.objectId = _data["objectId"];
            this.lessonZoomCount = _data["lessonZoomCount"];
            if (Array.isArray(_data["productChapters"])) {
                this.productChapters = [] as any;
                for (let item of _data["productChapters"])
                    this.productChapters!.push(ProductChapterEntity.fromJS(item));
            }
            if (Array.isArray(_data["chapters"])) {
                this.chapters = [] as any;
                for (let item of _data["chapters"])
                    this.chapters!.push(ProductChapterDetailDto.fromJS(item));
            }
            if (Array.isArray(_data["comboProducts"])) {
                this.comboProducts = [] as any;
                for (let item of _data["comboProducts"])
                    this.comboProducts!.push(ProductComboItemDto.fromJS(item));
            }
            if (Array.isArray(_data["attributes"])) {
                this.attributes = [] as any;
                for (let item of _data["attributes"])
                    this.attributes!.push(ProductAttributeSaveDto.fromJS(item));
            }
            if (Array.isArray(_data["combos"])) {
                this.combos = [] as any;
                for (let item of _data["combos"])
                    this.combos!.push(ProductEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["summary"] = this.summary;
        data["description"] = this.description;
        data["image"] = this.image;
        data["categoryId"] = this.categoryId;
        data["productType"] = this.productType;
        data["status"] = this.status;
        data["metaTitle"] = this.metaTitle;
        data["metaDescription"] = this.metaDescription;
        data["metaKeywords"] = this.metaKeywords;
        data["slug"] = this.slug;
        data["price"] = this.price;
        data["salePrice"] = this.salePrice;
        data["orgPrice"] = this.orgPrice;
        data["orgSalePrice"] = this.orgSalePrice;
        data["objectType"] = this.objectType;
        data["objectId"] = this.objectId;
        data["lessonZoomCount"] = this.lessonZoomCount;
        if (Array.isArray(this.productChapters)) {
            data["productChapters"] = [];
            for (let item of this.productChapters)
                data["productChapters"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.chapters)) {
            data["chapters"] = [];
            for (let item of this.chapters)
                data["chapters"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.comboProducts)) {
            data["comboProducts"] = [];
            for (let item of this.comboProducts)
                data["comboProducts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.attributes)) {
            data["attributes"] = [];
            for (let item of this.attributes)
                data["attributes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.combos)) {
            data["combos"] = [];
            for (let item of this.combos)
                data["combos"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProductDetailDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    summary?: string | undefined;
    description?: string | undefined;
    image?: string | undefined;
    categoryId?: number | undefined;
    productType?: ProductTypeEnum;
    status?: CommonStatusEnum;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaKeywords?: string | undefined;
    slug?: string | undefined;
    price?: number | undefined;
    salePrice?: number | undefined;
    orgPrice?: number | undefined;
    orgSalePrice?: number | undefined;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    lessonZoomCount?: number;
    productChapters?: ProductChapterEntity[] | undefined;
    chapters?: ProductChapterDetailDto[] | undefined;
    comboProducts?: ProductComboItemDto[] | undefined;
    attributes?: ProductAttributeSaveDto[] | undefined;
    combos?: ProductEntity[] | undefined;
}

export class ProductGetListQuery implements IProductGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    categoryId?: number | undefined;
    productType?: ProductTypeEnum;
    status?: CommonStatusEnum;
    scopeToCurrentObject?: boolean;

    constructor(data?: IProductGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.keyword = _data["keyword"];
            this.categoryId = _data["categoryId"];
            this.productType = _data["productType"];
            this.status = _data["status"];
            this.scopeToCurrentObject = _data["scopeToCurrentObject"];
        }
    }

    static fromJS(data: any): ProductGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ProductGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["keyword"] = this.keyword;
        data["categoryId"] = this.categoryId;
        data["productType"] = this.productType;
        data["status"] = this.status;
        data["scopeToCurrentObject"] = this.scopeToCurrentObject;
        return data;
    }
}

export interface IProductGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    categoryId?: number | undefined;
    productType?: ProductTypeEnum;
    status?: CommonStatusEnum;
    scopeToCurrentObject?: boolean;
}

export class ProductLessonDetailDto implements IProductLessonDetailDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    chapterId?: number;
    name?: string | undefined;
    description?: string | undefined;
    lessonType?: LessonTypeEnum;
    content?: string | undefined;
    notesHtml?: string | undefined;
    attachmentPaths?: string | undefined;
    sortOrder?: number;
    isFree?: boolean;
    duration?: number;
    quizType?: LessonQuizTypeEnum;
    quizId?: number | undefined;
    quizQuestionIds?: string | undefined;
    classSession?: ClassSessionInfoDto;
    isCompleted?: boolean | undefined;
    quizAttemptCount?: number | undefined;

    constructor(data?: IProductLessonDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.chapterId = _data["chapterId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.lessonType = _data["lessonType"];
            this.content = _data["content"];
            this.notesHtml = _data["notesHtml"];
            this.attachmentPaths = _data["attachmentPaths"];
            this.sortOrder = _data["sortOrder"];
            this.isFree = _data["isFree"];
            this.duration = _data["duration"];
            this.quizType = _data["quizType"];
            this.quizId = _data["quizId"];
            this.quizQuestionIds = _data["quizQuestionIds"];
            this.classSession = _data["classSession"] ? ClassSessionInfoDto.fromJS(_data["classSession"]) : undefined as any;
            this.isCompleted = _data["isCompleted"];
            this.quizAttemptCount = _data["quizAttemptCount"];
        }
    }

    static fromJS(data: any): ProductLessonDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductLessonDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["chapterId"] = this.chapterId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["lessonType"] = this.lessonType;
        data["content"] = this.content;
        data["notesHtml"] = this.notesHtml;
        data["attachmentPaths"] = this.attachmentPaths;
        data["sortOrder"] = this.sortOrder;
        data["isFree"] = this.isFree;
        data["duration"] = this.duration;
        data["quizType"] = this.quizType;
        data["quizId"] = this.quizId;
        data["quizQuestionIds"] = this.quizQuestionIds;
        data["classSession"] = this.classSession ? this.classSession.toJSON() : undefined as any;
        data["isCompleted"] = this.isCompleted;
        data["quizAttemptCount"] = this.quizAttemptCount;
        return data;
    }
}

export interface IProductLessonDetailDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    chapterId?: number;
    name?: string | undefined;
    description?: string | undefined;
    lessonType?: LessonTypeEnum;
    content?: string | undefined;
    notesHtml?: string | undefined;
    attachmentPaths?: string | undefined;
    sortOrder?: number;
    isFree?: boolean;
    duration?: number;
    quizType?: LessonQuizTypeEnum;
    quizId?: number | undefined;
    quizQuestionIds?: string | undefined;
    classSession?: ClassSessionInfoDto;
    isCompleted?: boolean | undefined;
    quizAttemptCount?: number | undefined;
}

export class ProductLessonSaveDto implements IProductLessonSaveDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    chapterId?: number;
    name?: string | undefined;
    description?: string | undefined;
    lessonType?: LessonTypeEnum;
    content?: string | undefined;
    notesHtml?: string | undefined;
    attachmentPaths?: string | undefined;
    sortOrder?: number;
    isFree?: boolean;
    allowExerciseBeforeComplete?: boolean;
    duration?: number;
    quizType?: LessonQuizTypeEnum;
    quizId?: number | undefined;
    quizQuestionIds?: string | undefined;
    quizData?: ExamDto;
    quizQuestions?: QuestionDto[] | undefined;

    constructor(data?: IProductLessonSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.chapterId = _data["chapterId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.lessonType = _data["lessonType"];
            this.content = _data["content"];
            this.notesHtml = _data["notesHtml"];
            this.attachmentPaths = _data["attachmentPaths"];
            this.sortOrder = _data["sortOrder"];
            this.isFree = _data["isFree"];
            this.allowExerciseBeforeComplete = _data["allowExerciseBeforeComplete"];
            this.duration = _data["duration"];
            this.quizType = _data["quizType"];
            this.quizId = _data["quizId"];
            this.quizQuestionIds = _data["quizQuestionIds"];
            this.quizData = _data["quizData"] ? ExamDto.fromJS(_data["quizData"]) : undefined as any;
            if (Array.isArray(_data["quizQuestions"])) {
                this.quizQuestions = [] as any;
                for (let item of _data["quizQuestions"])
                    this.quizQuestions!.push(QuestionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductLessonSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductLessonSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["chapterId"] = this.chapterId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["lessonType"] = this.lessonType;
        data["content"] = this.content;
        data["notesHtml"] = this.notesHtml;
        data["attachmentPaths"] = this.attachmentPaths;
        data["sortOrder"] = this.sortOrder;
        data["isFree"] = this.isFree;
        data["allowExerciseBeforeComplete"] = this.allowExerciseBeforeComplete;
        data["duration"] = this.duration;
        data["quizType"] = this.quizType;
        data["quizId"] = this.quizId;
        data["quizQuestionIds"] = this.quizQuestionIds;
        data["quizData"] = this.quizData ? this.quizData.toJSON() : undefined as any;
        if (Array.isArray(this.quizQuestions)) {
            data["quizQuestions"] = [];
            for (let item of this.quizQuestions)
                data["quizQuestions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProductLessonSaveDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    chapterId?: number;
    name?: string | undefined;
    description?: string | undefined;
    lessonType?: LessonTypeEnum;
    content?: string | undefined;
    notesHtml?: string | undefined;
    attachmentPaths?: string | undefined;
    sortOrder?: number;
    isFree?: boolean;
    allowExerciseBeforeComplete?: boolean;
    duration?: number;
    quizType?: LessonQuizTypeEnum;
    quizId?: number | undefined;
    quizQuestionIds?: string | undefined;
    quizData?: ExamDto;
    quizQuestions?: QuestionDto[] | undefined;
}

export class ProductListDto implements IProductListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    summary?: string | undefined;
    description?: string | undefined;
    image?: string | undefined;
    categoryId?: number | undefined;
    productType?: ProductTypeEnum;
    status?: CommonStatusEnum;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaKeywords?: string | undefined;
    slug?: string | undefined;
    price?: number | undefined;
    salePrice?: number | undefined;
    orgPrice?: number | undefined;
    orgSalePrice?: number | undefined;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    lessonZoomCount?: number;
    productChapters?: ProductChapterEntity[] | undefined;
    averageRating?: number;
    reviewCount?: number;
    lessonCount?: number;
    totalDuration?: number;
    source?: ProductSourceEnum;

    constructor(data?: IProductListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.summary = _data["summary"];
            this.description = _data["description"];
            this.image = _data["image"];
            this.categoryId = _data["categoryId"];
            this.productType = _data["productType"];
            this.status = _data["status"];
            this.metaTitle = _data["metaTitle"];
            this.metaDescription = _data["metaDescription"];
            this.metaKeywords = _data["metaKeywords"];
            this.slug = _data["slug"];
            this.price = _data["price"];
            this.salePrice = _data["salePrice"];
            this.orgPrice = _data["orgPrice"];
            this.orgSalePrice = _data["orgSalePrice"];
            this.objectType = _data["objectType"];
            this.objectId = _data["objectId"];
            this.lessonZoomCount = _data["lessonZoomCount"];
            if (Array.isArray(_data["productChapters"])) {
                this.productChapters = [] as any;
                for (let item of _data["productChapters"])
                    this.productChapters!.push(ProductChapterEntity.fromJS(item));
            }
            this.averageRating = _data["averageRating"];
            this.reviewCount = _data["reviewCount"];
            this.lessonCount = _data["lessonCount"];
            this.totalDuration = _data["totalDuration"];
            this.source = _data["source"];
        }
    }

    static fromJS(data: any): ProductListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["summary"] = this.summary;
        data["description"] = this.description;
        data["image"] = this.image;
        data["categoryId"] = this.categoryId;
        data["productType"] = this.productType;
        data["status"] = this.status;
        data["metaTitle"] = this.metaTitle;
        data["metaDescription"] = this.metaDescription;
        data["metaKeywords"] = this.metaKeywords;
        data["slug"] = this.slug;
        data["price"] = this.price;
        data["salePrice"] = this.salePrice;
        data["orgPrice"] = this.orgPrice;
        data["orgSalePrice"] = this.orgSalePrice;
        data["objectType"] = this.objectType;
        data["objectId"] = this.objectId;
        data["lessonZoomCount"] = this.lessonZoomCount;
        if (Array.isArray(this.productChapters)) {
            data["productChapters"] = [];
            for (let item of this.productChapters)
                data["productChapters"].push(item ? item.toJSON() : undefined as any);
        }
        data["averageRating"] = this.averageRating;
        data["reviewCount"] = this.reviewCount;
        data["lessonCount"] = this.lessonCount;
        data["totalDuration"] = this.totalDuration;
        data["source"] = this.source;
        return data;
    }
}

export interface IProductListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    summary?: string | undefined;
    description?: string | undefined;
    image?: string | undefined;
    categoryId?: number | undefined;
    productType?: ProductTypeEnum;
    status?: CommonStatusEnum;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaKeywords?: string | undefined;
    slug?: string | undefined;
    price?: number | undefined;
    salePrice?: number | undefined;
    orgPrice?: number | undefined;
    orgSalePrice?: number | undefined;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    lessonZoomCount?: number;
    productChapters?: ProductChapterEntity[] | undefined;
    averageRating?: number;
    reviewCount?: number;
    lessonCount?: number;
    totalDuration?: number;
    source?: ProductSourceEnum;
}

export class ProductReviewCreateDto implements IProductReviewCreateDto {
    productId?: number;
    rating?: number;
    comment?: string | undefined;
    createdByName?: string | undefined;

    constructor(data?: IProductReviewCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.rating = _data["rating"];
            this.comment = _data["comment"];
            this.createdByName = _data["createdByName"];
        }
    }

    static fromJS(data: any): ProductReviewCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductReviewCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["rating"] = this.rating;
        data["comment"] = this.comment;
        data["createdByName"] = this.createdByName;
        return data;
    }
}

export interface IProductReviewCreateDto {
    productId?: number;
    rating?: number;
    comment?: string | undefined;
    createdByName?: string | undefined;
}

export class ProductReviewGetListQuery implements IProductReviewGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    productId?: number | undefined;
    status?: ProductReviewStatusEnum;

    constructor(data?: IProductReviewGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.productId = _data["productId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ProductReviewGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ProductReviewGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["productId"] = this.productId;
        data["status"] = this.status;
        return data;
    }
}

export interface IProductReviewGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    productId?: number | undefined;
    status?: ProductReviewStatusEnum;
}

export class ProductReviewListDto implements IProductReviewListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    productId?: number;
    userId?: number | undefined;
    fullName?: string | undefined;
    avatar?: string | undefined;
    rating?: number;
    comment?: string | undefined;
    status?: ProductReviewStatusEnum;

    constructor(data?: IProductReviewListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.productId = _data["productId"];
            this.userId = _data["userId"];
            this.fullName = _data["fullName"];
            this.avatar = _data["avatar"];
            this.rating = _data["rating"];
            this.comment = _data["comment"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ProductReviewListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductReviewListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["productId"] = this.productId;
        data["userId"] = this.userId;
        data["fullName"] = this.fullName;
        data["avatar"] = this.avatar;
        data["rating"] = this.rating;
        data["comment"] = this.comment;
        data["status"] = this.status;
        return data;
    }
}

export interface IProductReviewListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    productId?: number;
    userId?: number | undefined;
    fullName?: string | undefined;
    avatar?: string | undefined;
    rating?: number;
    comment?: string | undefined;
    status?: ProductReviewStatusEnum;
}

export class ProductExamSaveDto implements IProductExamSaveDto {
    id?: number;
    examId?: number;
    productChapterId?: number | undefined;
    productLessonId?: number | undefined;
    sortOrder?: number;
    isSystem?: boolean;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    canEdit?: boolean;
    examTitle?: string | undefined;
    examType?: ExamTypeEnum;
    duration?: number;
    totalQuestion?: number;
    totalMark?: number;
    createdBy?: number;
    createdByName?: string | undefined;

    constructor(data?: IProductExamSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.examId = _data["examId"];
            this.productChapterId = _data["productChapterId"];
            this.productLessonId = _data["productLessonId"];
            this.sortOrder = _data["sortOrder"];
            this.isSystem = _data["isSystem"];
            this.objectId = _data["objectId"];
            this.objectType = _data["objectType"];
            this.canEdit = _data["canEdit"];
            this.examTitle = _data["examTitle"];
            this.examType = _data["examType"];
            this.duration = _data["duration"];
            this.totalQuestion = _data["totalQuestion"];
            this.totalMark = _data["totalMark"];
            this.createdBy = _data["createdBy"];
            this.createdByName = _data["createdByName"];
        }
    }

    static fromJS(data: any): ProductExamSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductExamSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["examId"] = this.examId;
        data["productChapterId"] = this.productChapterId;
        data["productLessonId"] = this.productLessonId;
        data["sortOrder"] = this.sortOrder;
        data["isSystem"] = this.isSystem;
        data["objectId"] = this.objectId;
        data["objectType"] = this.objectType;
        data["canEdit"] = this.canEdit;
        data["examTitle"] = this.examTitle;
        data["examType"] = this.examType;
        data["duration"] = this.duration;
        data["totalQuestion"] = this.totalQuestion;
        data["totalMark"] = this.totalMark;
        data["createdBy"] = this.createdBy;
        data["createdByName"] = this.createdByName;
        return data;
    }
}

export interface IProductExamSaveDto {
    id?: number;
    examId?: number;
    productChapterId?: number | undefined;
    productLessonId?: number | undefined;
    sortOrder?: number;
    isSystem?: boolean;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    canEdit?: boolean;
    examTitle?: string | undefined;
    examType?: ExamTypeEnum;
    duration?: number;
    totalQuestion?: number;
    totalMark?: number;
    createdBy?: number;
    createdByName?: string | undefined;
}

export class ProductSaveDto implements IProductSaveDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    summary?: string | undefined;
    description?: string | undefined;
    image?: string | undefined;
    categoryId?: number | undefined;
    productType?: ProductTypeEnum;
    status?: CommonStatusEnum;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaKeywords?: string | undefined;
    slug?: string | undefined;
    price?: number | undefined;
    salePrice?: number | undefined;
    orgPrice?: number | undefined;
    orgSalePrice?: number | undefined;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    lessonZoomCount?: number;
    productChapters?: ProductChapterEntity[] | undefined;
    tagIds?: number[] | undefined;
    chapters?: ProductChapterSaveDto[] | undefined;
    attributes?: ProductAttributeSaveDto[] | undefined;
    comboProductIds?: number[] | undefined;
    source?: ProductSourceEnum;
    productExams?: ProductExamSaveDto[] | undefined;

    constructor(data?: IProductSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.summary = _data["summary"];
            this.description = _data["description"];
            this.image = _data["image"];
            this.categoryId = _data["categoryId"];
            this.productType = _data["productType"];
            this.status = _data["status"];
            this.metaTitle = _data["metaTitle"];
            this.metaDescription = _data["metaDescription"];
            this.metaKeywords = _data["metaKeywords"];
            this.slug = _data["slug"];
            this.price = _data["price"];
            this.salePrice = _data["salePrice"];
            this.orgPrice = _data["orgPrice"];
            this.orgSalePrice = _data["orgSalePrice"];
            this.objectType = _data["objectType"];
            this.objectId = _data["objectId"];
            this.lessonZoomCount = _data["lessonZoomCount"];
            if (Array.isArray(_data["productChapters"])) {
                this.productChapters = [] as any;
                for (let item of _data["productChapters"])
                    this.productChapters!.push(ProductChapterEntity.fromJS(item));
            }
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
            if (Array.isArray(_data["chapters"])) {
                this.chapters = [] as any;
                for (let item of _data["chapters"])
                    this.chapters!.push(ProductChapterSaveDto.fromJS(item));
            }
            if (Array.isArray(_data["attributes"])) {
                this.attributes = [] as any;
                for (let item of _data["attributes"])
                    this.attributes!.push(ProductAttributeSaveDto.fromJS(item));
            }
            if (Array.isArray(_data["comboProductIds"])) {
                this.comboProductIds = [] as any;
                for (let item of _data["comboProductIds"])
                    this.comboProductIds!.push(item);
            }
            this.source = _data["source"];
            if (Array.isArray(_data["productExams"])) {
                this.productExams = [] as any;
                for (let item of _data["productExams"])
                    this.productExams!.push(ProductExamSaveDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["summary"] = this.summary;
        data["description"] = this.description;
        data["image"] = this.image;
        data["categoryId"] = this.categoryId;
        data["productType"] = this.productType;
        data["status"] = this.status;
        data["metaTitle"] = this.metaTitle;
        data["metaDescription"] = this.metaDescription;
        data["metaKeywords"] = this.metaKeywords;
        data["slug"] = this.slug;
        data["price"] = this.price;
        data["salePrice"] = this.salePrice;
        data["orgPrice"] = this.orgPrice;
        data["orgSalePrice"] = this.orgSalePrice;
        data["objectType"] = this.objectType;
        data["objectId"] = this.objectId;
        data["lessonZoomCount"] = this.lessonZoomCount;
        if (Array.isArray(this.productChapters)) {
            data["productChapters"] = [];
            for (let item of this.productChapters)
                data["productChapters"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        if (Array.isArray(this.chapters)) {
            data["chapters"] = [];
            for (let item of this.chapters)
                data["chapters"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.attributes)) {
            data["attributes"] = [];
            for (let item of this.attributes)
                data["attributes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.comboProductIds)) {
            data["comboProductIds"] = [];
            for (let item of this.comboProductIds)
                data["comboProductIds"].push(item);
        }
        data["source"] = this.source;
        if (Array.isArray(this.productExams)) {
            data["productExams"] = [];
            for (let item of this.productExams)
                data["productExams"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProductSaveDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    summary?: string | undefined;
    description?: string | undefined;
    image?: string | undefined;
    categoryId?: number | undefined;
    productType?: ProductTypeEnum;
    status?: CommonStatusEnum;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaKeywords?: string | undefined;
    slug?: string | undefined;
    price?: number | undefined;
    salePrice?: number | undefined;
    orgPrice?: number | undefined;
    orgSalePrice?: number | undefined;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    lessonZoomCount?: number;
    productChapters?: ProductChapterEntity[] | undefined;
    tagIds?: number[] | undefined;
    chapters?: ProductChapterSaveDto[] | undefined;
    attributes?: ProductAttributeSaveDto[] | undefined;
    comboProductIds?: number[] | undefined;
    source?: ProductSourceEnum;
    productExams?: ProductExamSaveDto[] | undefined;
}

export class PupilAddDto implements IPupilAddDto {
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: IPupilAddDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): PupilAddDto {
        data = typeof data === 'object' ? data : {};
        let result = new PupilAddDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IPupilAddDto {
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export class PupilCheckGoToClassDto implements IPupilCheckGoToClassDto {
    classId?: number;
    className?: string | undefined;
    academicYearId?: number;
    academicYearName?: string | undefined;
    grade?: number;

    constructor(data?: IPupilCheckGoToClassDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.classId = _data["classId"];
            this.className = _data["className"];
            this.academicYearId = _data["academicYearId"];
            this.academicYearName = _data["academicYearName"];
            this.grade = _data["grade"];
        }
    }

    static fromJS(data: any): PupilCheckGoToClassDto {
        data = typeof data === 'object' ? data : {};
        let result = new PupilCheckGoToClassDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["classId"] = this.classId;
        data["className"] = this.className;
        data["academicYearId"] = this.academicYearId;
        data["academicYearName"] = this.academicYearName;
        data["grade"] = this.grade;
        return data;
    }
}

export interface IPupilCheckGoToClassDto {
    classId?: number;
    className?: string | undefined;
    academicYearId?: number;
    academicYearName?: string | undefined;
    grade?: number;
}

export class PupilDashboardStatisticalDto implements IPupilDashboardStatisticalDto {
    classList?: ClassCourseDto[] | undefined;
    courseList?: UserProductDto[] | undefined;
    totalCourse?: number;
    totalCourseCompleted?: number;
    totalCourseLearning?: number;
    totalZoomLesson?: number;

    constructor(data?: IPupilDashboardStatisticalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["classList"])) {
                this.classList = [] as any;
                for (let item of _data["classList"])
                    this.classList!.push(ClassCourseDto.fromJS(item));
            }
            if (Array.isArray(_data["courseList"])) {
                this.courseList = [] as any;
                for (let item of _data["courseList"])
                    this.courseList!.push(UserProductDto.fromJS(item));
            }
            this.totalCourse = _data["totalCourse"];
            this.totalCourseCompleted = _data["totalCourseCompleted"];
            this.totalCourseLearning = _data["totalCourseLearning"];
            this.totalZoomLesson = _data["totalZoomLesson"];
        }
    }

    static fromJS(data: any): PupilDashboardStatisticalDto {
        data = typeof data === 'object' ? data : {};
        let result = new PupilDashboardStatisticalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.classList)) {
            data["classList"] = [];
            for (let item of this.classList)
                data["classList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.courseList)) {
            data["courseList"] = [];
            for (let item of this.courseList)
                data["courseList"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCourse"] = this.totalCourse;
        data["totalCourseCompleted"] = this.totalCourseCompleted;
        data["totalCourseLearning"] = this.totalCourseLearning;
        data["totalZoomLesson"] = this.totalZoomLesson;
        return data;
    }
}

export interface IPupilDashboardStatisticalDto {
    classList?: ClassCourseDto[] | undefined;
    courseList?: UserProductDto[] | undefined;
    totalCourse?: number;
    totalCourseCompleted?: number;
    totalCourseLearning?: number;
    totalZoomLesson?: number;
}

export class PupilFilterDto implements IPupilFilterDto {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    classId?: number | undefined;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    keyword?: string | undefined;
    status?: ClassUserStatusEnum;
    grade?: number | undefined;

    constructor(data?: IPupilFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.classId = _data["classId"];
            this.objectId = _data["objectId"];
            this.objectType = _data["objectType"];
            this.keyword = _data["keyword"];
            this.status = _data["status"];
            this.grade = _data["grade"];
        }
    }

    static fromJS(data: any): PupilFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new PupilFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["classId"] = this.classId;
        data["objectId"] = this.objectId;
        data["objectType"] = this.objectType;
        data["keyword"] = this.keyword;
        data["status"] = this.status;
        data["grade"] = this.grade;
        return data;
    }
}

export interface IPupilFilterDto {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    classId?: number | undefined;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    keyword?: string | undefined;
    status?: ClassUserStatusEnum;
    grade?: number | undefined;
}

export class PupilHistoryDoExamDto implements IPupilHistoryDoExamDto {
    assignExamId?: number;
    title?: string | undefined;
    type?: AssignExamTypeEnum;
    subject?: string | undefined;
    submitDate?: Date | undefined;
    score?: number | undefined;
    status?: AssignExamUserStatusEnum;
    createdBy?: number;
    canMark?: boolean;
    examId?: number | undefined;
    examResultId?: number | undefined;

    constructor(data?: IPupilHistoryDoExamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignExamId = _data["assignExamId"];
            this.title = _data["title"];
            this.type = _data["type"];
            this.subject = _data["subject"];
            this.submitDate = _data["submitDate"] ? new Date(_data["submitDate"].toString()) : undefined as any;
            this.score = _data["score"];
            this.status = _data["status"];
            this.createdBy = _data["createdBy"];
            this.canMark = _data["canMark"];
            this.examId = _data["examId"];
            this.examResultId = _data["examResultId"];
        }
    }

    static fromJS(data: any): PupilHistoryDoExamDto {
        data = typeof data === 'object' ? data : {};
        let result = new PupilHistoryDoExamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignExamId"] = this.assignExamId;
        data["title"] = this.title;
        data["type"] = this.type;
        data["subject"] = this.subject;
        data["submitDate"] = this.submitDate ? this.submitDate.toISOString() : undefined as any;
        data["score"] = this.score;
        data["status"] = this.status;
        data["createdBy"] = this.createdBy;
        data["canMark"] = this.canMark;
        data["examId"] = this.examId;
        data["examResultId"] = this.examResultId;
        return data;
    }
}

export interface IPupilHistoryDoExamDto {
    assignExamId?: number;
    title?: string | undefined;
    type?: AssignExamTypeEnum;
    subject?: string | undefined;
    submitDate?: Date | undefined;
    score?: number | undefined;
    status?: AssignExamUserStatusEnum;
    createdBy?: number;
    canMark?: boolean;
    examId?: number | undefined;
    examResultId?: number | undefined;
}

export class PupilHistoryDoExamFilterDto implements IPupilHistoryDoExamFilterDto {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    userId?: number;
    classId?: number;
    subjectId?: number | undefined;
    keyword?: string | undefined;
    submitDate?: Date | undefined;
    type?: AssignExamTypeEnum;

    constructor(data?: IPupilHistoryDoExamFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.userId = _data["userId"];
            this.classId = _data["classId"];
            this.subjectId = _data["subjectId"];
            this.keyword = _data["keyword"];
            this.submitDate = _data["submitDate"] ? new Date(_data["submitDate"].toString()) : undefined as any;
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): PupilHistoryDoExamFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new PupilHistoryDoExamFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["userId"] = this.userId;
        data["classId"] = this.classId;
        data["subjectId"] = this.subjectId;
        data["keyword"] = this.keyword;
        data["submitDate"] = this.submitDate ? this.submitDate.toISOString() : undefined as any;
        data["type"] = this.type;
        return data;
    }
}

export interface IPupilHistoryDoExamFilterDto {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    userId?: number;
    classId?: number;
    subjectId?: number | undefined;
    keyword?: string | undefined;
    submitDate?: Date | undefined;
    type?: AssignExamTypeEnum;
}

export class PupilListDto implements IPupilListDto {
    id?: number;
    userName?: string | undefined;
    avatar?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    studentCode?: string | undefined;
    createdDate?: Date | undefined;
    birthDay?: Date | undefined;
    gender?: number | undefined;
    status?: ClassUserStatusEnum;
    identifierCode?: string | undefined;
    classId?: number | undefined;
    className?: string | undefined;

    constructor(data?: IPupilListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.avatar = _data["avatar"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.studentCode = _data["studentCode"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.birthDay = _data["birthDay"] ? new Date(_data["birthDay"].toString()) : undefined as any;
            this.gender = _data["gender"];
            this.status = _data["status"];
            this.identifierCode = _data["identifierCode"];
            this.classId = _data["classId"];
            this.className = _data["className"];
        }
    }

    static fromJS(data: any): PupilListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PupilListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["avatar"] = this.avatar;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["studentCode"] = this.studentCode;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["birthDay"] = this.birthDay ? this.birthDay.toISOString() : undefined as any;
        data["gender"] = this.gender;
        data["status"] = this.status;
        data["identifierCode"] = this.identifierCode;
        data["classId"] = this.classId;
        data["className"] = this.className;
        return data;
    }
}

export interface IPupilListDto {
    id?: number;
    userName?: string | undefined;
    avatar?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    studentCode?: string | undefined;
    createdDate?: Date | undefined;
    birthDay?: Date | undefined;
    gender?: number | undefined;
    status?: ClassUserStatusEnum;
    identifierCode?: string | undefined;
    classId?: number | undefined;
    className?: string | undefined;
}

export class PupilStaticByTypeExamDto implements IPupilStaticByTypeExamDto {
    type?: AssignExamTypeEnum;
    total?: number | undefined;
    done?: number | undefined;
    averageScore?: number | undefined;

    constructor(data?: IPupilStaticByTypeExamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.total = _data["total"];
            this.done = _data["done"];
            this.averageScore = _data["averageScore"];
        }
    }

    static fromJS(data: any): PupilStaticByTypeExamDto {
        data = typeof data === 'object' ? data : {};
        let result = new PupilStaticByTypeExamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["total"] = this.total;
        data["done"] = this.done;
        data["averageScore"] = this.averageScore;
        return data;
    }
}

export interface IPupilStaticByTypeExamDto {
    type?: AssignExamTypeEnum;
    total?: number | undefined;
    done?: number | undefined;
    averageScore?: number | undefined;
}

export class PupilStaticDto implements IPupilStaticDto {
    averageScore?: number | undefined;
    percentage?: number | undefined;
    total?: number | undefined;

    constructor(data?: IPupilStaticDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.averageScore = _data["averageScore"];
            this.percentage = _data["percentage"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): PupilStaticDto {
        data = typeof data === 'object' ? data : {};
        let result = new PupilStaticDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["averageScore"] = this.averageScore;
        data["percentage"] = this.percentage;
        data["total"] = this.total;
        return data;
    }
}

export interface IPupilStaticDto {
    averageScore?: number | undefined;
    percentage?: number | undefined;
    total?: number | undefined;
}

export class PupilStatisticalDto implements IPupilStatisticalDto {
    totalClass?: number;
    totalExamNeedDo?: number;
    totalExam?: number;
    totalExamDone?: number;

    constructor(data?: IPupilStatisticalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalClass = _data["totalClass"];
            this.totalExamNeedDo = _data["totalExamNeedDo"];
            this.totalExam = _data["totalExam"];
            this.totalExamDone = _data["totalExamDone"];
        }
    }

    static fromJS(data: any): PupilStatisticalDto {
        data = typeof data === 'object' ? data : {};
        let result = new PupilStatisticalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalClass"] = this.totalClass;
        data["totalExamNeedDo"] = this.totalExamNeedDo;
        data["totalExam"] = this.totalExam;
        data["totalExamDone"] = this.totalExamDone;
        return data;
    }
}

export interface IPupilStatisticalDto {
    totalClass?: number;
    totalExamNeedDo?: number;
    totalExam?: number;
    totalExamDone?: number;
}

export class PurchaseTargetDto implements IPurchaseTargetDto {
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    name?: string | undefined;
    userType?: UserTypeEnum;

    constructor(data?: IPurchaseTargetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objectType = _data["objectType"];
            this.objectId = _data["objectId"];
            this.name = _data["name"];
            this.userType = _data["userType"];
        }
    }

    static fromJS(data: any): PurchaseTargetDto {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseTargetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objectType"] = this.objectType;
        data["objectId"] = this.objectId;
        data["name"] = this.name;
        data["userType"] = this.userType;
        return data;
    }
}

export interface IPurchaseTargetDto {
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    name?: string | undefined;
    userType?: UserTypeEnum;
}

export class QuestionDto implements IQuestionDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    type?: string | undefined;
    content?: string | undefined;
    avatar?: string | undefined;
    image?: string[] | undefined;
    answers?: any | undefined;
    explain?: string | undefined;
    transcript?: string | undefined;
    parentId?: number;
    sound?: string[] | undefined;
    video?: string | undefined;
    classLevel?: number;
    level?: QuestionLevelEnum;
    subjectId?: number;
    status?: QuestionStatusEnum;
    format?: ExamFormatEnum;
    labelType?: number;
    isSystem?: boolean;
    shareStatus?: ShareStatusEnum;
    sharedAt?: Date | undefined;
    tagIds?: number[] | undefined;
    mark?: number;
    childs?: QuestionDto[] | undefined;
    file?: string | undefined;

    constructor(data?: IQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.objectId = _data["objectId"];
            this.objectType = _data["objectType"];
            this.type = _data["type"];
            this.content = _data["content"];
            this.avatar = _data["avatar"];
            if (Array.isArray(_data["image"])) {
                this.image = [] as any;
                for (let item of _data["image"])
                    this.image!.push(item);
            }
            this.answers = _data["answers"];
            this.explain = _data["explain"];
            this.transcript = _data["transcript"];
            this.parentId = _data["parentId"];
            if (Array.isArray(_data["sound"])) {
                this.sound = [] as any;
                for (let item of _data["sound"])
                    this.sound!.push(item);
            }
            this.video = _data["video"];
            this.classLevel = _data["classLevel"];
            this.level = _data["level"];
            this.subjectId = _data["subjectId"];
            this.status = _data["status"];
            this.format = _data["format"];
            this.labelType = _data["labelType"];
            this.isSystem = _data["isSystem"];
            this.shareStatus = _data["shareStatus"];
            this.sharedAt = _data["sharedAt"] ? new Date(_data["sharedAt"].toString()) : undefined as any;
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
            this.mark = _data["mark"];
            if (Array.isArray(_data["childs"])) {
                this.childs = [] as any;
                for (let item of _data["childs"])
                    this.childs!.push(QuestionDto.fromJS(item));
            }
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): QuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["objectId"] = this.objectId;
        data["objectType"] = this.objectType;
        data["type"] = this.type;
        data["content"] = this.content;
        data["avatar"] = this.avatar;
        if (Array.isArray(this.image)) {
            data["image"] = [];
            for (let item of this.image)
                data["image"].push(item);
        }
        data["answers"] = this.answers;
        data["explain"] = this.explain;
        data["transcript"] = this.transcript;
        data["parentId"] = this.parentId;
        if (Array.isArray(this.sound)) {
            data["sound"] = [];
            for (let item of this.sound)
                data["sound"].push(item);
        }
        data["video"] = this.video;
        data["classLevel"] = this.classLevel;
        data["level"] = this.level;
        data["subjectId"] = this.subjectId;
        data["status"] = this.status;
        data["format"] = this.format;
        data["labelType"] = this.labelType;
        data["isSystem"] = this.isSystem;
        data["shareStatus"] = this.shareStatus;
        data["sharedAt"] = this.sharedAt ? this.sharedAt.toISOString() : undefined as any;
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        data["mark"] = this.mark;
        if (Array.isArray(this.childs)) {
            data["childs"] = [];
            for (let item of this.childs)
                data["childs"].push(item ? item.toJSON() : undefined as any);
        }
        data["file"] = this.file;
        return data;
    }
}

export interface IQuestionDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    type?: string | undefined;
    content?: string | undefined;
    avatar?: string | undefined;
    image?: string[] | undefined;
    answers?: any | undefined;
    explain?: string | undefined;
    transcript?: string | undefined;
    parentId?: number;
    sound?: string[] | undefined;
    video?: string | undefined;
    classLevel?: number;
    level?: QuestionLevelEnum;
    subjectId?: number;
    status?: QuestionStatusEnum;
    format?: ExamFormatEnum;
    labelType?: number;
    isSystem?: boolean;
    shareStatus?: ShareStatusEnum;
    sharedAt?: Date | undefined;
    tagIds?: number[] | undefined;
    mark?: number;
    childs?: QuestionDto[] | undefined;
    file?: string | undefined;
}

export class QuestionListDto implements IQuestionListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    type?: string | undefined;
    content?: string | undefined;
    avatar?: string | undefined;
    image?: string[] | undefined;
    answers?: string | undefined;
    explain?: string | undefined;
    transcript?: string | undefined;
    parentId?: number;
    sound?: string[] | undefined;
    video?: string | undefined;
    classLevel?: number;
    level?: QuestionLevelEnum;
    subjectId?: number;
    status?: QuestionStatusEnum;
    format?: ExamFormatEnum;
    labelType?: number;
    isSystem?: boolean;
    shareStatus?: ShareStatusEnum;
    sharedAt?: Date | undefined;
    isLike?: boolean;

    constructor(data?: IQuestionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.objectId = _data["objectId"];
            this.objectType = _data["objectType"];
            this.type = _data["type"];
            this.content = _data["content"];
            this.avatar = _data["avatar"];
            if (Array.isArray(_data["image"])) {
                this.image = [] as any;
                for (let item of _data["image"])
                    this.image!.push(item);
            }
            this.answers = _data["answers"];
            this.explain = _data["explain"];
            this.transcript = _data["transcript"];
            this.parentId = _data["parentId"];
            if (Array.isArray(_data["sound"])) {
                this.sound = [] as any;
                for (let item of _data["sound"])
                    this.sound!.push(item);
            }
            this.video = _data["video"];
            this.classLevel = _data["classLevel"];
            this.level = _data["level"];
            this.subjectId = _data["subjectId"];
            this.status = _data["status"];
            this.format = _data["format"];
            this.labelType = _data["labelType"];
            this.isSystem = _data["isSystem"];
            this.shareStatus = _data["shareStatus"];
            this.sharedAt = _data["sharedAt"] ? new Date(_data["sharedAt"].toString()) : undefined as any;
            this.isLike = _data["isLike"];
        }
    }

    static fromJS(data: any): QuestionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["objectId"] = this.objectId;
        data["objectType"] = this.objectType;
        data["type"] = this.type;
        data["content"] = this.content;
        data["avatar"] = this.avatar;
        if (Array.isArray(this.image)) {
            data["image"] = [];
            for (let item of this.image)
                data["image"].push(item);
        }
        data["answers"] = this.answers;
        data["explain"] = this.explain;
        data["transcript"] = this.transcript;
        data["parentId"] = this.parentId;
        if (Array.isArray(this.sound)) {
            data["sound"] = [];
            for (let item of this.sound)
                data["sound"].push(item);
        }
        data["video"] = this.video;
        data["classLevel"] = this.classLevel;
        data["level"] = this.level;
        data["subjectId"] = this.subjectId;
        data["status"] = this.status;
        data["format"] = this.format;
        data["labelType"] = this.labelType;
        data["isSystem"] = this.isSystem;
        data["shareStatus"] = this.shareStatus;
        data["sharedAt"] = this.sharedAt ? this.sharedAt.toISOString() : undefined as any;
        data["isLike"] = this.isLike;
        return data;
    }
}

export interface IQuestionListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    type?: string | undefined;
    content?: string | undefined;
    avatar?: string | undefined;
    image?: string[] | undefined;
    answers?: string | undefined;
    explain?: string | undefined;
    transcript?: string | undefined;
    parentId?: number;
    sound?: string[] | undefined;
    video?: string | undefined;
    classLevel?: number;
    level?: QuestionLevelEnum;
    subjectId?: number;
    status?: QuestionStatusEnum;
    format?: ExamFormatEnum;
    labelType?: number;
    isSystem?: boolean;
    shareStatus?: ShareStatusEnum;
    objectShareStatus?: ShareStatusEnum;
    sharedAt?: Date | undefined;
    isLike?: boolean;
    canEdit?: boolean;
}

export class RoleDto implements IRoleDto {
    id?: number;
    name?: string | undefined;
    userCount?: number;
    canEdit?: boolean;
    canAssign?: boolean;
    listModule?: RoleModuleDto[] | undefined;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.userCount = _data["userCount"];
            this.canEdit = _data["canEdit"];
            this.canAssign = _data["canAssign"];
            if (Array.isArray(_data["listModule"])) {
                this.listModule = [] as any;
                for (let item of _data["listModule"])
                    this.listModule!.push(RoleModuleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["userCount"] = this.userCount;
        data["canEdit"] = this.canEdit;
        data["canAssign"] = this.canAssign;
        if (Array.isArray(this.listModule)) {
            data["listModule"] = [];
            for (let item of this.listModule)
                data["listModule"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRoleDto {
    id?: number;
    name?: string | undefined;
    userCount?: number;
    canEdit?: boolean;
    canAssign?: boolean;
    listModule?: RoleModuleDto[] | undefined;
}

export class RoleModuleDto implements IRoleModuleDto {
    module?: ModuleEnum;
    moduleName?: string | undefined;
    isZone?: boolean;
    isFull?: boolean;
    objectId?: number;
    allow?: number;
    deny?: number;
    permissions?: RolePermissionDto[] | undefined;

    constructor(data?: IRoleModuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.module = _data["module"];
            this.moduleName = _data["moduleName"];
            this.isZone = _data["isZone"];
            this.isFull = _data["isFull"];
            this.objectId = _data["objectId"];
            this.allow = _data["allow"];
            this.deny = _data["deny"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(RolePermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleModuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleModuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["module"] = this.module;
        data["moduleName"] = this.moduleName;
        data["isZone"] = this.isZone;
        data["isFull"] = this.isFull;
        data["objectId"] = this.objectId;
        data["allow"] = this.allow;
        data["deny"] = this.deny;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRoleModuleDto {
    module?: ModuleEnum;
    moduleName?: string | undefined;
    isZone?: boolean;
    isFull?: boolean;
    objectId?: number;
    allow?: number;
    deny?: number;
    permissions?: RolePermissionDto[] | undefined;
}

export class RolePermissionDto implements IRolePermissionDto {
    fullZone?: boolean;
    zoneIds?: number[] | undefined;
    permission?: number;

    constructor(data?: IRolePermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullZone = _data["fullZone"];
            if (Array.isArray(_data["zoneIds"])) {
                this.zoneIds = [] as any;
                for (let item of _data["zoneIds"])
                    this.zoneIds!.push(item);
            }
            this.permission = _data["permission"];
        }
    }

    static fromJS(data: any): RolePermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RolePermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullZone"] = this.fullZone;
        if (Array.isArray(this.zoneIds)) {
            data["zoneIds"] = [];
            for (let item of this.zoneIds)
                data["zoneIds"].push(item);
        }
        data["permission"] = this.permission;
        return data;
    }
}

export interface IRolePermissionDto {
    fullZone?: boolean;
    zoneIds?: number[] | undefined;
    permission?: number;
}

export class SchoolClassDto implements ISchoolClassDto {
    id?: number;
    name?: string | undefined;
    classes?: ClassShortDto[] | undefined;

    constructor(data?: ISchoolClassDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["classes"])) {
                this.classes = [] as any;
                for (let item of _data["classes"])
                    this.classes!.push(ClassShortDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SchoolClassDto {
        data = typeof data === 'object' ? data : {};
        let result = new SchoolClassDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.classes)) {
            data["classes"] = [];
            for (let item of this.classes)
                data["classes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISchoolClassDto {
    id?: number;
    name?: string | undefined;
    classes?: ClassShortDto[] | undefined;
}

export class SchoolDto implements ISchoolDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    code?: string | undefined;
    name?: string | undefined;
    status?: SchoolStatusEnum;
    countryId?: number;
    districtId?: number;
    provinceId?: number;
    wardId?: number;
    address?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    logo?: string | undefined;
    url?: string | undefined;
    description?: string | undefined;
    type?: number;
    levels?: string | undefined;
    organizationId?: number;
    parentId?: number;
    isTemp?: boolean;
    templateSchoolId?: number;
    ownerUserId?: number;
    approvedBy?: number;
    approvedAt?: Date | undefined;
    rejectReason?: string | undefined;
    languageCode?: string | undefined;
    maxStudentCount?: number;
    maxStaffCount?: number;
    departmentId?: number;
    establishmentDecisionFile?: string | undefined;

    constructor(data?: ISchoolDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.countryId = _data["countryId"];
            this.districtId = _data["districtId"];
            this.provinceId = _data["provinceId"];
            this.wardId = _data["wardId"];
            this.address = _data["address"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.logo = _data["logo"];
            this.url = _data["url"];
            this.description = _data["description"];
            this.type = _data["type"];
            this.levels = _data["levels"];
            this.organizationId = _data["organizationId"];
            this.parentId = _data["parentId"];
            this.isTemp = _data["isTemp"];
            this.templateSchoolId = _data["templateSchoolId"];
            this.ownerUserId = _data["ownerUserId"];
            this.approvedBy = _data["approvedBy"];
            this.approvedAt = _data["approvedAt"] ? new Date(_data["approvedAt"].toString()) : undefined as any;
            this.rejectReason = _data["rejectReason"];
            this.languageCode = _data["languageCode"];
            this.maxStudentCount = _data["maxStudentCount"];
            this.maxStaffCount = _data["maxStaffCount"];
            this.departmentId = _data["departmentId"];
            this.establishmentDecisionFile = _data["establishmentDecisionFile"];
        }
    }

    static fromJS(data: any): SchoolDto {
        data = typeof data === 'object' ? data : {};
        let result = new SchoolDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["code"] = this.code;
        data["name"] = this.name;
        data["status"] = this.status;
        data["countryId"] = this.countryId;
        data["districtId"] = this.districtId;
        data["provinceId"] = this.provinceId;
        data["wardId"] = this.wardId;
        data["address"] = this.address;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["logo"] = this.logo;
        data["url"] = this.url;
        data["description"] = this.description;
        data["type"] = this.type;
        data["levels"] = this.levels;
        data["organizationId"] = this.organizationId;
        data["parentId"] = this.parentId;
        data["isTemp"] = this.isTemp;
        data["templateSchoolId"] = this.templateSchoolId;
        data["ownerUserId"] = this.ownerUserId;
        data["approvedBy"] = this.approvedBy;
        data["approvedAt"] = this.approvedAt ? this.approvedAt.toISOString() : undefined as any;
        data["rejectReason"] = this.rejectReason;
        data["languageCode"] = this.languageCode;
        data["maxStudentCount"] = this.maxStudentCount;
        data["maxStaffCount"] = this.maxStaffCount;
        data["departmentId"] = this.departmentId;
        data["establishmentDecisionFile"] = this.establishmentDecisionFile;
        return data;
    }
}

export interface ISchoolDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    code?: string | undefined;
    name?: string | undefined;
    status?: SchoolStatusEnum;
    countryId?: number;
    districtId?: number;
    provinceId?: number;
    wardId?: number;
    address?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    logo?: string | undefined;
    url?: string | undefined;
    description?: string | undefined;
    type?: number;
    levels?: string | undefined;
    organizationId?: number;
    parentId?: number;
    isTemp?: boolean;
    templateSchoolId?: number;
    ownerUserId?: number;
    approvedBy?: number;
    approvedAt?: Date | undefined;
    rejectReason?: string | undefined;
    languageCode?: string | undefined;
    maxStudentCount?: number;
    maxStaffCount?: number;
    departmentId?: number;
    establishmentDecisionFile?: string | undefined;
}

export class SchoolGetListQuery implements ISchoolGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    departmentId?: number | undefined;
    officeId?: number | undefined;
    type?: number | undefined;
    countryId?: number | undefined;
    organizationId?: number | undefined;
    parentId?: number | undefined;
    levels?: string | undefined;
    isTemp?: boolean | undefined;
    status?: SchoolStatusEnum;

    constructor(data?: ISchoolGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.keyword = _data["keyword"];
            this.departmentId = _data["departmentId"];
            this.officeId = _data["officeId"];
            this.type = _data["type"];
            this.countryId = _data["countryId"];
            this.organizationId = _data["organizationId"];
            this.parentId = _data["parentId"];
            this.levels = _data["levels"];
            this.isTemp = _data["isTemp"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): SchoolGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SchoolGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["keyword"] = this.keyword;
        data["departmentId"] = this.departmentId;
        data["officeId"] = this.officeId;
        data["type"] = this.type;
        data["countryId"] = this.countryId;
        data["organizationId"] = this.organizationId;
        data["parentId"] = this.parentId;
        data["levels"] = this.levels;
        data["isTemp"] = this.isTemp;
        data["status"] = this.status;
        return data;
    }
}

export interface ISchoolGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    departmentId?: number | undefined;
    officeId?: number | undefined;
    type?: number | undefined;
    countryId?: number | undefined;
    organizationId?: number | undefined;
    parentId?: number | undefined;
    levels?: string | undefined;
    isTemp?: boolean | undefined;
    status?: SchoolStatusEnum;
}

export class SchoolListDto implements ISchoolListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    code?: string | undefined;
    name?: string | undefined;
    status?: SchoolStatusEnum;
    countryId?: number;
    districtId?: number;
    provinceId?: number;
    wardId?: number;
    address?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    logo?: string | undefined;
    url?: string | undefined;
    description?: string | undefined;
    type?: number;
    levels?: string | undefined;
    organizationId?: number;
    parentId?: number;
    isTemp?: boolean;
    templateSchoolId?: number;
    ownerUserId?: number;
    approvedBy?: number;
    approvedAt?: Date | undefined;
    rejectReason?: string | undefined;
    languageCode?: string | undefined;
    maxStudentCount?: number;
    maxStaffCount?: number;
    countActiveClass?: number;
    departmentName?: string | undefined;
    officeName?: string | undefined;
    studentCount?: number;
    teacherCount?: number;

    constructor(data?: ISchoolListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.countryId = _data["countryId"];
            this.districtId = _data["districtId"];
            this.provinceId = _data["provinceId"];
            this.wardId = _data["wardId"];
            this.address = _data["address"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.logo = _data["logo"];
            this.url = _data["url"];
            this.description = _data["description"];
            this.type = _data["type"];
            this.levels = _data["levels"];
            this.organizationId = _data["organizationId"];
            this.parentId = _data["parentId"];
            this.isTemp = _data["isTemp"];
            this.templateSchoolId = _data["templateSchoolId"];
            this.ownerUserId = _data["ownerUserId"];
            this.approvedBy = _data["approvedBy"];
            this.approvedAt = _data["approvedAt"] ? new Date(_data["approvedAt"].toString()) : undefined as any;
            this.rejectReason = _data["rejectReason"];
            this.languageCode = _data["languageCode"];
            this.maxStudentCount = _data["maxStudentCount"];
            this.maxStaffCount = _data["maxStaffCount"];
            this.countActiveClass = _data["countActiveClass"];
            this.departmentName = _data["departmentName"];
            this.officeName = _data["officeName"];
            this.studentCount = _data["studentCount"];
            this.teacherCount = _data["teacherCount"];
        }
    }

    static fromJS(data: any): SchoolListDto {
        data = typeof data === 'object' ? data : {};
        let result = new SchoolListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["code"] = this.code;
        data["name"] = this.name;
        data["status"] = this.status;
        data["countryId"] = this.countryId;
        data["districtId"] = this.districtId;
        data["provinceId"] = this.provinceId;
        data["wardId"] = this.wardId;
        data["address"] = this.address;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["logo"] = this.logo;
        data["url"] = this.url;
        data["description"] = this.description;
        data["type"] = this.type;
        data["levels"] = this.levels;
        data["organizationId"] = this.organizationId;
        data["parentId"] = this.parentId;
        data["isTemp"] = this.isTemp;
        data["templateSchoolId"] = this.templateSchoolId;
        data["ownerUserId"] = this.ownerUserId;
        data["approvedBy"] = this.approvedBy;
        data["approvedAt"] = this.approvedAt ? this.approvedAt.toISOString() : undefined as any;
        data["rejectReason"] = this.rejectReason;
        data["languageCode"] = this.languageCode;
        data["maxStudentCount"] = this.maxStudentCount;
        data["maxStaffCount"] = this.maxStaffCount;
        data["countActiveClass"] = this.countActiveClass;
        data["departmentName"] = this.departmentName;
        data["officeName"] = this.officeName;
        data["studentCount"] = this.studentCount;
        data["teacherCount"] = this.teacherCount;
        return data;
    }
}

export interface ISchoolListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    code?: string | undefined;
    name?: string | undefined;
    status?: SchoolStatusEnum;
    countryId?: number;
    districtId?: number;
    provinceId?: number;
    wardId?: number;
    address?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    logo?: string | undefined;
    url?: string | undefined;
    description?: string | undefined;
    type?: number;
    levels?: string | undefined;
    organizationId?: number;
    parentId?: number;
    isTemp?: boolean;
    templateSchoolId?: number;
    ownerUserId?: number;
    approvedBy?: number;
    approvedAt?: Date | undefined;
    rejectReason?: string | undefined;
    languageCode?: string | undefined;
    maxStudentCount?: number;
    maxStaffCount?: number;
    countActiveClass?: number;
    departmentName?: string | undefined;
    officeName?: string | undefined;
    studentCount?: number;
    teacherCount?: number;
}

export class SchoolStaticCountDto implements ISchoolStaticCountDto {
    schoolName?: string | undefined;
    classCount?: number;
    teacherCount?: number;
    studentCount?: number;
    assignmentCount?: number;
    productCount?: number;

    constructor(data?: ISchoolStaticCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.schoolName = _data["schoolName"];
            this.classCount = _data["classCount"];
            this.teacherCount = _data["teacherCount"];
            this.studentCount = _data["studentCount"];
            this.assignmentCount = _data["assignmentCount"];
            this.productCount = _data["productCount"];
        }
    }

    static fromJS(data: any): SchoolStaticCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new SchoolStaticCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["schoolName"] = this.schoolName;
        data["classCount"] = this.classCount;
        data["teacherCount"] = this.teacherCount;
        data["studentCount"] = this.studentCount;
        data["assignmentCount"] = this.assignmentCount;
        data["productCount"] = this.productCount;
        return data;
    }
}

export interface ISchoolStaticCountDto {
    schoolName?: string | undefined;
    classCount?: number;
    teacherCount?: number;
    studentCount?: number;
    assignmentCount?: number;
    productCount?: number;
}

export class SePayNotifyResource implements ISePayNotifyResource {
    id?: number;
    gateway?: string | undefined;
    transactionDate?: string | undefined;
    accountNumber?: string | undefined;
    code?: string | undefined;
    content?: string | undefined;
    transferType?: string | undefined;
    transferAmount?: number;
    referenceCode?: string | undefined;
    description?: string | undefined;

    constructor(data?: ISePayNotifyResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gateway = _data["gateway"];
            this.transactionDate = _data["transactionDate"];
            this.accountNumber = _data["accountNumber"];
            this.code = _data["code"];
            this.content = _data["content"];
            this.transferType = _data["transferType"];
            this.transferAmount = _data["transferAmount"];
            this.referenceCode = _data["referenceCode"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): SePayNotifyResource {
        data = typeof data === 'object' ? data : {};
        let result = new SePayNotifyResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gateway"] = this.gateway;
        data["transactionDate"] = this.transactionDate;
        data["accountNumber"] = this.accountNumber;
        data["code"] = this.code;
        data["content"] = this.content;
        data["transferType"] = this.transferType;
        data["transferAmount"] = this.transferAmount;
        data["referenceCode"] = this.referenceCode;
        data["description"] = this.description;
        return data;
    }
}

export interface ISePayNotifyResource {
    id?: number;
    gateway?: string | undefined;
    transactionDate?: string | undefined;
    accountNumber?: string | undefined;
    code?: string | undefined;
    content?: string | undefined;
    transferType?: string | undefined;
    transferAmount?: number;
    referenceCode?: string | undefined;
    description?: string | undefined;
}

export class SessionStatusDto implements ISessionStatusDto {
    isActive?: boolean;
    expires?: Date | undefined;
    deviceRevoked?: boolean;

    constructor(data?: ISessionStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isActive = _data["isActive"];
            this.expires = _data["expires"] ? new Date(_data["expires"].toString()) : undefined as any;
            this.deviceRevoked = _data["deviceRevoked"];
        }
    }

    static fromJS(data: any): SessionStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new SessionStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["expires"] = this.expires ? this.expires.toISOString() : undefined as any;
        data["deviceRevoked"] = this.deviceRevoked;
        return data;
    }
}

export interface ISessionStatusDto {
    isActive?: boolean;
    expires?: Date | undefined;
    deviceRevoked?: boolean;
}

export class StaticPageDetailDto implements IStaticPageDetailDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    pageKey?: string | undefined;
    title?: string | undefined;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaImage?: string | undefined;
    status?: CommonStatusEnum;
    sections?: StaticPageSectionDto[] | undefined;
    locales?: StaticPageLocaleEntity[] | undefined;

    constructor(data?: IStaticPageDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.pageKey = _data["pageKey"];
            this.title = _data["title"];
            this.metaTitle = _data["metaTitle"];
            this.metaDescription = _data["metaDescription"];
            this.metaImage = _data["metaImage"];
            this.status = _data["status"];
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(StaticPageSectionDto.fromJS(item));
            }
            if (Array.isArray(_data["locales"])) {
                this.locales = [] as any;
                for (let item of _data["locales"])
                    this.locales!.push(StaticPageLocaleEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StaticPageDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new StaticPageDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["pageKey"] = this.pageKey;
        data["title"] = this.title;
        data["metaTitle"] = this.metaTitle;
        data["metaDescription"] = this.metaDescription;
        data["metaImage"] = this.metaImage;
        data["status"] = this.status;
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.locales)) {
            data["locales"] = [];
            for (let item of this.locales)
                data["locales"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IStaticPageDetailDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    pageKey?: string | undefined;
    title?: string | undefined;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaImage?: string | undefined;
    status?: CommonStatusEnum;
    sections?: StaticPageSectionDto[] | undefined;
    locales?: StaticPageLocaleEntity[] | undefined;
}

export class StaticPageGetListQuery implements IStaticPageGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    status?: CommonStatusEnum;

    constructor(data?: IStaticPageGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.keyword = _data["keyword"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): StaticPageGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new StaticPageGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["keyword"] = this.keyword;
        data["status"] = this.status;
        return data;
    }
}

export interface IStaticPageGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    status?: CommonStatusEnum;
}

export class StaticPageListDto implements IStaticPageListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    pageKey?: string | undefined;
    title?: string | undefined;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaImage?: string | undefined;
    status?: CommonStatusEnum;
    sections?: StaticPageSectionEntity[] | undefined;
    locales?: StaticPageLocaleEntity[] | undefined;

    constructor(data?: IStaticPageListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.pageKey = _data["pageKey"];
            this.title = _data["title"];
            this.metaTitle = _data["metaTitle"];
            this.metaDescription = _data["metaDescription"];
            this.metaImage = _data["metaImage"];
            this.status = _data["status"];
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(StaticPageSectionEntity.fromJS(item));
            }
            if (Array.isArray(_data["locales"])) {
                this.locales = [] as any;
                for (let item of _data["locales"])
                    this.locales!.push(StaticPageLocaleEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StaticPageListDto {
        data = typeof data === 'object' ? data : {};
        let result = new StaticPageListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["pageKey"] = this.pageKey;
        data["title"] = this.title;
        data["metaTitle"] = this.metaTitle;
        data["metaDescription"] = this.metaDescription;
        data["metaImage"] = this.metaImage;
        data["status"] = this.status;
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.locales)) {
            data["locales"] = [];
            for (let item of this.locales)
                data["locales"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IStaticPageListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    pageKey?: string | undefined;
    title?: string | undefined;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaImage?: string | undefined;
    status?: CommonStatusEnum;
    sections?: StaticPageSectionEntity[] | undefined;
    locales?: StaticPageLocaleEntity[] | undefined;
}

export class StaticPageLocaleDto implements IStaticPageLocaleDto {
    id?: number;
    pageId?: number;
    languageCode?: string | undefined;
    title?: string | undefined;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaImage?: string | undefined;

    constructor(data?: IStaticPageLocaleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pageId = _data["pageId"];
            this.languageCode = _data["languageCode"];
            this.title = _data["title"];
            this.metaTitle = _data["metaTitle"];
            this.metaDescription = _data["metaDescription"];
            this.metaImage = _data["metaImage"];
        }
    }

    static fromJS(data: any): StaticPageLocaleDto {
        data = typeof data === 'object' ? data : {};
        let result = new StaticPageLocaleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pageId"] = this.pageId;
        data["languageCode"] = this.languageCode;
        data["title"] = this.title;
        data["metaTitle"] = this.metaTitle;
        data["metaDescription"] = this.metaDescription;
        data["metaImage"] = this.metaImage;
        return data;
    }
}

export interface IStaticPageLocaleDto {
    id?: number;
    pageId?: number;
    languageCode?: string | undefined;
    title?: string | undefined;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaImage?: string | undefined;
}

export class StaticPageLocaleSaveDto implements IStaticPageLocaleSaveDto {
    id?: number;
    pageId?: number;
    languageCode?: string | undefined;
    title?: string | undefined;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaImage?: string | undefined;

    constructor(data?: IStaticPageLocaleSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pageId = _data["pageId"];
            this.languageCode = _data["languageCode"];
            this.title = _data["title"];
            this.metaTitle = _data["metaTitle"];
            this.metaDescription = _data["metaDescription"];
            this.metaImage = _data["metaImage"];
        }
    }

    static fromJS(data: any): StaticPageLocaleSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new StaticPageLocaleSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pageId"] = this.pageId;
        data["languageCode"] = this.languageCode;
        data["title"] = this.title;
        data["metaTitle"] = this.metaTitle;
        data["metaDescription"] = this.metaDescription;
        data["metaImage"] = this.metaImage;
        return data;
    }
}

export interface IStaticPageLocaleSaveDto {
    id?: number;
    pageId?: number;
    languageCode?: string | undefined;
    title?: string | undefined;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaImage?: string | undefined;
}

export class StaticPageLocaleStatusDto implements IStaticPageLocaleStatusDto {
    languageCode?: string | undefined;
    hasPageMeta?: boolean;
    hasAllSectionContent?: boolean;

    constructor(data?: IStaticPageLocaleStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageCode = _data["languageCode"];
            this.hasPageMeta = _data["hasPageMeta"];
            this.hasAllSectionContent = _data["hasAllSectionContent"];
        }
    }

    static fromJS(data: any): StaticPageLocaleStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new StaticPageLocaleStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageCode"] = this.languageCode;
        data["hasPageMeta"] = this.hasPageMeta;
        data["hasAllSectionContent"] = this.hasAllSectionContent;
        return data;
    }
}

export interface IStaticPageLocaleStatusDto {
    languageCode?: string | undefined;
    hasPageMeta?: boolean;
    hasAllSectionContent?: boolean;
}

export class StaticPageSaveDto implements IStaticPageSaveDto {
    id?: number;
    pageKey?: string | undefined;
    title?: string | undefined;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaImage?: string | undefined;
    status?: CommonStatusEnum;

    constructor(data?: IStaticPageSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pageKey = _data["pageKey"];
            this.title = _data["title"];
            this.metaTitle = _data["metaTitle"];
            this.metaDescription = _data["metaDescription"];
            this.metaImage = _data["metaImage"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): StaticPageSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new StaticPageSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pageKey"] = this.pageKey;
        data["title"] = this.title;
        data["metaTitle"] = this.metaTitle;
        data["metaDescription"] = this.metaDescription;
        data["metaImage"] = this.metaImage;
        data["status"] = this.status;
        return data;
    }
}

export interface IStaticPageSaveDto {
    id?: number;
    pageKey?: string | undefined;
    title?: string | undefined;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaImage?: string | undefined;
    status?: CommonStatusEnum;
}

export class StaticPageSectionContentCopyDto implements IStaticPageSectionContentCopyDto {
    sectionId?: number;
    sourceLanguageCode?: string | undefined;
    targetLanguageCode?: string | undefined;

    constructor(data?: IStaticPageSectionContentCopyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sectionId = _data["sectionId"];
            this.sourceLanguageCode = _data["sourceLanguageCode"];
            this.targetLanguageCode = _data["targetLanguageCode"];
        }
    }

    static fromJS(data: any): StaticPageSectionContentCopyDto {
        data = typeof data === 'object' ? data : {};
        let result = new StaticPageSectionContentCopyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sectionId"] = this.sectionId;
        data["sourceLanguageCode"] = this.sourceLanguageCode;
        data["targetLanguageCode"] = this.targetLanguageCode;
        return data;
    }
}

export interface IStaticPageSectionContentCopyDto {
    sectionId?: number;
    sourceLanguageCode?: string | undefined;
    targetLanguageCode?: string | undefined;
}

export class StaticPageSectionContentDto implements IStaticPageSectionContentDto {
    id?: number;
    sectionId?: number;
    languageCode?: string | undefined;
    contentData?: string | undefined;

    constructor(data?: IStaticPageSectionContentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sectionId = _data["sectionId"];
            this.languageCode = _data["languageCode"];
            this.contentData = _data["contentData"];
        }
    }

    static fromJS(data: any): StaticPageSectionContentDto {
        data = typeof data === 'object' ? data : {};
        let result = new StaticPageSectionContentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sectionId"] = this.sectionId;
        data["languageCode"] = this.languageCode;
        data["contentData"] = this.contentData;
        return data;
    }
}

export interface IStaticPageSectionContentDto {
    id?: number;
    sectionId?: number;
    languageCode?: string | undefined;
    contentData?: string | undefined;
}

export class StaticPageSectionContentSaveDto implements IStaticPageSectionContentSaveDto {
    id?: number;
    sectionId?: number;
    languageCode?: string | undefined;
    contentData?: string | undefined;

    constructor(data?: IStaticPageSectionContentSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sectionId = _data["sectionId"];
            this.languageCode = _data["languageCode"];
            this.contentData = _data["contentData"];
        }
    }

    static fromJS(data: any): StaticPageSectionContentSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new StaticPageSectionContentSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sectionId"] = this.sectionId;
        data["languageCode"] = this.languageCode;
        data["contentData"] = this.contentData;
        return data;
    }
}

export interface IStaticPageSectionContentSaveDto {
    id?: number;
    sectionId?: number;
    languageCode?: string | undefined;
    contentData?: string | undefined;
}

export class StaticPageSectionDto implements IStaticPageSectionDto {
    id?: number;
    pageId?: number;
    sectionKey?: string | undefined;
    label?: string | undefined;
    isRepeatable?: boolean;
    sortOrder?: number;
    fieldDefinitions?: string | undefined;
    contentData?: string | undefined;
    status?: CommonStatusEnum;

    constructor(data?: IStaticPageSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pageId = _data["pageId"];
            this.sectionKey = _data["sectionKey"];
            this.label = _data["label"];
            this.isRepeatable = _data["isRepeatable"];
            this.sortOrder = _data["sortOrder"];
            this.fieldDefinitions = _data["fieldDefinitions"];
            this.contentData = _data["contentData"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): StaticPageSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new StaticPageSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pageId"] = this.pageId;
        data["sectionKey"] = this.sectionKey;
        data["label"] = this.label;
        data["isRepeatable"] = this.isRepeatable;
        data["sortOrder"] = this.sortOrder;
        data["fieldDefinitions"] = this.fieldDefinitions;
        data["contentData"] = this.contentData;
        data["status"] = this.status;
        return data;
    }
}

export interface IStaticPageSectionDto {
    id?: number;
    pageId?: number;
    sectionKey?: string | undefined;
    label?: string | undefined;
    isRepeatable?: boolean;
    sortOrder?: number;
    fieldDefinitions?: string | undefined;
    contentData?: string | undefined;
    status?: CommonStatusEnum;
}

export class StaticPageSectionListDto implements IStaticPageSectionListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    pageId?: number;
    sectionKey?: string | undefined;
    label?: string | undefined;
    isRepeatable?: boolean;
    sortOrder?: number;
    fieldDefinitions?: string | undefined;
    contentData?: string | undefined;
    status?: CommonStatusEnum;
    page?: StaticPageEntity;
    contents?: StaticPageSectionContentEntity[] | undefined;

    constructor(data?: IStaticPageSectionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.pageId = _data["pageId"];
            this.sectionKey = _data["sectionKey"];
            this.label = _data["label"];
            this.isRepeatable = _data["isRepeatable"];
            this.sortOrder = _data["sortOrder"];
            this.fieldDefinitions = _data["fieldDefinitions"];
            this.contentData = _data["contentData"];
            this.status = _data["status"];
            this.page = _data["page"] ? StaticPageEntity.fromJS(_data["page"]) : undefined as any;
            if (Array.isArray(_data["contents"])) {
                this.contents = [] as any;
                for (let item of _data["contents"])
                    this.contents!.push(StaticPageSectionContentEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StaticPageSectionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new StaticPageSectionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["pageId"] = this.pageId;
        data["sectionKey"] = this.sectionKey;
        data["label"] = this.label;
        data["isRepeatable"] = this.isRepeatable;
        data["sortOrder"] = this.sortOrder;
        data["fieldDefinitions"] = this.fieldDefinitions;
        data["contentData"] = this.contentData;
        data["status"] = this.status;
        data["page"] = this.page ? this.page.toJSON() : undefined as any;
        if (Array.isArray(this.contents)) {
            data["contents"] = [];
            for (let item of this.contents)
                data["contents"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IStaticPageSectionListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    pageId?: number;
    sectionKey?: string | undefined;
    label?: string | undefined;
    isRepeatable?: boolean;
    sortOrder?: number;
    fieldDefinitions?: string | undefined;
    contentData?: string | undefined;
    status?: CommonStatusEnum;
    page?: StaticPageEntity;
    contents?: StaticPageSectionContentEntity[] | undefined;
}

export class StaticPageSectionOrderItem implements IStaticPageSectionOrderItem {
    id?: number;
    sortOrder?: number;

    constructor(data?: IStaticPageSectionOrderItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): StaticPageSectionOrderItem {
        data = typeof data === 'object' ? data : {};
        let result = new StaticPageSectionOrderItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IStaticPageSectionOrderItem {
    id?: number;
    sortOrder?: number;
}

export class StaticPageSectionReorderDto implements IStaticPageSectionReorderDto {
    pageId?: number;
    items?: StaticPageSectionOrderItem[] | undefined;

    constructor(data?: IStaticPageSectionReorderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageId = _data["pageId"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StaticPageSectionOrderItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StaticPageSectionReorderDto {
        data = typeof data === 'object' ? data : {};
        let result = new StaticPageSectionReorderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageId"] = this.pageId;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IStaticPageSectionReorderDto {
    pageId?: number;
    items?: StaticPageSectionOrderItem[] | undefined;
}

export class StaticPageSectionSaveDto implements IStaticPageSectionSaveDto {
    id?: number;
    pageId?: number;
    sectionKey?: string | undefined;
    label?: string | undefined;
    isRepeatable?: boolean;
    sortOrder?: number;
    fieldDefinitions?: string | undefined;
    contentData?: string | undefined;
    status?: CommonStatusEnum;

    constructor(data?: IStaticPageSectionSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pageId = _data["pageId"];
            this.sectionKey = _data["sectionKey"];
            this.label = _data["label"];
            this.isRepeatable = _data["isRepeatable"];
            this.sortOrder = _data["sortOrder"];
            this.fieldDefinitions = _data["fieldDefinitions"];
            this.contentData = _data["contentData"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): StaticPageSectionSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new StaticPageSectionSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pageId"] = this.pageId;
        data["sectionKey"] = this.sectionKey;
        data["label"] = this.label;
        data["isRepeatable"] = this.isRepeatable;
        data["sortOrder"] = this.sortOrder;
        data["fieldDefinitions"] = this.fieldDefinitions;
        data["contentData"] = this.contentData;
        data["status"] = this.status;
        return data;
    }
}

export interface IStaticPageSectionSaveDto {
    id?: number;
    pageId?: number;
    sectionKey?: string | undefined;
    label?: string | undefined;
    isRepeatable?: boolean;
    sortOrder?: number;
    fieldDefinitions?: string | undefined;
    contentData?: string | undefined;
    status?: CommonStatusEnum;
}

export class StatisticalDto implements IStatisticalDto {
    totalClass?: number;
    totalStudent?: number;
    totalExam?: number;
    totalQuestion?: number;

    constructor(data?: IStatisticalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalClass = _data["totalClass"];
            this.totalStudent = _data["totalStudent"];
            this.totalExam = _data["totalExam"];
            this.totalQuestion = _data["totalQuestion"];
        }
    }

    static fromJS(data: any): StatisticalDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalClass"] = this.totalClass;
        data["totalStudent"] = this.totalStudent;
        data["totalExam"] = this.totalExam;
        data["totalQuestion"] = this.totalQuestion;
        return data;
    }
}

export interface IStatisticalDto {
    totalClass?: number;
    totalStudent?: number;
    totalExam?: number;
    totalQuestion?: number;
}

export class TagAddNewsDto implements ITagAddNewsDto {
    tagId?: number;
    newsIds?: number[] | undefined;

    constructor(data?: ITagAddNewsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagId = _data["tagId"];
            if (Array.isArray(_data["newsIds"])) {
                this.newsIds = [] as any;
                for (let item of _data["newsIds"])
                    this.newsIds!.push(item);
            }
        }
    }

    static fromJS(data: any): TagAddNewsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagAddNewsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagId"] = this.tagId;
        if (Array.isArray(this.newsIds)) {
            data["newsIds"] = [];
            for (let item of this.newsIds)
                data["newsIds"].push(item);
        }
        return data;
    }
}

export interface ITagAddNewsDto {
    tagId?: number;
    newsIds?: number[] | undefined;
}

export class TagDto implements ITagDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    name?: string | undefined;
    unsignName?: string | undefined;
    url?: string | undefined;
    isHotTag?: boolean;
    status?: number;

    constructor(data?: ITagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.name = _data["name"];
            this.unsignName = _data["unsignName"];
            this.url = _data["url"];
            this.isHotTag = _data["isHotTag"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): TagDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["name"] = this.name;
        data["unsignName"] = this.unsignName;
        data["url"] = this.url;
        data["isHotTag"] = this.isHotTag;
        data["status"] = this.status;
        return data;
    }
}

export interface ITagDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    name?: string | undefined;
    unsignName?: string | undefined;
    url?: string | undefined;
    isHotTag?: boolean;
    status?: number;
}

export class TagGetListQuery implements ITagGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    zoneId?: number | undefined;
    type?: number;

    constructor(data?: ITagGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.keyword = _data["keyword"];
            this.zoneId = _data["zoneId"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): TagGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new TagGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["keyword"] = this.keyword;
        data["zoneId"] = this.zoneId;
        data["type"] = this.type;
        return data;
    }
}

export interface ITagGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    zoneId?: number | undefined;
    type?: number;
}

export class TagGetListWithNewsCountQuery implements ITagGetListWithNewsCountQuery {
    onlyHotTags?: boolean;

    constructor(data?: ITagGetListWithNewsCountQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.onlyHotTags = _data["onlyHotTags"];
        }
    }

    static fromJS(data: any): TagGetListWithNewsCountQuery {
        data = typeof data === 'object' ? data : {};
        let result = new TagGetListWithNewsCountQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onlyHotTags"] = this.onlyHotTags;
        return data;
    }
}

export interface ITagGetListWithNewsCountQuery {
    onlyHotTags?: boolean;
}

export class TagListDto implements ITagListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    isHotTag?: boolean;
    newsCount?: number;
    zoneId?: number;
    zone?: string | undefined;
    url?: string | undefined;

    constructor(data?: ITagListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.isHotTag = _data["isHotTag"];
            this.newsCount = _data["newsCount"];
            this.zoneId = _data["zoneId"];
            this.zone = _data["zone"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): TagListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["isHotTag"] = this.isHotTag;
        data["newsCount"] = this.newsCount;
        data["zoneId"] = this.zoneId;
        data["zone"] = this.zone;
        data["url"] = this.url;
        return data;
    }
}

export interface ITagListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    isHotTag?: boolean;
    newsCount?: number;
    zoneId?: number;
    zone?: string | undefined;
    url?: string | undefined;
}

export class TeacherFilterDto implements ITeacherFilterDto {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    classId?: number;
    keyword?: string | undefined;
    status?: ClassUserStatusEnum;
    isGetCountAssignExam?: boolean;

    constructor(data?: ITeacherFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.classId = _data["classId"];
            this.keyword = _data["keyword"];
            this.status = _data["status"];
            this.isGetCountAssignExam = _data["isGetCountAssignExam"];
        }
    }

    static fromJS(data: any): TeacherFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeacherFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["classId"] = this.classId;
        data["keyword"] = this.keyword;
        data["status"] = this.status;
        data["isGetCountAssignExam"] = this.isGetCountAssignExam;
        return data;
    }
}

export interface ITeacherFilterDto {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    classId?: number;
    keyword?: string | undefined;
    status?: ClassUserStatusEnum;
    isGetCountAssignExam?: boolean;
}

export class TeacherGetBySchoolDto implements ITeacherGetBySchoolDto {
    id?: number;
    userName?: string | undefined;
    avatar?: string | undefined;
    fullName?: string | undefined;
    fullNameNonAccent?: string | undefined;
    classCount?: number;
    assignmentCount?: number;
    assignmentMarkedCount?: number;
    assignmentMarkedWaitingCount?: number;

    constructor(data?: ITeacherGetBySchoolDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.avatar = _data["avatar"];
            this.fullName = _data["fullName"];
            this.fullNameNonAccent = _data["fullNameNonAccent"];
            this.classCount = _data["classCount"];
            this.assignmentCount = _data["assignmentCount"];
            this.assignmentMarkedCount = _data["assignmentMarkedCount"];
            this.assignmentMarkedWaitingCount = _data["assignmentMarkedWaitingCount"];
        }
    }

    static fromJS(data: any): TeacherGetBySchoolDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeacherGetBySchoolDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["avatar"] = this.avatar;
        data["fullName"] = this.fullName;
        data["fullNameNonAccent"] = this.fullNameNonAccent;
        data["classCount"] = this.classCount;
        data["assignmentCount"] = this.assignmentCount;
        data["assignmentMarkedCount"] = this.assignmentMarkedCount;
        data["assignmentMarkedWaitingCount"] = this.assignmentMarkedWaitingCount;
        return data;
    }
}

export interface ITeacherGetBySchoolDto {
    id?: number;
    userName?: string | undefined;
    avatar?: string | undefined;
    fullName?: string | undefined;
    fullNameNonAccent?: string | undefined;
    classCount?: number;
    assignmentCount?: number;
    assignmentMarkedCount?: number;
    assignmentMarkedWaitingCount?: number;
}

export class TeacherGetBySchoolFilterDto implements ITeacherGetBySchoolFilterDto {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    schoolId?: number;
    keyword?: string | undefined;

    constructor(data?: ITeacherGetBySchoolFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.schoolId = _data["schoolId"];
            this.keyword = _data["keyword"];
        }
    }

    static fromJS(data: any): TeacherGetBySchoolFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeacherGetBySchoolFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["schoolId"] = this.schoolId;
        data["keyword"] = this.keyword;
        return data;
    }
}

export interface ITeacherGetBySchoolFilterDto {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    schoolId?: number;
    keyword?: string | undefined;
}

export class TeacherListDto implements ITeacherListDto {
    id?: number;
    userName?: string | undefined;
    avatar?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    status?: ClassUserStatusEnum;
    createdDate?: Date | undefined;
    subjectIds?: number[] | undefined;
    subject?: string | undefined;
    isManager?: boolean;
    countAssignExam?: number;
    countAssignExamMarkedWaiting?: number;

    constructor(data?: ITeacherListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.avatar = _data["avatar"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.status = _data["status"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            if (Array.isArray(_data["subjectIds"])) {
                this.subjectIds = [] as any;
                for (let item of _data["subjectIds"])
                    this.subjectIds!.push(item);
            }
            this.subject = _data["subject"];
            this.isManager = _data["isManager"];
            this.countAssignExam = _data["countAssignExam"];
            this.countAssignExamMarkedWaiting = _data["countAssignExamMarkedWaiting"];
        }
    }

    static fromJS(data: any): TeacherListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeacherListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["avatar"] = this.avatar;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["status"] = this.status;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        if (Array.isArray(this.subjectIds)) {
            data["subjectIds"] = [];
            for (let item of this.subjectIds)
                data["subjectIds"].push(item);
        }
        data["subject"] = this.subject;
        data["isManager"] = this.isManager;
        data["countAssignExam"] = this.countAssignExam;
        data["countAssignExamMarkedWaiting"] = this.countAssignExamMarkedWaiting;
        return data;
    }
}

export interface ITeacherListDto {
    id?: number;
    userName?: string | undefined;
    avatar?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    status?: ClassUserStatusEnum;
    createdDate?: Date | undefined;
    subjectIds?: number[] | undefined;
    subject?: string | undefined;
    isManager?: boolean;
    countAssignExam?: number;
    countAssignExamMarkedWaiting?: number;
}

export class TeacherStaticByTypeExamDto implements ITeacherStaticByTypeExamDto {
    type?: AssignExamTypeEnum;
    total?: number | undefined;
    markedCount?: number | undefined;
    markedWaitingCount?: number | undefined;
    averageScore?: number | undefined;

    constructor(data?: ITeacherStaticByTypeExamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.total = _data["total"];
            this.markedCount = _data["markedCount"];
            this.markedWaitingCount = _data["markedWaitingCount"];
            this.averageScore = _data["averageScore"];
        }
    }

    static fromJS(data: any): TeacherStaticByTypeExamDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeacherStaticByTypeExamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["total"] = this.total;
        data["markedCount"] = this.markedCount;
        data["markedWaitingCount"] = this.markedWaitingCount;
        data["averageScore"] = this.averageScore;
        return data;
    }
}

export interface ITeacherStaticByTypeExamDto {
    type?: AssignExamTypeEnum;
    total?: number | undefined;
    markedCount?: number | undefined;
    markedWaitingCount?: number | undefined;
    averageScore?: number | undefined;
}

export class TopAverageScoreDto implements ITopAverageScoreDto {
    userId?: number;
    avatar?: string | undefined;
    fullName?: string | undefined;
    averageScore?: number;

    constructor(data?: ITopAverageScoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.avatar = _data["avatar"];
            this.fullName = _data["fullName"];
            this.averageScore = _data["averageScore"];
        }
    }

    static fromJS(data: any): TopAverageScoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new TopAverageScoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["avatar"] = this.avatar;
        data["fullName"] = this.fullName;
        data["averageScore"] = this.averageScore;
        return data;
    }
}

export interface ITopAverageScoreDto {
    userId?: number;
    avatar?: string | undefined;
    fullName?: string | undefined;
    averageScore?: number;
}

export class TopCourseStatisticalDto implements ITopCourseStatisticalDto {
    productId?: number;
    name?: string | undefined;
    image?: string | undefined;
    studentCount?: number;
    lessonCount?: number;

    constructor(data?: ITopCourseStatisticalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.name = _data["name"];
            this.image = _data["image"];
            this.studentCount = _data["studentCount"];
            this.lessonCount = _data["lessonCount"];
        }
    }

    static fromJS(data: any): TopCourseStatisticalDto {
        data = typeof data === 'object' ? data : {};
        let result = new TopCourseStatisticalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["name"] = this.name;
        data["image"] = this.image;
        data["studentCount"] = this.studentCount;
        data["lessonCount"] = this.lessonCount;
        return data;
    }
}

export interface ITopCourseStatisticalDto {
    productId?: number;
    name?: string | undefined;
    image?: string | undefined;
    studentCount?: number;
    lessonCount?: number;
}

export class TopNeedsToDoHomeworkDto implements ITopNeedsToDoHomeworkDto {
    userId?: number;
    avatar?: string | undefined;
    fullName?: string | undefined;
    readonly countExam?: number;
    countExamDone?: number;
    countExamNotStarted?: number;

    constructor(data?: ITopNeedsToDoHomeworkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.avatar = _data["avatar"];
            this.fullName = _data["fullName"];
            (this as any).countExam = _data["countExam"];
            this.countExamDone = _data["countExamDone"];
            this.countExamNotStarted = _data["countExamNotStarted"];
        }
    }

    static fromJS(data: any): TopNeedsToDoHomeworkDto {
        data = typeof data === 'object' ? data : {};
        let result = new TopNeedsToDoHomeworkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["avatar"] = this.avatar;
        data["fullName"] = this.fullName;
        data["countExam"] = this.countExam;
        data["countExamDone"] = this.countExamDone;
        data["countExamNotStarted"] = this.countExamNotStarted;
        return data;
    }
}

export interface ITopNeedsToDoHomeworkDto {
    userId?: number;
    avatar?: string | undefined;
    fullName?: string | undefined;
    countExam?: number;
    countExamDone?: number;
    countExamNotStarted?: number;
}

export class TrackEventsRequestDto implements ITrackEventsRequestDto {
    sessionId?: string | undefined;
    events?: TrackingEventDto[] | undefined;

    constructor(data?: ITrackEventsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            if (Array.isArray(_data["events"])) {
                this.events = [] as any;
                for (let item of _data["events"])
                    this.events!.push(TrackingEventDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TrackEventsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrackEventsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        if (Array.isArray(this.events)) {
            data["events"] = [];
            for (let item of this.events)
                data["events"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITrackEventsRequestDto {
    sessionId?: string | undefined;
    events?: TrackingEventDto[] | undefined;
}

export class TrackingActionCodeItemDto implements ITrackingActionCodeItemDto {
    code?: string | undefined;
    name?: string | undefined;
    category?: string | undefined;

    constructor(data?: ITrackingActionCodeItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): TrackingActionCodeItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrackingActionCodeItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["category"] = this.category;
        return data;
    }
}

export interface ITrackingActionCodeItemDto {
    code?: string | undefined;
    name?: string | undefined;
    category?: string | undefined;
}

export class TrackingEventDto implements ITrackingEventDto {
    eventId?: string | undefined;
    actionCode?: string | undefined;
    objectType?: string | undefined;
    objectId?: string | undefined;
    parentObjectType?: string | undefined;
    parentObjectId?: string | undefined;
    clientTimestamp?: Date | undefined;
    metadata?: { [key: string]: any; } | undefined;

    constructor(data?: ITrackingEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventId = _data["eventId"];
            this.actionCode = _data["actionCode"];
            this.objectType = _data["objectType"];
            this.objectId = _data["objectId"];
            this.parentObjectType = _data["parentObjectType"];
            this.parentObjectId = _data["parentObjectId"];
            this.clientTimestamp = _data["clientTimestamp"] ? new Date(_data["clientTimestamp"].toString()) : undefined as any;
            if (_data["metadata"]) {
                this.metadata = {} as any;
                for (let key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        (this.metadata as any)![key] = _data["metadata"][key];
                }
            }
        }
    }

    static fromJS(data: any): TrackingEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrackingEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId;
        data["actionCode"] = this.actionCode;
        data["objectType"] = this.objectType;
        data["objectId"] = this.objectId;
        data["parentObjectType"] = this.parentObjectType;
        data["parentObjectId"] = this.parentObjectId;
        data["clientTimestamp"] = this.clientTimestamp ? this.clientTimestamp.toISOString() : undefined as any;
        if (this.metadata) {
            data["metadata"] = {};
            for (let key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    (data["metadata"] as any)[key] = (this.metadata as any)[key];
            }
        }
        return data;
    }
}

export interface ITrackingEventDto {
    eventId?: string | undefined;
    actionCode?: string | undefined;
    objectType?: string | undefined;
    objectId?: string | undefined;
    parentObjectType?: string | undefined;
    parentObjectId?: string | undefined;
    clientTimestamp?: Date | undefined;
    metadata?: { [key: string]: any; } | undefined;
}

export class TranslationBundleDto implements ITranslationBundleDto {
    locale?: string | undefined;
    version?: string | undefined;
    translations?: { [key: string]: string; } | undefined;

    constructor(data?: ITranslationBundleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.version = _data["version"];
            if (_data["translations"]) {
                this.translations = {} as any;
                for (let key in _data["translations"]) {
                    if (_data["translations"].hasOwnProperty(key))
                        (this.translations as any)![key] = _data["translations"][key];
                }
            }
        }
    }

    static fromJS(data: any): TranslationBundleDto {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationBundleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["version"] = this.version;
        if (this.translations) {
            data["translations"] = {};
            for (let key in this.translations) {
                if (this.translations.hasOwnProperty(key))
                    (data["translations"] as any)[key] = (this.translations as any)[key];
            }
        }
        return data;
    }
}

export interface ITranslationBundleDto {
    locale?: string | undefined;
    version?: string | undefined;
    translations?: { [key: string]: string; } | undefined;
}

export class TranslationDetailDto implements ITranslationDetailDto {
    id?: number;
    namespace?: string | undefined;
    key?: string | undefined;
    readonly fullKey?: string | undefined;
    description?: string | undefined;
    defaultValue?: string | undefined;
    values?: { [key: string]: string; } | undefined;
    lastModifiedDate?: Date;

    constructor(data?: ITranslationDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.namespace = _data["namespace"];
            this.key = _data["key"];
            (this as any).fullKey = _data["fullKey"];
            this.description = _data["description"];
            this.defaultValue = _data["defaultValue"];
            if (_data["values"]) {
                this.values = {} as any;
                for (let key in _data["values"]) {
                    if (_data["values"].hasOwnProperty(key))
                        (this.values as any)![key] = _data["values"][key];
                }
            }
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): TranslationDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["namespace"] = this.namespace;
        data["key"] = this.key;
        data["fullKey"] = this.fullKey;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        if (this.values) {
            data["values"] = {};
            for (let key in this.values) {
                if (this.values.hasOwnProperty(key))
                    (data["values"] as any)[key] = (this.values as any)[key];
            }
        }
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ITranslationDetailDto {
    id?: number;
    namespace?: string | undefined;
    key?: string | undefined;
    fullKey?: string | undefined;
    description?: string | undefined;
    defaultValue?: string | undefined;
    values?: { [key: string]: string; } | undefined;
    lastModifiedDate?: Date;
}

export class TranslationGetListQuery implements ITranslationGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    namespace?: string | undefined;
    languageCode?: string | undefined;
    missingTranslation?: boolean | undefined;

    constructor(data?: ITranslationGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.keyword = _data["keyword"];
            this.namespace = _data["namespace"];
            this.languageCode = _data["languageCode"];
            this.missingTranslation = _data["missingTranslation"];
        }
    }

    static fromJS(data: any): TranslationGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["keyword"] = this.keyword;
        data["namespace"] = this.namespace;
        data["languageCode"] = this.languageCode;
        data["missingTranslation"] = this.missingTranslation;
        return data;
    }
}

export interface ITranslationGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    namespace?: string | undefined;
    languageCode?: string | undefined;
    missingTranslation?: boolean | undefined;
}

export class TranslationListDto implements ITranslationListDto {
    id?: number;
    namespace?: string | undefined;
    key?: string | undefined;
    readonly fullKey?: string | undefined;
    description?: string | undefined;
    defaultValue?: string | undefined;
    values?: { [key: string]: string; } | undefined;
    lastModifiedDate?: Date;

    constructor(data?: ITranslationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.namespace = _data["namespace"];
            this.key = _data["key"];
            (this as any).fullKey = _data["fullKey"];
            this.description = _data["description"];
            this.defaultValue = _data["defaultValue"];
            if (_data["values"]) {
                this.values = {} as any;
                for (let key in _data["values"]) {
                    if (_data["values"].hasOwnProperty(key))
                        (this.values as any)![key] = _data["values"][key];
                }
            }
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): TranslationListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["namespace"] = this.namespace;
        data["key"] = this.key;
        data["fullKey"] = this.fullKey;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        if (this.values) {
            data["values"] = {};
            for (let key in this.values) {
                if (this.values.hasOwnProperty(key))
                    (data["values"] as any)[key] = (this.values as any)[key];
            }
        }
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ITranslationListDto {
    id?: number;
    namespace?: string | undefined;
    key?: string | undefined;
    fullKey?: string | undefined;
    description?: string | undefined;
    defaultValue?: string | undefined;
    values?: { [key: string]: string; } | undefined;
    lastModifiedDate?: Date;
}

export class TranslationSaveDto implements ITranslationSaveDto {
    id?: number;
    namespace?: string | undefined;
    key?: string | undefined;
    description?: string | undefined;
    defaultValue?: string | undefined;
    values?: TranslationValueItemDto[] | undefined;

    constructor(data?: ITranslationSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.namespace = _data["namespace"];
            this.key = _data["key"];
            this.description = _data["description"];
            this.defaultValue = _data["defaultValue"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(TranslationValueItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TranslationSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["namespace"] = this.namespace;
        data["key"] = this.key;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITranslationSaveDto {
    id?: number;
    namespace?: string | undefined;
    key?: string | undefined;
    description?: string | undefined;
    defaultValue?: string | undefined;
    values?: TranslationValueItemDto[] | undefined;
}

export class TranslationValueItemDto implements ITranslationValueItemDto {
    languageCode?: string | undefined;
    value?: string | undefined;

    constructor(data?: ITranslationValueItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageCode = _data["languageCode"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): TranslationValueItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationValueItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageCode"] = this.languageCode;
        data["value"] = this.value;
        return data;
    }
}

export interface ITranslationValueItemDto {
    languageCode?: string | undefined;
    value?: string | undefined;
}

export class UserActivityLogAdminItemDto implements IUserActivityLogAdminItemDto {
    eventId?: string | undefined;
    actionCode?: string | undefined;
    objectType?: string | undefined;
    objectId?: string | undefined;
    metadata?: { [key: string]: any; } | undefined;
    serverTimestamp?: Date;
    pointsAwarded?: number | undefined;
    mongoId?: string | undefined;
    userId?: number;
    userFullName?: string | undefined;
    organizationId?: number | undefined;
    sessionId?: string | undefined;
    source?: string | undefined;
    trustLevel?: string | undefined;
    parentObjectType?: string | undefined;
    parentObjectId?: string | undefined;
    clientTimestamp?: Date | undefined;
    ip?: string | undefined;
    fraudFlags?: string[] | undefined;
    pointLedgerId?: number | undefined;

    constructor(data?: IUserActivityLogAdminItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventId = _data["eventId"];
            this.actionCode = _data["actionCode"];
            this.objectType = _data["objectType"];
            this.objectId = _data["objectId"];
            if (_data["metadata"]) {
                this.metadata = {} as any;
                for (let key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        (this.metadata as any)![key] = _data["metadata"][key];
                }
            }
            this.serverTimestamp = _data["serverTimestamp"] ? new Date(_data["serverTimestamp"].toString()) : undefined as any;
            this.pointsAwarded = _data["pointsAwarded"];
            this.mongoId = _data["mongoId"];
            this.userId = _data["userId"];
            this.userFullName = _data["userFullName"];
            this.organizationId = _data["organizationId"];
            this.sessionId = _data["sessionId"];
            this.source = _data["source"];
            this.trustLevel = _data["trustLevel"];
            this.parentObjectType = _data["parentObjectType"];
            this.parentObjectId = _data["parentObjectId"];
            this.clientTimestamp = _data["clientTimestamp"] ? new Date(_data["clientTimestamp"].toString()) : undefined as any;
            this.ip = _data["ip"];
            if (Array.isArray(_data["fraudFlags"])) {
                this.fraudFlags = [] as any;
                for (let item of _data["fraudFlags"])
                    this.fraudFlags!.push(item);
            }
            this.pointLedgerId = _data["pointLedgerId"];
        }
    }

    static fromJS(data: any): UserActivityLogAdminItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserActivityLogAdminItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId;
        data["actionCode"] = this.actionCode;
        data["objectType"] = this.objectType;
        data["objectId"] = this.objectId;
        if (this.metadata) {
            data["metadata"] = {};
            for (let key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    (data["metadata"] as any)[key] = (this.metadata as any)[key];
            }
        }
        data["serverTimestamp"] = this.serverTimestamp ? this.serverTimestamp.toISOString() : undefined as any;
        data["pointsAwarded"] = this.pointsAwarded;
        data["mongoId"] = this.mongoId;
        data["userId"] = this.userId;
        data["userFullName"] = this.userFullName;
        data["organizationId"] = this.organizationId;
        data["sessionId"] = this.sessionId;
        data["source"] = this.source;
        data["trustLevel"] = this.trustLevel;
        data["parentObjectType"] = this.parentObjectType;
        data["parentObjectId"] = this.parentObjectId;
        data["clientTimestamp"] = this.clientTimestamp ? this.clientTimestamp.toISOString() : undefined as any;
        data["ip"] = this.ip;
        if (Array.isArray(this.fraudFlags)) {
            data["fraudFlags"] = [];
            for (let item of this.fraudFlags)
                data["fraudFlags"].push(item);
        }
        data["pointLedgerId"] = this.pointLedgerId;
        return data;
    }
}

export interface IUserActivityLogAdminItemDto {
    eventId?: string | undefined;
    actionCode?: string | undefined;
    objectType?: string | undefined;
    objectId?: string | undefined;
    metadata?: { [key: string]: any; } | undefined;
    serverTimestamp?: Date;
    pointsAwarded?: number | undefined;
    mongoId?: string | undefined;
    userId?: number;
    userFullName?: string | undefined;
    organizationId?: number | undefined;
    sessionId?: string | undefined;
    source?: string | undefined;
    trustLevel?: string | undefined;
    parentObjectType?: string | undefined;
    parentObjectId?: string | undefined;
    clientTimestamp?: Date | undefined;
    ip?: string | undefined;
    fraudFlags?: string[] | undefined;
    pointLedgerId?: number | undefined;
}

export class UserActivityLogItemDto implements IUserActivityLogItemDto {
    eventId?: string | undefined;
    actionCode?: string | undefined;
    objectType?: string | undefined;
    objectId?: string | undefined;
    metadata?: { [key: string]: any; } | undefined;
    serverTimestamp?: Date;
    pointsAwarded?: number | undefined;

    constructor(data?: IUserActivityLogItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventId = _data["eventId"];
            this.actionCode = _data["actionCode"];
            this.objectType = _data["objectType"];
            this.objectId = _data["objectId"];
            if (_data["metadata"]) {
                this.metadata = {} as any;
                for (let key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        (this.metadata as any)![key] = _data["metadata"][key];
                }
            }
            this.serverTimestamp = _data["serverTimestamp"] ? new Date(_data["serverTimestamp"].toString()) : undefined as any;
            this.pointsAwarded = _data["pointsAwarded"];
        }
    }

    static fromJS(data: any): UserActivityLogItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserActivityLogItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId;
        data["actionCode"] = this.actionCode;
        data["objectType"] = this.objectType;
        data["objectId"] = this.objectId;
        if (this.metadata) {
            data["metadata"] = {};
            for (let key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    (data["metadata"] as any)[key] = (this.metadata as any)[key];
            }
        }
        data["serverTimestamp"] = this.serverTimestamp ? this.serverTimestamp.toISOString() : undefined as any;
        data["pointsAwarded"] = this.pointsAwarded;
        return data;
    }
}

export interface IUserActivityLogItemDto {
    eventId?: string | undefined;
    actionCode?: string | undefined;
    objectType?: string | undefined;
    objectId?: string | undefined;
    metadata?: { [key: string]: any; } | undefined;
    serverTimestamp?: Date;
    pointsAwarded?: number | undefined;
}

export class UserAnsweDataDto implements IUserAnsweDataDto {
    id?: string | undefined;
    content?: string | undefined;
    itemId?: string | undefined;
    isCorrect?: boolean;
    mark?: number;

    constructor(data?: IUserAnsweDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.content = _data["content"];
            this.itemId = _data["itemId"];
            this.isCorrect = _data["isCorrect"];
            this.mark = _data["mark"];
        }
    }

    static fromJS(data: any): UserAnsweDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserAnsweDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["content"] = this.content;
        data["itemId"] = this.itemId;
        data["isCorrect"] = this.isCorrect;
        data["mark"] = this.mark;
        return data;
    }
}

export interface IUserAnsweDataDto {
    id?: string | undefined;
    content?: string | undefined;
    itemId?: string | undefined;
    isCorrect?: boolean;
    mark?: number;
}

export class UserAnswerDto implements IUserAnswerDto {
    id?: number;
    questionId?: number;
    parentId?: number;
    content?: string | undefined;
    isCorrect?: boolean | undefined;
    mark?: number;
    comment?: string | undefined;
    commentBy?: number;
    commentDate?: Date | undefined;
    answer?: UserAnsweDataDto[] | undefined;
    childAnswer?: UserAnswerDto[] | undefined;

    constructor(data?: IUserAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.questionId = _data["questionId"];
            this.parentId = _data["parentId"];
            this.content = _data["content"];
            this.isCorrect = _data["isCorrect"];
            this.mark = _data["mark"];
            this.comment = _data["comment"];
            this.commentBy = _data["commentBy"];
            this.commentDate = _data["commentDate"] ? new Date(_data["commentDate"].toString()) : undefined as any;
            if (Array.isArray(_data["answer"])) {
                this.answer = [] as any;
                for (let item of _data["answer"])
                    this.answer!.push(UserAnsweDataDto.fromJS(item));
            }
            if (Array.isArray(_data["childAnswer"])) {
                this.childAnswer = [] as any;
                for (let item of _data["childAnswer"])
                    this.childAnswer!.push(UserAnswerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["questionId"] = this.questionId;
        data["parentId"] = this.parentId;
        data["content"] = this.content;
        data["isCorrect"] = this.isCorrect;
        data["mark"] = this.mark;
        data["comment"] = this.comment;
        data["commentBy"] = this.commentBy;
        data["commentDate"] = this.commentDate ? this.commentDate.toISOString() : undefined as any;
        if (Array.isArray(this.answer)) {
            data["answer"] = [];
            for (let item of this.answer)
                data["answer"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.childAnswer)) {
            data["childAnswer"] = [];
            for (let item of this.childAnswer)
                data["childAnswer"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserAnswerDto {
    id?: number;
    questionId?: number;
    parentId?: number;
    content?: string | undefined;
    isCorrect?: boolean | undefined;
    mark?: number;
    comment?: string | undefined;
    commentBy?: number;
    commentDate?: Date | undefined;
    answer?: UserAnsweDataDto[] | undefined;
    childAnswer?: UserAnswerDto[] | undefined;
}

export class UserDeviceListItemDto implements IUserDeviceListItemDto {
    id?: number;
    deviceType?: DeviceTypeEnum;
    brand?: string | undefined;
    model?: string | undefined;
    os?: string | undefined;
    browser?: string | undefined;
    firstSeen?: Date;
    lastSeen?: Date;
    trusted?: boolean;
    isActive?: boolean;
    isCurrent?: boolean;

    constructor(data?: IUserDeviceListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.deviceType = _data["deviceType"];
            this.brand = _data["brand"];
            this.model = _data["model"];
            this.os = _data["os"];
            this.browser = _data["browser"];
            this.firstSeen = _data["firstSeen"] ? new Date(_data["firstSeen"].toString()) : undefined as any;
            this.lastSeen = _data["lastSeen"] ? new Date(_data["lastSeen"].toString()) : undefined as any;
            this.trusted = _data["trusted"];
            this.isActive = _data["isActive"];
            this.isCurrent = _data["isCurrent"];
        }
    }

    static fromJS(data: any): UserDeviceListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDeviceListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deviceType"] = this.deviceType;
        data["brand"] = this.brand;
        data["model"] = this.model;
        data["os"] = this.os;
        data["browser"] = this.browser;
        data["firstSeen"] = this.firstSeen ? this.firstSeen.toISOString() : undefined as any;
        data["lastSeen"] = this.lastSeen ? this.lastSeen.toISOString() : undefined as any;
        data["trusted"] = this.trusted;
        data["isActive"] = this.isActive;
        data["isCurrent"] = this.isCurrent;
        return data;
    }
}

export interface IUserDeviceListItemDto {
    id?: number;
    deviceType?: DeviceTypeEnum;
    brand?: string | undefined;
    model?: string | undefined;
    os?: string | undefined;
    browser?: string | undefined;
    firstSeen?: Date;
    lastSeen?: Date;
    trusted?: boolean;
    isActive?: boolean;
    isCurrent?: boolean;
}

export class UserExamAttemptListItemDto implements IUserExamAttemptListItemDto {
    id?: number;
    mark?: number;
    correctAnswerCount?: number;
    wrongAnswerCount?: number;
    unansweredCount?: number;
    duration?: number;
    attemptDate?: Date;

    constructor(data?: IUserExamAttemptListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mark = _data["mark"];
            this.correctAnswerCount = _data["correctAnswerCount"];
            this.wrongAnswerCount = _data["wrongAnswerCount"];
            this.unansweredCount = _data["unansweredCount"];
            this.duration = _data["duration"];
            this.attemptDate = _data["attemptDate"] ? new Date(_data["attemptDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UserExamAttemptListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserExamAttemptListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mark"] = this.mark;
        data["correctAnswerCount"] = this.correctAnswerCount;
        data["wrongAnswerCount"] = this.wrongAnswerCount;
        data["unansweredCount"] = this.unansweredCount;
        data["duration"] = this.duration;
        data["attemptDate"] = this.attemptDate ? this.attemptDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IUserExamAttemptListItemDto {
    id?: number;
    mark?: number;
    correctAnswerCount?: number;
    wrongAnswerCount?: number;
    unansweredCount?: number;
    duration?: number;
    attemptDate?: Date;
}

export class UserExamResultDetailWithMessageDto implements IUserExamResultDetailWithMessageDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    examId?: number;
    assignExamId?: number;
    userId?: number;
    mark?: number;
    duration?: number;
    correctAnswerCount?: number;
    correctQuestions?: string | undefined;
    fromType?: number;
    comment?: string | undefined;
    status?: UserExamResultStatus;
    userAnswer?: UserAnswerDto[] | undefined;
    examInfo?: ExamLearnDto;
    userInfo?: UserWithSimpleInfoDto;
    message?: string | undefined;
    teacherNote?: string | undefined;
    isAssigner?: boolean;
    canMarkScore?: boolean;

    constructor(data?: IUserExamResultDetailWithMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.examId = _data["examId"];
            this.assignExamId = _data["assignExamId"];
            this.userId = _data["userId"];
            this.mark = _data["mark"];
            this.duration = _data["duration"];
            this.correctAnswerCount = _data["correctAnswerCount"];
            this.correctQuestions = _data["correctQuestions"];
            this.fromType = _data["fromType"];
            this.comment = _data["comment"];
            this.status = _data["status"];
            if (Array.isArray(_data["userAnswer"])) {
                this.userAnswer = [] as any;
                for (let item of _data["userAnswer"])
                    this.userAnswer!.push(UserAnswerDto.fromJS(item));
            }
            this.examInfo = _data["examInfo"] ? ExamLearnDto.fromJS(_data["examInfo"]) : undefined as any;
            this.userInfo = _data["userInfo"] ? UserWithSimpleInfoDto.fromJS(_data["userInfo"]) : undefined as any;
            this.message = _data["message"];
            this.teacherNote = _data["teacherNote"];
            this.isAssigner = _data["isAssigner"];
            this.canMarkScore = _data["canMarkScore"];
        }
    }

    static fromJS(data: any): UserExamResultDetailWithMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserExamResultDetailWithMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["examId"] = this.examId;
        data["assignExamId"] = this.assignExamId;
        data["userId"] = this.userId;
        data["mark"] = this.mark;
        data["duration"] = this.duration;
        data["correctAnswerCount"] = this.correctAnswerCount;
        data["correctQuestions"] = this.correctQuestions;
        data["fromType"] = this.fromType;
        data["comment"] = this.comment;
        data["status"] = this.status;
        if (Array.isArray(this.userAnswer)) {
            data["userAnswer"] = [];
            for (let item of this.userAnswer)
                data["userAnswer"].push(item ? item.toJSON() : undefined as any);
        }
        data["examInfo"] = this.examInfo ? this.examInfo.toJSON() : undefined as any;
        data["userInfo"] = this.userInfo ? this.userInfo.toJSON() : undefined as any;
        data["message"] = this.message;
        data["teacherNote"] = this.teacherNote;
        data["isAssigner"] = this.isAssigner;
        data["canMarkScore"] = this.canMarkScore;
        return data;
    }
}

export interface IUserExamResultDetailWithMessageDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    examId?: number;
    assignExamId?: number;
    userId?: number;
    mark?: number;
    duration?: number;
    correctAnswerCount?: number;
    correctQuestions?: string | undefined;
    fromType?: number;
    comment?: string | undefined;
    status?: UserExamResultStatus;
    userAnswer?: UserAnswerDto[] | undefined;
    examInfo?: ExamLearnDto;
    userInfo?: UserWithSimpleInfoDto;
    message?: string | undefined;
    teacherNote?: string | undefined;
    isAssigner?: boolean;
    canMarkScore?: boolean;
}

export class UserExamResultDto implements IUserExamResultDto {
    startTime?: Date | undefined;
    duration?: number;
    examId?: number;
    assignExamId?: number;
    userAnswer?: UserAnswerDto[] | undefined;
    fromType?: number;

    constructor(data?: IUserExamResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            this.duration = _data["duration"];
            this.examId = _data["examId"];
            this.assignExamId = _data["assignExamId"];
            if (Array.isArray(_data["userAnswer"])) {
                this.userAnswer = [] as any;
                for (let item of _data["userAnswer"])
                    this.userAnswer!.push(UserAnswerDto.fromJS(item));
            }
            this.fromType = _data["fromType"];
        }
    }

    static fromJS(data: any): UserExamResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserExamResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["duration"] = this.duration;
        data["examId"] = this.examId;
        data["assignExamId"] = this.assignExamId;
        if (Array.isArray(this.userAnswer)) {
            data["userAnswer"] = [];
            for (let item of this.userAnswer)
                data["userAnswer"].push(item ? item.toJSON() : undefined as any);
        }
        data["fromType"] = this.fromType;
        return data;
    }
}

export interface IUserExamResultDto {
    startTime?: Date | undefined;
    duration?: number;
    examId?: number;
    assignExamId?: number;
    userAnswer?: UserAnswerDto[] | undefined;
    fromType?: number;
}

export class UserListDto implements IUserListDto {
    isSystem?: boolean;
    isSuperAdmin?: boolean;
    isSystemAdmin?: boolean;
    id?: number;
    userName?: string | undefined;
    avatar?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    status?: number;
    createdDate?: Date;
    roles?: string | undefined;
    type?: UserTypeEnum;
    objectId?: number;
    objectName?: string | undefined;

    constructor(data?: IUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSystem = _data["isSystem"];
            this.isSuperAdmin = _data["isSuperAdmin"];
            this.isSystemAdmin = _data["isSystemAdmin"];
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.avatar = _data["avatar"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.status = _data["status"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.roles = _data["roles"];
            this.type = _data["type"];
            this.objectId = _data["objectId"];
            this.objectName = _data["objectName"];
        }
    }

    static fromJS(data: any): UserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSystem"] = this.isSystem;
        data["isSuperAdmin"] = this.isSuperAdmin;
        data["isSystemAdmin"] = this.isSystemAdmin;
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["avatar"] = this.avatar;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["status"] = this.status;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["roles"] = this.roles;
        data["type"] = this.type;
        data["objectId"] = this.objectId;
        data["objectName"] = this.objectName;
        return data;
    }
}

export interface IUserListDto {
    isSystem?: boolean;
    isSuperAdmin?: boolean;
    isSystemAdmin?: boolean;
    id?: number;
    userName?: string | undefined;
    avatar?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    status?: number;
    createdDate?: Date;
    roles?: string | undefined;
    type?: UserTypeEnum;
    objectId?: number;
    objectName?: string | undefined;
}

export class UserObjectAddDto implements IUserObjectAddDto {
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    userName?: string | undefined;
    roleIds?: number[] | undefined;
    userType?: UserTypeEnum;
    immediate?: boolean;

    constructor(data?: IUserObjectAddDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objectId = _data["objectId"];
            this.objectType = _data["objectType"];
            this.userName = _data["userName"];
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
            this.userType = _data["userType"];
            this.immediate = _data["immediate"];
        }
    }

    static fromJS(data: any): UserObjectAddDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserObjectAddDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objectId"] = this.objectId;
        data["objectType"] = this.objectType;
        data["userName"] = this.userName;
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        data["userType"] = this.userType;
        data["immediate"] = this.immediate;
        return data;
    }
}

export interface IUserObjectAddDto {
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    userName?: string | undefined;
    roleIds?: number[] | undefined;
    userType?: UserTypeEnum;
    immediate?: boolean;
}

export class UserObjectDto implements IUserObjectDto {
    userTypes?: number[] | undefined;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    objectName?: string | undefined;
    userType?: UserTypeEnum;
    status?: UserObjectStatusEnum;
    isDefault?: boolean;
    isActive?: boolean;
    roleIds?: number[] | undefined;
    roles?: string | undefined;
    subjectIds?: number[] | undefined;

    constructor(data?: IUserObjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userTypes = _data["userTypes"];
            this.objectType = _data["objectType"];
            this.objectId = _data["objectId"];
            this.objectName = _data["objectName"];
            this.userType = _data["userType"];
            this.status = _data["status"];
            this.isDefault = _data["isDefault"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
            this.roles = _data["roles"];
            if (Array.isArray(_data["subjectIds"])) {
                this.subjectIds = [] as any;
                for (let item of _data["subjectIds"])
                    this.subjectIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UserObjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserObjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userTypes"] = this.userTypes;
        data["objectType"] = this.objectType;
        data["objectId"] = this.objectId;
        data["objectName"] = this.objectName;
        data["userType"] = this.userType;
        data["status"] = this.status;
        data["isDefault"] = this.isDefault;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        data["roles"] = this.roles;
        if (Array.isArray(this.subjectIds)) {
            data["subjectIds"] = [];
            for (let item of this.subjectIds)
                data["subjectIds"].push(item);
        }
        return data;
    }
}

export interface IUserObjectDto {
    userTypes?: number[] | undefined;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    objectName?: string | undefined;
    userType?: UserTypeEnum;
    status?: UserObjectStatusEnum;
    isDefault?: boolean;
    isActive?: boolean;
    roleIds?: number[] | undefined;
    roles?: string | undefined;
    subjectIds?: number[] | undefined;
}

export class UserObjectRemoveDto implements IUserObjectRemoveDto {
    userType?: number | undefined;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    userId?: number;

    constructor(data?: IUserObjectRemoveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userType = _data["userType"];
            this.objectId = _data["objectId"];
            this.objectType = _data["objectType"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UserObjectRemoveDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserObjectRemoveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userType"] = this.userType;
        data["objectId"] = this.objectId;
        data["objectType"] = this.objectType;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IUserObjectRemoveDto {
    userType?: number | undefined;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    userId?: number;
}

export class UserObjectRolesDto implements IUserObjectRolesDto {
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    userId?: number;
    roleIds?: number[] | undefined;

    constructor(data?: IUserObjectRolesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objectId = _data["objectId"];
            this.objectType = _data["objectType"];
            this.userId = _data["userId"];
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UserObjectRolesDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserObjectRolesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objectId"] = this.objectId;
        data["objectType"] = this.objectType;
        data["userId"] = this.userId;
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        return data;
    }
}

export interface IUserObjectRolesDto {
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    userId?: number;
    roleIds?: number[] | undefined;
}

export class UserObjectSubjectsDto implements IUserObjectSubjectsDto {
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    userId?: number;
    subjectIds?: number[] | undefined;

    constructor(data?: IUserObjectSubjectsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objectId = _data["objectId"];
            this.objectType = _data["objectType"];
            this.userId = _data["userId"];
            if (Array.isArray(_data["subjectIds"])) {
                this.subjectIds = [] as any;
                for (let item of _data["subjectIds"])
                    this.subjectIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UserObjectSubjectsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserObjectSubjectsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objectId"] = this.objectId;
        data["objectType"] = this.objectType;
        data["userId"] = this.userId;
        if (Array.isArray(this.subjectIds)) {
            data["subjectIds"] = [];
            for (let item of this.subjectIds)
                data["subjectIds"].push(item);
        }
        return data;
    }
}

export interface IUserObjectSubjectsDto {
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    userId?: number;
    subjectIds?: number[] | undefined;
}

export class UserPointLedgerItemDto implements IUserPointLedgerItemDto {
    actionCode?: string | undefined;
    points?: number;
    createdDate?: Date;
    metadataJson?: string | undefined;

    constructor(data?: IUserPointLedgerItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionCode = _data["actionCode"];
            this.points = _data["points"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.metadataJson = _data["metadataJson"];
        }
    }

    static fromJS(data: any): UserPointLedgerItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserPointLedgerItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionCode"] = this.actionCode;
        data["points"] = this.points;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["metadataJson"] = this.metadataJson;
        return data;
    }
}

export interface IUserPointLedgerItemDto {
    actionCode?: string | undefined;
    points?: number;
    createdDate?: Date;
    metadataJson?: string | undefined;
}

export class UserPointSummaryDto implements IUserPointSummaryDto {
    userId?: number;
    totalPoints?: number;
    availablePoints?: number;
    recentLedger?: UserPointLedgerItemDto[] | undefined;

    constructor(data?: IUserPointSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.totalPoints = _data["totalPoints"];
            this.availablePoints = _data["availablePoints"];
            if (Array.isArray(_data["recentLedger"])) {
                this.recentLedger = [] as any;
                for (let item of _data["recentLedger"])
                    this.recentLedger!.push(UserPointLedgerItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserPointSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserPointSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["totalPoints"] = this.totalPoints;
        data["availablePoints"] = this.availablePoints;
        if (Array.isArray(this.recentLedger)) {
            data["recentLedger"] = [];
            for (let item of this.recentLedger)
                data["recentLedger"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserPointSummaryDto {
    userId?: number;
    totalPoints?: number;
    availablePoints?: number;
    recentLedger?: UserPointLedgerItemDto[] | undefined;
}

export class UserProductDto implements IUserProductDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    summary?: string | undefined;
    description?: string | undefined;
    image?: string | undefined;
    categoryId?: number | undefined;
    productType?: ProductTypeEnum;
    status?: CommonStatusEnum;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaKeywords?: string | undefined;
    slug?: string | undefined;
    price?: number | undefined;
    salePrice?: number | undefined;
    orgPrice?: number | undefined;
    orgSalePrice?: number | undefined;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    lessonZoomCount?: number;
    productChapters?: ProductChapterEntity[] | undefined;
    enrollmentDate?: Date | undefined;
    activationDate?: Date | undefined;
    enrollmentStatus?: EnrollmentStatusEnum;
    progressPercent?: number | undefined;
    lessonCount?: number;
    classId?: number;
    className?: string | undefined;
    totalDuration?: number;
    currentLesson?: ProductLessonDetailDto;
    currentSession?: ClassSessionEntity;

    constructor(data?: IUserProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.summary = _data["summary"];
            this.description = _data["description"];
            this.image = _data["image"];
            this.categoryId = _data["categoryId"];
            this.productType = _data["productType"];
            this.status = _data["status"];
            this.metaTitle = _data["metaTitle"];
            this.metaDescription = _data["metaDescription"];
            this.metaKeywords = _data["metaKeywords"];
            this.slug = _data["slug"];
            this.price = _data["price"];
            this.salePrice = _data["salePrice"];
            this.orgPrice = _data["orgPrice"];
            this.orgSalePrice = _data["orgSalePrice"];
            this.objectType = _data["objectType"];
            this.objectId = _data["objectId"];
            this.lessonZoomCount = _data["lessonZoomCount"];
            if (Array.isArray(_data["productChapters"])) {
                this.productChapters = [] as any;
                for (let item of _data["productChapters"])
                    this.productChapters!.push(ProductChapterEntity.fromJS(item));
            }
            this.enrollmentDate = _data["enrollmentDate"] ? new Date(_data["enrollmentDate"].toString()) : undefined as any;
            this.activationDate = _data["activationDate"] ? new Date(_data["activationDate"].toString()) : undefined as any;
            this.enrollmentStatus = _data["enrollmentStatus"];
            this.progressPercent = _data["progressPercent"];
            this.lessonCount = _data["lessonCount"];
            this.classId = _data["classId"];
            this.className = _data["className"];
            this.totalDuration = _data["totalDuration"];
            this.currentLesson = _data["currentLesson"] ? ProductLessonDetailDto.fromJS(_data["currentLesson"]) : undefined as any;
            this.currentSession = _data["currentSession"] ? ClassSessionEntity.fromJS(_data["currentSession"]) : undefined as any;
        }
    }

    static fromJS(data: any): UserProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["summary"] = this.summary;
        data["description"] = this.description;
        data["image"] = this.image;
        data["categoryId"] = this.categoryId;
        data["productType"] = this.productType;
        data["status"] = this.status;
        data["metaTitle"] = this.metaTitle;
        data["metaDescription"] = this.metaDescription;
        data["metaKeywords"] = this.metaKeywords;
        data["slug"] = this.slug;
        data["price"] = this.price;
        data["salePrice"] = this.salePrice;
        data["orgPrice"] = this.orgPrice;
        data["orgSalePrice"] = this.orgSalePrice;
        data["objectType"] = this.objectType;
        data["objectId"] = this.objectId;
        data["lessonZoomCount"] = this.lessonZoomCount;
        if (Array.isArray(this.productChapters)) {
            data["productChapters"] = [];
            for (let item of this.productChapters)
                data["productChapters"].push(item ? item.toJSON() : undefined as any);
        }
        data["enrollmentDate"] = this.enrollmentDate ? this.enrollmentDate.toISOString() : undefined as any;
        data["activationDate"] = this.activationDate ? this.activationDate.toISOString() : undefined as any;
        data["enrollmentStatus"] = this.enrollmentStatus;
        data["progressPercent"] = this.progressPercent;
        data["lessonCount"] = this.lessonCount;
        data["classId"] = this.classId;
        data["className"] = this.className;
        data["totalDuration"] = this.totalDuration;
        data["currentLesson"] = this.currentLesson ? this.currentLesson.toJSON() : undefined as any;
        data["currentSession"] = this.currentSession ? this.currentSession.toJSON() : undefined as any;
        return data;
    }
}

export interface IUserProductDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    summary?: string | undefined;
    description?: string | undefined;
    image?: string | undefined;
    categoryId?: number | undefined;
    productType?: ProductTypeEnum;
    status?: CommonStatusEnum;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaKeywords?: string | undefined;
    slug?: string | undefined;
    price?: number | undefined;
    salePrice?: number | undefined;
    orgPrice?: number | undefined;
    orgSalePrice?: number | undefined;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    lessonZoomCount?: number;
    productChapters?: ProductChapterEntity[] | undefined;
    enrollmentDate?: Date | undefined;
    activationDate?: Date | undefined;
    enrollmentStatus?: EnrollmentStatusEnum;
    progressPercent?: number | undefined;
    lessonCount?: number;
    classId?: number;
    className?: string | undefined;
    totalDuration?: number;
    currentLesson?: ProductLessonDetailDto;
    currentSession?: ClassSessionEntity;
}

export class UserScheduleDto implements IUserScheduleDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    classId?: number;
    productLessonId?: number | undefined;
    productId?: number;
    sessionNumber?: number;
    sessionName?: string | undefined;
    description?: string | undefined;
    startTime?: Date;
    endTime?: Date;
    deliveryMode?: SessionDeliveryModeEnum;
    zoomMeetingId?: string | undefined;
    zoomWebinarId?: string | undefined;
    zoomJoinLink?: string | undefined;
    zoomStartLink?: string | undefined;
    zoomPassword?: string | undefined;
    recordingUrl?: string | undefined;
    zoomAccountId?: number | undefined;
    actualDurationMinutes?: number | undefined;
    status?: SessionStatusEnum;
    notes?: string | undefined;
    isNotifiedReminder?: boolean;
    isNotifiedStart?: boolean;
    class?: ClassEntity;
    productLesson?: ProductLessonEntity;
    attendances?: SessionAttendanceEntity[] | undefined;
    productName?: string | undefined;
    className?: string | undefined;

    constructor(data?: IUserScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.classId = _data["classId"];
            this.productLessonId = _data["productLessonId"];
            this.productId = _data["productId"];
            this.sessionNumber = _data["sessionNumber"];
            this.sessionName = _data["sessionName"];
            this.description = _data["description"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
            this.deliveryMode = _data["deliveryMode"];
            this.zoomMeetingId = _data["zoomMeetingId"];
            this.zoomWebinarId = _data["zoomWebinarId"];
            this.zoomJoinLink = _data["zoomJoinLink"];
            this.zoomStartLink = _data["zoomStartLink"];
            this.zoomPassword = _data["zoomPassword"];
            this.recordingUrl = _data["recordingUrl"];
            this.zoomAccountId = _data["zoomAccountId"];
            this.actualDurationMinutes = _data["actualDurationMinutes"];
            this.status = _data["status"];
            this.notes = _data["notes"];
            this.isNotifiedReminder = _data["isNotifiedReminder"];
            this.isNotifiedStart = _data["isNotifiedStart"];
            this.class = _data["class"] ? ClassEntity.fromJS(_data["class"]) : undefined as any;
            this.productLesson = _data["productLesson"] ? ProductLessonEntity.fromJS(_data["productLesson"]) : undefined as any;
            if (Array.isArray(_data["attendances"])) {
                this.attendances = [] as any;
                for (let item of _data["attendances"])
                    this.attendances!.push(SessionAttendanceEntity.fromJS(item));
            }
            this.productName = _data["productName"];
            this.className = _data["className"];
        }
    }

    static fromJS(data: any): UserScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["classId"] = this.classId;
        data["productLessonId"] = this.productLessonId;
        data["productId"] = this.productId;
        data["sessionNumber"] = this.sessionNumber;
        data["sessionName"] = this.sessionName;
        data["description"] = this.description;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        data["deliveryMode"] = this.deliveryMode;
        data["zoomMeetingId"] = this.zoomMeetingId;
        data["zoomWebinarId"] = this.zoomWebinarId;
        data["zoomJoinLink"] = this.zoomJoinLink;
        data["zoomStartLink"] = this.zoomStartLink;
        data["zoomPassword"] = this.zoomPassword;
        data["recordingUrl"] = this.recordingUrl;
        data["zoomAccountId"] = this.zoomAccountId;
        data["actualDurationMinutes"] = this.actualDurationMinutes;
        data["status"] = this.status;
        data["notes"] = this.notes;
        data["isNotifiedReminder"] = this.isNotifiedReminder;
        data["isNotifiedStart"] = this.isNotifiedStart;
        data["class"] = this.class ? this.class.toJSON() : undefined as any;
        data["productLesson"] = this.productLesson ? this.productLesson.toJSON() : undefined as any;
        if (Array.isArray(this.attendances)) {
            data["attendances"] = [];
            for (let item of this.attendances)
                data["attendances"].push(item ? item.toJSON() : undefined as any);
        }
        data["productName"] = this.productName;
        data["className"] = this.className;
        return data;
    }
}

export interface IUserScheduleDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    classId?: number;
    productLessonId?: number | undefined;
    productId?: number;
    sessionNumber?: number;
    sessionName?: string | undefined;
    description?: string | undefined;
    startTime?: Date;
    endTime?: Date;
    deliveryMode?: SessionDeliveryModeEnum;
    zoomMeetingId?: string | undefined;
    zoomWebinarId?: string | undefined;
    zoomJoinLink?: string | undefined;
    zoomStartLink?: string | undefined;
    zoomPassword?: string | undefined;
    recordingUrl?: string | undefined;
    zoomAccountId?: number | undefined;
    actualDurationMinutes?: number | undefined;
    status?: SessionStatusEnum;
    notes?: string | undefined;
    isNotifiedReminder?: boolean;
    isNotifiedStart?: boolean;
    class?: ClassEntity;
    productLesson?: ProductLessonEntity;
    attendances?: SessionAttendanceEntity[] | undefined;
    productName?: string | undefined;
    className?: string | undefined;
}

export class UserSessionListItemDto implements IUserSessionListItemDto {
    id?: number;
    userDeviceId?: number | undefined;
    createdDate?: Date;
    lastActivity?: Date | undefined;
    expires?: Date;
    isCurrent?: boolean;

    constructor(data?: IUserSessionListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userDeviceId = _data["userDeviceId"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastActivity = _data["lastActivity"] ? new Date(_data["lastActivity"].toString()) : undefined as any;
            this.expires = _data["expires"] ? new Date(_data["expires"].toString()) : undefined as any;
            this.isCurrent = _data["isCurrent"];
        }
    }

    static fromJS(data: any): UserSessionListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserSessionListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userDeviceId"] = this.userDeviceId;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastActivity"] = this.lastActivity ? this.lastActivity.toISOString() : undefined as any;
        data["expires"] = this.expires ? this.expires.toISOString() : undefined as any;
        data["isCurrent"] = this.isCurrent;
        return data;
    }
}

export interface IUserSessionListItemDto {
    id?: number;
    userDeviceId?: number | undefined;
    createdDate?: Date;
    lastActivity?: Date | undefined;
    expires?: Date;
    isCurrent?: boolean;
}

export class UserWithSimpleInfoDto implements IUserWithSimpleInfoDto {
    id?: number;
    userName?: string | undefined;
    avatar?: string | undefined;
    fullName?: string | undefined;
    type?: UserTypeEnum;
    isOnline?: boolean;

    constructor(data?: IUserWithSimpleInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.avatar = _data["avatar"];
            this.fullName = _data["fullName"];
            this.type = _data["type"];
            this.isOnline = _data["isOnline"];
        }
    }

    static fromJS(data: any): UserWithSimpleInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserWithSimpleInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["avatar"] = this.avatar;
        data["fullName"] = this.fullName;
        data["type"] = this.type;
        data["isOnline"] = this.isOnline;
        return data;
    }
}

export interface IUserWithSimpleInfoDto {
    id?: number;
    userName?: string | undefined;
    avatar?: string | undefined;
    fullName?: string | undefined;
    type?: UserTypeEnum;
    isOnline?: boolean;
}

export class VanityDataBase implements IVanityDataBase {

    constructor(data?: IVanityDataBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): VanityDataBase {
        data = typeof data === 'object' ? data : {};
        let result = new VanityDataBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IVanityDataBase {
}

export class VanityOwnerDto implements IVanityOwnerDto {
    userTypes?: number[] | undefined;
    id?: number;
    type?: VanityTypeEnum;
    slug?: string | undefined;
    name?: string | undefined;
    avatar?: string | undefined;
    languageCode?: string | undefined;
    userPermissions?: RoleModuleDto[] | undefined;
    data?: VanityDataBase;

    constructor(data?: IVanityOwnerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userTypes = _data["userTypes"];
            this.id = _data["id"];
            this.type = _data["type"];
            this.slug = _data["slug"];
            this.name = _data["name"];
            this.avatar = _data["avatar"];
            this.languageCode = _data["languageCode"];
            if (Array.isArray(_data["userPermissions"])) {
                this.userPermissions = [] as any;
                for (let item of _data["userPermissions"])
                    this.userPermissions!.push(RoleModuleDto.fromJS(item));
            }
            this.data = _data["data"] ? VanityDataBase.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): VanityOwnerDto {
        data = typeof data === 'object' ? data : {};
        let result = new VanityOwnerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userTypes"] = this.userTypes;
        data["id"] = this.id;
        data["type"] = this.type;
        data["slug"] = this.slug;
        data["name"] = this.name;
        data["avatar"] = this.avatar;
        data["languageCode"] = this.languageCode;
        if (Array.isArray(this.userPermissions)) {
            data["userPermissions"] = [];
            for (let item of this.userPermissions)
                data["userPermissions"].push(item ? item.toJSON() : undefined as any);
        }
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IVanityOwnerDto {
    userTypes?: number[] | undefined;
    id?: number;
    type?: VanityTypeEnum;
    slug?: string | undefined;
    name?: string | undefined;
    avatar?: string | undefined;
    languageCode?: string | undefined;
    userPermissions?: RoleModuleDto[] | undefined;
    data?: VanityDataBase;
}

export class VideoHeartbeatRequestDto implements IVideoHeartbeatRequestDto {
    sessionId?: string | undefined;
    productId?: number;
    productLessonId?: number;
    currentSecond?: number;
    duration?: number;
    watchPercent?: number;

    constructor(data?: IVideoHeartbeatRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.productId = _data["productId"];
            this.productLessonId = _data["productLessonId"];
            this.currentSecond = _data["currentSecond"];
            this.duration = _data["duration"];
            this.watchPercent = _data["watchPercent"];
        }
    }

    static fromJS(data: any): VideoHeartbeatRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new VideoHeartbeatRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["productId"] = this.productId;
        data["productLessonId"] = this.productLessonId;
        data["currentSecond"] = this.currentSecond;
        data["duration"] = this.duration;
        data["watchPercent"] = this.watchPercent;
        return data;
    }
}

export interface IVideoHeartbeatRequestDto {
    sessionId?: string | undefined;
    productId?: number;
    productLessonId?: number;
    currentSecond?: number;
    duration?: number;
    watchPercent?: number;
}

export class ActivityEntity implements IActivityEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    title?: string | undefined;
    description?: string | undefined;
    videoUrl?: string | undefined;
    tag?: string | undefined;
    type?: string | undefined;
    imageUrl?: string | undefined;
    status?: CommonStatusEnum;
    displayOrder?: number;

    constructor(data?: IActivityEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.videoUrl = _data["videoUrl"];
            this.tag = _data["tag"];
            this.type = _data["type"];
            this.imageUrl = _data["imageUrl"];
            this.status = _data["status"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): ActivityEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["title"] = this.title;
        data["description"] = this.description;
        data["videoUrl"] = this.videoUrl;
        data["tag"] = this.tag;
        data["type"] = this.type;
        data["imageUrl"] = this.imageUrl;
        data["status"] = this.status;
        data["displayOrder"] = this.displayOrder;
        return data;
    }
}

export interface IActivityEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    title?: string | undefined;
    description?: string | undefined;
    videoUrl?: string | undefined;
    tag?: string | undefined;
    type?: string | undefined;
    imageUrl?: string | undefined;
    status?: CommonStatusEnum;
    displayOrder?: number;
}

export class ActivityLogEntity implements IActivityLogEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    title?: string | undefined;
    data?: string | undefined;
    objectType?: string | undefined;
    ip?: string | undefined;

    constructor(data?: IActivityLogEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.title = _data["title"];
            this.data = _data["data"];
            this.objectType = _data["objectType"];
            this.ip = _data["ip"];
        }
    }

    static fromJS(data: any): ActivityLogEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityLogEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["title"] = this.title;
        data["data"] = this.data;
        data["objectType"] = this.objectType;
        data["ip"] = this.ip;
        return data;
    }
}

export interface IActivityLogEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    title?: string | undefined;
    data?: string | undefined;
    objectType?: string | undefined;
    ip?: string | undefined;
}

export class AiPromptEntity implements IAiPromptEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    grade?: number | undefined;
    categoryId?: number | undefined;
    code!: string;
    name?: string | undefined;
    description?: string | undefined;
    prompt!: string;
    category?: CategoryEntity;

    constructor(data?: IAiPromptEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.grade = _data["grade"];
            this.categoryId = _data["categoryId"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.prompt = _data["prompt"];
            this.category = _data["category"] ? CategoryEntity.fromJS(_data["category"]) : undefined as any;
        }
    }

    static fromJS(data: any): AiPromptEntity {
        data = typeof data === 'object' ? data : {};
        let result = new AiPromptEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["grade"] = this.grade;
        data["categoryId"] = this.categoryId;
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["prompt"] = this.prompt;
        data["category"] = this.category ? this.category.toJSON() : undefined as any;
        return data;
    }
}

export interface IAiPromptEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    grade?: number | undefined;
    categoryId?: number | undefined;
    code: string;
    name?: string | undefined;
    description?: string | undefined;
    prompt: string;
    category?: CategoryEntity;
}

export class FilterResult_1OfSystemConfigAdminDto implements IFilterResult_1OfSystemConfigAdminDto {
    totalRows?: number;
    data?: SystemConfigAdminDto[] | undefined;

    constructor(data?: IFilterResult_1OfSystemConfigAdminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SystemConfigAdminDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfSystemConfigAdminDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfSystemConfigAdminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfSystemConfigAdminDto {
    totalRows?: number;
    data?: SystemConfigAdminDto[] | undefined;
}

export class FilterResult_1OfUserIdentifierAdminDto implements IFilterResult_1OfUserIdentifierAdminDto {
    totalRows?: number;
    data?: UserIdentifierAdminDto[] | undefined;

    constructor(data?: IFilterResult_1OfUserIdentifierAdminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserIdentifierAdminDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfUserIdentifierAdminDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfUserIdentifierAdminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfUserIdentifierAdminDto {
    totalRows?: number;
    data?: UserIdentifierAdminDto[] | undefined;
}

export class FilterResult_1OfActionRuleDto implements IFilterResult_1OfActionRuleDto {
    totalRows?: number;
    data?: ActionRuleDto[] | undefined;

    constructor(data?: IFilterResult_1OfActionRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ActionRuleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfActionRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfActionRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfActionRuleDto {
    totalRows?: number;
    data?: ActionRuleDto[] | undefined;
}

export class FilterResult_1OfActivityListDto implements IFilterResult_1OfActivityListDto {
    totalRows?: number;
    data?: ActivityListDto[] | undefined;

    constructor(data?: IFilterResult_1OfActivityListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ActivityListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfActivityListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfActivityListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfActivityListDto {
    totalRows?: number;
    data?: ActivityListDto[] | undefined;
}

export class FilterResult_1OfActivityStatsDailyItemDto implements IFilterResult_1OfActivityStatsDailyItemDto {
    totalRows?: number;
    data?: ActivityStatsDailyItemDto[] | undefined;

    constructor(data?: IFilterResult_1OfActivityStatsDailyItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ActivityStatsDailyItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfActivityStatsDailyItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfActivityStatsDailyItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfActivityStatsDailyItemDto {
    totalRows?: number;
    data?: ActivityStatsDailyItemDto[] | undefined;
}

export class FilterResult_1OfAiPromptListDto implements IFilterResult_1OfAiPromptListDto {
    totalRows?: number;
    data?: AiPromptListDto[] | undefined;

    constructor(data?: IFilterResult_1OfAiPromptListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AiPromptListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfAiPromptListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfAiPromptListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfAiPromptListDto {
    totalRows?: number;
    data?: AiPromptListDto[] | undefined;
}

export class FilterResult_1OfAssignExamListByExamIdDto implements IFilterResult_1OfAssignExamListByExamIdDto {
    totalRows?: number;
    data?: AssignExamListByExamIdDto[] | undefined;

    constructor(data?: IFilterResult_1OfAssignExamListByExamIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AssignExamListByExamIdDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfAssignExamListByExamIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfAssignExamListByExamIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfAssignExamListByExamIdDto {
    totalRows?: number;
    data?: AssignExamListByExamIdDto[] | undefined;
}

export class FilterResult_1OfAssignExamListDto implements IFilterResult_1OfAssignExamListDto {
    totalRows?: number;
    data?: AssignExamListDto[] | undefined;

    constructor(data?: IFilterResult_1OfAssignExamListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AssignExamListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfAssignExamListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfAssignExamListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfAssignExamListDto {
    totalRows?: number;
    data?: AssignExamListDto[] | undefined;
}

export class FilterResult_1OfAssignExamListExamDto implements IFilterResult_1OfAssignExamListExamDto {
    totalRows?: number;
    data?: AssignExamListExamDto[] | undefined;

    constructor(data?: IFilterResult_1OfAssignExamListExamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AssignExamListExamDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfAssignExamListExamDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfAssignExamListExamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfAssignExamListExamDto {
    totalRows?: number;
    data?: AssignExamListExamDto[] | undefined;
}

export class FilterResult_1OfCategoryConfigListDto implements IFilterResult_1OfCategoryConfigListDto {
    totalRows?: number;
    data?: CategoryConfigListDto[] | undefined;

    constructor(data?: IFilterResult_1OfCategoryConfigListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CategoryConfigListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfCategoryConfigListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfCategoryConfigListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfCategoryConfigListDto {
    totalRows?: number;
    data?: CategoryConfigListDto[] | undefined;
}

export class FilterResult_1OfCategoryListDto implements IFilterResult_1OfCategoryListDto {
    totalRows?: number;
    data?: CategoryListDto[] | undefined;

    constructor(data?: IFilterResult_1OfCategoryListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CategoryListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfCategoryListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfCategoryListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfCategoryListDto {
    totalRows?: number;
    data?: CategoryListDto[] | undefined;
}

export class FilterResult_1OfClassListDto implements IFilterResult_1OfClassListDto {
    totalRows?: number;
    data?: ClassListDto[] | undefined;

    constructor(data?: IFilterResult_1OfClassListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ClassListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfClassListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfClassListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfClassListDto {
    totalRows?: number;
    data?: ClassListDto[] | undefined;
}

export class FilterResult_1OfClassListOfSchoolDto implements IFilterResult_1OfClassListOfSchoolDto {
    totalRows?: number;
    data?: ClassListOfSchoolDto[] | undefined;

    constructor(data?: IFilterResult_1OfClassListOfSchoolDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ClassListOfSchoolDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfClassListOfSchoolDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfClassListOfSchoolDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfClassListOfSchoolDto {
    totalRows?: number;
    data?: ClassListOfSchoolDto[] | undefined;
}

export class FilterResult_1OfClassPupilStatisticalDto implements IFilterResult_1OfClassPupilStatisticalDto {
    totalRows?: number;
    data?: ClassPupilStatisticalDto[] | undefined;

    constructor(data?: IFilterResult_1OfClassPupilStatisticalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ClassPupilStatisticalDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfClassPupilStatisticalDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfClassPupilStatisticalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfClassPupilStatisticalDto {
    totalRows?: number;
    data?: ClassPupilStatisticalDto[] | undefined;
}

export class FilterResult_1OfConsultationRegistrationListDto implements IFilterResult_1OfConsultationRegistrationListDto {
    totalRows?: number;
    data?: ConsultationRegistrationListDto[] | undefined;

    constructor(data?: IFilterResult_1OfConsultationRegistrationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ConsultationRegistrationListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfConsultationRegistrationListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfConsultationRegistrationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfConsultationRegistrationListDto {
    totalRows?: number;
    data?: ConsultationRegistrationListDto[] | undefined;
}

export class FilterResult_1OfContactListDto implements IFilterResult_1OfContactListDto {
    totalRows?: number;
    data?: ContactListDto[] | undefined;

    constructor(data?: IFilterResult_1OfContactListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ContactListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfContactListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfContactListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfContactListDto {
    totalRows?: number;
    data?: ContactListDto[] | undefined;
}

export class FilterResult_1OfExamListDto implements IFilterResult_1OfExamListDto {
    totalRows?: number;
    data?: ExamListDto[] | undefined;

    constructor(data?: IFilterResult_1OfExamListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ExamListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfExamListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfExamListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfExamListDto {
    totalRows?: number;
    data?: ExamListDto[] | undefined;
}

export class FilterResult_1OfExamResultDto implements IFilterResult_1OfExamResultDto {
    totalRows?: number;
    data?: ExamResultDto[] | undefined;

    constructor(data?: IFilterResult_1OfExamResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ExamResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfExamResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfExamResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfExamResultDto {
    totalRows?: number;
    data?: ExamResultDto[] | undefined;
}

export class FilterResult_1OfGalleryListDto implements IFilterResult_1OfGalleryListDto {
    totalRows?: number;
    data?: GalleryListDto[] | undefined;

    constructor(data?: IFilterResult_1OfGalleryListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(GalleryListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfGalleryListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfGalleryListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfGalleryListDto {
    totalRows?: number;
    data?: GalleryListDto[] | undefined;
}

export class FilterResult_1OfLanguageListDto implements IFilterResult_1OfLanguageListDto {
    totalRows?: number;
    data?: LanguageListDto[] | undefined;

    constructor(data?: IFilterResult_1OfLanguageListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(LanguageListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfLanguageListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfLanguageListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfLanguageListDto {
    totalRows?: number;
    data?: LanguageListDto[] | undefined;
}

export class FilterResult_1OfListActivityLogDto implements IFilterResult_1OfListActivityLogDto {
    totalRows?: number;
    data?: ListActivityLogDto[] | undefined;

    constructor(data?: IFilterResult_1OfListActivityLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ListActivityLogDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfListActivityLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfListActivityLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfListActivityLogDto {
    totalRows?: number;
    data?: ListActivityLogDto[] | undefined;
}

export class FilterResult_1OfListChatGroupDto implements IFilterResult_1OfListChatGroupDto {
    totalRows?: number;
    data?: ListChatGroupDto[] | undefined;

    constructor(data?: IFilterResult_1OfListChatGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ListChatGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfListChatGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfListChatGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfListChatGroupDto {
    totalRows?: number;
    data?: ListChatGroupDto[] | undefined;
}

export class FilterResult_1OfListChatMessageByGroupDto implements IFilterResult_1OfListChatMessageByGroupDto {
    totalRows?: number;
    data?: ListChatMessageByGroupDto[] | undefined;

    constructor(data?: IFilterResult_1OfListChatMessageByGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ListChatMessageByGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfListChatMessageByGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfListChatMessageByGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfListChatMessageByGroupDto {
    totalRows?: number;
    data?: ListChatMessageByGroupDto[] | undefined;
}

export class FilterResult_1OfNewsListDto implements IFilterResult_1OfNewsListDto {
    totalRows?: number;
    data?: NewsListDto[] | undefined;

    constructor(data?: IFilterResult_1OfNewsListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(NewsListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfNewsListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfNewsListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfNewsListDto {
    totalRows?: number;
    data?: NewsListDto[] | undefined;
}

export class FilterResult_1OfNotificationDto implements IFilterResult_1OfNotificationDto {
    totalRows?: number;
    data?: NotificationDto[] | undefined;

    constructor(data?: IFilterResult_1OfNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(NotificationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfNotificationDto {
    totalRows?: number;
    data?: NotificationDto[] | undefined;
}

export class FilterResult_1OfOfficeDto implements IFilterResult_1OfOfficeDto {
    totalRows?: number;
    data?: OfficeDto[] | undefined;

    constructor(data?: IFilterResult_1OfOfficeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(OfficeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfOfficeDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfOfficeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfOfficeDto {
    totalRows?: number;
    data?: OfficeDto[] | undefined;
}

export class FilterResult_1OfOrderDto implements IFilterResult_1OfOrderDto {
    totalRows?: number;
    data?: OrderDto[] | undefined;

    constructor(data?: IFilterResult_1OfOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(OrderDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfOrderDto {
    totalRows?: number;
    data?: OrderDto[] | undefined;
}

export class FilterResult_1OfOrganizationListDto implements IFilterResult_1OfOrganizationListDto {
    totalRows?: number;
    data?: OrganizationListDto[] | undefined;

    constructor(data?: IFilterResult_1OfOrganizationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(OrganizationListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfOrganizationListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfOrganizationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfOrganizationListDto {
    totalRows?: number;
    data?: OrganizationListDto[] | undefined;
}

export class FilterResult_1OfProductDashboardListDto implements IFilterResult_1OfProductDashboardListDto {
    totalRows?: number;
    data?: ProductDashboardListDto[] | undefined;

    constructor(data?: IFilterResult_1OfProductDashboardListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ProductDashboardListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfProductDashboardListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfProductDashboardListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfProductDashboardListDto {
    totalRows?: number;
    data?: ProductDashboardListDto[] | undefined;
}

export class FilterResult_1OfProductListDto implements IFilterResult_1OfProductListDto {
    totalRows?: number;
    data?: ProductListDto[] | undefined;

    constructor(data?: IFilterResult_1OfProductListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ProductListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfProductListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfProductListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfProductListDto {
    totalRows?: number;
    data?: ProductListDto[] | undefined;
}

export class FilterResult_1OfProductReviewListDto implements IFilterResult_1OfProductReviewListDto {
    totalRows?: number;
    data?: ProductReviewListDto[] | undefined;

    constructor(data?: IFilterResult_1OfProductReviewListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ProductReviewListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfProductReviewListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfProductReviewListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfProductReviewListDto {
    totalRows?: number;
    data?: ProductReviewListDto[] | undefined;
}

export class FilterResult_1OfPupilHistoryDoExamDto implements IFilterResult_1OfPupilHistoryDoExamDto {
    totalRows?: number;
    data?: PupilHistoryDoExamDto[] | undefined;

    constructor(data?: IFilterResult_1OfPupilHistoryDoExamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PupilHistoryDoExamDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfPupilHistoryDoExamDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfPupilHistoryDoExamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfPupilHistoryDoExamDto {
    totalRows?: number;
    data?: PupilHistoryDoExamDto[] | undefined;
}

export class FilterResult_1OfPupilListDto implements IFilterResult_1OfPupilListDto {
    totalRows?: number;
    data?: PupilListDto[] | undefined;

    constructor(data?: IFilterResult_1OfPupilListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PupilListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfPupilListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfPupilListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfPupilListDto {
    totalRows?: number;
    data?: PupilListDto[] | undefined;
}

export class FilterResult_1OfQuestionListDto implements IFilterResult_1OfQuestionListDto {
    totalRows?: number;
    data?: QuestionListDto[] | undefined;

    constructor(data?: IFilterResult_1OfQuestionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(QuestionListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfQuestionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfQuestionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfQuestionListDto {
    totalRows?: number;
    data?: QuestionListDto[] | undefined;
}

export class FilterResult_1OfSchoolListDto implements IFilterResult_1OfSchoolListDto {
    totalRows?: number;
    data?: SchoolListDto[] | undefined;

    constructor(data?: IFilterResult_1OfSchoolListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SchoolListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfSchoolListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfSchoolListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfSchoolListDto {
    totalRows?: number;
    data?: SchoolListDto[] | undefined;
}

export class FilterResult_1OfStaticPageListDto implements IFilterResult_1OfStaticPageListDto {
    totalRows?: number;
    data?: StaticPageListDto[] | undefined;

    constructor(data?: IFilterResult_1OfStaticPageListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(StaticPageListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfStaticPageListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfStaticPageListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfStaticPageListDto {
    totalRows?: number;
    data?: StaticPageListDto[] | undefined;
}

export class FilterResult_1OfTagListDto implements IFilterResult_1OfTagListDto {
    totalRows?: number;
    data?: TagListDto[] | undefined;

    constructor(data?: IFilterResult_1OfTagListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TagListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfTagListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfTagListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfTagListDto {
    totalRows?: number;
    data?: TagListDto[] | undefined;
}

export class FilterResult_1OfTeacherGetBySchoolDto implements IFilterResult_1OfTeacherGetBySchoolDto {
    totalRows?: number;
    data?: TeacherGetBySchoolDto[] | undefined;

    constructor(data?: IFilterResult_1OfTeacherGetBySchoolDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TeacherGetBySchoolDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfTeacherGetBySchoolDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfTeacherGetBySchoolDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfTeacherGetBySchoolDto {
    totalRows?: number;
    data?: TeacherGetBySchoolDto[] | undefined;
}

export class FilterResult_1OfTeacherListDto implements IFilterResult_1OfTeacherListDto {
    totalRows?: number;
    data?: TeacherListDto[] | undefined;

    constructor(data?: IFilterResult_1OfTeacherListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TeacherListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfTeacherListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfTeacherListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfTeacherListDto {
    totalRows?: number;
    data?: TeacherListDto[] | undefined;
}

export class FilterResult_1OfTranslationListDto implements IFilterResult_1OfTranslationListDto {
    totalRows?: number;
    data?: TranslationListDto[] | undefined;

    constructor(data?: IFilterResult_1OfTranslationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TranslationListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfTranslationListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfTranslationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfTranslationListDto {
    totalRows?: number;
    data?: TranslationListDto[] | undefined;
}

export class FilterResult_1OfUserActivityLogAdminItemDto implements IFilterResult_1OfUserActivityLogAdminItemDto {
    totalRows?: number;
    data?: UserActivityLogAdminItemDto[] | undefined;

    constructor(data?: IFilterResult_1OfUserActivityLogAdminItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserActivityLogAdminItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfUserActivityLogAdminItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfUserActivityLogAdminItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfUserActivityLogAdminItemDto {
    totalRows?: number;
    data?: UserActivityLogAdminItemDto[] | undefined;
}

export class FilterResult_1OfUserListDto implements IFilterResult_1OfUserListDto {
    totalRows?: number;
    data?: UserListDto[] | undefined;

    constructor(data?: IFilterResult_1OfUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfUserListDto {
    totalRows?: number;
    data?: UserListDto[] | undefined;
}

export class FilterResult_1OfFileEntity implements IFilterResult_1OfFileEntity {
    totalRows?: number;
    data?: FileEntity[] | undefined;

    constructor(data?: IFilterResult_1OfFileEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FileEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfFileEntity {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfFileEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfFileEntity {
    totalRows?: number;
    data?: FileEntity[] | undefined;
}

export class FilterResult_1OfLocalityEntity implements IFilterResult_1OfLocalityEntity {
    totalRows?: number;
    data?: LocalityEntity[] | undefined;

    constructor(data?: IFilterResult_1OfLocalityEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(LocalityEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfLocalityEntity {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfLocalityEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResult_1OfLocalityEntity {
    totalRows?: number;
    data?: LocalityEntity[] | undefined;
}

export class CategoryClassLevelEntity implements ICategoryClassLevelEntity {
    categoryId?: number;
    classLevel?: number;

    constructor(data?: ICategoryClassLevelEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"];
            this.classLevel = _data["classLevel"];
        }
    }

    static fromJS(data: any): CategoryClassLevelEntity {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryClassLevelEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["classLevel"] = this.classLevel;
        return data;
    }
}

export interface ICategoryClassLevelEntity {
    categoryId?: number;
    classLevel?: number;
}

export class CategoryConfigEntity implements ICategoryConfigEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    code?: string | undefined;
    name?: string | undefined;
    priority?: number;
    allowCreate?: boolean;
    allowTree?: boolean;

    constructor(data?: ICategoryConfigEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.priority = _data["priority"];
            this.allowCreate = _data["allowCreate"];
            this.allowTree = _data["allowTree"];
        }
    }

    static fromJS(data: any): CategoryConfigEntity {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryConfigEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["code"] = this.code;
        data["name"] = this.name;
        data["priority"] = this.priority;
        data["allowCreate"] = this.allowCreate;
        data["allowTree"] = this.allowTree;
        return data;
    }
}

export interface ICategoryConfigEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    code?: string | undefined;
    name?: string | undefined;
    priority?: number;
    allowCreate?: boolean;
    allowTree?: boolean;
}

export class CategoryEntity implements ICategoryEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    nameViVN?: string | undefined;
    nameEnUS?: string | undefined;
    nameZhCN?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;
    code?: string | undefined;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    parentId?: number;
    level?: number;
    path?: string | undefined;
    icon?: string | undefined;
    status?: CommonStatusEnum;
    priority?: number;
    categoryClassLevels?: CategoryClassLevelEntity[] | undefined;

    constructor(data?: ICategoryEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.nameViVN = _data["nameViVN"];
            this.nameEnUS = _data["nameEnUS"];
            this.nameZhCN = _data["nameZhCN"];
            this.description = _data["description"];
            this.url = _data["url"];
            this.code = _data["code"];
            this.objectType = _data["objectType"];
            this.objectId = _data["objectId"];
            this.parentId = _data["parentId"];
            this.level = _data["level"];
            this.path = _data["path"];
            this.icon = _data["icon"];
            this.status = _data["status"];
            this.priority = _data["priority"];
            if (Array.isArray(_data["categoryClassLevels"])) {
                this.categoryClassLevels = [] as any;
                for (let item of _data["categoryClassLevels"])
                    this.categoryClassLevels!.push(CategoryClassLevelEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CategoryEntity {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["nameViVN"] = this.nameViVN;
        data["nameEnUS"] = this.nameEnUS;
        data["nameZhCN"] = this.nameZhCN;
        data["description"] = this.description;
        data["url"] = this.url;
        data["code"] = this.code;
        data["objectType"] = this.objectType;
        data["objectId"] = this.objectId;
        data["parentId"] = this.parentId;
        data["level"] = this.level;
        data["path"] = this.path;
        data["icon"] = this.icon;
        data["status"] = this.status;
        data["priority"] = this.priority;
        if (Array.isArray(this.categoryClassLevels)) {
            data["categoryClassLevels"] = [];
            for (let item of this.categoryClassLevels)
                data["categoryClassLevels"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICategoryEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    nameViVN?: string | undefined;
    nameEnUS?: string | undefined;
    nameZhCN?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;
    code?: string | undefined;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    parentId?: number;
    level?: number;
    path?: string | undefined;
    icon?: string | undefined;
    status?: CommonStatusEnum;
    priority?: number;
    categoryClassLevels?: CategoryClassLevelEntity[] | undefined;
}

export class ChatGroupEntity implements IChatGroupEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    avatar?: string | undefined;
    status?: number | undefined;
    type?: number | undefined;
    documentId?: number | undefined;

    constructor(data?: IChatGroupEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.avatar = _data["avatar"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.documentId = _data["documentId"];
        }
    }

    static fromJS(data: any): ChatGroupEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ChatGroupEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["avatar"] = this.avatar;
        data["status"] = this.status;
        data["type"] = this.type;
        data["documentId"] = this.documentId;
        return data;
    }
}

export interface IChatGroupEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    avatar?: string | undefined;
    status?: number | undefined;
    type?: number | undefined;
    documentId?: number | undefined;
}

export class ConsultationRegistrationEntity implements IConsultationRegistrationEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    message?: string | undefined;
    planType?: string | undefined;
    productId?: number | undefined;
    status?: ConsultationStatusEnum;
    adminNote?: string | undefined;
    contactedDate?: Date | undefined;
    contactedBy?: number | undefined;

    constructor(data?: IConsultationRegistrationEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.message = _data["message"];
            this.planType = _data["planType"];
            this.productId = _data["productId"];
            this.status = _data["status"];
            this.adminNote = _data["adminNote"];
            this.contactedDate = _data["contactedDate"] ? new Date(_data["contactedDate"].toString()) : undefined as any;
            this.contactedBy = _data["contactedBy"];
        }
    }

    static fromJS(data: any): ConsultationRegistrationEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationRegistrationEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["message"] = this.message;
        data["planType"] = this.planType;
        data["productId"] = this.productId;
        data["status"] = this.status;
        data["adminNote"] = this.adminNote;
        data["contactedDate"] = this.contactedDate ? this.contactedDate.toISOString() : undefined as any;
        data["contactedBy"] = this.contactedBy;
        return data;
    }
}

export interface IConsultationRegistrationEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    message?: string | undefined;
    planType?: string | undefined;
    productId?: number | undefined;
    status?: ConsultationStatusEnum;
    adminNote?: string | undefined;
    contactedDate?: Date | undefined;
    contactedBy?: number | undefined;
}

export enum ConsultationStatusEnum {
    Pending = 0,
    Contacted = 1,
    Completed = 2,
    Cancelled = 3,
}

export class ContactEntity implements IContactEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    fullName?: string | undefined;
    phone?: string | undefined;
    message?: string | undefined;
    status?: ContactStatusEnum;
    adminNote?: string | undefined;
    contactedDate?: Date | undefined;
    contactedBy?: number | undefined;

    constructor(data?: IContactEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.fullName = _data["fullName"];
            this.phone = _data["phone"];
            this.message = _data["message"];
            this.status = _data["status"];
            this.adminNote = _data["adminNote"];
            this.contactedDate = _data["contactedDate"] ? new Date(_data["contactedDate"].toString()) : undefined as any;
            this.contactedBy = _data["contactedBy"];
        }
    }

    static fromJS(data: any): ContactEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ContactEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["fullName"] = this.fullName;
        data["phone"] = this.phone;
        data["message"] = this.message;
        data["status"] = this.status;
        data["adminNote"] = this.adminNote;
        data["contactedDate"] = this.contactedDate ? this.contactedDate.toISOString() : undefined as any;
        data["contactedBy"] = this.contactedBy;
        return data;
    }
}

export interface IContactEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    fullName?: string | undefined;
    phone?: string | undefined;
    message?: string | undefined;
    status?: ContactStatusEnum;
    adminNote?: string | undefined;
    contactedDate?: Date | undefined;
    contactedBy?: number | undefined;
}

export enum ContactStatusEnum {
    Pending = 0,
    Contacted = 1,
    Completed = 2,
    Cancelled = 3,
}

export class DepartmentEntity implements IDepartmentEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    parentId?: number;
    code?: string | undefined;
    name?: string | undefined;
    sortOrder?: number;
    isActive?: boolean;
    isDefault?: boolean;

    constructor(data?: IDepartmentEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.objectType = _data["objectType"];
            this.objectId = _data["objectId"];
            this.parentId = _data["parentId"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
            this.isActive = _data["isActive"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): DepartmentEntity {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["objectType"] = this.objectType;
        data["objectId"] = this.objectId;
        data["parentId"] = this.parentId;
        data["code"] = this.code;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        data["isActive"] = this.isActive;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface IDepartmentEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    parentId?: number;
    code?: string | undefined;
    name?: string | undefined;
    sortOrder?: number;
    isActive?: boolean;
    isDefault?: boolean;
}

export class DepartmentUserEntity implements IDepartmentUserEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    departmentId?: number;
    userId?: number;
    title?: string | undefined;
    titleId?: number;
    isPrimary?: boolean;
    joinedAt?: Date;
    leftAt?: Date | undefined;
    roleIds?: number[] | undefined;
    roleNames?: string[] | undefined;
    fullName?: string | undefined;
    userName?: string | undefined;
    email?: string | undefined;
    departmentName?: string | undefined;

    constructor(data?: IDepartmentUserEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.departmentId = _data["departmentId"];
            this.userId = _data["userId"];
            this.title = _data["title"];
            this.titleId = _data["titleId"];
            this.isPrimary = _data["isPrimary"];
            this.joinedAt = _data["joinedAt"] ? new Date(_data["joinedAt"].toString()) : undefined as any;
            this.leftAt = _data["leftAt"] ? new Date(_data["leftAt"].toString()) : undefined as any;
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
            this.fullName = _data["fullName"];
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.departmentName = _data["departmentName"];
        }
    }

    static fromJS(data: any): DepartmentUserEntity {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentUserEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["departmentId"] = this.departmentId;
        data["userId"] = this.userId;
        data["title"] = this.title;
        data["titleId"] = this.titleId;
        data["isPrimary"] = this.isPrimary;
        data["joinedAt"] = this.joinedAt ? this.joinedAt.toISOString() : undefined as any;
        data["leftAt"] = this.leftAt ? this.leftAt.toISOString() : undefined as any;
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["fullName"] = this.fullName;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["departmentName"] = this.departmentName;
        return data;
    }
}

export interface IDepartmentUserEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    departmentId?: number;
    userId?: number;
    title?: string | undefined;
    titleId?: number;
    isPrimary?: boolean;
    joinedAt?: Date;
    leftAt?: Date | undefined;
    roleIds?: number[] | undefined;
    roleNames?: string[] | undefined;
    fullName?: string | undefined;
    userName?: string | undefined;
    email?: string | undefined;
    departmentName?: string | undefined;
}

export class AssignExamEntity implements IAssignExamEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    title?: string | undefined;
    classId?: number;
    examId?: number;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    allowDeadline?: boolean;
    allowViewAnswer?: boolean;
    duration?: number;
    status?: AssignExamStatusEnum;
    type?: AssignExamTypeEnum;
    assignExamUsers?: AssignExamUserEntity[] | undefined;

    constructor(data?: IAssignExamEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.title = _data["title"];
            this.classId = _data["classId"];
            this.examId = _data["examId"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : undefined as any;
            this.allowDeadline = _data["allowDeadline"];
            this.allowViewAnswer = _data["allowViewAnswer"];
            this.duration = _data["duration"];
            this.status = _data["status"];
            this.type = _data["type"];
            if (Array.isArray(_data["assignExamUsers"])) {
                this.assignExamUsers = [] as any;
                for (let item of _data["assignExamUsers"])
                    this.assignExamUsers!.push(AssignExamUserEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssignExamEntity {
        data = typeof data === 'object' ? data : {};
        let result = new AssignExamEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["title"] = this.title;
        data["classId"] = this.classId;
        data["examId"] = this.examId;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : undefined as any;
        data["allowDeadline"] = this.allowDeadline;
        data["allowViewAnswer"] = this.allowViewAnswer;
        data["duration"] = this.duration;
        data["status"] = this.status;
        data["type"] = this.type;
        if (Array.isArray(this.assignExamUsers)) {
            data["assignExamUsers"] = [];
            for (let item of this.assignExamUsers)
                data["assignExamUsers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAssignExamEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    title?: string | undefined;
    classId?: number;
    examId?: number;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    allowDeadline?: boolean;
    allowViewAnswer?: boolean;
    duration?: number;
    status?: AssignExamStatusEnum;
    type?: AssignExamTypeEnum;
    assignExamUsers?: AssignExamUserEntity[] | undefined;
}

export class AssignExamUserEntity implements IAssignExamUserEntity {
    assignExamId?: number;
    userId?: number;
    status?: AssignExamUserStatusEnum;
    examResultId?: number;
    startDate?: Date | undefined;
    mark?: number;
    duration?: number;
    endDate?: Date | undefined;
    note?: string | undefined;

    constructor(data?: IAssignExamUserEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignExamId = _data["assignExamId"];
            this.userId = _data["userId"];
            this.status = _data["status"];
            this.examResultId = _data["examResultId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.mark = _data["mark"];
            this.duration = _data["duration"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): AssignExamUserEntity {
        data = typeof data === 'object' ? data : {};
        let result = new AssignExamUserEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignExamId"] = this.assignExamId;
        data["userId"] = this.userId;
        data["status"] = this.status;
        data["examResultId"] = this.examResultId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["mark"] = this.mark;
        data["duration"] = this.duration;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["note"] = this.note;
        return data;
    }
}

export interface IAssignExamUserEntity {
    assignExamId?: number;
    userId?: number;
    status?: AssignExamUserStatusEnum;
    examResultId?: number;
    startDate?: Date | undefined;
    mark?: number;
    duration?: number;
    endDate?: Date | undefined;
    note?: string | undefined;
}

export class ExamQuestionEntity implements IExamQuestionEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    examId?: number;
    questionId?: number;
    mark?: number;
    parentId?: number;

    constructor(data?: IExamQuestionEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.examId = _data["examId"];
            this.questionId = _data["questionId"];
            this.mark = _data["mark"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): ExamQuestionEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ExamQuestionEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["examId"] = this.examId;
        data["questionId"] = this.questionId;
        data["mark"] = this.mark;
        data["parentId"] = this.parentId;
        return data;
    }
}

export interface IExamQuestionEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    examId?: number;
    questionId?: number;
    mark?: number;
    parentId?: number;
}

export class UserExamResultEntity implements IUserExamResultEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    examId?: number;
    assignExamId?: number;
    userId?: number;
    mark?: number;
    duration?: number;
    correctAnswerCount?: number;
    correctQuestions?: string | undefined;
    fromType?: number;
    comment?: string | undefined;
    status?: UserExamResultStatus;
    userAnswer?: UserAnswerEntity[] | undefined;

    constructor(data?: IUserExamResultEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.examId = _data["examId"];
            this.assignExamId = _data["assignExamId"];
            this.userId = _data["userId"];
            this.mark = _data["mark"];
            this.duration = _data["duration"];
            this.correctAnswerCount = _data["correctAnswerCount"];
            this.correctQuestions = _data["correctQuestions"];
            this.fromType = _data["fromType"];
            this.comment = _data["comment"];
            this.status = _data["status"];
            if (Array.isArray(_data["userAnswer"])) {
                this.userAnswer = [] as any;
                for (let item of _data["userAnswer"])
                    this.userAnswer!.push(UserAnswerEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserExamResultEntity {
        data = typeof data === 'object' ? data : {};
        let result = new UserExamResultEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["examId"] = this.examId;
        data["assignExamId"] = this.assignExamId;
        data["userId"] = this.userId;
        data["mark"] = this.mark;
        data["duration"] = this.duration;
        data["correctAnswerCount"] = this.correctAnswerCount;
        data["correctQuestions"] = this.correctQuestions;
        data["fromType"] = this.fromType;
        data["comment"] = this.comment;
        data["status"] = this.status;
        if (Array.isArray(this.userAnswer)) {
            data["userAnswer"] = [];
            for (let item of this.userAnswer)
                data["userAnswer"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserExamResultEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    examId?: number;
    assignExamId?: number;
    userId?: number;
    mark?: number;
    duration?: number;
    correctAnswerCount?: number;
    correctQuestions?: string | undefined;
    fromType?: number;
    comment?: string | undefined;
    status?: UserExamResultStatus;
    userAnswer?: UserAnswerEntity[] | undefined;
}

export class FileEntity implements IFileEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    path?: string | undefined;
    contentType?: string | undefined;
    width?: number;
    height?: number;
    size?: number;
    extension?: string | undefined;
    folderId?: number;
    status?: number;
    avatar?: string | undefined;
    thumbnails?: string | undefined;
    streamUrl?: string | undefined;
    duration?: number;
    fileType?: string | undefined;
    objectType?: number;
    parentId?: number | undefined;
    metaDatas?: FileMetaDataEntity[] | undefined;

    constructor(data?: IFileEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.path = _data["path"];
            this.contentType = _data["contentType"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.size = _data["size"];
            this.extension = _data["extension"];
            this.folderId = _data["folderId"];
            this.status = _data["status"];
            this.avatar = _data["avatar"];
            this.thumbnails = _data["thumbnails"];
            this.streamUrl = _data["streamUrl"];
            this.duration = _data["duration"];
            this.fileType = _data["fileType"];
            this.objectType = _data["objectType"];
            this.parentId = _data["parentId"];
            if (Array.isArray(_data["metaDatas"])) {
                this.metaDatas = [] as any;
                for (let item of _data["metaDatas"])
                    this.metaDatas!.push(FileMetaDataEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FileEntity {
        data = typeof data === 'object' ? data : {};
        let result = new FileEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["path"] = this.path;
        data["contentType"] = this.contentType;
        data["width"] = this.width;
        data["height"] = this.height;
        data["size"] = this.size;
        data["extension"] = this.extension;
        data["folderId"] = this.folderId;
        data["status"] = this.status;
        data["avatar"] = this.avatar;
        data["thumbnails"] = this.thumbnails;
        data["streamUrl"] = this.streamUrl;
        data["duration"] = this.duration;
        data["fileType"] = this.fileType;
        data["objectType"] = this.objectType;
        data["parentId"] = this.parentId;
        if (Array.isArray(this.metaDatas)) {
            data["metaDatas"] = [];
            for (let item of this.metaDatas)
                data["metaDatas"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFileEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    path?: string | undefined;
    contentType?: string | undefined;
    width?: number;
    height?: number;
    size?: number;
    extension?: string | undefined;
    folderId?: number;
    status?: number;
    avatar?: string | undefined;
    thumbnails?: string | undefined;
    streamUrl?: string | undefined;
    duration?: number;
    fileType?: string | undefined;
    objectType?: number;
    parentId?: number | undefined;
    metaDatas?: FileMetaDataEntity[] | undefined;
}

export class FileMetaDataEntity implements IFileMetaDataEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    fileId?: number;
    metaDirectory?: string | undefined;
    metaKey?: string | undefined;
    metaValue?: string | undefined;

    constructor(data?: IFileMetaDataEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.fileId = _data["fileId"];
            this.metaDirectory = _data["metaDirectory"];
            this.metaKey = _data["metaKey"];
            this.metaValue = _data["metaValue"];
        }
    }

    static fromJS(data: any): FileMetaDataEntity {
        data = typeof data === 'object' ? data : {};
        let result = new FileMetaDataEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["fileId"] = this.fileId;
        data["metaDirectory"] = this.metaDirectory;
        data["metaKey"] = this.metaKey;
        data["metaValue"] = this.metaValue;
        return data;
    }
}

export interface IFileMetaDataEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    fileId?: number;
    metaDirectory?: string | undefined;
    metaKey?: string | undefined;
    metaValue?: string | undefined;
}

export class FolderEntity implements IFolderEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    parentId?: number;

    constructor(data?: IFolderEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): FolderEntity {
        data = typeof data === 'object' ? data : {};
        let result = new FolderEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        return data;
    }
}

export interface IFolderEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    parentId?: number;
}

export class GalleryEntity implements IGalleryEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    description?: string | undefined;
    media?: string | undefined;
    categoryId?: number | undefined;
    status?: CommonStatusEnum;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaKeywords?: string | undefined;
    slug?: string | undefined;

    constructor(data?: IGalleryEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.media = _data["media"];
            this.categoryId = _data["categoryId"];
            this.status = _data["status"];
            this.metaTitle = _data["metaTitle"];
            this.metaDescription = _data["metaDescription"];
            this.metaKeywords = _data["metaKeywords"];
            this.slug = _data["slug"];
        }
    }

    static fromJS(data: any): GalleryEntity {
        data = typeof data === 'object' ? data : {};
        let result = new GalleryEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["description"] = this.description;
        data["media"] = this.media;
        data["categoryId"] = this.categoryId;
        data["status"] = this.status;
        data["metaTitle"] = this.metaTitle;
        data["metaDescription"] = this.metaDescription;
        data["metaKeywords"] = this.metaKeywords;
        data["slug"] = this.slug;
        return data;
    }
}

export interface IGalleryEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    description?: string | undefined;
    media?: string | undefined;
    categoryId?: number | undefined;
    status?: CommonStatusEnum;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaKeywords?: string | undefined;
    slug?: string | undefined;
}

export class LoginHistoryEntity implements ILoginHistoryEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    userId?: number | undefined;
    user?: UserEntity;
    userDeviceId?: number | undefined;
    userDevice?: UserDeviceEntity;
    ip?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    loginTime?: Date;
    loginResult?: LoginResultEnum;
    userAgent?: string | undefined;

    constructor(data?: ILoginHistoryEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? UserEntity.fromJS(_data["user"]) : undefined as any;
            this.userDeviceId = _data["userDeviceId"];
            this.userDevice = _data["userDevice"] ? UserDeviceEntity.fromJS(_data["userDevice"]) : undefined as any;
            this.ip = _data["ip"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.loginTime = _data["loginTime"] ? new Date(_data["loginTime"].toString()) : undefined as any;
            this.loginResult = _data["loginResult"];
            this.userAgent = _data["userAgent"];
        }
    }

    static fromJS(data: any): LoginHistoryEntity {
        data = typeof data === 'object' ? data : {};
        let result = new LoginHistoryEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["userDeviceId"] = this.userDeviceId;
        data["userDevice"] = this.userDevice ? this.userDevice.toJSON() : undefined as any;
        data["ip"] = this.ip;
        data["city"] = this.city;
        data["country"] = this.country;
        data["loginTime"] = this.loginTime ? this.loginTime.toISOString() : undefined as any;
        data["loginResult"] = this.loginResult;
        data["userAgent"] = this.userAgent;
        return data;
    }
}

export interface ILoginHistoryEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    userId?: number | undefined;
    user?: UserEntity;
    userDeviceId?: number | undefined;
    userDevice?: UserDeviceEntity;
    ip?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    loginTime?: Date;
    loginResult?: LoginResultEnum;
    userAgent?: string | undefined;
}

export class OwnershipTransferEntity implements IOwnershipTransferEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    fromUserId?: number;
    toUserId?: number;
    status?: OwnershipTransferStatusEnum;
    requestedAt?: Date;
    respondedAt?: Date | undefined;

    constructor(data?: IOwnershipTransferEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.objectType = _data["objectType"];
            this.objectId = _data["objectId"];
            this.fromUserId = _data["fromUserId"];
            this.toUserId = _data["toUserId"];
            this.status = _data["status"];
            this.requestedAt = _data["requestedAt"] ? new Date(_data["requestedAt"].toString()) : undefined as any;
            this.respondedAt = _data["respondedAt"] ? new Date(_data["respondedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): OwnershipTransferEntity {
        data = typeof data === 'object' ? data : {};
        let result = new OwnershipTransferEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["objectType"] = this.objectType;
        data["objectId"] = this.objectId;
        data["fromUserId"] = this.fromUserId;
        data["toUserId"] = this.toUserId;
        data["status"] = this.status;
        data["requestedAt"] = this.requestedAt ? this.requestedAt.toISOString() : undefined as any;
        data["respondedAt"] = this.respondedAt ? this.respondedAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IOwnershipTransferEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    fromUserId?: number;
    toUserId?: number;
    status?: OwnershipTransferStatusEnum;
    requestedAt?: Date;
    respondedAt?: Date | undefined;
}

export class RefreshTokenEntity implements IRefreshTokenEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    tokenHash!: string;
    userId?: number;
    user?: UserEntity;
    userDeviceId?: number | undefined;
    userDevice?: UserDeviceEntity;
    expires?: Date;
    lastActivity?: Date | undefined;
    revoked?: Date | undefined;
    revokedReason?: RefreshTokenRevokedReasonEnum;
    readonly isExpired?: boolean;
    readonly isActive?: boolean;

    constructor(data?: IRefreshTokenEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.tokenHash = _data["tokenHash"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? UserEntity.fromJS(_data["user"]) : undefined as any;
            this.userDeviceId = _data["userDeviceId"];
            this.userDevice = _data["userDevice"] ? UserDeviceEntity.fromJS(_data["userDevice"]) : undefined as any;
            this.expires = _data["expires"] ? new Date(_data["expires"].toString()) : undefined as any;
            this.lastActivity = _data["lastActivity"] ? new Date(_data["lastActivity"].toString()) : undefined as any;
            this.revoked = _data["revoked"] ? new Date(_data["revoked"].toString()) : undefined as any;
            this.revokedReason = _data["revokedReason"];
            (this as any).isExpired = _data["isExpired"];
            (this as any).isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): RefreshTokenEntity {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["tokenHash"] = this.tokenHash;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["userDeviceId"] = this.userDeviceId;
        data["userDevice"] = this.userDevice ? this.userDevice.toJSON() : undefined as any;
        data["expires"] = this.expires ? this.expires.toISOString() : undefined as any;
        data["lastActivity"] = this.lastActivity ? this.lastActivity.toISOString() : undefined as any;
        data["revoked"] = this.revoked ? this.revoked.toISOString() : undefined as any;
        data["revokedReason"] = this.revokedReason;
        data["isExpired"] = this.isExpired;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IRefreshTokenEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    tokenHash: string;
    userId?: number;
    user?: UserEntity;
    userDeviceId?: number | undefined;
    userDevice?: UserDeviceEntity;
    expires?: Date;
    lastActivity?: Date | undefined;
    revoked?: Date | undefined;
    revokedReason?: RefreshTokenRevokedReasonEnum;
    isExpired?: boolean;
    isActive?: boolean;
}

export class UserClaimEntity implements IUserClaimEntity {
    id?: number;
    userId?: number;
    claimType?: string | undefined;
    claimValue?: string | undefined;

    constructor(data?: IUserClaimEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.claimType = _data["claimType"];
            this.claimValue = _data["claimValue"];
        }
    }

    static fromJS(data: any): UserClaimEntity {
        data = typeof data === 'object' ? data : {};
        let result = new UserClaimEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        return data;
    }
}

export interface IUserClaimEntity {
    id?: number;
    userId?: number;
    claimType?: string | undefined;
    claimValue?: string | undefined;
}

export class UserDeviceEntity implements IUserDeviceEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    userId?: number;
    user?: UserEntity;
    deviceIdentifier!: string;
    deviceType?: DeviceTypeEnum;
    brand?: string | undefined;
    model?: string | undefined;
    os?: string | undefined;
    browser?: string | undefined;
    firstSeen?: Date;
    lastSeen?: Date;
    trusted?: boolean;
    isActive?: boolean;
    refreshTokens?: RefreshTokenEntity[] | undefined;
    loginHistories?: LoginHistoryEntity[] | undefined;

    constructor(data?: IUserDeviceEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? UserEntity.fromJS(_data["user"]) : undefined as any;
            this.deviceIdentifier = _data["deviceIdentifier"];
            this.deviceType = _data["deviceType"];
            this.brand = _data["brand"];
            this.model = _data["model"];
            this.os = _data["os"];
            this.browser = _data["browser"];
            this.firstSeen = _data["firstSeen"] ? new Date(_data["firstSeen"].toString()) : undefined as any;
            this.lastSeen = _data["lastSeen"] ? new Date(_data["lastSeen"].toString()) : undefined as any;
            this.trusted = _data["trusted"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["refreshTokens"])) {
                this.refreshTokens = [] as any;
                for (let item of _data["refreshTokens"])
                    this.refreshTokens!.push(RefreshTokenEntity.fromJS(item));
            }
            if (Array.isArray(_data["loginHistories"])) {
                this.loginHistories = [] as any;
                for (let item of _data["loginHistories"])
                    this.loginHistories!.push(LoginHistoryEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserDeviceEntity {
        data = typeof data === 'object' ? data : {};
        let result = new UserDeviceEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["deviceIdentifier"] = this.deviceIdentifier;
        data["deviceType"] = this.deviceType;
        data["brand"] = this.brand;
        data["model"] = this.model;
        data["os"] = this.os;
        data["browser"] = this.browser;
        data["firstSeen"] = this.firstSeen ? this.firstSeen.toISOString() : undefined as any;
        data["lastSeen"] = this.lastSeen ? this.lastSeen.toISOString() : undefined as any;
        data["trusted"] = this.trusted;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.refreshTokens)) {
            data["refreshTokens"] = [];
            for (let item of this.refreshTokens)
                data["refreshTokens"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.loginHistories)) {
            data["loginHistories"] = [];
            for (let item of this.loginHistories)
                data["loginHistories"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserDeviceEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    userId?: number;
    user?: UserEntity;
    deviceIdentifier: string;
    deviceType?: DeviceTypeEnum;
    brand?: string | undefined;
    model?: string | undefined;
    os?: string | undefined;
    browser?: string | undefined;
    firstSeen?: Date;
    lastSeen?: Date;
    trusted?: boolean;
    isActive?: boolean;
    refreshTokens?: RefreshTokenEntity[] | undefined;
    loginHistories?: LoginHistoryEntity[] | undefined;
}

export class UserEntity implements IUserEntity {
    id?: number;
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    email?: string | undefined;
    normalizedEmail?: string | undefined;
    emailConfirmed?: boolean;
    passwordHash?: string | undefined;
    securityStamp?: string | undefined;
    concurrencyStamp?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: Date | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;
    claims?: UserClaimEntity[] | undefined;
    refreshTokens?: RefreshTokenEntity[] | undefined;
    devices?: UserDeviceEntity[] | undefined;
    loginHistories?: LoginHistoryEntity[] | undefined;
    avatar?: string | undefined;
    fullName?: string | undefined;
    fullNameNonAccent?: string | undefined;
    lastLoginDate?: Date | undefined;
    createdDate?: Date;
    isDeleted?: boolean;
    isSystem?: boolean;
    type?: UserTypeEnum;
    objectId?: number;
    provinceId?: number;
    isOnline?: boolean;
    studentCode?: string | undefined;
    birthDay?: Date | undefined;
    gender?: number | undefined;
    identifierCode?: string | undefined;
    address?: string | undefined;
    ethnic?: string | undefined;
    isKid?: boolean;
    hasLocalPassword?: boolean;
    languageCode?: string | undefined;

    constructor(data?: IUserEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.email = _data["email"];
            this.normalizedEmail = _data["normalizedEmail"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.passwordHash = _data["passwordHash"];
            this.securityStamp = _data["securityStamp"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"];
            this.twoFactorEnabled = _data["twoFactorEnabled"];
            this.lockoutEnd = _data["lockoutEnd"] ? new Date(_data["lockoutEnd"].toString()) : undefined as any;
            this.lockoutEnabled = _data["lockoutEnabled"];
            this.accessFailedCount = _data["accessFailedCount"];
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims!.push(UserClaimEntity.fromJS(item));
            }
            if (Array.isArray(_data["refreshTokens"])) {
                this.refreshTokens = [] as any;
                for (let item of _data["refreshTokens"])
                    this.refreshTokens!.push(RefreshTokenEntity.fromJS(item));
            }
            if (Array.isArray(_data["devices"])) {
                this.devices = [] as any;
                for (let item of _data["devices"])
                    this.devices!.push(UserDeviceEntity.fromJS(item));
            }
            if (Array.isArray(_data["loginHistories"])) {
                this.loginHistories = [] as any;
                for (let item of _data["loginHistories"])
                    this.loginHistories!.push(LoginHistoryEntity.fromJS(item));
            }
            this.avatar = _data["avatar"];
            this.fullName = _data["fullName"];
            this.fullNameNonAccent = _data["fullNameNonAccent"];
            this.lastLoginDate = _data["lastLoginDate"] ? new Date(_data["lastLoginDate"].toString()) : undefined as any;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.isSystem = _data["isSystem"];
            this.type = _data["type"];
            this.objectId = _data["objectId"];
            this.provinceId = _data["provinceId"];
            this.isOnline = _data["isOnline"];
            this.studentCode = _data["studentCode"];
            this.birthDay = _data["birthDay"] ? new Date(_data["birthDay"].toString()) : undefined as any;
            this.gender = _data["gender"];
            this.identifierCode = _data["identifierCode"];
            this.address = _data["address"];
            this.ethnic = _data["ethnic"];
            this.isKid = _data["isKid"];
            this.hasLocalPassword = _data["hasLocalPassword"];
            this.languageCode = _data["languageCode"];
        }
    }

    static fromJS(data: any): UserEntity {
        data = typeof data === 'object' ? data : {};
        let result = new UserEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["normalizedUserName"] = this.normalizedUserName;
        data["email"] = this.email;
        data["normalizedEmail"] = this.normalizedEmail;
        data["emailConfirmed"] = this.emailConfirmed;
        data["passwordHash"] = this.passwordHash;
        data["securityStamp"] = this.securityStamp;
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
        data["twoFactorEnabled"] = this.twoFactorEnabled;
        data["lockoutEnd"] = this.lockoutEnd ? this.lockoutEnd.toISOString() : undefined as any;
        data["lockoutEnabled"] = this.lockoutEnabled;
        data["accessFailedCount"] = this.accessFailedCount;
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.refreshTokens)) {
            data["refreshTokens"] = [];
            for (let item of this.refreshTokens)
                data["refreshTokens"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.devices)) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.loginHistories)) {
            data["loginHistories"] = [];
            for (let item of this.loginHistories)
                data["loginHistories"].push(item ? item.toJSON() : undefined as any);
        }
        data["avatar"] = this.avatar;
        data["fullName"] = this.fullName;
        data["fullNameNonAccent"] = this.fullNameNonAccent;
        data["lastLoginDate"] = this.lastLoginDate ? this.lastLoginDate.toISOString() : undefined as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["isSystem"] = this.isSystem;
        data["type"] = this.type;
        data["objectId"] = this.objectId;
        data["provinceId"] = this.provinceId;
        data["isOnline"] = this.isOnline;
        data["studentCode"] = this.studentCode;
        data["birthDay"] = this.birthDay ? this.birthDay.toISOString() : undefined as any;
        data["gender"] = this.gender;
        data["identifierCode"] = this.identifierCode;
        data["address"] = this.address;
        data["ethnic"] = this.ethnic;
        data["isKid"] = this.isKid;
        data["hasLocalPassword"] = this.hasLocalPassword;
        data["languageCode"] = this.languageCode;
        return data;
    }
}

export interface IUserEntity {
    id?: number;
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    email?: string | undefined;
    normalizedEmail?: string | undefined;
    emailConfirmed?: boolean;
    passwordHash?: string | undefined;
    securityStamp?: string | undefined;
    concurrencyStamp?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: Date | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;
    claims?: UserClaimEntity[] | undefined;
    refreshTokens?: RefreshTokenEntity[] | undefined;
    devices?: UserDeviceEntity[] | undefined;
    loginHistories?: LoginHistoryEntity[] | undefined;
    avatar?: string | undefined;
    fullName?: string | undefined;
    fullNameNonAccent?: string | undefined;
    lastLoginDate?: Date | undefined;
    createdDate?: Date;
    isDeleted?: boolean;
    isSystem?: boolean;
    type?: UserTypeEnum;
    objectId?: number;
    provinceId?: number;
    isOnline?: boolean;
    studentCode?: string | undefined;
    birthDay?: Date | undefined;
    gender?: number | undefined;
    identifierCode?: string | undefined;
    address?: string | undefined;
    ethnic?: string | undefined;
    isKid?: boolean;
    hasLocalPassword?: boolean;
    languageCode?: string | undefined;
}

export class LocalityEntity implements ILocalityEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    code?: string | undefined;
    name?: string | undefined;
    nameViVN?: string | undefined;
    nameEnUS?: string | undefined;
    nameZhCN?: string | undefined;
    fullName?: string | undefined;
    otherName?: string | undefined;
    url?: string | undefined;
    unitType?: string | undefined;
    parentId?: number;
    priority?: number;
    type?: LocalityTypeEnum;
    status?: LocalityStatusEnum;
    parentName?: string | undefined;

    constructor(data?: ILocalityEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.nameViVN = _data["nameViVN"];
            this.nameEnUS = _data["nameEnUS"];
            this.nameZhCN = _data["nameZhCN"];
            this.fullName = _data["fullName"];
            this.otherName = _data["otherName"];
            this.url = _data["url"];
            this.unitType = _data["unitType"];
            this.parentId = _data["parentId"];
            this.priority = _data["priority"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.parentName = _data["parentName"];
        }
    }

    static fromJS(data: any): LocalityEntity {
        data = typeof data === 'object' ? data : {};
        let result = new LocalityEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["code"] = this.code;
        data["name"] = this.name;
        data["nameViVN"] = this.nameViVN;
        data["nameEnUS"] = this.nameEnUS;
        data["nameZhCN"] = this.nameZhCN;
        data["fullName"] = this.fullName;
        data["otherName"] = this.otherName;
        data["url"] = this.url;
        data["unitType"] = this.unitType;
        data["parentId"] = this.parentId;
        data["priority"] = this.priority;
        data["type"] = this.type;
        data["status"] = this.status;
        data["parentName"] = this.parentName;
        return data;
    }
}

export interface ILocalityEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    code?: string | undefined;
    name?: string | undefined;
    nameViVN?: string | undefined;
    nameEnUS?: string | undefined;
    nameZhCN?: string | undefined;
    fullName?: string | undefined;
    otherName?: string | undefined;
    url?: string | undefined;
    unitType?: string | undefined;
    parentId?: number;
    priority?: number;
    type?: LocalityTypeEnum;
    status?: LocalityStatusEnum;
    parentName?: string | undefined;
}

export enum LocalityTypeEnum {
    Country = 1,
    Province = 2,
    Ward = 3,
}

export class NewsEntity implements INewsEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    title?: string | undefined;
    summary?: string | undefined;
    content?: string | undefined;
    image?: string | undefined;
    author?: string | undefined;
    publishedDate?: Date | undefined;
    viewCount?: number;
    status?: CommonStatusEnum;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaKeywords?: string | undefined;
    slug?: string | undefined;
    categoryId?: number | undefined;
    isFeatured?: boolean;
    relatedNewsIds?: string | undefined;

    constructor(data?: INewsEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.title = _data["title"];
            this.summary = _data["summary"];
            this.content = _data["content"];
            this.image = _data["image"];
            this.author = _data["author"];
            this.publishedDate = _data["publishedDate"] ? new Date(_data["publishedDate"].toString()) : undefined as any;
            this.viewCount = _data["viewCount"];
            this.status = _data["status"];
            this.metaTitle = _data["metaTitle"];
            this.metaDescription = _data["metaDescription"];
            this.metaKeywords = _data["metaKeywords"];
            this.slug = _data["slug"];
            this.categoryId = _data["categoryId"];
            this.isFeatured = _data["isFeatured"];
            this.relatedNewsIds = _data["relatedNewsIds"];
        }
    }

    static fromJS(data: any): NewsEntity {
        data = typeof data === 'object' ? data : {};
        let result = new NewsEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["title"] = this.title;
        data["summary"] = this.summary;
        data["content"] = this.content;
        data["image"] = this.image;
        data["author"] = this.author;
        data["publishedDate"] = this.publishedDate ? this.publishedDate.toISOString() : undefined as any;
        data["viewCount"] = this.viewCount;
        data["status"] = this.status;
        data["metaTitle"] = this.metaTitle;
        data["metaDescription"] = this.metaDescription;
        data["metaKeywords"] = this.metaKeywords;
        data["slug"] = this.slug;
        data["categoryId"] = this.categoryId;
        data["isFeatured"] = this.isFeatured;
        data["relatedNewsIds"] = this.relatedNewsIds;
        return data;
    }
}

export interface INewsEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    title?: string | undefined;
    summary?: string | undefined;
    content?: string | undefined;
    image?: string | undefined;
    author?: string | undefined;
    publishedDate?: Date | undefined;
    viewCount?: number;
    status?: CommonStatusEnum;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaKeywords?: string | undefined;
    slug?: string | undefined;
    categoryId?: number | undefined;
    isFeatured?: boolean;
    relatedNewsIds?: string | undefined;
}

export class UserMobileTokenEntity implements IUserMobileTokenEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    userId?: number;
    deviceToken?: string | undefined;
    os?: string | undefined;
    appId?: number;

    constructor(data?: IUserMobileTokenEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.userId = _data["userId"];
            this.deviceToken = _data["deviceToken"];
            this.os = _data["os"];
            this.appId = _data["appId"];
        }
    }

    static fromJS(data: any): UserMobileTokenEntity {
        data = typeof data === 'object' ? data : {};
        let result = new UserMobileTokenEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["userId"] = this.userId;
        data["deviceToken"] = this.deviceToken;
        data["os"] = this.os;
        data["appId"] = this.appId;
        return data;
    }
}

export interface IUserMobileTokenEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    userId?: number;
    deviceToken?: string | undefined;
    os?: string | undefined;
    appId?: number;
}

export class UserWebTokenEntity implements IUserWebTokenEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    userId?: number;
    pushEndPoint?: string | undefined;
    pushP256DH?: string | undefined;
    pushAuth?: string | undefined;
    appId?: number;

    constructor(data?: IUserWebTokenEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.userId = _data["userId"];
            this.pushEndPoint = _data["pushEndPoint"];
            this.pushP256DH = _data["pushP256DH"];
            this.pushAuth = _data["pushAuth"];
            this.appId = _data["appId"];
        }
    }

    static fromJS(data: any): UserWebTokenEntity {
        data = typeof data === 'object' ? data : {};
        let result = new UserWebTokenEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["userId"] = this.userId;
        data["pushEndPoint"] = this.pushEndPoint;
        data["pushP256DH"] = this.pushP256DH;
        data["pushAuth"] = this.pushAuth;
        data["appId"] = this.appId;
        return data;
    }
}

export interface IUserWebTokenEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    userId?: number;
    pushEndPoint?: string | undefined;
    pushP256DH?: string | undefined;
    pushAuth?: string | undefined;
    appId?: number;
}

export class CartEntity implements ICartEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    userId?: number;
    notes?: string | undefined;
    items?: CartItemEntity[] | undefined;

    constructor(data?: ICartEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.userId = _data["userId"];
            this.notes = _data["notes"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CartItemEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CartEntity {
        data = typeof data === 'object' ? data : {};
        let result = new CartEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["userId"] = this.userId;
        data["notes"] = this.notes;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICartEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    userId?: number;
    notes?: string | undefined;
    items?: CartItemEntity[] | undefined;
}

export class CartItemEntity implements ICartItemEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    cartId?: number;
    productId?: number;
    quantity?: number;
    cart?: CartEntity;
    product?: ProductEntity;

    constructor(data?: ICartItemEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.cartId = _data["cartId"];
            this.productId = _data["productId"];
            this.quantity = _data["quantity"];
            this.cart = _data["cart"] ? CartEntity.fromJS(_data["cart"]) : undefined as any;
            this.product = _data["product"] ? ProductEntity.fromJS(_data["product"]) : undefined as any;
        }
    }

    static fromJS(data: any): CartItemEntity {
        data = typeof data === 'object' ? data : {};
        let result = new CartItemEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["cartId"] = this.cartId;
        data["productId"] = this.productId;
        data["quantity"] = this.quantity;
        data["cart"] = this.cart ? this.cart.toJSON() : undefined as any;
        data["product"] = this.product ? this.product.toJSON() : undefined as any;
        return data;
    }
}

export interface ICartItemEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    cartId?: number;
    productId?: number;
    quantity?: number;
    cart?: CartEntity;
    product?: ProductEntity;
}

export class OrderEntity implements IOrderEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    userId?: number;
    fullName?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    notes?: string | undefined;
    totalAmount?: number;
    paidDate?: Date | undefined;
    paymentLog?: string | undefined;
    status?: OrderStatusEnum;
    purchaseTarget?: OrderPurchaseTargetEnum;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    items?: OrderItemEntity[] | undefined;

    constructor(data?: IOrderEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.userId = _data["userId"];
            this.fullName = _data["fullName"];
            this.phone = _data["phone"];
            this.address = _data["address"];
            this.notes = _data["notes"];
            this.totalAmount = _data["totalAmount"];
            this.paidDate = _data["paidDate"] ? new Date(_data["paidDate"].toString()) : undefined as any;
            this.paymentLog = _data["paymentLog"];
            this.status = _data["status"];
            this.purchaseTarget = _data["purchaseTarget"];
            this.objectType = _data["objectType"];
            this.objectId = _data["objectId"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrderItemEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderEntity {
        data = typeof data === 'object' ? data : {};
        let result = new OrderEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["userId"] = this.userId;
        data["fullName"] = this.fullName;
        data["phone"] = this.phone;
        data["address"] = this.address;
        data["notes"] = this.notes;
        data["totalAmount"] = this.totalAmount;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : undefined as any;
        data["paymentLog"] = this.paymentLog;
        data["status"] = this.status;
        data["purchaseTarget"] = this.purchaseTarget;
        data["objectType"] = this.objectType;
        data["objectId"] = this.objectId;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOrderEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    userId?: number;
    fullName?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    notes?: string | undefined;
    totalAmount?: number;
    paidDate?: Date | undefined;
    paymentLog?: string | undefined;
    status?: OrderStatusEnum;
    purchaseTarget?: OrderPurchaseTargetEnum;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    items?: OrderItemEntity[] | undefined;
}

export class OrderItemEntity implements IOrderItemEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    orderId?: number;
    productId?: number;
    quantity?: number;
    unitPrice?: number;
    salePrice?: number | undefined;
    totalPrice?: number;
    order?: OrderEntity;
    product?: ProductEntity;

    constructor(data?: IOrderItemEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.orderId = _data["orderId"];
            this.productId = _data["productId"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.salePrice = _data["salePrice"];
            this.totalPrice = _data["totalPrice"];
            this.order = _data["order"] ? OrderEntity.fromJS(_data["order"]) : undefined as any;
            this.product = _data["product"] ? ProductEntity.fromJS(_data["product"]) : undefined as any;
        }
    }

    static fromJS(data: any): OrderItemEntity {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItemEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["orderId"] = this.orderId;
        data["productId"] = this.productId;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["salePrice"] = this.salePrice;
        data["totalPrice"] = this.totalPrice;
        data["order"] = this.order ? this.order.toJSON() : undefined as any;
        data["product"] = this.product ? this.product.toJSON() : undefined as any;
        return data;
    }
}

export interface IOrderItemEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    orderId?: number;
    productId?: number;
    quantity?: number;
    unitPrice?: number;
    salePrice?: number | undefined;
    totalPrice?: number;
    order?: OrderEntity;
    product?: ProductEntity;
}

export enum OrderStatusEnum {
    Pending = 0,
    Confirmed = 1,
    Processing = 2,
    Shipped = 3,
    Completed = 4,
    Cancelled = 5,
    Failure = 6,
}

export class OrganizationEntity implements IOrganizationEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    code?: string | undefined;
    name?: string | undefined;
    status?: OrganizationStatusEnum;
    countryId?: number;
    districtId?: number;
    provinceId?: number;
    wardId?: number;
    address?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    logo?: string | undefined;
    url?: string | undefined;
    description?: string | undefined;
    type?: string | undefined;
    isTemp?: boolean;
    templateOrganizationId?: number;
    ownerUserId?: number;
    languageCode?: string | undefined;
    maxStudentCount?: number;
    maxStaffCount?: number;

    constructor(data?: IOrganizationEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.countryId = _data["countryId"];
            this.districtId = _data["districtId"];
            this.provinceId = _data["provinceId"];
            this.wardId = _data["wardId"];
            this.address = _data["address"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.logo = _data["logo"];
            this.url = _data["url"];
            this.description = _data["description"];
            this.type = _data["type"];
            this.isTemp = _data["isTemp"];
            this.templateOrganizationId = _data["templateOrganizationId"];
            this.ownerUserId = _data["ownerUserId"];
            this.languageCode = _data["languageCode"];
            this.maxStudentCount = _data["maxStudentCount"];
            this.maxStaffCount = _data["maxStaffCount"];
        }
    }

    static fromJS(data: any): OrganizationEntity {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["code"] = this.code;
        data["name"] = this.name;
        data["status"] = this.status;
        data["countryId"] = this.countryId;
        data["districtId"] = this.districtId;
        data["provinceId"] = this.provinceId;
        data["wardId"] = this.wardId;
        data["address"] = this.address;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["logo"] = this.logo;
        data["url"] = this.url;
        data["description"] = this.description;
        data["type"] = this.type;
        data["isTemp"] = this.isTemp;
        data["templateOrganizationId"] = this.templateOrganizationId;
        data["ownerUserId"] = this.ownerUserId;
        data["languageCode"] = this.languageCode;
        data["maxStudentCount"] = this.maxStudentCount;
        data["maxStaffCount"] = this.maxStaffCount;
        return data;
    }
}

export interface IOrganizationEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    code?: string | undefined;
    name?: string | undefined;
    status?: OrganizationStatusEnum;
    countryId?: number;
    districtId?: number;
    provinceId?: number;
    wardId?: number;
    address?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    logo?: string | undefined;
    url?: string | undefined;
    description?: string | undefined;
    type?: string | undefined;
    isTemp?: boolean;
    templateOrganizationId?: number;
    ownerUserId?: number;
    languageCode?: string | undefined;
    maxStudentCount?: number;
    maxStaffCount?: number;
}

export enum EnrollmentStatusEnum {
    Active = 1,
    Waiting = 2,
    Completed = 3,
    Expired = 4,
    Refunded = 5,
}

export enum LessonQuizTypeEnum {
    None = 0,
    Exam = 1,
    QuestionList = 2,
}

export enum LessonTypeEnum {
    Video = 1,
    File = 2,
    Editor = 3,
    Zoom = 4,
    Exam = 5,
}

export class ProductChapterEntity implements IProductChapterEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    productId?: number;
    name?: string | undefined;
    description?: string | undefined;
    sortOrder?: number;
    productLessons?: ProductLessonEntity[] | undefined;

    constructor(data?: IProductChapterEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.productId = _data["productId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.sortOrder = _data["sortOrder"];
            if (Array.isArray(_data["productLessons"])) {
                this.productLessons = [] as any;
                for (let item of _data["productLessons"])
                    this.productLessons!.push(ProductLessonEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductChapterEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ProductChapterEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["productId"] = this.productId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["sortOrder"] = this.sortOrder;
        if (Array.isArray(this.productLessons)) {
            data["productLessons"] = [];
            for (let item of this.productLessons)
                data["productLessons"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProductChapterEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    productId?: number;
    name?: string | undefined;
    description?: string | undefined;
    sortOrder?: number;
    productLessons?: ProductLessonEntity[] | undefined;
}

export class ProductEntity implements IProductEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    summary?: string | undefined;
    description?: string | undefined;
    image?: string | undefined;
    categoryId?: number | undefined;
    productType?: ProductTypeEnum;
    status?: CommonStatusEnum;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaKeywords?: string | undefined;
    slug?: string | undefined;
    price?: number | undefined;
    salePrice?: number | undefined;
    orgPrice?: number | undefined;
    orgSalePrice?: number | undefined;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    lessonZoomCount?: number;
    productChapters?: ProductChapterEntity[] | undefined;

    constructor(data?: IProductEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.summary = _data["summary"];
            this.description = _data["description"];
            this.image = _data["image"];
            this.categoryId = _data["categoryId"];
            this.productType = _data["productType"];
            this.status = _data["status"];
            this.metaTitle = _data["metaTitle"];
            this.metaDescription = _data["metaDescription"];
            this.metaKeywords = _data["metaKeywords"];
            this.slug = _data["slug"];
            this.price = _data["price"];
            this.salePrice = _data["salePrice"];
            this.orgPrice = _data["orgPrice"];
            this.orgSalePrice = _data["orgSalePrice"];
            this.objectType = _data["objectType"];
            this.objectId = _data["objectId"];
            this.lessonZoomCount = _data["lessonZoomCount"];
            if (Array.isArray(_data["productChapters"])) {
                this.productChapters = [] as any;
                for (let item of _data["productChapters"])
                    this.productChapters!.push(ProductChapterEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ProductEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["summary"] = this.summary;
        data["description"] = this.description;
        data["image"] = this.image;
        data["categoryId"] = this.categoryId;
        data["productType"] = this.productType;
        data["status"] = this.status;
        data["metaTitle"] = this.metaTitle;
        data["metaDescription"] = this.metaDescription;
        data["metaKeywords"] = this.metaKeywords;
        data["slug"] = this.slug;
        data["price"] = this.price;
        data["salePrice"] = this.salePrice;
        data["orgPrice"] = this.orgPrice;
        data["orgSalePrice"] = this.orgSalePrice;
        data["objectType"] = this.objectType;
        data["objectId"] = this.objectId;
        data["lessonZoomCount"] = this.lessonZoomCount;
        if (Array.isArray(this.productChapters)) {
            data["productChapters"] = [];
            for (let item of this.productChapters)
                data["productChapters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProductEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    summary?: string | undefined;
    description?: string | undefined;
    image?: string | undefined;
    categoryId?: number | undefined;
    productType?: ProductTypeEnum;
    status?: CommonStatusEnum;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaKeywords?: string | undefined;
    slug?: string | undefined;
    price?: number | undefined;
    salePrice?: number | undefined;
    orgPrice?: number | undefined;
    orgSalePrice?: number | undefined;
    objectType?: ObjectOwnerTypeEnum;
    objectId?: number;
    lessonZoomCount?: number;
    productChapters?: ProductChapterEntity[] | undefined;
}

export class ProductLessonEntity implements IProductLessonEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    chapterId?: number;
    name?: string | undefined;
    description?: string | undefined;
    lessonType?: LessonTypeEnum;
    content?: string | undefined;
    notesHtml?: string | undefined;
    attachmentPaths?: string | undefined;
    sortOrder?: number;
    isFree?: boolean;
    allowExerciseBeforeComplete?: boolean;
    duration?: number;
    quizType?: LessonQuizTypeEnum;
    quizId?: number | undefined;
    quizQuestionIds?: string | undefined;

    constructor(data?: IProductLessonEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.chapterId = _data["chapterId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.lessonType = _data["lessonType"];
            this.content = _data["content"];
            this.notesHtml = _data["notesHtml"];
            this.attachmentPaths = _data["attachmentPaths"];
            this.sortOrder = _data["sortOrder"];
            this.isFree = _data["isFree"];
            this.allowExerciseBeforeComplete = _data["allowExerciseBeforeComplete"];
            this.duration = _data["duration"];
            this.quizType = _data["quizType"];
            this.quizId = _data["quizId"];
            this.quizQuestionIds = _data["quizQuestionIds"];
        }
    }

    static fromJS(data: any): ProductLessonEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ProductLessonEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["chapterId"] = this.chapterId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["lessonType"] = this.lessonType;
        data["content"] = this.content;
        data["notesHtml"] = this.notesHtml;
        data["attachmentPaths"] = this.attachmentPaths;
        data["sortOrder"] = this.sortOrder;
        data["isFree"] = this.isFree;
        data["allowExerciseBeforeComplete"] = this.allowExerciseBeforeComplete;
        data["duration"] = this.duration;
        data["quizType"] = this.quizType;
        data["quizId"] = this.quizId;
        data["quizQuestionIds"] = this.quizQuestionIds;
        return data;
    }
}

export interface IProductLessonEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    chapterId?: number;
    name?: string | undefined;
    description?: string | undefined;
    lessonType?: LessonTypeEnum;
    content?: string | undefined;
    notesHtml?: string | undefined;
    attachmentPaths?: string | undefined;
    sortOrder?: number;
    isFree?: boolean;
    allowExerciseBeforeComplete?: boolean;
    duration?: number;
    quizType?: LessonQuizTypeEnum;
    quizId?: number | undefined;
    quizQuestionIds?: string | undefined;
}

export class ProductReviewEntity implements IProductReviewEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    productId?: number;
    userId?: number | undefined;
    fullName?: string | undefined;
    avatar?: string | undefined;
    rating?: number;
    comment?: string | undefined;
    status?: ProductReviewStatusEnum;

    constructor(data?: IProductReviewEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.productId = _data["productId"];
            this.userId = _data["userId"];
            this.fullName = _data["fullName"];
            this.avatar = _data["avatar"];
            this.rating = _data["rating"];
            this.comment = _data["comment"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ProductReviewEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ProductReviewEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["productId"] = this.productId;
        data["userId"] = this.userId;
        data["fullName"] = this.fullName;
        data["avatar"] = this.avatar;
        data["rating"] = this.rating;
        data["comment"] = this.comment;
        data["status"] = this.status;
        return data;
    }
}

export interface IProductReviewEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    productId?: number;
    userId?: number | undefined;
    fullName?: string | undefined;
    avatar?: string | undefined;
    rating?: number;
    comment?: string | undefined;
    status?: ProductReviewStatusEnum;
}

export enum ProductReviewStatusEnum {
    Pending = 0,
    Approved = 1,
    Rejected = 2,
}

export enum ProductTypeEnum {
    Normal = 0,
    Course = 1,
    Combo = 2,
}

export class AcademicYearEntity implements IAcademicYearEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    startPeriod1?: Date | undefined;
    startPeriod2?: Date | undefined;
    end?: Date | undefined;
    name?: string | undefined;

    constructor(data?: IAcademicYearEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.objectId = _data["objectId"];
            this.objectType = _data["objectType"];
            this.startPeriod1 = _data["startPeriod1"] ? new Date(_data["startPeriod1"].toString()) : undefined as any;
            this.startPeriod2 = _data["startPeriod2"] ? new Date(_data["startPeriod2"].toString()) : undefined as any;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : undefined as any;
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AcademicYearEntity {
        data = typeof data === 'object' ? data : {};
        let result = new AcademicYearEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["objectId"] = this.objectId;
        data["objectType"] = this.objectType;
        data["startPeriod1"] = this.startPeriod1 ? this.startPeriod1.toISOString() : undefined as any;
        data["startPeriod2"] = this.startPeriod2 ? this.startPeriod2.toISOString() : undefined as any;
        data["end"] = this.end ? this.end.toISOString() : undefined as any;
        data["name"] = this.name;
        return data;
    }
}

export interface IAcademicYearEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    startPeriod1?: Date | undefined;
    startPeriod2?: Date | undefined;
    end?: Date | undefined;
    name?: string | undefined;
}

export enum AttendanceStatusEnum {
    Present = 1,
    Absent = 2,
    Late = 3,
    LeftEarly = 4,
}

export class ClassEntity implements IClassEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    academicYearId?: number | undefined;
    status?: ClassStatusEnum;
    grade?: number;
    priority?: number;
    educationSystemId?: number | undefined;
    classType?: ClassTypeEnum;
    maxStudents?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    zoomMeetingId?: string | undefined;
    zoomPassword?: string | undefined;
    description?: string | undefined;
    allowRegistration?: boolean;
    zoomHostVideo?: boolean;
    zoomParticipantVideo?: boolean;
    zoomJoinBeforeHost?: boolean;
    zoomMuteUponEntry?: boolean;
    zoomAutoRecording?: string | undefined;
    defaultSessionDeliveryMode?: SessionDeliveryModeEnum;
    classUsers?: ClassUserEntity[] | undefined;
    assignExams?: AssignExamEntity[] | undefined;
    classSessions?: ClassSessionEntity[] | undefined;
    classProducts?: ClassProductEntity[] | undefined;

    constructor(data?: IClassEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.objectId = _data["objectId"];
            this.objectType = _data["objectType"];
            this.academicYearId = _data["academicYearId"];
            this.status = _data["status"];
            this.grade = _data["grade"];
            this.priority = _data["priority"];
            this.educationSystemId = _data["educationSystemId"];
            this.classType = _data["classType"];
            this.maxStudents = _data["maxStudents"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.zoomMeetingId = _data["zoomMeetingId"];
            this.zoomPassword = _data["zoomPassword"];
            this.description = _data["description"];
            this.allowRegistration = _data["allowRegistration"];
            this.zoomHostVideo = _data["zoomHostVideo"];
            this.zoomParticipantVideo = _data["zoomParticipantVideo"];
            this.zoomJoinBeforeHost = _data["zoomJoinBeforeHost"];
            this.zoomMuteUponEntry = _data["zoomMuteUponEntry"];
            this.zoomAutoRecording = _data["zoomAutoRecording"];
            this.defaultSessionDeliveryMode = _data["defaultSessionDeliveryMode"];
            if (Array.isArray(_data["classUsers"])) {
                this.classUsers = [] as any;
                for (let item of _data["classUsers"])
                    this.classUsers!.push(ClassUserEntity.fromJS(item));
            }
            if (Array.isArray(_data["assignExams"])) {
                this.assignExams = [] as any;
                for (let item of _data["assignExams"])
                    this.assignExams!.push(AssignExamEntity.fromJS(item));
            }
            if (Array.isArray(_data["classSessions"])) {
                this.classSessions = [] as any;
                for (let item of _data["classSessions"])
                    this.classSessions!.push(ClassSessionEntity.fromJS(item));
            }
            if (Array.isArray(_data["classProducts"])) {
                this.classProducts = [] as any;
                for (let item of _data["classProducts"])
                    this.classProducts!.push(ClassProductEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClassEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ClassEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["objectId"] = this.objectId;
        data["objectType"] = this.objectType;
        data["academicYearId"] = this.academicYearId;
        data["status"] = this.status;
        data["grade"] = this.grade;
        data["priority"] = this.priority;
        data["educationSystemId"] = this.educationSystemId;
        data["classType"] = this.classType;
        data["maxStudents"] = this.maxStudents;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["zoomMeetingId"] = this.zoomMeetingId;
        data["zoomPassword"] = this.zoomPassword;
        data["description"] = this.description;
        data["allowRegistration"] = this.allowRegistration;
        data["zoomHostVideo"] = this.zoomHostVideo;
        data["zoomParticipantVideo"] = this.zoomParticipantVideo;
        data["zoomJoinBeforeHost"] = this.zoomJoinBeforeHost;
        data["zoomMuteUponEntry"] = this.zoomMuteUponEntry;
        data["zoomAutoRecording"] = this.zoomAutoRecording;
        data["defaultSessionDeliveryMode"] = this.defaultSessionDeliveryMode;
        if (Array.isArray(this.classUsers)) {
            data["classUsers"] = [];
            for (let item of this.classUsers)
                data["classUsers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.assignExams)) {
            data["assignExams"] = [];
            for (let item of this.assignExams)
                data["assignExams"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.classSessions)) {
            data["classSessions"] = [];
            for (let item of this.classSessions)
                data["classSessions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.classProducts)) {
            data["classProducts"] = [];
            for (let item of this.classProducts)
                data["classProducts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IClassEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    academicYearId?: number | undefined;
    status?: ClassStatusEnum;
    grade?: number;
    priority?: number;
    educationSystemId?: number | undefined;
    classType?: ClassTypeEnum;
    maxStudents?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    zoomMeetingId?: string | undefined;
    zoomPassword?: string | undefined;
    description?: string | undefined;
    allowRegistration?: boolean;
    zoomHostVideo?: boolean;
    zoomParticipantVideo?: boolean;
    zoomJoinBeforeHost?: boolean;
    zoomMuteUponEntry?: boolean;
    zoomAutoRecording?: string | undefined;
    defaultSessionDeliveryMode?: SessionDeliveryModeEnum;
    classUsers?: ClassUserEntity[] | undefined;
    assignExams?: AssignExamEntity[] | undefined;
    classSessions?: ClassSessionEntity[] | undefined;
    classProducts?: ClassProductEntity[] | undefined;
}

export class ClassProductEntity implements IClassProductEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    classId?: number;
    productId?: number;
    maxStudents?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    status?: ClassProductStatusEnum;
    zoomMeetingId?: string | undefined;
    zoomPassword?: string | undefined;
    description?: string | undefined;
    sortOrder?: number;

    constructor(data?: IClassProductEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.classId = _data["classId"];
            this.productId = _data["productId"];
            this.maxStudents = _data["maxStudents"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.status = _data["status"];
            this.zoomMeetingId = _data["zoomMeetingId"];
            this.zoomPassword = _data["zoomPassword"];
            this.description = _data["description"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): ClassProductEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ClassProductEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["classId"] = this.classId;
        data["productId"] = this.productId;
        data["maxStudents"] = this.maxStudents;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["status"] = this.status;
        data["zoomMeetingId"] = this.zoomMeetingId;
        data["zoomPassword"] = this.zoomPassword;
        data["description"] = this.description;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IClassProductEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    classId?: number;
    productId?: number;
    maxStudents?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    status?: ClassProductStatusEnum;
    zoomMeetingId?: string | undefined;
    zoomPassword?: string | undefined;
    description?: string | undefined;
    sortOrder?: number;
}

export enum ClassProductStatusEnum {
    Active = 1,
    Completed = 2,
    Paused = 3,
    Cancelled = 4,
}

export class ClassProgramTypeEntity implements IClassProgramTypeEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    description?: string | undefined;

    constructor(data?: IClassProgramTypeEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.objectId = _data["objectId"];
            this.objectType = _data["objectType"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ClassProgramTypeEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ClassProgramTypeEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["objectId"] = this.objectId;
        data["objectType"] = this.objectType;
        data["description"] = this.description;
        return data;
    }
}

export interface IClassProgramTypeEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    objectId?: number;
    objectType?: ObjectOwnerTypeEnum;
    description?: string | undefined;
}

export class ClassSessionEntity implements IClassSessionEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    classId?: number;
    productLessonId?: number | undefined;
    productId?: number;
    sessionNumber?: number;
    sessionName?: string | undefined;
    description?: string | undefined;
    startTime?: Date;
    endTime?: Date;
    deliveryMode?: SessionDeliveryModeEnum;
    zoomMeetingId?: string | undefined;
    zoomWebinarId?: string | undefined;
    zoomJoinLink?: string | undefined;
    zoomStartLink?: string | undefined;
    zoomPassword?: string | undefined;
    recordingUrl?: string | undefined;
    zoomAccountId?: number | undefined;
    actualDurationMinutes?: number | undefined;
    status?: SessionStatusEnum;
    notes?: string | undefined;
    isNotifiedReminder?: boolean;
    isNotifiedStart?: boolean;
    class?: ClassEntity;
    productLesson?: ProductLessonEntity;
    attendances?: SessionAttendanceEntity[] | undefined;

    constructor(data?: IClassSessionEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.classId = _data["classId"];
            this.productLessonId = _data["productLessonId"];
            this.productId = _data["productId"];
            this.sessionNumber = _data["sessionNumber"];
            this.sessionName = _data["sessionName"];
            this.description = _data["description"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
            this.deliveryMode = _data["deliveryMode"];
            this.zoomMeetingId = _data["zoomMeetingId"];
            this.zoomWebinarId = _data["zoomWebinarId"];
            this.zoomJoinLink = _data["zoomJoinLink"];
            this.zoomStartLink = _data["zoomStartLink"];
            this.zoomPassword = _data["zoomPassword"];
            this.recordingUrl = _data["recordingUrl"];
            this.zoomAccountId = _data["zoomAccountId"];
            this.actualDurationMinutes = _data["actualDurationMinutes"];
            this.status = _data["status"];
            this.notes = _data["notes"];
            this.isNotifiedReminder = _data["isNotifiedReminder"];
            this.isNotifiedStart = _data["isNotifiedStart"];
            this.class = _data["class"] ? ClassEntity.fromJS(_data["class"]) : undefined as any;
            this.productLesson = _data["productLesson"] ? ProductLessonEntity.fromJS(_data["productLesson"]) : undefined as any;
            if (Array.isArray(_data["attendances"])) {
                this.attendances = [] as any;
                for (let item of _data["attendances"])
                    this.attendances!.push(SessionAttendanceEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClassSessionEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ClassSessionEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["classId"] = this.classId;
        data["productLessonId"] = this.productLessonId;
        data["productId"] = this.productId;
        data["sessionNumber"] = this.sessionNumber;
        data["sessionName"] = this.sessionName;
        data["description"] = this.description;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        data["deliveryMode"] = this.deliveryMode;
        data["zoomMeetingId"] = this.zoomMeetingId;
        data["zoomWebinarId"] = this.zoomWebinarId;
        data["zoomJoinLink"] = this.zoomJoinLink;
        data["zoomStartLink"] = this.zoomStartLink;
        data["zoomPassword"] = this.zoomPassword;
        data["recordingUrl"] = this.recordingUrl;
        data["zoomAccountId"] = this.zoomAccountId;
        data["actualDurationMinutes"] = this.actualDurationMinutes;
        data["status"] = this.status;
        data["notes"] = this.notes;
        data["isNotifiedReminder"] = this.isNotifiedReminder;
        data["isNotifiedStart"] = this.isNotifiedStart;
        data["class"] = this.class ? this.class.toJSON() : undefined as any;
        data["productLesson"] = this.productLesson ? this.productLesson.toJSON() : undefined as any;
        if (Array.isArray(this.attendances)) {
            data["attendances"] = [];
            for (let item of this.attendances)
                data["attendances"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IClassSessionEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    classId?: number;
    productLessonId?: number | undefined;
    productId?: number;
    sessionNumber?: number;
    sessionName?: string | undefined;
    description?: string | undefined;
    startTime?: Date;
    endTime?: Date;
    deliveryMode?: SessionDeliveryModeEnum;
    zoomMeetingId?: string | undefined;
    zoomWebinarId?: string | undefined;
    zoomJoinLink?: string | undefined;
    zoomStartLink?: string | undefined;
    zoomPassword?: string | undefined;
    recordingUrl?: string | undefined;
    zoomAccountId?: number | undefined;
    actualDurationMinutes?: number | undefined;
    status?: SessionStatusEnum;
    notes?: string | undefined;
    isNotifiedReminder?: boolean;
    isNotifiedStart?: boolean;
    class?: ClassEntity;
    productLesson?: ProductLessonEntity;
    attendances?: SessionAttendanceEntity[] | undefined;
}

export enum ClassTypeEnum {
    School = 1,
    OnlineCourse = 2,
}

export class ClassUserEntity implements IClassUserEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    userId?: number;
    classId?: number;
    role?: ClassUserRoleEnum;
    status?: ClassUserStatusEnum;
    note?: string | undefined;
    subjectIds?: number[] | undefined;
    isManager?: boolean;

    constructor(data?: IClassUserEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.userId = _data["userId"];
            this.classId = _data["classId"];
            this.role = _data["role"];
            this.status = _data["status"];
            this.note = _data["note"];
            if (Array.isArray(_data["subjectIds"])) {
                this.subjectIds = [] as any;
                for (let item of _data["subjectIds"])
                    this.subjectIds!.push(item);
            }
            this.isManager = _data["isManager"];
        }
    }

    static fromJS(data: any): ClassUserEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ClassUserEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["userId"] = this.userId;
        data["classId"] = this.classId;
        data["role"] = this.role;
        data["status"] = this.status;
        data["note"] = this.note;
        if (Array.isArray(this.subjectIds)) {
            data["subjectIds"] = [];
            for (let item of this.subjectIds)
                data["subjectIds"].push(item);
        }
        data["isManager"] = this.isManager;
        return data;
    }
}

export interface IClassUserEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    userId?: number;
    classId?: number;
    role?: ClassUserRoleEnum;
    status?: ClassUserStatusEnum;
    note?: string | undefined;
    subjectIds?: number[] | undefined;
    isManager?: boolean;
}

export class SchoolEntity implements ISchoolEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    code?: string | undefined;
    name?: string | undefined;
    status?: SchoolStatusEnum;
    countryId?: number;
    districtId?: number;
    provinceId?: number;
    wardId?: number;
    address?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    logo?: string | undefined;
    url?: string | undefined;
    description?: string | undefined;
    type?: number;
    levels?: string | undefined;
    organizationId?: number;
    parentId?: number;
    isTemp?: boolean;
    templateSchoolId?: number;
    ownerUserId?: number;
    approvedBy?: number;
    approvedAt?: Date | undefined;
    rejectReason?: string | undefined;
    languageCode?: string | undefined;
    maxStudentCount?: number;
    maxStaffCount?: number;
    establishmentDecisionFile?: string | undefined;

    constructor(data?: ISchoolEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.countryId = _data["countryId"];
            this.districtId = _data["districtId"];
            this.provinceId = _data["provinceId"];
            this.wardId = _data["wardId"];
            this.address = _data["address"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.logo = _data["logo"];
            this.url = _data["url"];
            this.description = _data["description"];
            this.type = _data["type"];
            this.levels = _data["levels"];
            this.organizationId = _data["organizationId"];
            this.parentId = _data["parentId"];
            this.isTemp = _data["isTemp"];
            this.templateSchoolId = _data["templateSchoolId"];
            this.ownerUserId = _data["ownerUserId"];
            this.approvedBy = _data["approvedBy"];
            this.approvedAt = _data["approvedAt"] ? new Date(_data["approvedAt"].toString()) : undefined as any;
            this.rejectReason = _data["rejectReason"];
            this.languageCode = _data["languageCode"];
            this.maxStudentCount = _data["maxStudentCount"];
            this.maxStaffCount = _data["maxStaffCount"];
            this.establishmentDecisionFile = _data["establishmentDecisionFile"];
        }
    }

    static fromJS(data: any): SchoolEntity {
        data = typeof data === 'object' ? data : {};
        let result = new SchoolEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["code"] = this.code;
        data["name"] = this.name;
        data["status"] = this.status;
        data["countryId"] = this.countryId;
        data["districtId"] = this.districtId;
        data["provinceId"] = this.provinceId;
        data["wardId"] = this.wardId;
        data["address"] = this.address;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["logo"] = this.logo;
        data["url"] = this.url;
        data["description"] = this.description;
        data["type"] = this.type;
        data["levels"] = this.levels;
        data["organizationId"] = this.organizationId;
        data["parentId"] = this.parentId;
        data["isTemp"] = this.isTemp;
        data["templateSchoolId"] = this.templateSchoolId;
        data["ownerUserId"] = this.ownerUserId;
        data["approvedBy"] = this.approvedBy;
        data["approvedAt"] = this.approvedAt ? this.approvedAt.toISOString() : undefined as any;
        data["rejectReason"] = this.rejectReason;
        data["languageCode"] = this.languageCode;
        data["maxStudentCount"] = this.maxStudentCount;
        data["maxStaffCount"] = this.maxStaffCount;
        data["establishmentDecisionFile"] = this.establishmentDecisionFile;
        return data;
    }
}

export interface ISchoolEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    code?: string | undefined;
    name?: string | undefined;
    status?: SchoolStatusEnum;
    countryId?: number;
    districtId?: number;
    provinceId?: number;
    wardId?: number;
    address?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    logo?: string | undefined;
    url?: string | undefined;
    description?: string | undefined;
    type?: number;
    levels?: string | undefined;
    organizationId?: number;
    parentId?: number;
    isTemp?: boolean;
    templateSchoolId?: number;
    ownerUserId?: number;
    approvedBy?: number;
    approvedAt?: Date | undefined;
    rejectReason?: string | undefined;
    languageCode?: string | undefined;
    maxStudentCount?: number;
    maxStaffCount?: number;
    establishmentDecisionFile?: string | undefined;
}

export class SessionAttendanceEntity implements ISessionAttendanceEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    sessionId?: number;
    userId?: number;
    joinTime?: Date | undefined;
    leaveTime?: Date | undefined;
    durationMinutes?: number | undefined;
    status?: AttendanceStatusEnum;
    notes?: string | undefined;
    session?: ClassSessionEntity;
    user?: UserEntity;

    constructor(data?: ISessionAttendanceEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.sessionId = _data["sessionId"];
            this.userId = _data["userId"];
            this.joinTime = _data["joinTime"] ? new Date(_data["joinTime"].toString()) : undefined as any;
            this.leaveTime = _data["leaveTime"] ? new Date(_data["leaveTime"].toString()) : undefined as any;
            this.durationMinutes = _data["durationMinutes"];
            this.status = _data["status"];
            this.notes = _data["notes"];
            this.session = _data["session"] ? ClassSessionEntity.fromJS(_data["session"]) : undefined as any;
            this.user = _data["user"] ? UserEntity.fromJS(_data["user"]) : undefined as any;
        }
    }

    static fromJS(data: any): SessionAttendanceEntity {
        data = typeof data === 'object' ? data : {};
        let result = new SessionAttendanceEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["sessionId"] = this.sessionId;
        data["userId"] = this.userId;
        data["joinTime"] = this.joinTime ? this.joinTime.toISOString() : undefined as any;
        data["leaveTime"] = this.leaveTime ? this.leaveTime.toISOString() : undefined as any;
        data["durationMinutes"] = this.durationMinutes;
        data["status"] = this.status;
        data["notes"] = this.notes;
        data["session"] = this.session ? this.session.toJSON() : undefined as any;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        return data;
    }
}

export interface ISessionAttendanceEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    sessionId?: number;
    userId?: number;
    joinTime?: Date | undefined;
    leaveTime?: Date | undefined;
    durationMinutes?: number | undefined;
    status?: AttendanceStatusEnum;
    notes?: string | undefined;
    session?: ClassSessionEntity;
    user?: UserEntity;
}

export enum SessionDeliveryModeEnum {
    Meeting = 1,
    Webinar = 2,
}

export enum SessionStatusEnum {
    Scheduled = 1,
    Live = 2,
    Finished = 3,
    Cancelled = 4,
}

export class StaticPageEntity implements IStaticPageEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    pageKey?: string | undefined;
    title?: string | undefined;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaImage?: string | undefined;
    status?: CommonStatusEnum;
    sections?: StaticPageSectionEntity[] | undefined;
    locales?: StaticPageLocaleEntity[] | undefined;

    constructor(data?: IStaticPageEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.pageKey = _data["pageKey"];
            this.title = _data["title"];
            this.metaTitle = _data["metaTitle"];
            this.metaDescription = _data["metaDescription"];
            this.metaImage = _data["metaImage"];
            this.status = _data["status"];
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(StaticPageSectionEntity.fromJS(item));
            }
            if (Array.isArray(_data["locales"])) {
                this.locales = [] as any;
                for (let item of _data["locales"])
                    this.locales!.push(StaticPageLocaleEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StaticPageEntity {
        data = typeof data === 'object' ? data : {};
        let result = new StaticPageEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["pageKey"] = this.pageKey;
        data["title"] = this.title;
        data["metaTitle"] = this.metaTitle;
        data["metaDescription"] = this.metaDescription;
        data["metaImage"] = this.metaImage;
        data["status"] = this.status;
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.locales)) {
            data["locales"] = [];
            for (let item of this.locales)
                data["locales"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IStaticPageEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    pageKey?: string | undefined;
    title?: string | undefined;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaImage?: string | undefined;
    status?: CommonStatusEnum;
    sections?: StaticPageSectionEntity[] | undefined;
    locales?: StaticPageLocaleEntity[] | undefined;
}

export class StaticPageLocaleEntity implements IStaticPageLocaleEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    pageId?: number;
    languageCode?: string | undefined;
    title?: string | undefined;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaImage?: string | undefined;
    page?: StaticPageEntity;

    constructor(data?: IStaticPageLocaleEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.pageId = _data["pageId"];
            this.languageCode = _data["languageCode"];
            this.title = _data["title"];
            this.metaTitle = _data["metaTitle"];
            this.metaDescription = _data["metaDescription"];
            this.metaImage = _data["metaImage"];
            this.page = _data["page"] ? StaticPageEntity.fromJS(_data["page"]) : undefined as any;
        }
    }

    static fromJS(data: any): StaticPageLocaleEntity {
        data = typeof data === 'object' ? data : {};
        let result = new StaticPageLocaleEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["pageId"] = this.pageId;
        data["languageCode"] = this.languageCode;
        data["title"] = this.title;
        data["metaTitle"] = this.metaTitle;
        data["metaDescription"] = this.metaDescription;
        data["metaImage"] = this.metaImage;
        data["page"] = this.page ? this.page.toJSON() : undefined as any;
        return data;
    }
}

export interface IStaticPageLocaleEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    pageId?: number;
    languageCode?: string | undefined;
    title?: string | undefined;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaImage?: string | undefined;
    page?: StaticPageEntity;
}

export class StaticPageSectionContentEntity implements IStaticPageSectionContentEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    sectionId?: number;
    languageCode?: string | undefined;
    contentData?: string | undefined;
    section?: StaticPageSectionEntity;

    constructor(data?: IStaticPageSectionContentEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.sectionId = _data["sectionId"];
            this.languageCode = _data["languageCode"];
            this.contentData = _data["contentData"];
            this.section = _data["section"] ? StaticPageSectionEntity.fromJS(_data["section"]) : undefined as any;
        }
    }

    static fromJS(data: any): StaticPageSectionContentEntity {
        data = typeof data === 'object' ? data : {};
        let result = new StaticPageSectionContentEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["sectionId"] = this.sectionId;
        data["languageCode"] = this.languageCode;
        data["contentData"] = this.contentData;
        data["section"] = this.section ? this.section.toJSON() : undefined as any;
        return data;
    }
}

export interface IStaticPageSectionContentEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    sectionId?: number;
    languageCode?: string | undefined;
    contentData?: string | undefined;
    section?: StaticPageSectionEntity;
}

export class StaticPageSectionEntity implements IStaticPageSectionEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    pageId?: number;
    sectionKey?: string | undefined;
    label?: string | undefined;
    isRepeatable?: boolean;
    sortOrder?: number;
    fieldDefinitions?: string | undefined;
    contentData?: string | undefined;
    status?: CommonStatusEnum;
    page?: StaticPageEntity;
    contents?: StaticPageSectionContentEntity[] | undefined;

    constructor(data?: IStaticPageSectionEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.pageId = _data["pageId"];
            this.sectionKey = _data["sectionKey"];
            this.label = _data["label"];
            this.isRepeatable = _data["isRepeatable"];
            this.sortOrder = _data["sortOrder"];
            this.fieldDefinitions = _data["fieldDefinitions"];
            this.contentData = _data["contentData"];
            this.status = _data["status"];
            this.page = _data["page"] ? StaticPageEntity.fromJS(_data["page"]) : undefined as any;
            if (Array.isArray(_data["contents"])) {
                this.contents = [] as any;
                for (let item of _data["contents"])
                    this.contents!.push(StaticPageSectionContentEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StaticPageSectionEntity {
        data = typeof data === 'object' ? data : {};
        let result = new StaticPageSectionEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["pageId"] = this.pageId;
        data["sectionKey"] = this.sectionKey;
        data["label"] = this.label;
        data["isRepeatable"] = this.isRepeatable;
        data["sortOrder"] = this.sortOrder;
        data["fieldDefinitions"] = this.fieldDefinitions;
        data["contentData"] = this.contentData;
        data["status"] = this.status;
        data["page"] = this.page ? this.page.toJSON() : undefined as any;
        if (Array.isArray(this.contents)) {
            data["contents"] = [];
            for (let item of this.contents)
                data["contents"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IStaticPageSectionEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    pageId?: number;
    sectionKey?: string | undefined;
    label?: string | undefined;
    isRepeatable?: boolean;
    sortOrder?: number;
    fieldDefinitions?: string | undefined;
    contentData?: string | undefined;
    status?: CommonStatusEnum;
    page?: StaticPageEntity;
    contents?: StaticPageSectionContentEntity[] | undefined;
}

export class LanguageEntity implements ILanguageEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    code?: string | undefined;
    name?: string | undefined;
    nativeName?: string | undefined;
    isDefault?: boolean;
    isActive?: boolean;
    sortOrder?: number;
    flagIcon?: string | undefined;

    constructor(data?: ILanguageEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.nativeName = _data["nativeName"];
            this.isDefault = _data["isDefault"];
            this.isActive = _data["isActive"];
            this.sortOrder = _data["sortOrder"];
            this.flagIcon = _data["flagIcon"];
        }
    }

    static fromJS(data: any): LanguageEntity {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["code"] = this.code;
        data["name"] = this.name;
        data["nativeName"] = this.nativeName;
        data["isDefault"] = this.isDefault;
        data["isActive"] = this.isActive;
        data["sortOrder"] = this.sortOrder;
        data["flagIcon"] = this.flagIcon;
        return data;
    }
}

export interface ILanguageEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    code?: string | undefined;
    name?: string | undefined;
    nativeName?: string | undefined;
    isDefault?: boolean;
    isActive?: boolean;
    sortOrder?: number;
    flagIcon?: string | undefined;
}

export class TranslationKeyEntity implements ITranslationKeyEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    namespace?: string | undefined;
    key?: string | undefined;
    description?: string | undefined;
    defaultValue?: string | undefined;
    values?: TranslationValueEntity[] | undefined;

    constructor(data?: ITranslationKeyEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.namespace = _data["namespace"];
            this.key = _data["key"];
            this.description = _data["description"];
            this.defaultValue = _data["defaultValue"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(TranslationValueEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TranslationKeyEntity {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationKeyEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["namespace"] = this.namespace;
        data["key"] = this.key;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITranslationKeyEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    namespace?: string | undefined;
    key?: string | undefined;
    description?: string | undefined;
    defaultValue?: string | undefined;
    values?: TranslationValueEntity[] | undefined;
}

export class TranslationValueEntity implements ITranslationValueEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    translationKeyId?: number;
    languageCode?: string | undefined;
    value?: string | undefined;
    translationKey?: TranslationKeyEntity;

    constructor(data?: ITranslationValueEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            (this as any).isDeleted = _data["isDeleted"];
            this.translationKeyId = _data["translationKeyId"];
            this.languageCode = _data["languageCode"];
            this.value = _data["value"];
            this.translationKey = _data["translationKey"] ? TranslationKeyEntity.fromJS(_data["translationKey"]) : undefined as any;
        }
    }

    static fromJS(data: any): TranslationValueEntity {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationValueEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["translationKeyId"] = this.translationKeyId;
        data["languageCode"] = this.languageCode;
        data["value"] = this.value;
        data["translationKey"] = this.translationKey ? this.translationKey.toJSON() : undefined as any;
        return data;
    }
}

export interface ITranslationValueEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    translationKeyId?: number;
    languageCode?: string | undefined;
    value?: string | undefined;
    translationKey?: TranslationKeyEntity;
}

export enum FileStatusEnum {
    Inited = 0,
    Uploading = 1,
    Uploaded = 2,
    WaitForProcessing = 3,
    Processing = 4,
    Processed = 5,
    Error = 6,
}

export class PermissionMigrationResult implements IPermissionMigrationResult {
    rolesProcessed?: number;
    rolePermissionsCreated?: number;
    userRolesUpdated?: number;
    userOverridesMigrated?: number;
    userPermissionsRebuilt?: number;
    errors?: string[] | undefined;

    constructor(data?: IPermissionMigrationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rolesProcessed = _data["rolesProcessed"];
            this.rolePermissionsCreated = _data["rolePermissionsCreated"];
            this.userRolesUpdated = _data["userRolesUpdated"];
            this.userOverridesMigrated = _data["userOverridesMigrated"];
            this.userPermissionsRebuilt = _data["userPermissionsRebuilt"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): PermissionMigrationResult {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionMigrationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rolesProcessed"] = this.rolesProcessed;
        data["rolePermissionsCreated"] = this.rolePermissionsCreated;
        data["userRolesUpdated"] = this.userRolesUpdated;
        data["userOverridesMigrated"] = this.userOverridesMigrated;
        data["userPermissionsRebuilt"] = this.userPermissionsRebuilt;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IPermissionMigrationResult {
    rolesProcessed?: number;
    rolePermissionsCreated?: number;
    userRolesUpdated?: number;
    userOverridesMigrated?: number;
    userPermissionsRebuilt?: number;
    errors?: string[] | undefined;
}

export class DNTCaptchaApiResponse implements IDNTCaptchaApiResponse {
    dntCaptchaImgUrl?: string | undefined;
    dntCaptchaId?: string | undefined;
    dntCaptchaTextValue?: string | undefined;
    dntCaptchaTokenValue?: string | undefined;

    constructor(data?: IDNTCaptchaApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dntCaptchaImgUrl = _data["dntCaptchaImgUrl"];
            this.dntCaptchaId = _data["dntCaptchaId"];
            this.dntCaptchaTextValue = _data["dntCaptchaTextValue"];
            this.dntCaptchaTokenValue = _data["dntCaptchaTokenValue"];
        }
    }

    static fromJS(data: any): DNTCaptchaApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DNTCaptchaApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dntCaptchaImgUrl"] = this.dntCaptchaImgUrl;
        data["dntCaptchaId"] = this.dntCaptchaId;
        data["dntCaptchaTextValue"] = this.dntCaptchaTextValue;
        data["dntCaptchaTokenValue"] = this.dntCaptchaTokenValue;
        return data;
    }
}

export interface IDNTCaptchaApiResponse {
    dntCaptchaImgUrl?: string | undefined;
    dntCaptchaId?: string | undefined;
    dntCaptchaTextValue?: string | undefined;
    dntCaptchaTokenValue?: string | undefined;
}

export class Enum implements IEnum {

    constructor(data?: IEnum) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Enum {
        data = typeof data === 'object' ? data : {};
        let result = new Enum();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IEnum {
}

export class UserAnswerEntity implements IUserAnswerEntity {
    id?: number;
    userExamResultId?: number;
    questionId?: number;
    parentId?: number;
    content?: string | undefined;
    fileUrl?: string | undefined;
    mark?: number;
    isCorrect?: boolean;
    answer?: string | undefined;
    comment?: string | undefined;
    commentBy?: number;
    commentDate?: Date | undefined;
    lastModifiedBy?: number;
    lastModifiedDate?: Date | undefined;

    constructor(data?: IUserAnswerEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userExamResultId = _data["userExamResultId"];
            this.questionId = _data["questionId"];
            this.parentId = _data["parentId"];
            this.content = _data["content"];
            this.fileUrl = _data["fileUrl"];
            this.mark = _data["mark"];
            this.isCorrect = _data["isCorrect"];
            this.answer = _data["answer"];
            this.comment = _data["comment"];
            this.commentBy = _data["commentBy"];
            this.commentDate = _data["commentDate"] ? new Date(_data["commentDate"].toString()) : undefined as any;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UserAnswerEntity {
        data = typeof data === 'object' ? data : {};
        let result = new UserAnswerEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userExamResultId"] = this.userExamResultId;
        data["questionId"] = this.questionId;
        data["parentId"] = this.parentId;
        data["content"] = this.content;
        data["fileUrl"] = this.fileUrl;
        data["mark"] = this.mark;
        data["isCorrect"] = this.isCorrect;
        data["answer"] = this.answer;
        data["comment"] = this.comment;
        data["commentBy"] = this.commentBy;
        data["commentDate"] = this.commentDate ? this.commentDate.toISOString() : undefined as any;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IUserAnswerEntity {
    id?: number;
    userExamResultId?: number;
    questionId?: number;
    parentId?: number;
    content?: string | undefined;
    fileUrl?: string | undefined;
    mark?: number;
    isCorrect?: boolean;
    answer?: string | undefined;
    comment?: string | undefined;
    commentBy?: number;
    commentDate?: Date | undefined;
    lastModifiedBy?: number;
    lastModifiedDate?: Date | undefined;
}

export class VapidDetails implements IVapidDetails {
    subject?: string | undefined;
    publicKey?: string | undefined;
    privateKey?: string | undefined;
    expiration?: number;

    constructor(data?: IVapidDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"];
            this.publicKey = _data["publicKey"];
            this.privateKey = _data["privateKey"];
            this.expiration = _data["expiration"];
        }
    }

    static fromJS(data: any): VapidDetails {
        data = typeof data === 'object' ? data : {};
        let result = new VapidDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject;
        data["publicKey"] = this.publicKey;
        data["privateKey"] = this.privateKey;
        data["expiration"] = this.expiration;
        return data;
    }
}

export interface IVapidDetails {
    subject?: string | undefined;
    publicKey?: string | undefined;
    privateKey?: string | undefined;
    expiration?: number;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class BearException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isBearException = true;

    static isBearException(obj: any): obj is BearException {
        return obj.isBearException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new BearException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}